import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { blockSuspension } from "./redux/slices/watchdogs";

const resources = {
  gr: {
    translation: {
      sidebar: {
        dashboard: "Ταμπλό",
        crm: "ΔΠΣ",
        admins: "Διαχειριστές",
        tenants: "Ενοικιαστές",
        managers: "Μανατζερ",
        customers: "Πελάτες",
        subaccounts: "Υπολογαριασμοί",
        sims: "Κάρτες SIM",
        account: "Λογαριασμός",
        profile: "Προφίλ",
        billingProducts: "Τιμολογιακά Προϊόντα",
        invoices: "Τιμολόγια",
        statements: "Κατάσταση Λογαριασμού",
        orders: "Παραγγελίες",
        emails: "Emails",
        reports: "Αναφορές",
        generateReport: "Δημιουργία Αναφοράς",
        automatedReports: "Αυτοματοποιημένες Αναφορές",
        reportHistory: "Ιστορικό Αναφορών",
        alerts: "Συναγερμοί",
        notifications: "Ειδοποιήσεις",
        support: "Υποστήριξη",
        privileges: "Προνόμια",
        settings: "Ρυθμίσεις",
        services: "Υπηρεσίες",
        documentation: "Οδηγίες",
        whitelist: "Επιτρεπόμενη διεύθυνση IP",
        customFields: "Προσαρμοσμένα Πεδία",
        simProducts: "Προϊόντα SIM",
        purchaseSims: "Αγορά Καρτών SIM",
        health: "Υγεία Συστήματος",
        purchaseOrders: "Παραγγελίες Καρτών SIM",
      },
      dashboard: {
        dataVolume: "Όγκος Δεδομένων",
        dataSessions: "Συνεδρίες Δεδομένων",
        alerts: "Ειδοποιήσεις",
        zeroSessions: "Μηδενικές Συνεδρίες",
        sinceYesterday: "Από Χθες",
        sinceLastMonth: "Από τον Προηγούμενο Μήνα",
        sinceLastYear: "Από τον Προηγούμενο Χρόνο",
        averageVolume: "Μέσος Όγκος Δεδομένων",
        activeSims: "Ενεργές SIM",
        dataVolumePerHour: "Όγκος Δεδομένων ανά ώρα",
        topMetrics: "Κορυφαίες Μετρικές",
        simCardsPerOffer: "Κάρτες SIM ανά Πακέτο",
        simInventory: "Κατανομή SIM ανά Κατάσταση",
        dataVolumePerNetwork: "Όγκος Δεδομένων ανά Δίκτυο",
        selectCountry: "Επιλέξτε Χώρα",
        networksDistribution: "Κατανομή Ενεργών Καρτών SIM ανά Δίκτυο",
        watchdogAlerts: "Ειδοποιήσεις Κατανάλωσης",
        noData: "Δεν υπάρχουν δεδομένα",
        daily: "Ημερήσια",
        monthly: "Μηνιαία",
        yearly: "Ετήσια",
      },
      crm: {
        admins: "Διαχειριστές",
        tenants: "Ενοικιαστές",
        managers: "Μάνατζερ",
        customers: "Πελάτες",
        subaccounts: "Υπολογαριασμοί",
        filters: "Φίλτρα",
        fullName: "Ονοματεπώνυμο",
        company: "Εταιρεία",
        email: "Email",
        address: "Διεύθυνση",
        city: "Πόλη",
        country: "Χώρα",
        postcode: "Ταχυδρομικός Κώδικας",
        telephone: "Τηλέφωνο",
        mobile: "Κινητό",
        email: "Email",
        occupation: "Επάγγελμα",
        company: "Εταιρεία",
        tin: "ΑΦΜ",
        username: "Όνομα Χρήστη",
        role: "Ρόλος",
        actions: "Ενέργειες",
        edit: "Επεξεργασία",
        delete: "Διαγραφή",
        billing: "Τιμολόγηση",
        whitelabeling: "Whitelabeling",
        offers: "Πακέτα",
        impersonate: "Είσοδος",
        permissions: "Δικαιώματα",
        sendWelcomeEmail: "Αποστολή Email Καλωσορίσματος",
        resetPassword: "Επαναφορά Κωδικού",
        initializeSIMs: "Αρχικοποίηση SIM",
        initializeAlerts: "Αρχικοποίηση Ειδοποιήσεων",
        newTenant: "Νέος Ενοικιαστής",
        newManager: "Νέος Μανατζερ",
        newCustomer: "Νέος Πελάτης",
        newSubaccount: "Νέος Υπολογαριασμός",
        registerPayment: "Εισαγωγή Πληρωμής",
        accountId: "ID Λογαριασμού",
        registerPayment: {
          title: "Εισαγωγή Πληρωμής",
          amount: "Ποσό",
          currency: "Νόμισμα",
          invoice: "Αριθμός Τιμολογίου",
          submit: "Υποβολή",
          cancel: "Ακύρωση",
          selectCurrency: "Επιλέξτε Νόμισμα",
          selectInvoice: "Επιλέξτε Αριθμό Τιμολογίου",
        },
        creditNote: {
          title: "Πιστωτικό Σημείωμα",
          amount: "Ποσό",
          vat: "ΦΠΑ",
          reason: "Αιτία",
          submit: "Υποβολή",
          cancel: "Ακύρωση",
        },
        invoiceCycle: {
          title: "Επανάληψη κύκλου τιμολόγησης",
        },
        newModal: {
          newTenant: "Δημιουργία Tenant",
          newManager: "Δημιουργία Manager",
          newCustomer: "Δημιουργία Customer",
          newSubaccount: "Δημιουργία Subaccount",
          fullName: "Ονοματεπώνυμο",
          address: "Διεύθυνση",
          city: "Πόλη",
          country: "Χώρα",
          postcode: "Ταχυδρομικός Κώδικας",
          telephone: "Τηλέφωνο",
          mobile: "Κινητό",
          email: "Email",
          occupation: "Επάγγελμα",
          company: "Εταιρεία",
          tin: "ΑΦΜ",
          username: "Όνομα Χρήστη",
          sendWelcomeEmail: "Αποστολή Email Καλωσορίσματος",
          cancel: "Ακύρωση",
          submit: "Υποβολή",
          next: "Επόμενο",
          previous: "Προγούμενο",
          currency: "Νόμισμα",
          billingFrequency: "Συχνότητα Τιμολόγησης",
          daysToPayInvoice: "Ημέρες Πληρωμής Τιμολογίου",
          minimumAmountToInvoice: "Ελάχιστο Ποσό για Τιμολόγηση",
          invoiceType: "Τύπος Τιμολόγησης",
          preferredLanguage: "Προτιμώμενη Γλώσσα",
          billingEmail: "Email Τιμολόγησης",
          currency: "Νόμισμα",
        },
        editModal: {
          editTenant: "Επεξεργασία Tenant",
          editManager: "Επεξεργασία Manager",
          editCustomer: "Επεξεργασία Customer",
          editSubaccount: "Επεξεργασία Subaccount",
          fullName: "Ονοματεπώνυμο",
          address: "Διεύθυνση",
          city: "Πόλη",
          country: "Χώρα",
          postcode: "Ταχυδρομικός Κώδικας",
          telephone: "Τηλέφωνο",
          mobile: "Κινητό",
          email: "Email",
          occupation: "Επάγγελμα",
          company: "Εταιρεία",
          tin: "ΑΦΜ",
          username: "Όνομα Χρήστη",
          cancel: "Ακύρωση",
          submit: "Υποβολή",
        },
        billingModal: {
          title: "Ρυθμίσεις Τιμολόγησης",
          currency: "Νόμισμα",
          billingFrequency: "Συχνότητα Τιμολόγησης",
          daysToPayInvoice: "Ημέρες Πληρωμής Τιμολογίου",
          minimumAmountToInvoice: "Ελάχιστο Ποσό για Τιμολόγηση",
          invoiceType: "Τύπος Τιμολόγησης",
          preferredLanguage: "Προτιμώμενη Γλώσσα",
          billingEmail: "Email Τιμολόγησης",
          platformUsage: "Χρέωση Πλατφόρμας",
          platformUsagePrice: "Τιμή Χρέωσης Πλατφόρμας",
          onStockPriceEnabled: "Χρέωση Καρτών SIM On Stock",
          onStockPrice: "Τιμή Καρτών SIM On Stock",
          simCardPriceEnabled: "Χρέωση Στελέχους Κάρτας SIM?",
          simCardPrice: "Τιμή Στελέχους Κάρτας SIM",
          simChipPriceEnabled: "Χρέωση Chip Κάρτας SIM?",
          simChipPrice: "Τιμή Chip Κάρτας SIM",
          billable: "Χρεώσιμος?",
          isVatExempt: "Aπαλλάσσεται από ΦΠΑ?",
          cancel: "Ακύρωση",
          submit: "Υποβολή",
        },
        whitelabelModal: {
          title: "Ρυθμίσεις Whitelabel",
          enableWhitelabel: "Ενεργοποίηση Whitelabel",
          pricePerMonth: "Τιμή ανά Μήνα",
          url: "URL",
          cancel: "Ακύρωση",
          submit: "Υποβολή",
        },
        roleModal: {
          title: "Ενημέρωση Ρόλου",
          role: "Ρόλος",
          tenant: "Tenant",
          manager: "Manager",
          customer: "Customer",
          cancel: "Ακύρωση",
          submit: "Υποβολή",
          selectRole: "Επιλέξτε Ρόλο",
          selectParent: "Επιλογή Ιδιοκτήτη Λογαριασμού",
          parentEntity: "Ιδιοκτήτη Λογαριασμός",
        },
        offersModal: {
          title: "Ανάθεση Πακέτων",
          availableOffers: "Διαθέσιμα Πακέτα",
          assignedOffers: "Ανατεθειμένα Πακέτα",
          submit: "Υποβολή",
          cancel: "Ακύρωση",
        },
        "1nceModal": {
          enable1nce: "Ενεργοποίηση 1NCE Ρυθμίσεων",
          title: "Ρυθμίσεις 1NCE",
          organizationId: "ID πελάτη",
          username: "Όνομα Χρήστη",
          password: "Κωδικός",
          confirmPassword: "Επιβεβαίωση Κωδικού",
          changePassword: "Αλλαγή Κωδικού",
          submit: "Υποβολή",
          cancel: "Ακύρωση",
        },
      },
      sims: {
        title: "Κάρτες SIM",
        dataVolume: "Όγκος Δεδομένων",
        dataSessions: "Sessions Δεδομένων",
        zeroSessions: "Μηδενικά Sessions",
        filters: "Φίλτρα",
        simStatus: "Ενεργή σύνδεση",
        simState: "Κατάσταση",
        portfolioId: "Portfolio ID",
        imsi: "IMSI",
        iccid: "ICCID",
        eid: "EID",
        msisdn: "MSISDN",
        offer: "Πακέτο",
        data: "Δεδομένα",
        min: "Ελάχιστο",
        max: "Μέγιστο",
        search: "Αναζήτηση",
        clear: "Καθαρισμός",
        actions: "Ενέργειες",
        bulk: "Μαζικές Λειτουργίες",
        modify: "Τροποποίηση",
        product: "Προϊόν",
        clearSelection: "Καθαρισμός Επιλεγμένων",
        activate: "Ενεργοποίηση",
        suspend: "Παύση",
        resume: "Επαναφορά",
        terminate: "Τερματισμός",
        testMode: "Δοκιμαστική Λειτουργία",
        sendSms: "Αποστολή SMS",
        watchdogs: "Watchdogs",
        createWatchdog: "Δημιουργία Watchdog",
        removeAllWatchdogs: "Κατάργηση Watchdogs",
        blockSuspension: "Μπλοκάρισμα Αναστολής",
        export: "Εξαγωγή",
        simInformation: "Πληροφορίες SIM",
        usage: "Χρήση",
        ipAddress: "Διεύθυνση IP",
        imei: "IMEI",
        status: "Κατάσταση",
        visitProfile: "Επίσκεψη Προφίλ",
        provider: "Πάροχος",
        area: "Περιοχή",
        cell: "Κελί",
        longitude: "Γεωγραφικό Μήκος",
        latitude: "Γεωγραφικό Πλάτος",
        cellRange: "Εύρος Κελιού",
        unit: "Μονάδα",
        sort: "Ταξινόμηση",
        simType: "Τύπος SIM",
        suspendModal: {
          title: "Παύση SIM",
          orderComplete: "Η παύση της SIM ολοκληρώθηκε",
          orderError: "Η παύση της SIM απέτυχε",
          contactAdmin:
            "Παρακαλούμε επικοινωνήστε με τον διαχειριστή του συστήματος",
          cancel: "Ακύρωση",
          submit: "Υποβολή",
          close: "Κλείσιμο",
        },
        resumeModal: {
          title: "Συνέχιση SIM",
          orderComplete: "Η συνέχιση της SIM ολοκληρώθηκε",
          orderError: "Η συνέχιση της SIM απέτυχε",
          contactAdmin:
            "Παρακαλούμε επικοινωνήστε με τον διαχειριστή του συστήματος",
          cancel: "Ακύρωση",
          submit: "Υποβολή",
          close: "Κλείσιμο",
        },
        activateModal: {
          title: "Ενεργοποίηση SIM",
          offer: "Πακέτο",
          selectOffer: "Επιλέξτε Πακέτο",
          success: "Η ενεργοποίηση της SIM ολοκληρώθηκε",
          orderError: "Η ενεργοποίηση της SIM απέτυχε",
          contactAdmin:
            "Παρακαλούμε επικοινωνήστε με τον διαχειριστή του συστήματος",
          cancel: "Ακύρωση",
          submit: "Υποβολή",
          close: "Κλείσιμο",
        },
        terminateModal: {
          title: "Τερματισμός SIM",
          targetState: "Επιθυμητή Κατάσταση",
          onStock: "On Stock",
          terminated: "Διαγραμμένο",
          success: "Ο τερματισμός της SIM ολοκληρώθηκε",
          orderError: "Ο τερματισμός της SIM απέτυχε",
          contactAdmin:
            "Παρακαλούμε επικοινωνήστε με τον διαχειριστή του συστήματος",
          cancel: "Ακύρωση",
          submit: "Υποβολή",
          close: "Κλείσιμο",
        },
      },
      simProfile: {
        simProvisioning: "Διαχείριση κατάστασης SIM",
        simDetails: "Λεπτομέρειες SIM",
        actions: "Ενέργειες",
        hlr: "HLR",
        session: "Καταναλώσεις",
        smsUsage: "Χρήση SMS",
        updateLoc: "Ενημέρωση Τοποθεσίας",
        imeiLock: "Κλείδωμα IMEI",
        usage: "Χρήση",
        imei: "IMEI",
        status: "Κατάσταση",
        dataSession: "Ενεργό Session",
        map: "Χάρτης",
        provider: "Πάροχος",
        imsi: "IMSI",
        iccid: "ICCID",
        msisdn: "MSISDN",
        country: "Χώρα",
        operator: "Πάροχος",
        area: "Περιοχή",
        cell: "Κελί",
        longitude: "Γεωγραφικό Μήκος",
        latitude: "Γεωγραφικό Πλάτος",
        cellRange: "Εύρος Κελιού",
        activity: "Δραστηριότητα",
        selectPeriod: "Επιλέξτε Περίοδο",
        daily: "Ημερήσια",
        monthly: "Μηνιαία",
        yearly: "Ετήσια",
        dataVolume: "Όγκος Δεδομένων",
        dataSessions: "Sessions Δεδομένων",
        alerts: "Ειδοποιήσεις",
        zeroSessions: "Μηδενικά Sessions",
        watchdog: "Watchdog",
        type: "Τύπος",
        blockSuspension: "Θα ανασταλεί η κάρτα SIM",
        amount: "Ποσότητα",
        hlrModal: {
          title: "Προφίλ HLR",
          selectScope: "Επιλέξτε Κατηγορία",
          basicInfo: "Βασικές Πληροφορίες",
          locationInfo: "Πληροφορίες Τοποθεσίας",
          csBasicInfo: "Βασικές Πληροφορίες CS",
          gprsService2g3g: "Υπηρεσίες GPRS 2G/3G",
          telephonyService: "Υπηρεσίες Τηλεφωνίας",
          supplementaryService: "Επιπλέον Υπηρεσίες",
          epcService4G: "Υπηρεσίες EPC 4G",
        },
        sessionModal: {
          title: "Καταναλώσεις Δεδομένων SIM",
          openDate: "Ημερομηνία Έναρξης",
          closeDate: "Ημερομηνία Λήξης",
          consumption: "Κατανάλωση",
          roundedBytes: "Στρογγυλοποιημένα Bytes",
          operator: "Πάροχος",
          cell: "Κελί",
          imei: "IMEI",
          close: "Κλείσιμο",
        },
        orders: {
          title: "Αιτήματα",
          close: "Κλείσιμο",
        },
        smsUsageModal: {
          title: "Χρήση SMS",
          direction: "Κατεύθυνση",
          date: "Ημερομηνία",
          sender: "Αποστολέας",
          message: "Μήνυμα",
          status: "Κατάσταση",
          close: "Κλείσιμο",
        },
      },
      profile: {
        profileDetails: "Λεπτομέρειες Προφίλ",
        contactInformation: "Στοιχεία Επικοινωνίας",
        professionalInformation: "Επαγγελματικές Πληροφορίες",
        activities: "Δραστηριότητες",
        loadMore: "Περισσότερα",
      },
      billingProducts: {
        title: "Τιμολογιακά Προϊόντα",
        name: "Όνομα",
        pricePlan: "Πακέτο Τιμολόγησης",
        price: "Τιμή",
        number: "Πλήθος",
      },
      invoices: {
        title: "Τιμολόγια",
        invoiceNo: "Αριθμός Τιμολογίου",
        date: "Ημερομηνία",
        amount: "Ποσό(συμπ.ΦΠΑ)",
        description: "Περιγραφή",
        paid: "Πληρώθηκε",
        download: "Λήψη",
      },
      statements: {
        title: "Ενημερώσεις Λογαριασμού",
        cutDate: "Ημερομηνία Έκδοσης",
        description: "Περιγραφή",
        amount: "Ποσό(συμπ. ΦΠΑ)",
        balance: "Υπόλοιπο",
      },
      orders: {
        title: "Αιτήσεις",
        open: "Ανοιχτές",
        parked: "Σε Αναμονή",
        finished: "Ολοκληρωμένες",
        error: "Σφάλμα",
        noOrders: "Δεν υπάρχουν αιτήσεις",
        showAllOrders: "Εμφάνιση όλων των αιτήσεων",
        showLess: "Εμφάνιση λιγότερων",
      },
      emails: {
        filters: "Φίλτρα",
        category: "Κατηγορία",
        name: "Όνομα",
        address: "Διεύθυνση",
        actions: "Ενέργειες",
        newEmail: "Νέο Email",
        edit: "Επεξεργασία",
        delete: "Διαγραφή",
        cancel: "Ακύρωση",
        submit: "Υποβολή",
        selectCategory: "Επιλέξτε Κατηγορία",
        invoice: "Τιμολόγιο",
        watchdog: "Watchdog",
        updateEmail: "Επεξεργασία Email",
      },
      reports: {
        title: "Αναφορές",
        reportType: "Τύπος Αναφοράς",
        usage: "Χρήση",
        groupBy: "Ομαδοποίηση κατά",
        field: "Πεδίο",
        usageType: "Τύπος Χρήσης",
        selectUsageType: "Επιλέξτε τύπο χρήσης",
        data: "Δεδομένα",
        sms: "SMS",
        all: "Όλα",
        imsi: "IMSI",
        network: "Δίκτυο",
        customer: "Πελάτης",
        period: "Περίοδος",
        day: "Ημέρα",
        month: "Μήνας",
        year: "Έτος",
        period: "Περίοδος",
        today: "Σήμερα",
        thisWeek: "Αυτή την εβδομάδα",
        thisMonth: "Αυτό το μήνα",
        thisYear: "Αυτό το έτος",
        lastMonth: "Τελευταίος μήνας",
        lastYear: "Προηγούμενο έτος",
        customer: "Πελάτης",
        select: "Επιλέξτε",
        simSearchCriteria: "Κριτήρια Αναζήτησης SIM",
        all: "Όλα",
        bySpecificImsi: "Ανά συγκεκριμένο IMSI",
        byImsiRange: "Ανά εύρος IMSI",
        byIccid: "Ανά ICCID",
        imsi: "IMSI",
        startImsi: "Αρχή IMSI",
        endImsi: "Τέλος IMSI",
        iccid: "ICCID",
        eid: "EID",
        view: "Προβολή",
        customerId: "ID Πελάτη",
        date: "Ημερομηνία",
        startDate: "Από",
        simType: "Τύπος SIM",
        networkCode: "Κωδικός Δικτύου",
        networkName: "Όνομα Δικτύου",
        country: "Χώρα",
        totalBytes: "Συνολικά Bytes",
        roundedBytes: "Στρογγυλοποιημένα Bytes",
        sessions: "Sessions",
        zeroSessions: "Μηδενικά Sessions",
        actions: "Ενέργειες",
        export: "Εξαγωγή",
        description: "Περιγραφή",
        quantity: "Ποσότητα",
        unitPrice: "Τιμή Μονάδας",
        tax: "ΦΠΑ",
        costWithoutTax: "Τιμή προ φόρου",
        costWithTax: "Τιμή μετά φόρου",
        currency: "Νόμισμα",
        offerName: "Προσφορά",
        id: "ID",
        name: "Όνομα",
        status: "Κατάσταση",
        creator: "Δημιουργός",
        creationDate: "Ημερομηνία Δημιουργίας",
        offer: "Πακέτο",
        activations: "Ενεργοποιήσεις",
        terminations: "Τερματισμοί",
        automated: {
          title: "Αυτοματοποιημένες Αναφορές",
          name: "Όνομα",
          type: "Τύπος",
          frequency: "Συχνότητα",
          nextReport: "Επόμενη Αναφορά",
          new: "Νέα Αυτοματοποιημένη Αναφορά",
          save: "Αποθήκευση",
          daily: "Ημερήσια",
          weekly: "Εβδομαδιαία",
          monthly: "Μηνιαία",
          edit: "Επεξεργασία",
          delete: "Διαγραφή",
          actions: "Ενέργειες",
        },
        history: {
          title: "Ιστορικό Αναφορών",
          tableHeaders: {
            reportName: "Όνομα Αναφοράς",
            date: "Ημερομηνία",
            status: "Κατάσταση",
            download: "Λήψη",
            actions: "Ενέργειες",
          },
          delete: "Διαγραφή",
          completed: "Ολοκληρώθηκε",
          incomplete: "Μη Ολοκληρωμένη",
        },
      },
      timeoutReports: {
        view: "Προβολή",
        delete: "Διαγραφή",
      },

      alerts: {
        title: "Ειδοποιήσεις",
        filters: "Φίλτρα",
        alert: "Ειδοποίηση",
        date: "Ημερομηνία",
        imsi: "IMSI",
        enterValue: "Εισάγετε τιμή",
      },
      settings: {
        title: "Ρυθμίσεις",
        profileSettings: "Ρυθμίσεις Προφίλ",
        general: "Γενικά",
        account: "Λογαριασμός",
        profileImage: "Εικόνα Προφίλ",
        whitelabel: "Whitelabel",
        privacyAndSafety: "Απορρήτου και Ασφάλεια",
        notifications: "Ειδοποιήσεις",
        billing: "Τιμολόγηση",
        invoice: "Τιμολόγιο",
        importSim: "Εισαγωγή SIM",
        mailConfig: "Ρυθμίσεις Mail Server",
        generalSettings: {
          title: "Γενικές Ρυθμίσεις",
          timeZone: "Ζώνη Ώρας",
          dateFormat: "Μορφή Ημερομηνίας",
          timeFormat: "Μορφή Ώρας",
          save: "Αποθήκευση",
        },
        accountSettings: {
          title: "Ρυθμίσεις Λογαριασμού",
          fullName: "Ονοματεπώνυμο",
          address: "Διεύθυνση",
          city: "Πόλη",
          country: "Χώρα",
          postcode: "Ταχυδρομικός Κώδικας",
          telephone: "Τηλέφωνο",
          mobileNumber: "Κινητό",
          email: "Email",
          occupation: "Επάγγελμα",
          company: "Εταιρεία",
          tin: "ΑΦΜ",
          username: "Όνομα Χρήστη",
          changePassword: "Αλλαγή Κωδικού",
          password: "Κωδικός",
          confirmPassword: "Επιβεβαίωση Κωδικού",
          save: "Αποθήκευση",
        },
        profileImageSettings: {
          title: "Ρυθμίσεις Εικόνας Προφίλ",
          upload: "Ανέβασμα",
          save: "Αποθήκευση",
        },
        whitelabelSettings: {
          title: "Ρυθμίσεις Whitelabel",
          backgroundColor: "Χρώμα Φόντου",
          fontColor: "Χρώμα Γραμματοσειράς",
          accentColor: "Χρώμα Έμφασης",
          sidebarPosition: "Θέση Sidebar",
          favicon: "Favicon",
          whitelabelImage: "Εικόνα Whitelabel",
          upload: "Ανέβασμα",
          save: "Αποθήκευση",
        },
        privacySettings: {
          title: "Ρυθμίσεις Απορρήτου",
          enable2FA: "Ενεργοποίηση 2FA",
          save: "Αποθήκευση",
        },
        notificationSettings: {
          title: "Ρυθμίσεις Ειδοποιήσεων",
          receiveNotifications: "Λήψη Ειδοποιήσεων",
          sms: "SMS",
          email: "Email",
          weeklyAnalytics: "Λήψη Εβδομαδιαίων Αναλυτικών",
          checkIfYouWantToReceiveWeeklyAnalytics:
            "Ελέγξτε αν θέλετε να λαμβάνετε εβδομαδιαίες αναλυτικές",
          notifyAboutNewAlerts: "Λήψη ειδοποιήσεων κατανάλωσης",
          checkIfYouWantToReceiveNotificationsWhenThereAreNewAlerts:
            "Επιλέξτε αν επιθυμείτε να ειδοποιείστε όταν ξεπεραστούν τα όρια κατανάλωσης",
          submit: "Υποβολή",
        },
        billingSettings: {
          title: "Ρυθμίσεις Τιμολόγησης",
          selectCurrency: "Επιλέξτε Νόμισμα",
          currency: "Νόμισμα",
          preferredLanguage: "Προτιμώμενη Γλώσσα",
          selectLanguage: "Επιλέξτε Γλώσσα",
          submit: "Υποβολή",
        },
        invoiceSettings: {
          title: "Ρυθμίσεις Τιμολογίου",
          name: "Όνομα",
          showGuis: "Εμφάνιση GUIs",
          showSubtotal: "Εμφάνιση Μερικού Συνόλου",
          showLineOfService: "Εμφάνιση Line of Service",
          save: "Αποθήκευση",
        },
        importSimSettings: {
          title: "Χειροκίνητη Εισαγωγή Κάρτας SIM",
          provider: "Πάροχος",
          selectProvider: "Επιλέξτε Πάροχο",
          submit: "Υποβολή",
          inputType: "Τύπος Εισαγωγής",
          selectInputType: "Επιλέξτε Τύπο Εισαγωγής",
          single: "Μονή Εισαγωγή",
          file: "Εισαγωγή με Αρχείο",
        },
        mailConfig: {
          title: "Ρυθμίσεις Mail Server",
          host: "Διεύθυνση SMTP (Host)",
          port: "Θύρα SMTP (Port)",
          fromAddress: "Διεύθυνση Αποστολέα",
          username: "Όνομα Χρήστη",
          changePassword: "Αλλαγή Κωδικού",
          password: "Κωδικός",
          confirmPassword: "Επιβεβαίωση Κωδικού",
          useTLS: "Χρήση TLS",
          save: "Αποθήκευση Ρυθμίσεων",
          success: "Η ρύθμιση του Mail Server αποθηκεύτηκε επιτυχώς",
          error: "Αποτυχία αποθήκευσης των ρυθμίσεων Mail Server",
          healthStatus: "Κατάσταση Υγείας",
          healthUp: "Λειτουργεί (UP)",
          healthDown: "Μη Λειτουργεί (DOWN)",
          healthUnknown: "Άγνωστο",
          lastCheckedAt: "Τελευταίος Έλεγχος",
        },
        purchaseOrderConfig: {
          title: "Ρυθμίσεις παραγγελιών",
          sellerName: "Όνομα Πωλητή",
          host: "Διεύθυνση SMTP (Host)",
          port: "Θύρα SMTP (Port)",
          fromAddress: "Διεύθυνση Αποστολέα",
          username: "Όνομα Χρήστη",
          changePassword: "Αλλαγή Κωδικού",
          password: "Κωδικός",
          confirmPassword: "Επιβεβαίωση Κωδικού",
          useTLS: "Χρήση TLS",
          save: "Αποθήκευση Ρυθμίσεων",
          success: "Η ρύθμιση του Mail Server αποθηκεύτηκε επιτυχώς",
          error: "Αποτυχία αποθήκευσης των ρυθμίσεων Mail Server",
          healthStatus: "Κατάσταση Υγείας",
          healthUp: "Λειτουργεί (UP)",
          healthDown: "Μη Λειτουργεί (DOWN)",
          healthUnknown: "Άγνωστο",
          lastCheckedAt: "Τελευταίος Έλεγχος",
        },
        platformConfig: {
          title: "Ρυθμίσεις πλατφόρμας",
          dataStreamingEnabled: "Ενεργοποίηση ροής δεδομένων",
          maintenanceMode: "Λειτουργία Συντήρησης",
          maintenanceMessage: "Μήνυμα Συντήρησης",
          maintenanceMessagePlaceholder:
            "Εισάγετε το μήνυμα που θα εμφανίζεται στους χρήστες κατά τη διάρκεια της συντήρησης",
          save: "Αποθήκευση Ρυθμίσεων",
          reset: "Επαναφορά Ρυθμίσεων",
        },
        crmConfig: {
          title: "Ρυθμίσεις CRM",
          type: "Τύπος CRM",
          selectType: "Επιλέξτε Τύπο CRM",
          selectAuthType: "Επιλέξτε τύπο authentication",
          authType: "Τύπος Authentication",
          username: "Όνομα Χρήστη",
          changePassword: "Αλλαγή Κωδικού;",
          changeToken: "Αλλαγή Token;",
          password: "Κωδικός Πρόσβασης",
          confirmPassword: "Επιβεβαίωση Κωδικού Πρόσβασης",
          token: "Token",
        },
      },
      privileges: {
        title: "Προνόμια",
        name: "Όνομα",
        actions: "Ενέργειες",
        newPrivilege: "Νέο Προνόμιο",
        edit: "Επεξεργασία",
        delete: "Διαγραφή",
      },
      table: {
        page: "Σελίδα",
        of: "από",
        show: "Προβολή",
        goToPage: "Μετάβαση στη σελίδα",
      },
      notifications: {
        title: "Ειδοποιήσεις",
        id: "ID",
        date: "Ημερομηνία",
        message: "Μήνυμα",
        type: "Τύπος",
      },
      whitelist: {
        title: "Επιτρεπόμενη διεύθυνση IP",
        ip: "Διεύθυνση IP",
        active: "Ενεργή",
        createdAt: "Ημερομηνία Προσθήκης",
        updatedAt: "Τελευταία Ενημέρωση",
        lastUsed: "Τελευταία Χρήση",
        new: "Νέα Διεύθυνση IP",
      },
      customFields: {
        title: "Προσαρμοσμένα Πεδία",
        new: "Νέο Προσαρμοσμένο Πεδίο",
        name: "Όνομα",
        type: "Τύπος",
        createdAt: "Ημερομηνία Δημιουργίας",
        updatedAt: "Ημερομηνία Ενημέρωσης",
        edit: "Επεξεργασία",
        delete: "Διαγραφή",
        submit: "Υποβολή",
        cancel: "Ακύρωση",
        actions: "Ενέργειες",
        selectType: "Επιλέξτε τύπο",
        text: "Κείμενο",
        number: "Αριθμός",
      },
      documentation: {
        introduction: {
          welcomeTitle: "Καλώς ήρθατε στην {{brand}}",
          welcomeText:
            "Η {{brand}} είναι η ολοκληρωμένη πλατφόρμα σας για εύκολη διαχείριση SIM καρτών. Παρακολουθήστε τη χρήση, ενεργοποιήστε νέες γραμμές και κρατήστε τις λειτουργίες σας σε τάξη—όλα από ένα μόνο πίνακα ελέγχου.",
          getStarted: "Ξεκινήστε",
        },
        dashboard: {
          title: "Επισκόπηση Dashboard",
          description:
            "Το Dashboard αποτελεί την κεντρική οθόνη παρακολούθησης και ανάλυσης της δραστηριότητας των SIM καρτών μέσω της πλατφόρμας {{brand}}. Παρέχει συνοπτικές αλλά και αναλυτικές πληροφορίες για κατανάλωση δεδομένων, αριθμό συνδέσεων, ειδοποιήσεις, καθώς και για τη γεωγραφική και χρονική κατανομή της χρήσης.",
          goal: "Στόχος του Dashboard είναι να προσφέρει στον χρήστη ένα άμεσο εργαλείο εποπτείας, το οποίο διευκολύνει την κατανόηση της τρέχουσας κατάστασης και την έγκαιρη λήψη αποφάσεων.",
          cards: {
            title: "Κάρτες Στατιστικών (πάνω μέρος οθόνης)",
            dataVolume: {
              title: "Όγκος Δεδομένων",
              description:
                "Δείχνει τον συνολικό όγκο δεδομένων που έχουν καταναλωθεί σήμερα, μαζί με τη σύγκριση με την προηγούμενη ημέρα.",
            },
            dataSessions: {
              title: "Συνδέσεις Δεδομένων",
              description:
                "Απεικονίζει τον αριθμό των συνδέσεων που πραγματοποιήθηκαν σήμερα, σε σύγκριση με την προηγούμενη ημέρα.",
            },
            alerts: {
              title: "Ειδοποιήσεις Κατανάλωσης",
              description:
                "Εμφανίζει τον αριθμό ειδοποιήσεων για υπερβάσεις κατανάλωσης που δημιουργήθηκαν σήμερα.",
            },
            zeroSessions: {
              title: "Συνδέσεις Μηδενικής Κατανάλωσης",
              description:
                "Δείχνει πόσες συνδέσεις δεδομένων σημείωσαν μηδενική κατανάλωση την επιλεγμένη χρονική περίοδο",
            },
          },
          charts: {
            title: "Αναλυτικά Γραφήματα και Χάρτες",
            dataSessionsMap: {
              title: "Γεωγραφική Κατανομή Συνδέσεων Δεδομένων",
              description:
                "Ο χάρτης παρουσιάζει γεωγραφικά τις χώρες με τις περισσότερες συνδέσεις. Από το μενού στην επάνω δεξιά γωνία της κάρτας, μπορείτε να επιλέξετε την πληροφορία που θα απεικονιστεί: Data Sessions, Data Volume ή Zero Sessions.",
            },
            avgDataAndActiveSims: {
              title: "Μέση κατανάλωση και ενεργές κάρτες SIM",
              description:
                "Προσφέρει τον μέσο όρο κατανάλωσης δεδομένων ανά σύνδεση και τον συνολικό αριθμό ενεργών SIM.",
            },
            dataVolumePerHour: {
              title: "Ωριαία κατανομή κατανάλωσης δεδομένων",
              description:
                "Το γράφημα παρουσιάζει την κατανάλωση δεδομένων ανά τρίωρη περίοδο και ανά ημέρα της εβδομάδας για τον τρέχοντα μήνα, προσφέροντας μια πιο ολοκληρωμένη εικόνα των χρονικών διαστημάτων με τη μεγαλύτερη δραστηριότητα των SIM καρτών σας.",
            },
            monthlyDataVolume: {
              title: "Μηνιαία κατανομή κατανάλωσης δεδομένων",
              description:
                "Το γράφημα παρουσιάζει τη μηνιαία κατανομή της κατανάλωσης δεδομένων για τους τελευταίους 12 μήνες. Από το μενού στην επάνω δεξιά γωνία της κάρτας, μπορείτε να επιλέξετε την πληροφορία που θέλετε να απεικονιστεί: Data Sessions, Data Volume ή Zero Sessions.",
            },
            topMetrics: {
              title: "Κορυφαίες μετρικές",
              description:
                "Το γράφημα αναδεικνύει τις SIM κάρτες με τον μεγαλύτερο αριθμό συνδέσεων για την επιλεγμένη περίοδο. Σας επιτρέπει να εντοπίζετε γρήγορα τις πιο ενεργές SIM στο δίκτυό σας, να αναλύετε τα πρότυπα χρήσης, να εντοπίζετε χρήστες με αυξημένη δραστηριότητα και να βελτιστοποιείτε την κατανομή των πόρων σας.",
            },
            dataVolumePerNetwork: {
              title:
                "Κατανομή Κατανάλωσης Δεδομένων ανά Δίκτυο - Ενεργές Κάρτες ανά Δίκτυο",
              description:
                "Τα γραφήματα αυτά προσφέρουν μια συγκριτική εικόνα της δραστηριότητας των δικτύων στη χώρα που έχετε επιλέξει. Το πρώτο γράφημα παρουσιάζει την κατανομή της συνολικής κατανάλωσης δεδομένων ανά δίκτυο κινητής τηλεφωνίας, βοηθώντας σας να αξιολογήσετε το φορτίο, να εντοπίσετε συγκεντρώσεις χρήσης και να συγκρίνετε την απόδοση των παρόχων. Το δεύτερο γράφημα δείχνει την κατανομή των ενεργών SIM καρτών ανά δίκτυο, προσφέροντας πληροφορίες για την κάλυψη και το μερίδιο αγοράς των παρόχων. Μαζί, παρέχουν μια ολοκληρωμένη κατανόηση του πώς οι SIM κάρτες σας αλληλεπιδρούν με τα διάφορα δίκτυα και αναδεικνύουν τα πρότυπα συνδεσιμότητας και χρήσης.",
            },
            simCardsPerOffer: {
              title: "Κατανομή Καρτών SIM ανά Πακέτο και Κατάσταση",
              description:
                "Τα γραφήματα αυτά προσφέρουν μια συνολική εικόνα του χαρτοφυλακίου SIM σας. Το πρώτο δείχνει την κατανομή ανά πακέτο συνδρομής και πρόγραμμα δεδομένων, βοηθώντας σας να εντοπίσετε τις προτιμήσεις και τις πιο δημοφιλείς υπηρεσίες. Το δεύτερο παρουσιάζει την κατανομή ανά κατάσταση, δίνοντάς σας ορατότητα στα στάδια κύκλου ζωής και στη διαθεσιμότητα. Μαζί, σας βοηθούν να παρακολουθείτε τις τάσεις χρήσης, τα αποθέματα και τη συνολική αποτελεσματικότητα διαχείρισης SIM.",
            },
            alerts: {
              title: "Ειδοποιήσεις Κατανάλωσης",
              description:
                "Ο πίνακας αυτός εμφανίζει τις ειδοποιήσεις κατανάλωσης που δημιουργούνται από τον μηχανισμό παρακολούθησης WatchDog. Ο WatchDog παρακολουθεί συνεχώς τη χρήση δεδομένων των SIM και ενεργοποιεί ειδοποιήσεις όταν επιτυγχάνονται προκαθορισμένα όρια.",
              types: {
                warning:
                  "Warning: ενεργοποιείται όταν η κατανάλωση φτάσει στο 80% του διαθέσιμου όγκου.",
                depleted:
                  "Depleted: ενεργοποιείται όταν η κατανάλωση φτάσει στο 100% του διαθέσιμου όγκου.",
              },
              note: "Οι ειδοποιήσεις αυτές σας βοηθούν να λάβετε έγκαιρα μέτρα ώστε να αποφευχθούν διακοπές υπηρεσιών ή απρόσμενες χρεώσεις. Αναλυτική παρουσίαση του WatchDog και της λειτουργίας του δίνεται στο σχετικό κεφάλαιο της τεκμηρίωσης.",
            },
          },
          utility: {
            title: "Χρησιμότητα Dashboard",
            description:
              "Με την ενιαία παρουσίαση κρίσιμων μεγεθών, τάσεων και ειδοποιήσεων, το Dashboard διευκολύνει την άμεση αναγνώριση προβλημάτων, την κατανόηση της συμπεριφοράς των SIM, τη διαχείριση κόστους και πόρων και την τεκμηριωμένη λήψη αποφάσεων.",
          },
        },
        simCards: {
          introduction: {
            title: "Εισαγωγή στις Κάρτες SIM",
            description:
              "Αυτό το κεφάλαιο παρέχει όλες τις απαραίτητες πληροφορίες για τις κάρτες SIM μέσα στην πλατφόρμα {{brand}}.",
            details:
              "Θα μάθετε πώς οι κάρτες SIM διαχειρίζονται, παρακολουθούνται και αναλύονται, με έμφαση στην κατανάλωση δεδομένων, τη συνδεσιμότητα, τις ειδοποιήσεις και τα στάδια του κύκλου ζωής.",
            getStarted: "Ξεκινήστε",
          },
          lifecycle: {
            title: "Κύκλος Ζωής SIM",
            intro:
              "Οι κάρτες SIM στην πλατφόρμα περνούν από διαφορετικά στάδια κύκλου ζωής. Κάθε στάδιο αναπαρίσταται με έναν κύκλο με χρωματική κωδικοποίηση και έχει συγκεκριμένες επιτρεπόμενες μεταβάσεις.",
            status: {
              productive: "Ενεργή και σε χρήση.",
              suspended: "Ανεστάλη χειροκίνητα.",
              autoSuspended: "Ανεστάλη αυτόματα.",
              onstock: "Διαθέσιμη αλλά μη ενεργή.",
              deleted: "Διαγραμμένη και ανενεργή.",
            },
            diagramDescription:
              "Αυτό το διάγραμμα δείχνει τα στάδια κύκλου ζωής των SIM και τις πιθανές μεταβάσεις μεταξύ τους. Οι μεταβάσεις μπορεί να ενεργοποιηθούν χειροκίνητα (π.χ. ενεργοποίηση SIM από το OnStock στο Productive) ή αυτόματα (π.χ. μέσω διεργασίας που αναστέλλει αυτόματα μια SIM όταν φτάσει σε όρια κατανάλωσης). Οι μεταβάσεις αυτές διασφαλίζουν τον σωστό έλεγχο της δραστηριότητας, της διαθεσιμότητας και της απενεργοποίησης των SIM στην πλατφόρμα.",
          },
          panel: {
            title: "Πίνακας SIMs",
            intro:
              "Ο πίνακας SIMs παρέχει μια επισκόπηση όλων των καρτών SIM στην πλατφόρμα. Σας επιτρέπει να παρακολουθείτε τη δραστηριότητα, να αναλύετε την κατανάλωση δεδομένων και να διαχειρίζεστε τα στάδια κύκλου ζωής αποτελεσματικά.",
            summary: {
              title: "Κάρτες Επισκόπησης & Φίλτρα",
              intro:
                "Στην κορυφή του πίνακα, τρεις κάρτες παρουσιάζουν μια γρήγορη επισκόπηση της χρήσης SIM για τον τρέχοντα μήνα:",
              dataVolume: "Όγκος Δεδομένων – συνολικά καταναλωμένα δεδομένα.",
              dataSessions: "Συνεδρίες Δεδομένων – αριθμός συνδέσεων.",
              zeroSessions: "Μηδενικές Συνεδρίες – συνεδρίες χωρίς δεδομένα.",
              filters:
                "Τα φίλτρα επιτρέπουν τον περιορισμό των SIMs ανά IMSI, ICCID, MSISDN, κατάσταση SIM, προσφορά, τύπο SIM ή όγκο δεδομένων. Η ταξινόμηση μπορεί να εφαρμοστεί σε πολλά πεδία, όπως IMSI ή χρήση.",
            },
            table: {
              title: "Πίνακας SIM",
              intro:
                "Ο κύριος πίνακας εμφανίζει όλες τις κάρτες SIM με τις βασικές λεπτομέρειες:",
              activeSession:
                "Ενεργή Συνεδρία – δείκτης ζωντανής δραστηριότητας.",
              identifiers: "Αναγνωριστικά – IMSI, ICCID, MSISDN.",
              state:
                "Κατάσταση SIM – στάδιο κύκλου ζωής (π.χ. Ενεργή, Σε Αναστολή).",
              offer: "Προσφορά – πρόγραμμα συνδρομής (αν ισχύει).",
              data: "Δεδομένα – όγκος χρήσης για τον μήνα.",
              type: "Τύπος SIM – τύπος προϊόντος (π.χ. ενσωματωμένη, βιομηχανική).",
              footer:
                "Η σελιδοποίηση και οι μαζικές λειτουργίες υποστηρίζονται επίσης για αποτελεσματική διαχείριση SIM.",
            },
          },
          simProvisioning: {
            introduction: {
              title: "Διαχείριση SIM (Provisioning)",
              description:
                "Η Διαχείριση SIM (Provisioning) αναφέρεται στο σύνολο των λειτουργιών που επιτρέπουν στους διαχειριστές να ελέγχουν τον κύκλο ζωής των καρτών SIM στην πλατφόρμα. Μέσω του provisioning, μπορείτε:",
              closing:
                "Οι ενέργειες αυτές εξασφαλίζουν ότι οι SIM κάρτες ενεργοποιούνται, ελέγχονται και απενεργοποιούνται σωστά, υποστηρίζοντας την ευελιξία και την ασφάλεια των λειτουργιών.",
            },
            actions: {
              activate: {
                title: "Ενεργοποίηση",
                description: "θέτει μια SIM σε παραγωγική χρήση.",
                details: {
                  intro:
                    "Για να ενεργοποιήσετε μία ή περισσότερες SIM κάρτες υπάρχουν τρεις τρόποι:",
                  steps: [
                    "Επιλέγοντας τις SIM κάρτες από τον πίνακα, τσεκάροντας τα checkboxes και από το μενού Bulk Operations πάνω δεξιά, επιλέγετε το μενού Ενεργοποίηση.",
                    "Κάνοντας κλικ απευθείας στο ίδιο μενού και χρησιμοποιώντας ένα αρχείο Excel που περιέχει τους αριθμούς IMSI/ICCID στη στήλη A με τον αντίστοιχο τίτλο (IMSI/ICCID) στο κελί A1.",
                    "Κάνοντας κλικ στη γραμμή, εμφανίζεται μια πλευρική κάρτα με το προφίλ της SIM, στην κορυφή της οποίας θα υπάρχει το κουμπί Ενεργοποίηση.",
                  ],
                  important:
                    "Σημαντικό! Όλες οι επιλεγμένες SIM κάρτες πρέπει να βρίσκονται σε κατάσταση OnStock για να ενεργοποιηθούν.",
                  closing:
                    "Ακολουθώντας τα παραπάνω βήματα, θα εμφανιστεί ένα παράθυρο επιβεβαίωσης 2 βημάτων όπου ο χρήστης πρέπει να επιλέξει την Προσφορά υπό την οποία θέλει να ενεργοποιήσει τις SIM κάρτες. Προαιρετικά, μπορεί να ορίσει κάποιες τιμές custom fields. Στο δεύτερο βήμα, ο χρήστης ελέγχει τις επιλεγμένες SIM και προχωρά στην ενεργοποίηση.",
                },
              },
              suspend: {
                title: "Αναστολή",
                description: "απενεργοποιεί προσωρινά τη συνδεσιμότητα.",
                details: {
                  intro:
                    "Παρόμοια με την ενεργοποίηση, για να ανασταλεί μία ή περισσότερες SIM κάρτες ο χρήστης έχει τις ίδιες επιλογές:",
                  steps: [
                    "Επιλέγοντας τις SIM από τον πίνακα και από το μενού Bulk Operations πάνω δεξιά, επιλέγει Αναστολή.",
                    "Χρησιμοποιώντας ένα αρχείο Excel με IMSI/ICCID στη στήλη A και τίτλο (IMSI/ICCID) στο κελί A1.",
                    "Κάνοντας κλικ στη γραμμή, εμφανίζεται κάρτα προφίλ με κουμπί Αναστολή.",
                  ],
                  important:
                    "Σημαντικό! Όλες οι SIM πρέπει να είναι σε κατάσταση Productive για να ανασταλούν.",
                  closing:
                    "Ακολουθώντας τα παραπάνω βήματα, εμφανίζεται ένα παράθυρο επιβεβαίωσης όπου ο χρήστης ελέγχει τις SIM και προχωρά στην αναστολή.",
                },
              },
              resume: {
                title: "Επαναφορά",
                description: "επαναφέρει μια κάρτα SIM από αναστολή.",
                details: {
                  intro:
                    "Ομοίως, για να επαναφέρει κανείς μία ή περισσότερες SIM κάρτες ο χρήστης έχει τις ίδιες επιλογές:",
                  steps: [
                    "Επιλέγοντας τις SIM και από το μενού Bulk Operations πάνω δεξιά, επιλέγει Επαναφορά.",
                    "Με αρχείο Excel IMSI/ICCID στη στήλη A με τίτλο (IMSI/ICCID) στο κελί A1.",
                    "Κάνοντας κλικ στη γραμμή, εμφανίζεται κάρτα προφίλ με κουμπί Επαναφορά.",
                  ],
                  important:
                    "Σημαντικό! Όλες οι SIM πρέπει να είναι σε κατάσταση Suspended ή AutoSuspended για να επανέλθουν.",
                  closing:
                    "Ακολουθώντας τα βήματα, εμφανίζεται ένα παράθυρο επιβεβαίωσης όπου ο χρήστης ελέγχει και προχωρά στην επαναφορά.",
                },
              },
              terminate: {
                title: "Τερματισμός",
                description:
                  "αποσύρει μια SIM από ενεργή χρήση (είτε σε OnStock είτε σε Deleted).",
                details: {
                  intro:
                    "Ομοίως, για να τερματίσει κανείς μία ή περισσότερες SIM κάρτες ο χρήστης έχει τις ίδιες επιλογές:",
                  steps: [
                    "Επιλέγοντας τις SIM και από το μενού Bulk Operations πάνω δεξιά, επιλέγει Τερματισμός.",
                    "Με αρχείο Excel IMSI/ICCID στη στήλη A με τίτλο (IMSI/ICCID) στο κελί A1.",
                    "Κάνοντας κλικ στη γραμμή, εμφανίζεται κάρτα προφίλ με κουμπί Τερματισμός.",
                  ],
                  important:
                    "Σημαντικό! Όλες οι SIM πρέπει να είναι σε κατάσταση Productive για να τερματιστούν.",
                  closing:
                    "Ακολουθώντας τα βήματα, εμφανίζεται παράθυρο επιβεβαίωσης όπου ο χρήστης επιλέγει την τελική κατάσταση (OnStock ή Μόνιμα Διαγεγραμμένη), ελέγχει και προχωρά.",
                },
              },
              modify: {
                title: "Τροποποίηση",
                description:
                  "τροποποιεί το πακέτο κάτω από το οποίο είναι ενεργοποιημένη και χρεώνεται η κάρτα",
                details: {
                  intro: "Για να τροποποιηθεί η προσφορά μιας SIM:",
                  steps: [
                    "Επιλέγοντας την SIM και από το μενού Actions πάνω δεξιά, επιλέγει Τροποποίηση.",
                  ],
                  important:
                    "Σημαντικό! Η SIM πρέπει να είναι σε κατάσταση Productive για να τροποποιηθεί.",
                  closing:
                    "Ακολουθώντας τα βήματα, εμφανίζεται παράθυρο επιβεβαίωσης όπου ο χρήστης επιλέγει την επιθυμητή Προσφορά, ελέγχει και προχωρά.",
                },
              },
            },
          },
          simProfile: {
            title: "Προφίλ SIM",
            description:
              "Το Προφίλ SIM είναι ένας πίνακας ελέγχου που επικεντρώνεται στα στατιστικά και στις λειτουργίες μιας συγκεκριμένης κάρτας SIM. Παρέχει στατιστικά παρόμοια με τον κύριο πίνακα ελέγχου και λεπτομερείς πληροφορίες για ανάλυση και διαχείριση.",
            items: {
              kpis: "KPIs και στατιστικά χρήσης",
              monthly: "Μηνιαία κατανομή χρήσης",
              hlr: "Προφίλ HLR (εάν ισχύει)",
              dataSessions: "Ιστορικό συνεδριών δεδομένων",
              smsUsage: "Ιστορικό χρήσης SMS",
              requests: "Αιτήματα που έγιναν για αυτήν την κάρτα SIM",
              provisioning: "Δραστηριότητα και λειτουργίες SIM Provisioning",
              cellInfo: "Πληροφορίες κελιού και συνδεσιμότητας",
              watchdogs: "Πληροφορίες watchdog και ειδοποιήσεις",
            },
            sections: {
              howToAccess: {
                title: "Πώς να αποκτήσετε πρόσβαση",
                description:
                  "Για να αποκτήσετε πρόσβαση στο προφίλ μιας συγκεκριμένης κάρτας SIM, επιλέξτε την SIM από τον πίνακα και κάντε κλικ πάνω της. Ένα πλαϊνό πάνελ θα εμφανιστεί με τις πληροφορίες της SIM. Μέσα σε αυτό το πάνελ υπάρχει ο σύνδεσμος 'Επίσκεψη Προφίλ' που σας ανακατευθύνει στη σελίδα Προφίλ SIM. Η σελίδα Προφίλ SIM παρέχει αναλυτικά στατιστικά, ιστορικό χρήσης, ενέργειες provisioning και τεχνικές πληροφορίες για την επιλεγμένη SIM.",
              },
              kpis: {
                title: "Δείκτες Απόδοσης (KPIs)",
                description:
                  "Η ενότητα KPI του Προφίλ SIM παρέχει μια γρήγορη επισκόπηση της απόδοσης και της δραστηριότητας της SIM. Οι δείκτες αυτοί βοηθούν τον χρήστη να κατανοήσει άμεσα τη χρήση και την κατάσταση της SIM.",
                bullets: [
                  "Όγκος Δεδομένων – το συνολικό ποσό δεδομένων που καταναλώθηκε από τη SIM για την επιλεγμένη περίοδο.",
                  "Συνεδρίες Δεδομένων – ο αριθμός των συνεδριών δεδομένων που δημιουργήθηκαν κατά την επιλεγμένη περίοδο.",
                  "Ειδοποιήσεις – ο αριθμός των ειδοποιήσεων που ενεργοποιήθηκαν για αυτή τη SIM (π.χ. όρια χρήσης).",
                  "Μηδενικές Συνεδρίες – ο αριθμός συνεδριών όπου η SIM προσπάθησε να συνδεθεί αλλά δεν κατανάλωσε δεδομένα.",
                ],
                closing:
                  "Ο χρήστης μπορεί να φιλτράρει τα KPIs ανά περίοδο (Ημερήσια, Μηνιαία ή Ετήσια) για να αναλύσει τα πρότυπα χρήσης με την πάροδο του χρόνου.",
              },
              monthly: {
                title: "Μηνιαία Κατανομή",
                description: "Κατανομή δεδομένων, SMS και συνεδριών ανά μήνα.",
              },
              hlr: {
                title: "Προφίλ HLR",
                description:
                  "Το προφίλ HLR (Home Location Register) παρέχει λεπτομερείς πληροφορίες συνδρομής και δικτύου για την κάρτα SIM. Κάνοντας κλικ στο κουμπί HLR από το μενού Ενέργειες, εμφανίζεται ένα παράθυρο με λεπτομέρειες όπως:",
                fields: {
                  msisdn: "MSISDN",
                  imsi: "IMSI",
                  networkAccessMode:
                    "Λειτουργία πρόσβασης δικτύου (π.χ., CS και PS)",
                  subscriberType: "Τύπος συνδρομητή (π.χ., συνδρομητής LTE)",
                  simStatus: "Κατάσταση SIM (π.χ., Διαθέσιμη)",
                },
                scopes:
                  "Επιπλέον, ο χρήστης μπορεί να επιλέξει από μια αναπτυσσόμενη λίστα διαθέσιμων πεδίων (π.χ., Βασικές Πληροφορίες, Εκτεταμένες Πληροφορίες) για να δει τις αντίστοιχες λεπτομέρειες ανάλογα με το βάθος πληροφόρησης που απαιτείται.",
                closing:
                  "Αυτή η λειτουργικότητα επιτρέπει στους διαχειριστές να επικυρώνουν γρήγορα τις λεπτομέρειες της παροχής SIM και να επιβεβαιώνουν ότι η SIM είναι σωστά καταχωρημένη και διαθέσιμη στο δίκτυο.",
              },

              dataSessions: {
                title: "Συνεδρίες Δεδομένων",
                description:
                  "Η λειτουργία Συνεδρίες Δεδομένων επιτρέπει στους διαχειριστές να δουν αναλυτικά αρχεία όλων των συνεδριών δεδομένων που σχετίζονται με μια κάρτα SIM. Κάνοντας κλικ στο κουμπί Συνεδρίες από το μενού Ενέργειες, εμφανίζεται ένα παράθυρο όπου παρουσιάζεται το ιστορικό συνεδριών και οι σχετικές πληροφορίες.",
                fields: {
                  openDate: "Η χρονική σήμανση έναρξης της συνεδρίας",
                  closeDate: "Η χρονική σήμανση λήξης της συνεδρίας",
                  consumption:
                    "Ο πραγματικός αριθμός bytes που καταναλώθηκαν κατά τη συνεδρία",
                  roundedBytes:
                    "Η χρήση στρογγυλοποιημένη βάσει των πολιτικών χρέωσης του παρόχου",
                  operator: "Ο πάροχος δικτύου που διαχειρίστηκε τη συνεδρία",
                  cell: "Το Cell ID στο οποίο πραγματοποιήθηκε η συνεδρία",
                  imei: "Το αναγνωριστικό συσκευής (IMEI) που χρησιμοποιήθηκε για τη συνεδρία",
                },
              },
              smsUsage: {
                title: "Χρήση SMS",
                description:
                  "Το παράθυρο Χρήσης SMS επιτρέπει στους διαχειριστές να παρακολουθούν όλα τα SMS που αποστέλλονται και λαμβάνονται από την κάρτα SIM. Πατώντας το κουμπί Χρήση SMS στο μενού Ενέργειες, εμφανίζεται ένας αναλυτικός πίνακας με κάθε συναλλαγή SMS.",
                fields: {
                  direction: "Κατεύθυνση (π.χ. Εισερχόμενο ή Εξερχόμενο)",
                  date: "Ημερομηνία και ώρα του συμβάντος SMS",
                  sender: "Ο αποστολέας του SMS",
                  message: "Το περιεχόμενο του SMS (αν είναι διαθέσιμο)",
                  status:
                    "Κατάσταση παράδοσης (π.χ. Υποβλήθηκε, Παραδόθηκε, Απέτυχε)",
                },
                note: "Αυτή η λειτουργία παρέχει πλήρη ιχνηλασιμότητα της κυκλοφορίας SMS για σκοπούς αντιμετώπισης προβλημάτων, κανονιστικής συμμόρφωσης ή ανάλυσης χρήσης.",
              },
              requests: {
                title: "Αιτήσεις",
                description:
                  "Η ενότητα Αιτήσεις παρέχει πλήρες ιστορικό όλων των εντολών provisioning που έγιναν για την επιλεγμένη κάρτα SIM. Πατώντας το κουμπί Αιτήσεις στο μενού Ενέργειες, εμφανίζεται ένα παράθυρο με όλες τις εντολές, όπως Ενεργοποίηση, Αναστολή, Επαναφορά και Τερματισμός.",
                fields: {
                  id: "ID: Ο μοναδικός αναγνωριστικός αριθμός της εντολής.",
                  name: "Όνομα: Ο τύπος της ενέργειας (π.χ. SuspendSIM, ResumeSIM, TerminateSIM).",
                  status:
                    "Κατάσταση: Η κατάσταση εκτέλεσης της εντολής (π.χ. Ολοκληρώθηκε, Σε εκκρεμότητα).",
                  creator: "Δημιουργός: Ο χρήστης που ξεκίνησε την αίτηση.",
                  creationDate:
                    "Ημερομηνία Δημιουργίας: Πότε δημιουργήθηκε η εντολή.",
                  lastUpdate:
                    "Τελευταία Ενημέρωση: Η πιο πρόσφατη χρονική σήμανση ενημέρωσης της κατάστασης.",
                },
                note: "Αυτή η λειτουργία επιτρέπει στους διαχειριστές να παρακολουθούν όλες τις ενέργειες provisioning που εκτελέστηκαν στην SIM, εξασφαλίζοντας διαφάνεια και υπευθυνότητα στη διαχείριση του κύκλου ζωής.",
              },
              provisioning: {
                title: "Δραστηριότητα Provisioning",
                description:
                  "Ενέργειες provisioning όπως ενεργοποίηση, αναστολή και τροποποιήσεις.",
              },
              cellInfo: {
                title: "Πληροφορίες Κυψέλης",
                description:
                  "Πληροφορίες κεραίας και δεδομένα σύνδεσης της SIM.",
              },
              watchdogs: {
                title: "Watchdogs",
                description:
                  "Η ενότητα Watchdogs στο προφίλ SIM εμφανίζει τυχόν ρυθμισμένα watchdogs που σχετίζονται με την κάρτα SIM. Τα watchdogs ορίζονται σε επίπεδο πλατφόρμας και συνδέονται με την SIM για την παρακολούθηση συγκεκριμένων συνθηκών.",
                bullets: [
                  "Δείτε τη λίστα με τα ενεργά watchdogs που σχετίζονται με την SIM.",
                  "Ελέγξτε τις ρυθμίσεις τους (π.χ. τύπος watchdog, κατάσταση και καθορισμένα όρια).",
                  "Παρακολουθήστε ποια watchdogs παρακολουθούν τη δραστηριότητα της SIM.",
                ],
                note: "Σημείωση: Η ρύθμιση ορίων, ειδοποιήσεων ή αυτόματων ενεργειών δεν είναι διαθέσιμη μέσω του προφίλ SIM. Η ενότητα είναι μόνο για ανάγνωση και χρησιμοποιείται αποκλειστικά για σκοπούς παρακολούθησης.",
              },
            },
          },
          simTransfers: {
            title: "Μεταφορές SIM",
            description:
              "Η λειτουργία μεταφοράς SIM επιτρέπει στους διαχειριστές να μετακινούν κάρτες SIM μεταξύ λογαριασμών ή οργανισμών. Είναι χρήσιμη για την ανακατανομή SIM, την αποστολή τους σε άλλον οργανισμό ή τη διαχείριση αλλαγών ιδιοκτησίας.",

            howToAccess: {
              title: "Πώς να αποκτήσετε πρόσβαση",
              description:
                "Για να αποκτήσετε πρόσβαση στις μεταφορές SIM, μεταβείτε στη διαχείριση χρηστών, ανοίξτε το μενού ενεργειών για έναν χρήστη και επιλέξτε την επιλογή 'Αποστολή SIMs'.",
            },

            steps: {
              title: "Βήματα για να εκτελέσετε μεταφορά SIM",
              description:
                "Η διαδικασία μεταφοράς περιλαμβάνει τα εξής βήματα:",
              bullets: [
                "Βεβαιωθείτε ότι οι κάρτες SIM βρίσκονται σε κατάσταση 'Σε Απόθεμα' πριν ξεκινήσετε τη μεταφορά. Μόνο οι διαθέσιμες SIM μπορούν να μεταφερθούν μεταξύ λογαριασμών.",
                "Επιλέξτε τύπο επιλογής SIM: Μοναδικό IMSI, Μοναδικό ICCID, Εύρος IMSI, Εύρος ICCID ή ανέβασμα αρχείου CSV/XLSX. Αυτό καθορίζει πώς θα επιλεγούν οι SIM που θα μεταφερθούν.",
                "Εισάγετε ή ανεβάστε τα απαιτούμενα αναγνωριστικά SIM ανάλογα με τον τύπο επιλογής.",
                "Προαιρετικά ορίστε τιμή και ποσοστό ΦΠΑ. Αυτά τα πεδία βοηθούν στην παρακολούθηση των οικονομικών επιπτώσεων της μεταφοράς.",
                "Επιλέξτε Προσφορά Χρέωσης. Αυτή είναι η προσφορά που θα χρεωθεί στον λογαριασμό προέλευσης όταν ο λογαριασμός προορισμού ενεργοποιήσει την μεταφερόμενη SIM.",
                "Κάντε κλικ στο 'Υποβολή' για να ολοκληρώσετε τη μεταφορά. Μόλις επιβεβαιωθεί, οι SIM θα εμφανιστούν στο απόθεμα του λογαριασμού προορισμού.",
              ],
            },
            deallocate: {
              title: "Αποδέσμευση SIMs",
              description:
                "Η αποδέσμευση είναι η αντίστροφη διαδικασία της μεταφοράς SIM. Επιτρέπει στους χρήστες να αφαιρούν κάρτες SIM από έναν λογαριασμό προορισμού και να τις επιστρέφουν στον αρχικό λογαριασμό ή στο απόθεμα. Είναι χρήσιμο όταν οι SIM αποδόθηκαν κατά λάθος, δεν χρειάζονται πλέον από τον λογαριασμό προορισμού ή πρέπει να επανακατανεμηθούν.",
              bullets: [
                "Μεταβείτε στην ενότητα Διαχείρισης Χρηστών, ανοίξτε το μενού Ενέργειες για έναν χρήστη και επιλέξτε 'Αποδέσμευση SIMs'.",
                "Βεβαιωθείτε ότι οι κάρτες SIM είναι σε κατάσταση 'Σε Απόθεμα' ή 'Δεσμευμένες' πριν προσπαθήσετε να τις αποδεσμεύσετε.",
                "Επιλέξτε τύπο επιλογής SIM: Single IMSI, Single ICCID, IMSI Range, ICCID Range ή μεταφόρτωση αρχείου CSV/XLSX.",
                "Εισαγάγετε ή ανεβάστε τους αναγνωριστικούς αριθμούς των SIMs που θα αποδεσμευτούν.",
                "Επιβεβαιώστε τους λογαριασμούς προέλευσης και προορισμού. Το πεδίο 'Από' δείχνει τον τρέχοντα λογαριασμό και το πεδίο 'Προς' δείχνει τον λογαριασμό ή το απόθεμα στο οποίο θα επιστραφούν οι SIMs.",
                "Κάντε κλικ στο 'Υποβολή' για να ολοκληρώσετε την αποδέσμευση. Μόλις επιβεβαιωθεί, οι SIMs δεν θα εμφανίζονται πλέον στο απόθεμα του λογαριασμού προορισμού και θα είναι διαθέσιμες για νέα κατανομή.",
              ],
            },
          },
        },
        watchdog: {
          title: "Watchdog",
          description:
            "Τα Watchdogs είναι κανόνες παρακολούθησης που βοηθούν τους χρήστες να ελέγχουν τη χρήση των καρτών SIM και να ανιχνεύουν μη φυσιολογική συμπεριφορά. Επιτρέπουν την προληπτική διαχείριση ορίζοντας όρια σε μετρήσεις όπως ο όγκος δεδομένων, οι συνεδρίες ή η χρήση SMS. Όταν ξεπεραστεί ένα όριο, το σύστημα μπορεί να δημιουργήσει ειδοποιήσεις ή να ενεργοποιήσει ενέργειες για την αποφυγή κατάχρησης ή απρόσμενου κόστους.",
          items: {
            add: "Πώς να προσθέσετε ένα Watchdog",
            remove: "Πώς να αφαιρέσετε ένα Watchdog",
            reset: "Πώς να επαναφέρετε ένα Watchdog",
            suspensionBlock:
              "Αποτροπή αναστολής SIM στην τρέχουσα περίοδο χρέωσης",
            alerts: "Ειδοποιήσεις που δημιουργούνται από τα Watchdogs",
          },
          add: {
            title: "Προσθήκη Watchdog",
            description:
              "Οι χρήστες μπορούν να δημιουργήσουν ένα νέο watchdog για να παρακολουθούν τη δραστηριότητα της SIM και να εκτελούν αυτόματες ενέργειες όταν η χρήση υπερβεί τα καθορισμένα όρια. Αυτό βοηθά στη διασφάλιση προληπτικής διαχείρισης και ελέγχου κόστους.",
            howToAccess:
              "Για να προσθέσετε ένα νέο watchdog, μεταβείτε στο SIM Panel → Μαζικές Ενέργειες → Watchdogs → Δημιουργία Watchdog. Σημαντικό: όλες οι κάρτες SIM πρέπει να βρίσκονται σε κατάσταση Productive (ενεργοποιημένες) για να ρυθμιστεί watchdog.",
            fields: {
              actionType:
                "Επιλέξτε την ενέργεια που θα εκτελεστεί όταν επιτευχθεί το όριο (π.χ. ειδοποίηση, αναστολή).",
              interval:
                "Επιλέξτε την περίοδο παρακολούθησης (ημερήσια, εβδομαδιαία, μηνιαία).",
              amount:
                "Εισάγετε το όριο χρήσης που θα ενεργοποιήσει την ενέργεια.",
              service:
                "Επιλέξτε την υπηρεσία που θα παρακολουθείται (π.χ. Δεδομένα, SMS).",
              unitType: "Επιλέξτε τη μονάδα μέτρησης (π.χ. Bytes, πλήθος SMS).",
              warnings:
                "Καθορίστε προειδοποιητικά όρια πριν την κύρια ενέργεια, ώστε οι χρήστες να ειδοποιούνται έγκαιρα.",
              suspendInterval:
                "Καθορίζει για πόσο διάστημα η SIM θα παραμείνει σε αναστολή όταν ενεργοποιηθεί το watchdog. Αν είναι ημερήσιο, η SIM θα επανενεργοποιηθεί τα μεσάνυχτα της επόμενης ημέρας. Αν είναι εβδομαδιαίο, θα επανενεργοποιηθεί τα μεσάνυχτα της επόμενης Δευτέρας. Αν είναι μηνιαίο, θα επανενεργοποιηθεί τα μεσάνυχτα της πρώτης ημέρας του επόμενου μήνα.",
            },
          },
          removeAll: {
            title: "Αφαίρεση Όλων των Watchdogs",
            description:
              "Οι χρήστες μπορούν να αφαιρέσουν όλα τα διαμορφωμένα watchdogs από μια κάρτα SIM με μία ενέργεια. Αυτό είναι χρήσιμο για γρήγορη επαναφορά παρακολούθησης χωρίς να απαιτείται διαγραφή κάθε watchdog ξεχωριστά.",
            howToAccess:
              "Για να αφαιρέσετε όλα τα watchdogs, πηγαίνετε στον πίνακα SIM → επιλέξτε ενεργές κάρτες SIM → Μαζικές Ενέργειες → Watchdogs → Αφαίρεση Όλων των Watchdogs.",
            details: {
              title: "Λεπτομέρειες",
              immediateEffect:
                "Με την εκτέλεση, όλες οι υπάρχουσες ρυθμίσεις watchdog στις επιλεγμένες SIM θα διαγραφούν.",
              noAlerts:
                "Δεν θα δημιουργούνται ειδοποιήσεις ή αυτόματες ενέργειες μετά την αφαίρεση.",
              cleanSlate:
                "Η κάρτα SIM θα συνεχίσει να λειτουργεί κανονικά, αλλά χωρίς παρακολούθηση μέχρι να δημιουργηθούν νέα watchdogs.",
            },
            useCases: {
              title: "Περιπτώσεις Χρήσης",
              policyChanges:
                "Όταν αλλάζουν οι πολιτικές παρακολούθησης, τα υπάρχοντα watchdogs μπορεί να χρειαστεί να καθαριστούν.",
              testing:
                "Σε περιβάλλοντα δοκιμών, πολλά watchdogs μπορούν να δημιουργηθούν και να αφαιρεθούν γρήγορα για καθαρισμό.",
              errorRecovery:
                "Αν έχουν ρυθμιστεί λάθος ή αντικρουόμενα watchdogs, η αφαίρεση τα επαναφέρει σε ουδέτερη κατάσταση.",
            },
            considerations: {
              title: "Σημεία Προσοχής",
              irreversible:
                "Η αφαίρεση όλων των watchdogs δεν αναιρείται· πρέπει να δημιουργηθούν ξανά εάν χρειαστούν.",
              criticalMonitoring:
                "Βεβαιωθείτε ότι οι SIM δεν μένουν χωρίς παρακολούθηση σε κρίσιμα περιβάλλοντα.",
              bulkOperations:
                "Σε μαζικές ενέργειες, επιβεβαιώστε προσεκτικά, καθώς επηρεάζονται όλες οι επιλεγμένες SIM.",
            },
          },
          reset: {
            title: "Επαναφορά Watchdog",
            description:
              "Η επαναφορά ενός watchdog μηδενίζει τον μετρητή κατανάλωσης και επανενεργοποιεί την αναστολή, εάν ο χρήστης είχε προηγουμένως επιλέξει να την μπλοκάρει για την τρέχουσα περίοδο χρέωσης. Αυτό επιτρέπει την επανεκκίνηση της παρακολούθησης χωρίς δημιουργία νέου watchdog.",
            howToAccess: {
              title: "Πρόσβαση",
              description:
                "Μεταβείτε στο προφίλ της κάρτας SIM. Στην ενότητα Watchdog, κάντε κλικ στο εικονίδιο με το κυκλικό βέλος δίπλα στο σχετικό watchdog για να το επαναφέρετε.",
            },
          },
          blockSuspension: {
            title: "Μπλοκάρισμα Αναστολής",
            description:
              "Το Μπλοκάρισμα Αναστολής αποτρέπει την αναστολή μιας κάρτας SIM όταν ένα watchdog που παρακολουθεί την κατανάλωση της ενεργοποιήσει ειδοποίηση κατανάλωσης 100% (Depleted Alert). Αυτή η λειτουργία ισχύει μόνο για την τρέχουσα περίοδο χρέωσης. Με την έναρξη της επόμενης περιόδου χρέωσης, η αναστολή επανέρχεται αυτόματα.",
            howToAccess: {
              title: "Πώς να αποκτήσετε πρόσβαση",
              description:
                "Επιλέξτε κάρτες SIM σε κατάσταση 'Παραγωγική' από τον πίνακα SIM. Στη συνέχεια, πηγαίνετε σε Μαζικές Ενέργειες → Watchdogs → Μπλοκάρισμα Αναστολής.",
            },
          },
          alerts: {
            title: "Ειδοποιήσεις",
            description:
              "Τα watchdogs που παρακολουθούν την κατανάλωση SIM δημιουργούν Ειδοποιήσεις. Οι ειδοποιήσεις βοηθούν τους χρήστες να παρακολουθούν τα όρια χρήσης SIM και να λαμβάνουν μέτρα όταν είναι απαραίτητο.",
            typesTitle: "Τύποι Ειδοποιήσεων",
            types: {
              depleted:
                "Εξαντλημένο: Δημιουργείται για όλα τα watchdogs. Ενεργοποιείται όταν μια SIM φτάσει στο 100% της κατανάλωσης.",
              warning:
                "Προειδοποίηση: Δημιουργείται προαιρετικά για watchdogs που έχουν ορίσει όρια προειδοποίησης.",
            },
            howToAccess: {
              title: "Πώς να Αποκτήσετε Πρόσβαση",
              description:
                "Για να δείτε τις Ειδοποιήσεις, μεταβείτε στο μενού 'Ειδοποιήσεις' στην πλαϊνή μπάρα. Ο πίνακας εμφανίζει τις ειδοποιήσεις ταξινομημένες κατά ημερομηνία (πιο πρόσφατη πρώτα) και περιλαμβάνει φίλτρα για τύπο, ημερομηνία και IMSI.",
            },
          },
        },
        reports: {
          intro: {
            title: "Αναφορές",
            description:
              "Η πλατφόρμα προσφέρει στους χρήστες τη δυνατότητα να προβάλλουν και να εξάγουν μια μεγάλη ποικιλία αναφορών, όπως κατανάλωση SIM, λίστα τιμολογίων, αναλυτικές γραμμές τιμολογίων, αιτήματα provisioning SIM, δραστηριότητα χαρτοφυλακίου (ενεργοποιήσεις - τερματισμοί ανά πακέτο), κατανομή κατάστασης SIM καρτών και ενεργές συνεδρίες SIM. Επιπλέον, υπάρχει η δυνατότητα δημιουργίας Αυτοματοποιημένων Αναφορών για Χρήση και Επισκόπηση SIM που παράγονται σε σταθερά χρονικά διαστήματα σε μορφή λήψης. Το κεφάλαιο αυτό επικεντρώνεται σε τρεις υποενότητες.",
            subchaptersTitle: "Υποκεφάλαια",
            subchapters: {
              single: "Μεμονωμένη Αναφορά",
              automated: "Αυτοματοποιημένη Αναφορά",
              history: "Ιστορικό Αναφορών",
            },
          },
          single: {
            title: "Μοναδική Αναφορά",
            description:
              "Οι μοναδικές αναφορές επιτρέπουν στους χρήστες να δημιουργούν συγκεκριμένες αναφορές για κατανάλωση SIM, τιμολόγια, δραστηριότητα χαρτοφυλακίου, αιτήματα προμήθειας ή συνεδρίες. Οι αναφορές μπορούν να προσαρμοστούν με κριτήρια, να ομαδοποιηθούν και να εξαχθούν για περαιτέρω ανάλυση.",

            howToAccess: {
              title: "Πρόσβαση",
              description:
                "Για να αποκτήσετε πρόσβαση στις Μοναδικές Αναφορές, μεταβείτε στο Reports στην πλαϊνή μπάρα και επιλέξτε 'Generate Report'.",
            },

            usageReport: {
              title: "Αναφορά Χρήσης",
              description:
                "Η Αναφορά Χρήσης παρέχει λεπτομερείς πληροφορίες σχετικά με την κατανάλωση SIM για Data ή SMS, με ευέλικτες επιλογές ομαδοποίησης και φιλτραρίσματος.",
              bullets: [
                "Επιλέξτε 'Usage' ως Τύπο Αναφοράς.",
                "Επιλέξτε Τύπο Χρήσης: Data ή SMS.",
                "Ομαδοποίηση ανά Πεδίο: IMSI, Δίκτυο, Πελάτης ή χωρίς ομαδοποίηση.",
                "Ομαδοποίηση ανά Περίοδο: Ημέρα, Μήνας ή Έτος.",
                "Προαιρετικά, φιλτράρετε με βάση SIM: Συγκεκριμένο IMSI, Εύρος IMSI ή ICCID.",
                "Πατήστε 'View' για να δημιουργήσετε την αναφορά.",
              ],
            },
            invoiceList: {
              title: "Λίστα Τιμολογίων",
              description:
                "Η αναφορά Λίστας Τιμολογίων παρέχει μια επισκόπηση όλων των τιμολογίων που έχουν εκδοθεί στον λογαριασμό. Περιλαμβάνει βασικές πληροφορίες όπως αριθμός τιμολογίου, ημερομηνία έκδοσης, ημερομηνία λήξης, ποσό και κατάσταση πληρωμής. Οι χρήστες μπορούν να φιλτράρουν τα τιμολόγια ανά εύρος ημερομηνιών για γρήγορη αναζήτηση.",
              bullets: [
                "Μεταβείτε στο Reports → Generate Report.",
                "Επιλέξτε 'Invoice List' ως τύπο αναφοράς.",
                "Ορίστε το εύρος ημερομηνιών (Από – Έως) για να περιορίσετε τη λίστα τιμολογίων.",
                "Κάντε κλικ στο 'View' για να δημιουργηθεί η αναφορά.",
                "Ο πίνακας εμφανίζει τα τιμολόγια με λεπτομέρειες όπως αριθμός, ημερομηνία έκδοσης, ημερομηνία λήξης, συνολικό ποσό και κατάσταση πληρωμής.",
              ],
            },
            orders: {
              title: "Αναφορά Παραγγελιών",
              description:
                "Η αναφορά Παραγγελιών επιτρέπει στον χρήστη να δει όλες τις αιτήσεις προμήθειας που σχετίζονται με τις κάρτες SIM. Παρέχει ιστορική εικόνα των παραγγελιών που δημιουργήθηκαν κατά την επιλεγμένη περίοδο.",
              bullets: [
                "Πρόσβαση μέσω Αναφορές → Δημιουργία Αναφοράς → Παραγγελίες.",
                "Επιτρέπει το φιλτράρισμα ανά χρονικό διάστημα (περίοδο).",
                "Εμφανίζει λίστα με αιτήσεις προμήθειας SIM.",
              ],
            },
            portfolioActivity: {
              title: "Αναφορά Δραστηριότητας Χαρτοφυλακίου",
              description:
                "Η αναφορά Δραστηριότητας Χαρτοφυλακίου παρέχει μια επισκόπηση της δραστηριότητας των καρτών SIM, συμπεριλαμβανομένων ενεργοποιήσεων, τερματισμών και αλλαγών ανά πακέτο. Βοηθά τους χρήστες να παρακολουθούν την εξέλιξη του χαρτοφυλακίου τους με την πάροδο του χρόνου.",
              bullets: [
                "Διαθέσιμη μέσω Αναφορές → Δημιουργία Αναφοράς → Δραστηριότητα Χαρτοφυλακίου.",
                "Οι χρήστες μπορούν να φιλτράρουν την αναφορά με βάση το χρονικό διάστημα (Από–Έως).",
                "Εμφανίζει ενεργοποιήσεις, τερματισμούς και δραστηριότητα ομαδοποιημένα ανά πακέτο.",
              ],
            },
            customerSimSessions: {
              title: "Αναφορά Συνεδριών SIM Πελατών",
              description:
                "Η αναφορά Συνεδριών SIM Πελατών εμφανίζει πληροφορίες σχετικά με τις ενεργές και παρελθούσες συνεδρίες SIM των πελατών. Βοηθά στην παρακολούθηση του πότε και πώς οι κάρτες SIM συνδέονται στο δίκτυο.",
              bullets: [
                "Διαθέσιμη μέσω Αναφορές → Δημιουργία Αναφοράς → Συνεδρίες SIM Πελατών.",
                "Εμφανίζει λεπτομέρειες συνεδρίας όπως IMSI, ώρα έναρξης και λήξης, και δεδομένα που μεταφέρθηκαν.",
                "Χρήσιμη για επίλυση προβλημάτων συνδεσιμότητας και ανάλυση προτύπων χρήσης SIM.",
              ],
            },
            simOverview: {
              title: "Αναφορά Επισκόπησης SIM",
              description:
                "Η αναφορά Επισκόπησης SIM παρέχει μια συνοπτική εικόνα των καρτών SIM στο σύστημα, εμφανίζοντας την κατανομή τους ανά κατάσταση, εκχώρηση και δραστηριότητα. Βοηθά τους διαχειριστές να αξιολογούν γρήγορα τον στόλο SIM.",
              bullets: [
                "Διαθέσιμη μέσω Αναφορές → Δημιουργία Αναφοράς → Επισκόπηση SIM.",
                "Εμφανίζει τις SIM ομαδοποιημένες ανά κατάσταση όπως Ενεργή, Σε Αναστολή, Τερματισμένη ή Σε Απόθεμα.",
                "Χρήσιμη για την παρακολούθηση της κατάστασης και της κατανομής των καρτών SIM με μια ματιά.",
              ],
            },
            simList: {
              title: "Αναφορά Λίστας SIM",
              description:
                "Η αναφορά Λίστας SIM παρέχει μια αναλυτική απογραφή όλων των καρτών SIM στο σύστημα. Περιλαμβάνει αναγνωριστικά όπως IMSI και ICCID, την τρέχουσα κατάσταση και τις λεπτομέρειες εκχώρησης.",
              bullets: [
                "Διαθέσιμη μέσω Αναφορές → Δημιουργία Αναφοράς → Λίστα SIM.",
                "Εμφανίζει κάθε κάρτα SIM με IMSI, ICCID και τρέχουσα κατάσταση.",
                "Χρήσιμη για τον έλεγχο και τη διαχείριση της πλήρους απογραφής των καρτών SIM.",
              ],
            },
            exportReport: {
              title: "Εξαγωγή Αναφοράς σε Αρχείο",
              description:
                "Όλες οι αναφορές που δημιουργούνται μπορούν να εξαχθούν σε αρχείο για περαιτέρω ανάλυση ή διαμοιρασμό. Οι διαθέσιμες επιλογές είναι CSV και PDF, ανάλογα με τις ανάγκες του χρήστη.",
              bullets: [
                "Διαθέσιμο μέσω Ενέργειες → Εξαγωγή → CSV ή PDF.",
                "Η μορφή CSV είναι χρήσιμη για ανάλυση δεδομένων σε Excel ή άλλα εργαλεία υπολογιστικών φύλλων.",
                "Η μορφή PDF είναι χρήσιμη για διαμοιρασμό αναφορών σε σταθερή μορφή.",
              ],
            },
            timeoutReports: {
              title: "Αναφορές με Χρονικό Όριο",
              description:
                "Κάθε δημιουργία αναφοράς έχει χρονικό όριο 15 δευτερολέπτων. Όταν αυτό ξεπεραστεί, η αναφορά συνεχίζει να δημιουργείται στο παρασκήνιο.",
              bullets: [
                "Ο χρήστης ενημερώνεται με ειδοποίηση όταν μια αναφορά ξεπεράσει το χρονικό όριο.",
                "Όταν η αναφορά είναι έτοιμη, λαμβάνεται push ειδοποίηση.",
                "Η δημιουργημένη αναφορά με χρονικό όριο μπορεί να προβληθεί μέσω Ενέργειες → Προβολή.",
                "Οι αναφορές με χρονικό όριο μπορούν επίσης να εξαχθούν σε CSV ή PDF, όπως και οι άμεσες αναφορές.",
              ],
            },
          },
          automated: {
            title: "Αυτοματοποιημένες Αναφορές",
            description:
              "Οι Αυτοματοποιημένες Αναφορές επιτρέπουν στους χρήστες να προγραμματίζουν την παραγωγή αναφορών σε τακτά χρονικά διαστήματα και σε επιλεγμένη μορφή.",
            overview: {
              title: "Επισκόπηση",
              description:
                "Οι Αυτοματοποιημένες Αναφορές δημιουργούνται μία φορά και στη συνέχεια παράγονται αυτόματα με τη συχνότητα και τη μορφή που έχει επιλεγεί.",
              bullets: [
                "Οι αναφορές μπορούν να προγραμματιστούν καθημερινά, εβδομαδιαία ή μηνιαία.",
                "Οι αναφορές μπορούν να παραχθούν σε μορφή CSV ή PDF.",
                "Διαθέσιμοι τύποι αναφορών: Κατανάλωση και Επισκόπηση SIM Πελάτη.",
              ],
            },
            create: {
              title: "Δημιουργία Αυτοματοποιημένης Αναφοράς",
              description:
                "Για να δημιουργήσετε μια νέα αυτοματοποιημένη αναφορά, κάντε κλικ στο κουμπί πάνω δεξιά της κάρτας. Θα εμφανιστεί μια φόρμα που απαιτεί κάποιες πληροφορίες:",
              bullets: [
                "Όνομα: Το όνομα της αναφοράς.",
                "Συχνότητα Αναφοράς: Καθημερινά, εβδομαδιαία ή μηνιαία.",
                "Μορφή Αναφοράς: CSV ή PDF.",
                "Τύπος Αναφοράς: Επιλογή μεταξύ Κατανάλωσης και Επισκόπησης SIM Πελάτη.",
                "Ανάλογα με τον τύπο αναφοράς, μπορεί να εμφανιστούν επιπλέον πεδία, όπως στο μενού Δημιουργία Αναφοράς.",
              ],
            },
          },
          history: {
            title: "Ιστορικό Αναφορών",
            description:
              "Η ενότητα Ιστορικό Αναφορών παρέχει μια λίστα με τα αποτελέσματα όλων των εκτελέσεων Αυτοματοποιημένων Αναφορών. Κάθε καταχώρηση περιλαμβάνει το όνομα της αναφοράς, την ημερομηνία δημιουργίας, την κατάσταση, την επιλογή λήψης και τη δυνατότητα διαγραφής της αναφοράς.",
            reportHistory: {
              title: "Προβολή Αποτελεσμάτων Αυτοματοποιημένων Αναφορών",
              description:
                "Από την ενότητα Ιστορικό Αναφορών, οι χρήστες μπορούν να:",
              bullets: [
                "Προβάλουν τα αποτελέσματα όλων των εκτελεσμένων Αυτοματοποιημένων Αναφορών.",
                "Ελέγξουν την κατάσταση εκτέλεσης (Ολοκληρωμένη, Σε εκκρεμότητα, Απέτυχε).",
                "Κατεβάσουν τα παραγόμενα αρχεία σε μορφή CSV ή PDF.",
                "Διαγράψουν μια καταχώρηση αναφοράς μέσω του μενού Ενέργειες.",
              ],
            },
          },
        },
      },
    },
  },
  en: {
    translation: {
      sidebar: {
        dashboard: "Dashboard",
        crm: "CRM",
        admins: "Admins",
        tenants: "Tenants",
        managers: "Managers",
        customers: "Customers",
        subaccounts: "Subaccounts",
        sims: "SIM Cards",
        account: "Account",
        profile: "Profile",
        billingProducts: "Billing Products",
        invoices: "Invoices",
        statements: "Statements",
        orders: "Orders",
        emails: "Emails",
        reports: "Reports",
        generateReport: "Generate Report",
        automatedReports: "Automated Reports",
        reportHistory: "Report History",
        alerts: "Alerts",
        notifications: "Notifications",
        support: "Support",
        privileges: "Privileges",
        settings: "Settings",
        services: "Services",
        documentation: "Documentation",
        whitelist: "Whitelist IP",
        customFields: "Custom Fields",
        simProducts: "SIM Products",
        purchaseSims: "Purchase SIMs",
        health: "System Health",
        purchaseOrders: "SIM Purchase Orders",
      },
      dashboard: {
        dataVolume: "Data Volume",
        dataSessions: "Data Sessions",
        alerts: "Alerts",
        zeroSessions: "Zero Sessions",
        sinceYesterday: "Since Yesterday",
        sinceLastMonth: "Since Last Month",
        sinceLastYear: "Since Last Year",
        averageVolume: "Average Data Volume",
        activeSims: "Active SIMs",
        dataVolumePerHour: "Data Volume per Hour",
        topMetrics: "Top Metrics",
        simCardsPerOffer: "SIM Cards per Offer",
        simInventory: "SIM Distribution by Status",
        dataVolumePerNetwork: "Data Volume per Network",
        selectCountry: "Select Country",
        networksDistribution: "Active SIM Cards per Network Distribution",
        watchdogAlerts: "Consumption Alerts",
        noData: "No Data Available",
        daily: "Daily",
        monthly: "Monthly",
        yearly: "Yearly",
      },
      crm: {
        admins: "Admins",
        tenants: "Tenants",
        managers: "Managers",
        customers: "Customers",
        subaccounts: "Subaccounts",
        filters: "Filters",
        fullName: "Full Name",
        company: "Company",
        email: "Email",
        address: "Address",
        city: "City",
        country: "Country",
        postcode: "Postcode",
        telephone: "Telephone",
        mobile: "Mobile",
        email: "Email",
        occupation: "Occupation",
        company: "Company",
        tin: "Tax ID",
        username: "Username",
        role: "Role",
        actions: "Actions",
        edit: "Edit",
        delete: "Delete",
        billing: "Billing",
        whitelabeling: "Whitelabeling",
        offers: "Offers",
        impersonate: "Impersonate",
        permissions: "Permissions",
        sendWelcomeEmail: "Send Welcome Email",
        resetPassword: "Reset Password",
        initializeSIMs: "Initialize SIMs",
        initializeAlerts: "Initialize Alerts",
        newTenant: "New Tenant",
        newManager: "New Manager",
        newCustomer: "New Customer",
        newSubaccount: "New Subaccount",
        registerPayment: "Register Payment",
        accountId: "Account ID",
        registerPayment: {
          title: "Register Payment",
          amount: "Amount",
          currency: "Currency",
          invoice: "Invoice Number",
          submit: "Submit",
          cancel: "Cancel",
          selectCurrency: "Select Currency",
          selectInvoice: "Select Invoice Number",
        },
        creditNote: {
          title: "Credit Note",
          amount: "Amount",
          vat: "VAT",
          reason: "Reason",
          submit: "Submit",
          cancel: "Cancel",
        },
        invoiceCycle: {
          title: "Re-run invoice cycle",
        },
        newModal: {
          newTenant: "Create Tenant",
          newManager: "Create Manager",
          newCustomer: "Create Customer",
          newSubaccount: "Create Subaccount",
          fullName: "Full Name",
          address: "Address",
          city: "City",
          country: "Country",
          postcode: "Postcode",
          telephone: "Telephone",
          mobile: "Mobile",
          email: "Email",
          occupation: "Occupation",
          company: "Company",
          tin: "TIN",
          username: "Username",
          sendWelcomeEmail: "Send Welcome Email",
          cancel: "Cancel",
          submit: "Submit",
          next: "Next",
          previous: "Previous",
          preferredLanguage: "Preferred Language",
          billingEmail: "Billing Email",
          currency: "Currency",
        },
        editModal: {
          editTenant: "Edit Tenant",
          editManager: "Edit Manager",
          editCustomer: "Edit Customer",
          editSubaccount: "Edit Subaccount",
          fullName: "Full Name",
          address: "Address",
          city: "City",
          country: "Country",
          postcode: "Postcode",
          telephone: "Telephone",
          mobile: "Mobile",
          email: "Email",
          occupation: "Occupation",
          company: "Company",
          tin: "Tax ID",
          username: "Username",
          cancel: "Cancel",
          submit: "Submit",
        },
        billingModal: {
          title: "Billing Settings",
          currency: "Currency",
          billingFrequency: "Billing Frequency",
          daysToPayInvoice: "Days to Pay Invoice",
          minimumAmountToInvoice: "Minimum Amount to Invoice",
          invoiceType: "Invoice Type",
          preferredLanguage: "Preferred Language",
          billingEmail: "Billing Email",
          platformUsage: "Platform Usage Charge",
          platformUsagePrice: "Platform Usage Price",
          onStockPriceEnabled: "On Stock SIM Charge Enabled",
          onStockPrice: "On Stock SIM Price",
          simCardPriceEnabled: "SIM Card Charge?",
          simCardPrice: "SIM Card Price",
          simChipPriceEnabled: "SIM Chip Charge?",
          simChipPrice: "SIM Chip Price",
          billable: "Billable?",
          isVatExempt: "Is VAT Exempt?",
          cancel: "Cancel",
          submit: "Submit",
        },
        whitelabelModal: {
          title: "Whitelabel Settings",
          enableWhitelabel: "Enable Whitelabel",
          pricePerMonth: "Price per Month",
          url: "URL",
          cancel: "Cancel",
          submit: "Submit",
        },
        roleModal: {
          title: "Update Role",
          role: "Role",
          tenant: "Tenant",
          manager: "Manager",
          customer: "Customer",
          cancel: "Cancel",
          submit: "Submit",
          selectRole: "Select Role",
          selectParent: "Select Parent Account",
          parentEntity: "Parent Account",
        },
        offersModal: {
          title: "Assign Offers",
          availableOffers: "Available Offers",
          assignedOffers: "Assigned Offers",
          submit: "Submit",
          cancel: "Cancel",
        },
        "1nceModal": {
          enable1nce: "Enable 1NCE Connection",
          title: "1NCE Configuration",
          organizationId: "Organization ID",
          username: "Username",
          password: "Password",
          confirmPassword: "Confirm Password",
          changePassword: "Change Password",
          submit: "Submit",
          cancel: "Cancel",
        },
      },
      sims: {
        title: "SIM Cards",
        dataVolume: "Data Volume",
        dataSessions: "Data Sessions",
        zeroSessions: "Zero Sessions",
        filters: "Filters",
        simStatus: "Active Session",
        simState: "SIM State",
        portfolioId: "Portfolio ID",
        imsi: "IMSI",
        iccid: "ICCID",
        msisdn: "MSISDN",
        eid: "EID",
        offer: "Offer",
        data: "Data",
        min: "Min",
        max: "Max",
        search: "Search",
        clear: "Clear",
        actions: "Actions",
        bulk: "Bulk Operations",
        modify: "Modify",
        product: "Product",
        clearSelection: "Clear Selection",
        activate: "Activate",
        suspend: "Suspend",
        resume: "Resume",
        terminate: "Terminate",
        testMode: "Test Mode",
        sendSms: "Send SMS",
        watchdogs: "Watchdogs",
        createWatchdog: "Create Watchdog",
        removeAllWatchdogs: "Remove All Watchdogs",
        blockSuspension: "Block Suspension",
        export: "Export",
        simInformation: "SIM Information",
        usage: "Usage",
        ipAddress: "IP Address",
        imei: "IMEI",
        status: "Status",
        visitProfile: "Visit Profile",
        provider: "Provider",
        area: "Area",
        cell: "Cell",
        longitude: "Longitude",
        latitude: "Latitude",
        cellRange: "Cell Range",
        unit: "Unit",
        sort: "Sort",
        simType: "SIM Type",
        suspendModal: {
          title: "Suspend SIM",
          orderComplete: "SIM suspension completed",
          orderError: "SIM suspension failed",
          contactAdmin: "Please contact the system administrator",
          cancel: "Cancel",
          submit: "Submit",
          close: "Close",
        },
        resumeModal: {
          title: "Resume SIM",
          orderComplete: "SIM resumption completed",
          orderError: "SIM resumption failed",
          contactAdmin: "Please contact the system administrator",
          cancel: "Cancel",
          submit: "Submit",
          close: "Close",
        },
        activateModal: {
          title: "Activate SIM",
          offer: "Offer",
          selectOffer: "Select Offer",
          success: "SIM activation completed",
          orderError: "SIM activation failed",
          contactAdmin: "Please contact the system administrator",
          cancel: "Cancel",
          submit: "Submit",
          close: "Close",
        },
        terminateModal: {
          title: "Terminate SIM",
          targetState: "Desired State",
          onStock: "On Stock",
          terminated: "Terminated",
          success: "SIM termination completed",
          orderError: "SIM termination failed",
          contactAdmin: "Please contact the system administrator",
          cancel: "Cancel",
          submit: "Submit",
          close: "Close",
        },
      },
      simProfile: {
        simProvisioning: "SIM Provisioning",
        simDetails: "SIM Details",
        actions: "Actions",
        hlr: "HLR",
        session: "Sessions",
        smsUsage: "SMS Usage",
        updateLoc: "Update Location",
        imeiLock: "IMEI Lock",
        usage: "Usage",
        imei: "IMEI",
        status: "Status",
        dataSession: "Active Session",
        map: "Map",
        provider: "Provider",
        imsi: "IMSI",
        iccid: "ICCID",
        msisdn: "MSISDN",
        country: "Country",
        operator: "Network Operator",
        area: "Area",
        cell: "Cell",
        longitude: "Longitude",
        latitude: "Latitude",
        cellRange: "Cell Range",
        activity: "Activity",
        selectPeriod: "Select Period",
        daily: "Daily",
        monthly: "Monthly",
        yearly: "Yearly",
        dataVolume: "Data Volume",
        dataSessions: "Data Sessions",
        alerts: "Alerts",
        zeroSessions: "Zero Sessions",
        watchdog: "Watchdog",
        type: "Type",
        blockSuspension: "Will suspend SIM",
        amount: "Amount",
        hlrModal: {
          title: "HLR Profile",
          selectScope: "Select Scope",
          basicInfo: "Basic Info",
          locationInfo: "Location Info",
          csBasicInfo: "CS Basic Info",
          gprsService2g3g: "GPRS Services 2G/3G",
          telephonyService: "Telephony Services",
          supplementaryService: "Supplementary Services",
          epcService4G: "EPC Services 4G",
        },
        sessionModal: {
          title: "SIM Data Sessions",
          openDate: "Open Date",
          closeDate: "Close Date",
          consumption: "Consumption",
          roundedBytes: "Rounded Bytes",
          operator: "Operator",
          cell: "Cell",
          imei: "IMEI",
          close: "Close",
        },
        orders: {
          title: "Requests",
          close: "Close",
        },
        smsUsageModal: {
          title: "SMS Usage",
          direction: "Direction",
          date: "Date",
          sender: "Sender",
          message: "Message",
          status: "Status",
          close: "Close",
        },
      },
      profile: {
        profileDetails: "Profile Details",
        contactInformation: "Contact Information",
        professionalInformation: "Professional Information",
        activities: "Activities",
        loadMore: "Load More",
      },
      billingProducts: {
        title: "Billing Products",
        name: "Name",
        pricePlan: "Price Plan",
        price: "Price",
        number: "Number",
      },
      invoices: {
        title: "Invoices",
        invoiceNo: "Invoice Number",
        date: "Date",
        amount: "Amount (incl. VAT)",
        description: "Description",
        paid: "Paid",
        download: "Download",
      },
      statements: {
        title: "Account Statements",
        cutDate: "Cut Date",
        description: "Description",
        amount: "Amount (incl. VAT)",
        balance: "Balance",
      },
      orders: {
        title: "Orders",
        open: "Open",
        parked: "Parked",
        finished: "Finished",
        error: "Error",
        noOrders: "No Orders",
        showAllOrders: "Show All Orders",
        showLess: "Show Less Orders",
      },
      emails: {
        filters: "Filters",
        category: "Category",
        name: "Name",
        address: "Address",
        actions: "Actions",
        newEmail: "New Email",
        edit: "Edit",
        delete: "Delete",
        cancel: "Cancel",
        submit: "Submit",
        selectCategory: "Select Category",
        invoice: "Invoice",
        watchdog: "Watchdog",
        updateEmail: "Update Email",
      },
      reports: {
        title: "Reports",
        reportType: "Report Type",
        usage: "Usage",
        groupBy: "Group By",
        field: "Field",
        usageType: "Usage Type",
        selectUsageType: "Select Usage Type",
        data: "Data",
        sms: "SMS",
        all: "All",
        imsi: "IMSI",
        eid: "EID",
        network: "Network",
        customer: "Customer",
        period: "Period",
        day: "Day",
        month: "Month",
        year: "Year",
        today: "Today",
        "This Week": "This Week",
        "This Month": "This Month",
        "This Year": "This Year",
        "Last Month": "Last Month",
        "Last Year": "Last Year",
        customer: "Customer",
        select: "Select",
        simSearchCriteria: "SIM Search Criteria",
        all: "All",
        bySpecificImsi: "By Specific IMSI",
        byImsiRange: "By IMSI Range",
        byIccid: "By ICCID",
        imsi: "IMSI",
        startImsi: "Start IMSI",
        endImsi: "End IMSI",
        iccid: "ICCID",
        view: "View",
        customerId: "Customer ID",
        date: "Date",
        startDate: "From",
        simType: "SIM Type",
        networkCode: "Network Code",
        networkName: "Network Name",
        country: "Country",
        totalBytes: "Total Bytes",
        roundedBytes: "Rounded Bytes",
        sessions: "Sessions",
        zeroSessions: "Zero Sessions",
        actions: "Actions",
        export: "Export",
        description: "Description",
        quantity: "Quantity",
        unitPrice: "Unit Price",
        tax: "VAT",
        costWithoutTax: "Price before tax",
        costWithTax: "Price after tax",
        currency: "Currency",
        offerName: "Offer Name",
        id: "ID",
        name: "Name",
        status: "Status",
        creator: "Creator",
        creationDate: "Creation Date",
        offer: "Offer",
        activations: "Activations",
        terminations: "Terminations",
        automated: {
          title: "Automated Reports",
          name: "Name",
          type: "Type",
          frequency: "Frequency",
          nextReport: "Next Report",
          new: "New Automated Report",
          save: "Save",
          daily: "Daily",
          weekly: "Weekly",
          monthly: "Monthly",
          edit: "Edit",
          delete: "Delete",
          actions: "Actions",
        },
        history: {
          title: "Report History",
          tableHeaders: {
            reportName: "Report Name",
            date: "Date",
            status: "Status",
            download: "Download",
            actions: "Actions",
          },
          delete: "Delete",
          completed: "Completed",
          incomplete: "Incomplete",
        },
      },
      timeoutReports: {
        view: "View",
        delete: "Delete",
      },
      alerts: {
        title: "Alerts",
        filters: "Filters",
        alert: "Alert",
        date: "Date",
        imsi: "IMSI",
        enterValue: "Enter Value",
      },
      settings: {
        title: "Settings",
        profileSettings: "Profile Settings",
        general: "General",
        account: "Account",
        profileImage: "Profile Image",
        whitelabel: "Whitelabel",
        privacyAndSafety: "Privacy & Safety",
        notifications: "Notifications",
        billing: "Billing",
        invoice: "Invoice",
        importSim: "Import SIM",
        mailConfig: "Mail Server",
        generalSettings: {
          title: "General Settings",
          timeZone: "Time Zone",
          dateFormat: "Date Format",
          timeFormat: "Time Format",
          save: "Save",
        },
        accountSettings: {
          title: "Account Settings",
          fullName: "Full Name",
          address: "Address",
          city: "City",
          country: "Country",
          postcode: "Postcode",
          telephone: "Telephone",
          mobileNumber: "Mobile",
          email: "Email",
          occupation: "Occupation",
          company: "Company",
          tin: "Tax ID",
          username: "Username",
          changePassword: "Change Password",
          password: "Password",
          confirmPassword: "Confirm Password",
          save: "Save",
        },
        profileImageSettings: {
          title: "Profile Image Settings",
          upload: "Upload",
          save: "Save",
        },
        whitelabelSettings: {
          title: "Whitelabel Settings",
          backgroundColor: "Background Color",
          fontColor: "Font Color",
          accentColor: "Accent Color",
          sidebarPosition: "Sidebar Position",
          favicon: "Favicon",
          whitelabelImage: "Whitelabel Image",
          upload: "Upload",
          save: "Save",
        },
        privacySettings: {
          title: "Privacy Settings",
          enable2FA: "Enable 2FA",
          save: "Save",
        },
        notificationSettings: {
          title: "Notification Settings",
          receiveNotifications: "Receive Notifications",
          sms: "SMS",
          email: "Email",
          weeklyAnalytics: "Receive Weekly Analytics",
          checkIfYouWantToReceiveWeeklyAnalytics:
            "Check if you want to receive weekly analytics",
          notifyAboutNewAlerts: "Notify about new alerts",
          checkIfYouWantToReceiveNotificationsWhenThereAreNewAlerts:
            "Check if you want to receive notifications when there are new alerts",
          submit: "Submit",
        },
        billingSettings: {
          title: "Billing Settings",
          selectCurrency: "Select Currency",
          currency: "Currency",
          preferredLanguage: "Preferred Language",
          selectLanguage: "Select Language",
          submit: "Submit",
        },
        invoiceSettings: {
          title: "Invoice Settings",
          name: "Name",
          showGuis: "Show GUIs",
          showSubtotal: "Show Subtotal",
          showLineOfService: "Show Line of Service",
          save: "Save",
        },
        importSimSettings: {
          title: "Import SIM Card",
          provider: "Provider",
          selectProvider: "Select Provider",
          submit: "Submit",
          inputType: "Input Type",
          selectInputType: "Select Input Type",
          single: "Single Insert",
          file: "File Insert",
        },
        mailConfig: {
          title: "Mail Server Settings",
          host: "SMTP Host Address",
          port: "SMTP Port",
          fromAddress: "Sender Address",
          username: "Username",
          changePassword: "Change Password",
          password: "Password",
          confirmPassword: "Confirm Password",
          useTLS: "Use TLS",
          save: "Save Settings",
          success: "Mail server settings saved successfully",
          error: "Failed to save mail server settings",
          healthStatus: "Health Status",
          healthUp: "Healthy (UP)",
          healthDown: "Unhealthy (DOWN)",
          healthUnknown: "Unknown",
          lastCheckedAt: "Last Checked At",
        },
        purchaseOrderConfig: {
          title: "Purchase Order Configuration",
          sellerName: "Seller Name",
          host: "SMTP Host Address",
          port: "SMTP Port",
          fromAddress: "Sender Address",
          username: "Username",
          changePassword: "Change Password",
          password: "Password",
          confirmPassword: "Confirm Password",
          useTLS: "Use TLS",
          save: "Save Settings",
          success: "Mail server settings saved successfully",
          error: "Failed to save mail server settings",
          healthStatus: "Health Status",
          healthUp: "Healthy (UP)",
          healthDown: "Unhealthy (DOWN)",
          healthUnknown: "Unknown",
          lastCheckedAt: "Last Checked At",
        },
        platformConfig: {
          title: "Platform Configuration",
          dataStreamingEnabled: "Data Streaming Enabled",
          maintenanceMode: "Maintenance Mode",
          maintenanceMessage: "Maintenance Message",
          maintenanceMessagePlaceholder:
            "Enter the message to display during maintenance",
          save: "Save Settings",
          reset: "Reset to Default",
        },
        crmConfig: {
          title: "CRM Configuration",
          type: "CRM Type",
          selectType: "Select CRM Type",
          selectAuthType: "Select Authentication Type",
          authType: "Authentication Type",
          username: "Username",
          changePassword: "Change Password?",
          changeToken: "Change Token?",
          password: "Password",
          confirmPassword: "Confirm Password",
          token: "Token",
        },
      },
      privileges: {
        title: "Privileges",
        name: "Name",
        actions: "Actions",
        newPrivilege: "New Privilege",
        edit: "Edit",
        delete: "Delete",
      },
      table: {
        page: "Page",
        of: "of",
        show: "Show",
        goToPage: "Go to page",
      },
      notifications: {
        title: "Notifications",
        id: "ID",
        date: "Date",
        message: "Message",
        type: "Type",
      },
      whitelist: {
        title: "Allowed IP Address",
        ip: "IP Address",
        active: "Active",
        createdAt: "Date Added",
        updatedAt: "Last Updated",
        lastUsed: "Last Used",
        new: "New IP Address",
      },
      customFields: {
        title: "Custom Fields",
        new: "New Custom Field",
        name: "Name",
        type: "Type",
        createdAt: "Created At",
        updatedAt: "Updated At",
        edit: "Edit",
        delete: "Delete",
        submit: "Submit",
        cancel: "Cancel",
        actions: "Actions",
        selectType: "Select Type",
        text: "Text",
        number: "Number",
      },
      documentation: {
        introduction: {
          welcomeTitle: "Welcome to {{brand}}",
          welcomeText:
            "{{brand}} is your all-in-one platform for managing SIM cards with ease. Monitor usage, activate new lines, and keep your operations running smoothly—all from a single dashboard.",
          getStarted: "Get Started",
        },
        dashboard: {
          title: "Dashboard Overview",
          description:
            "The Dashboard is the central screen for monitoring and analyzing SIM card activity through the {{brand}} platform. It provides both summary and detailed insights into data consumption, number of connections, alerts, as well as geographic and temporal distribution of usage.",
          goal: "The goal of the Dashboard is to provide users with an instant supervision tool, enabling quick understanding of the current state and timely decision-making.",
          cards: {
            title: "Statistics Cards (top section)",
            dataVolume: {
              title: "Data Volume",
              description:
                "Shows the total volume of data consumed today, along with a comparison to the previous day.",
            },
            dataSessions: {
              title: "Data Sessions",
              description:
                "Displays the number of connections made today, compared to the previous day.",
            },
            alerts: {
              title: "Consumption Alerts",
              description:
                "Shows the number of consumption alerts generated today due to usage thresholds being exceeded.",
            },
            zeroSessions: {
              title: "Zero Consumption Sessions",
              description:
                "Indicates how many data sessions recorded zero consumption during the selected time period.",
            },
          },
          charts: {
            title: "Detailed Charts and Maps",
            dataSessionsMap: {
              title: "Geographical Distribution of Data Connections",
              description:
                "The map displays the countries with the highest number of connections. From the menu in the top-right corner of the card, you can choose which information to display: Data Sessions, Data Volume, or Zero Sessions.",
            },
            avgDataAndActiveSims: {
              title: "Average Data Consumption and Active SIMs",
              description:
                "Provides the average data consumption per connection and the total number of active SIMs.",
            },
            dataVolumePerHour: {
              title: "Hourly Distribution of Data Consumption",
              description:
                "The chart shows data consumption per three-hour period and per day of the week for the current month, offering a more complete picture of the time intervals with the highest SIM activity.",
            },
            monthlyDataVolume: {
              title: "Monthly Distribution of Data Consumption",
              description:
                "The chart displays the monthly distribution of data consumption over the last 12 months. From the menu in the top-right corner of the card, you can select which information to display: Data Sessions, Data Volume, or Zero Sessions.",
            },
            topMetrics: {
              title: "Top Metrics",
              description:
                "This chart highlights the SIM cards with the highest number of connections for the selected period. It allows you to quickly identify the most active SIMs in your network, analyze usage patterns, detect heavy users, and optimize resource allocation.",
            },
            dataVolumePerNetwork: {
              title: "Data Consumption per Network - Active SIMs per Network",
              description:
                "These charts provide a comparative view of network activity in the selected country. The first chart shows the distribution of total data consumption per mobile network, helping you evaluate load, identify usage concentration, and compare operator performance. The second chart shows the distribution of active SIMs per network, providing insights into operator coverage and market share. Together, they give a complete understanding of how your SIMs interact with different networks and highlight connectivity and usage patterns.",
            },
            simCardsPerOffer: {
              title: "SIM Cards per Offer and Status",
              description:
                "These charts provide an overview of your SIM portfolio. The first chart shows the distribution across subscription offers and data plans, helping you identify preferences and the most popular services. The second chart shows the distribution by status, giving you visibility into lifecycle stages and availability. Together, they help you monitor usage trends, stock levels, and overall SIM management efficiency.",
            },
            alerts: {
              title: "Consumption Alerts",
              description:
                "This table lists the consumption alerts generated by the monitoring mechanism known as WatchDog. WatchDog continuously monitors SIM data usage and raises alerts when predefined thresholds are reached.",
              types: {
                warning:
                  "Warning: triggered when consumption reaches 80% of the allocated volume.",
                depleted:
                  "Depleted: triggered when consumption reaches 100% of the allocated volume.",
              },
              note: "These alerts help you take timely action to prevent service interruptions or unexpected costs. A more detailed analysis of WatchDog and its logic will be presented in the relevant chapter of the documentation.",
            },
          },
          utility: {
            title: "Dashboard Utility",
            description:
              "By unifying critical metrics, trends, and alerts, the Dashboard enables quick problem detection, better understanding of SIM behavior, cost/resource optimization, and informed decision-making.",
          },
        },
        simCards: {
          introduction: {
            title: "Introduction to SIM Cards",
            description:
              "This chapter provides all the necessary information about SIM cards within the {{brand}} platform.",
            details:
              "You will learn how SIMs are managed, monitored, and analyzed, with insights into data consumption, connectivity, alerts, and lifecycle stages.",
            getStarted: "Get Started",
          },
          lifecycle: {
            title: "SIM Lifecycle",
            intro:
              "SIM cards in the platform go through different lifecycle statuses. Each status is represented by a color-coded circle and has specific allowed transitions.",
            status: {
              productive: "Active and in use.",
              suspended: "Manually suspended.",
              autoSuspended: "Automatically suspended.",
              onstock: "Available but not active.",
              deleted: "Removed and inactive.",
            },
            diagramDescription:
              "This diagram shows the SIM lifecycle states and the possible transitions between them. Transitions may be triggered manually (for example, activating a SIM from OnStock to Productive) or automatically (such as a system process suspending a SIM when limits are reached). These transitions ensure proper control of SIM activity, availability, and deactivation across the platform.",
          },
          panel: {
            title: "SIMs Panel",
            intro:
              "The SIMs panel provides an overview of all SIM cards within the platform. It allows you to monitor activity, analyze data consumption, and manage lifecycle states efficiently.",
            summary: {
              title: "Summary Cards & Filters",
              intro:
                "At the top of the panel, three cards present a quick overview of SIM usage for the current month:",
              dataVolume: "Data Volume – total consumed data.",
              dataSessions: "Data Sessions – number of connections.",
              zeroSessions: "Zero Sessions – sessions with no data.",
              filters:
                "Filters allow narrowing SIMs by IMSI, ICCID, MSISDN, SIM state, offer, SIM type, or data volume. Sorting can be applied to multiple fields such as IMSI or usage.",
            },
            table: {
              title: "SIM Table",
              intro:
                "The main table lists all SIM cards with their key details:",
              activeSession: "Active Session – live activity indicator.",
              identifiers: "Identifiers – IMSI, ICCID, MSISDN.",
              state:
                "SIM State – lifecycle status (e.g., Productive, Suspended).",
              offer: "Offer – subscription plan (if applicable).",
              data: "Data – usage volume for the month.",
              type: "SIM Type – product type (e.g., embedded, industrial).",
              footer:
                "Pagination and bulk operations are also supported for efficient SIM management.",
            },
          },
          simProvisioning: {
            introduction: {
              title: "SIM Provisioning",
              description:
                "SIM Provisioning refers to the set of functionalities that allow administrators to manage the lifecycle of SIM cards within the platform. Through provisioning, you can:",
              closing:
                "These actions ensure that SIMs are provisioned, controlled, and deactivated properly, supporting both operational flexibility and security.",
            },
            actions: {
              activate: {
                title: "Activate",
                description: "make a SIM ready for productive use.",
                details: {
                  intro:
                    "In order to activate one or more SIMs there are three ways:",
                  steps: [
                    "By selecting the SIMs from the table by checking the checkboxes and from the menu Bulk Operations on the top right, select the menu Activate.",
                    "By instantly clicking on the same menu and using an Excel file containing the IMSI/ICCID numbers in column A with the respective title (IMSI/ICCID) in cell A1.",
                    "By clicking on the row, a side card will slide in with the profile of the SIM, on top of which there will be a button Activate.",
                  ],
                  important:
                    "Important! All the selected SIM cards must be in OnStock state to be activated.",
                  closing:
                    "Following the steps described, a confirmation modal with 2 steps will appear where the user needs to select the Offer under which they wish to activate the SIM cards. Optionally, the user can set some custom field values for these SIMs. As a second step, the user reviews the selected SIMs and proceeds with activation.",
                },
              },
              suspend: {
                title: "Suspend",
                description: "temporarily disable connectivity.",
                details: {
                  intro:
                    "Similar to activation, to suspend one or more SIM cards the user has the same options:",
                  steps: [
                    "By selecting the SIMs from the table by checking the checkboxes and from the menu Bulk Operations on the top right, select Suspend.",
                    "By instantly clicking on the same menu and using an Excel file containing the IMSI/ICCID numbers in column A with the respective title (IMSI/ICCID) in cell A1.",
                    "By clicking on the row, a side card will slide in with the profile of the SIM, on top of which there will be a button Suspend.",
                  ],
                  important:
                    "Important! All selected SIM cards must be in Productive state to be suspended.",
                  closing:
                    "Following the steps described, a confirmation modal will appear where the user reviews the selected SIMs and proceeds with suspension.",
                },
              },
              resume: {
                title: "Resume",
                description: "reactivate a suspended SIM.",
                details: {
                  intro:
                    "Similarly, to resume one or more SIM cards the user has the same options:",
                  steps: [
                    "By selecting the SIMs from the table by checking the checkboxes and from the menu Bulk Operations on the top right, select Resume.",
                    "By instantly clicking on the same menu and using an Excel file containing the IMSI/ICCID numbers in column A with the respective title (IMSI/ICCID) in cell A1.",
                    "By clicking on the row, a side card will slide in with the profile of the SIM, on top of which there will be a button Resume.",
                  ],
                  important:
                    "Important! All selected SIM cards must be in Suspended or AutoSuspended state to be resumed.",
                  closing:
                    "Following the steps described, a confirmation modal will appear where the user reviews the selected SIMs and proceeds with resume.",
                },
              },
              terminate: {
                title: "Terminate",
                description:
                  "retire a SIM from active use (either to OnStock or Deleted).",
                details: {
                  intro:
                    "Similarly, to terminate one or more SIM cards the user has the same options:",
                  steps: [
                    "By selecting the SIMs from the table by checking the checkboxes and from the menu Bulk Operations on the top right, select Terminate.",
                    "By instantly clicking on the same menu and using an Excel file containing the IMSI/ICCID numbers in column A with the respective title (IMSI/ICCID) in cell A1.",
                    "By clicking on the row, a side card will slide in with the profile of the SIM, on top of which there will be a button Terminate.",
                  ],
                  important:
                    "Important! All selected SIM cards must be in Productive state to be terminated.",
                  closing:
                    "Following the steps described, a confirmation modal will appear where the user selects the target status (OnStock or Permanently Deleted) of the termination, reviews the selected SIMs and proceeds with termination.",
                },
              },
              modify: {
                title: "Modify",
                description:
                  "modify the Offer under which the card is activated and charged.",
                details: {
                  intro: "In order to modify a SIM’s offer:",
                  steps: [
                    "By selecting the SIM from the table by checking its checkbox and from the menu Actions on the top right, select the menu Modify.",
                  ],
                  important:
                    "Important! The selected SIM card must be in Productive state to be modified.",
                  closing:
                    "Following the steps described, a confirmation modal will appear where the user needs to select the desired target Offer of the SIM card. Then, the user reviews the selected SIMs and proceeds with modification.",
                },
              },
            },
          },
          simProfile: {
            title: "SIM Profile",
            description:
              "SIM Profile is a dashboard that focuses on the statistics and functionalities of a single SIM card. It offers statistics similar to the main dashboard and provides detailed information for analysis and management.",
            items: {
              kpis: "KPIs and usage statistics",
              monthly: "Monthly distribution of usage",
              hlr: "HLR Profile (if applicable)",
              dataSessions: "Data Session history",
              smsUsage: "SMS Usage history",
              requests: "Requests made for this SIM card",
              provisioning: "SIM Provisioning activity and functionalities",
              cellInfo: "Cell info and connectivity details",
              watchdogs: "Watchdog information and alerts",
            },
            sections: {
              howToAccess: {
                title: "How to Access",
                description:
                  "To access the profile of a specific SIM card, select the SIM from the table and click on it. A side panel will slide in showing the SIM information. Inside this panel, there is a 'Visit Profile' link that redirects you to the full SIM Profile page. The SIM Profile page provides detailed statistics, usage history, provisioning actions, and technical information about the selected SIM card.",
              },
              kpis: {
                title: "KPIs",
                description:
                  "The KPI section of the SIM Profile provides a quick overview of the SIM’s performance and activity. These indicators help the user understand the current usage and health of the SIM at a glance.",
                bullets: [
                  "Data Volume – the total amount of data consumed by the SIM in the selected period.",
                  "Data Sessions – the number of data sessions established during the selected period.",
                  "Alerts – the number of alerts triggered for this SIM (e.g., usage thresholds).",
                  "Zero Sessions – the number of sessions where the SIM attempted to connect but consumed no data.",
                ],
                closing:
                  "At the top right, the user can filter KPIs by period (Daily, Monthly, or Yearly) to analyze usage patterns over time.",
              },
              monthly: {
                title: "Monthly Distribution",
                description:
                  "Distribution of data, SMS, and sessions per month.",
              },
              hlr: {
                title: "HLR Profile",
                description:
                  "The HLR (Home Location Register) Profile provides detailed subscription and network information for the SIM card. By clicking the HLR button under the Actions menu, a modal appears showing details such as:",
                fields: {
                  msisdn: "MSISDN",
                  imsi: "IMSI",
                  networkAccessMode: "Network Access Mode (e.g., CS and PS)",
                  subscriberType: "Subscriber Type (e.g., LTE subscriber)",
                  simStatus: "SIM Status (e.g., Available)",
                },
                scopes:
                  "Additionally, the user can select from a dropdown list of available scopes (e.g., Basic Info, Extended Info) to view respective details depending on the required depth of information.",
                closing:
                  "This functionality allows administrators to quickly validate SIM provisioning details and confirm whether the SIM is correctly registered and available in the network.",
              },

              dataSessions: {
                title: "Data Sessions",
                description:
                  "The Data Sessions functionality allows administrators to view detailed logs of all data sessions associated with a SIM card. By clicking the Sessions button under the Actions menu, a modal appears showing the session history and related details.",
                fields: {
                  openDate: "The timestamp when the session was initiated",
                  closeDate: "The timestamp when the session ended",
                  consumption:
                    "The actual number of bytes consumed during the session",
                  roundedBytes:
                    "The usage rounded based on operator billing policies",
                  operator: "The network operator handling the session",
                  cell: "The cell ID where the session was established",
                  imei: "The device identifier (IMEI) used for that session",
                },
              },
              smsUsage: {
                title: "SMS Usage",
                description:
                  "The SMS Usage modal allows administrators to monitor all SMS messages sent and received by the SIM card. By clicking the SMS Usage button under the Actions menu, a detailed table appears listing each SMS transaction.",
                fields: {
                  direction: "Direction (e.g., Inbound or Outbound)",
                  date: "Date and time of the SMS event",
                  sender: "The sender of the SMS message",
                  message: "The content of the SMS message (if available)",
                  status:
                    "Delivery status (e.g., Submitted, Delivered, Failed)",
                },
                note: "This functionality provides full traceability of SMS traffic for troubleshooting, compliance, or usage analysis.",
              },
              requests: {
                title: "Requests",
                description:
                  "The Requests section provides a complete history of all provisioning orders made for the selected SIM card. By clicking the Requests button under the Actions menu, a modal appears listing all orders, such as Activate, Suspend, Resume, and Terminate.",
                fields: {
                  id: "ID: The unique identifier of the order.",
                  name: "Name: The type of action (e.g., SuspendSIM, ResumeSIM, TerminateSIM).",
                  status:
                    "Status: The execution state of the order (e.g., Done, Pending).",
                  creator: "Creator: The user who initiated the request.",
                  creationDate: "Creation Date: When the order was created.",
                  lastUpdate:
                    "Last Update: The most recent status update timestamp.",
                },
                note: "This functionality enables administrators to track all provisioning activities performed on the SIM, ensuring transparency and accountability for lifecycle management.",
              },
              provisioning: {
                title: "Provisioning Activity",
                description:
                  "Provisioning actions performed for this SIM, such as activation, suspension, and modifications.",
              },
              cellInfo: {
                title: "Cell Info",
                description:
                  "Cell tower information and connection data for the SIM.",
              },
              watchdogs: {
                title: "Watchdogs",
                description:
                  "The Watchdogs section in the SIM Profile displays any configured watchdogs associated with the SIM card. These watchdogs are typically defined at the platform level and linked to a SIM to monitor specific conditions.",
                bullets: [
                  "View the list of active watchdogs related to the SIM.",
                  "Check their configuration (e.g., type of watchdog, status, and assigned limits).",
                  "Track which watchdogs are currently monitoring the SIM’s activity.",
                ],
                note: "Note: Configuration of thresholds, alerts, or automated actions is not available through the SIM Profile itself. This section is read-only and meant for monitoring purposes.",
              },
            },
          },
          simTransfers: {
            title: "SIM Transfers",
            description:
              "The SIM Transfer functionality allows administrators to move SIM cards between accounts or entities. This is useful for reallocating SIMs, shipping them to another organization, or managing ownership changes.",

            howToAccess: {
              title: "How to Access",
              description:
                "To access SIM Transfers, navigate to the User Management section, open the Actions menu for a user, and select the 'Ship SIMs' option.",
            },

            steps: {
              title: "Steps to Perform a SIM Transfer",
              description:
                "The transfer process consists of the following steps:",
              bullets: [
                "Ensure that the SIM cards are in 'On Stock' state before starting the transfer. Only SIMs that are available in stock can be transferred between accounts.",
                "Choose a SIM selection type: Single IMSI, Single ICCID, IMSI Range, ICCID Range, or CSV/XLSX file upload. This determines how you identify which SIMs to transfer.",
                "Enter or upload the required SIM identifiers based on the selection type chosen.",
                "Optionally define the price and VAT percentage. These fields help track financial implications of the transfer.",
                "Select a Billing Offer. This is the offer that the source account will be charged for when the destination account activates the transferred SIM card.",
                "Click 'Submit' to complete the SIM transfer. Once confirmed, the SIMs will appear in the destination account inventory.",
              ],
            },
            deallocate: {
              title: "Deallocate SIMs",
              description:
                "Deallocation is the reverse procedure of a SIM transfer. It allows users to remove SIM cards from a destination account and return them back to the source account or to stock. This is useful when SIMs were allocated by mistake, are no longer needed by the receiving account, or need to be reassigned.",
              bullets: [
                "Navigate to the User Management section, open the Actions menu for a user, and select 'Deallocate SIMs'.",
                "Ensure the SIM cards are in 'On Stock' or 'Allocated' state before attempting to deallocate.",
                "Choose a SIM selection type: Single IMSI, Single ICCID, IMSI Range, ICCID Range, or CSV/XLSX file upload.",
                "Enter or upload the identifiers of the SIMs to be deallocated.",
                "Confirm the source and destination accounts. The 'From' field shows the current account, and the 'To' field shows the account or stock pool the SIMs will be returned to.",
                "Click 'Submit' to complete the deallocation. Once confirmed, the SIMs will no longer appear under the destination account’s inventory and will be available for reallocation.",
              ],
            },
          },
        },
        watchdog: {
          title: "Watchdog",
          description:
            "Watchdogs are monitoring rules that help users control SIM card usage and detect abnormal behavior. They allow proactive management by defining thresholds on metrics such as data volume, sessions, or SMS usage. When a threshold is exceeded, the system can generate alerts or trigger actions to prevent misuse or unexpected costs.",
          items: {
            add: "How to Add a Watchdog",
            remove: "How to Remove a Watchdog",
            reset: "How to Reset a Watchdog",
            suspensionBlock: "Block SIM Suspension in Current Billing Period",
            alerts: "Alerts Generated by Watchdogs",
          },
          add: {
            title: "Add Watchdog",
            description:
              "Users can create a new watchdog to monitor SIM activity and trigger automated actions when usage exceeds defined thresholds. This helps ensure proactive SIM management and cost control.",
            howToAccess:
              "To add a new watchdog, go to the SIM Panel → Bulk Operations → Watchdogs → Create Watchdog. Important: all SIM cards must be in the Productive state (activated) to configure a watchdog.",
            fields: {
              actionType:
                "Select the action to take when the threshold is reached (e.g., notify, suspend).",
              interval:
                "Choose the monitoring period (daily, weekly, monthly).",
              amount: "Enter the usage threshold that will trigger the action.",
              service: "Select the service to monitor (e.g., Data, SMS).",
              unitType:
                "Choose the unit for measurement (e.g., Bytes, SMS count).",
              warnings:
                "Define early warning thresholds before the main action to notify users in advance.",
              suspendInterval:
                "Defines how long the SIM remains suspended once the watchdog is triggered. If set to daily, the SIM will be automatically resumed at midnight of the next day. If weekly, the SIM will resume at midnight on the coming Monday. If monthly, the SIM will resume at midnight on the first day of the next month.",
            },
          },
          removeAll: {
            title: "Remove All Watchdogs",
            description:
              "Users can remove all configured watchdogs from a SIM card in a single action. This is useful for quickly resetting monitoring without needing to delete each watchdog individually.",
            howToAccess:
              "To remove all watchdogs, go to the SIM panel → select active SIM cards → Bulk Operations → Watchdogs → Remove All Watchdogs.",
            details: {
              title: "Details",
              immediateEffect:
                "When executed, all existing watchdog configurations on the selected SIMs will be deleted.",
              noAlerts:
                "No alerts or automated actions will be triggered after removal.",
              cleanSlate:
                "The SIM will continue operating normally but without monitoring until new watchdogs are created.",
            },
            useCases: {
              title: "Use Cases",
              policyChanges:
                "When monitoring policies change, existing watchdogs may need to be cleared.",
              testing:
                "In testing environments, many watchdogs may be created and quickly removed for cleanup.",
              errorRecovery:
                "If misconfigured or conflicting watchdogs exist, removal resets them to a neutral state.",
            },
            considerations: {
              title: "Considerations",
              irreversible:
                "Removing all watchdogs cannot be undone; they must be recreated if needed.",
              criticalMonitoring:
                "Ensure SIMs are not left without monitoring in critical environments.",
              bulkOperations:
                "In bulk operations, review carefully as all selected SIMs will be affected.",
            },
          },
          reset: {
            title: "Reset Watchdog",
            description:
              "Resetting a watchdog clears its consumption counter and reinstates suspension if the user has previously chosen to block suspension for the current billing period. This allows users to restart monitoring without creating a new watchdog.",
            howToAccess: {
              title: "How to Access",
              description:
                "Navigate to the SIM card’s profile. Under the Watchdog section, click the circular arrow icon next to the relevant watchdog to reset it.",
            },
          },
          blockSuspension: {
            title: "Block Suspension",
            description:
              "Block Suspension prevents the suspension of a SIM card when a watchdog monitoring its consumption triggers a 100% consumption alert (Depleted Alert). This functionality applies only to the current billing period. At the start of the next billing period, the suspension is reinstated automatically.",
            howToAccess: {
              title: "How to Access",
              description:
                "Select SIM cards in 'Productive' state from the SIM panel. Then, open Bulk Operations → Watchdogs → Block Suspension.",
            },
          },
          alerts: {
            title: "Alerts",
            description:
              "Watchdogs monitoring SIM consumption trigger Alerts. Alerts help users keep track of SIM usage thresholds and take action when necessary.",
            typesTitle: "Types of Alerts",
            types: {
              depleted:
                "Depleted: Generated for all Watchdogs. Triggered when a SIM card reaches 100% of its consumption.",
              warning:
                "Warning: Optionally generated for Watchdogs that have set warning limits.",
            },
            howToAccess: {
              title: "How to Access",
              description:
                "To view Alerts, navigate to the 'Alerts' menu in the sidebar. The table lists Alerts sorted by date (most recent first) and includes filters for type, date, and IMSI.",
            },
          },
        },
        reports: {
          intro: {
            title: "Reports",
            description:
              "The platform offers users the ability to view and export a wide variety of reports, including SIM card consumption, invoice lists, detailed invoice lines, SIM provisioning requests, portfolio activity (activations and terminations per offer), SIM card state distribution, and active SIM sessions. Additionally, automated reports for Usage and SIM Overview can be created and generated at fixed intervals in downloadable form. This chapter focuses on three main subchapters.",
            subchaptersTitle: "Subchapters",
            subchapters: {
              single: "Single Report",
              automated: "Automated Report",
              history: "Report History",
            },
          },
          single: {
            title: "Single Report",
            description:
              "Single reports allow users to generate specific reports on SIM usage, invoices, portfolio activity, provisioning, or sessions. These reports can be customized by criteria, grouped by field or time period, and exported for further analysis.",

            howToAccess: {
              title: "How to Access",
              description:
                "To access Single Reports, navigate to Reports in the sidebar and select 'Generate Report'.",
            },

            usageReport: {
              title: "Usage Report",
              description:
                "The Usage Report provides detailed insights into SIM consumption for Data or SMS, with flexible grouping and filtering options.",
              bullets: [
                "Choose 'Usage' as the Report Type.",
                "Select Usage Type: Data or SMS.",
                "Group by Field: IMSI, Network, Customer, or no grouping.",
                "Group by Period: Day, Month, or Year.",
                "Optionally filter by SIM criteria: Specific IMSI, IMSI Range, or ICCID.",
                "Click 'View' to generate the report.",
              ],
            },
            invoiceList: {
              title: "Invoice List",
              description:
                "The Invoice List report provides a summary of all invoices issued to the account. It includes key information such as invoice number, issue date, due date, amount, and payment status. Users can filter invoices by date range to quickly locate billing documents.",
              bullets: [
                "Navigate to Reports → Generate Report.",
                "Select 'Invoice List' as the Report Type.",
                "Define the date range (From – To) to limit the list of invoices.",
                "Click 'View' to generate the report.",
                "The resulting table displays invoices with details such as number, issue date, due date, total amount, and payment status.",
              ],
            },
            orders: {
              title: "Orders Report",
              description:
                "The Orders report allows the user to view all provisioning orders related to SIM cards. It provides a historical overview of orders created during the selected period.",
              bullets: [
                "Accessible via Reports → Generate Report → Orders.",
                "Allows filtering by date range (period).",
                "Displays a list of SIM-related provisioning orders.",
              ],
            },
            portfolioActivity: {
              title: "Portfolio Activity Report",
              description:
                "The Portfolio Activity report provides an overview of SIM card portfolio activity, including activations, terminations, and changes per offer. It helps users track the evolution of their SIM portfolio over time.",
              bullets: [
                "Accessible via Reports → Generate Report → Portfolio Activity.",
                "Users can filter the report by period (From–To).",
                "Displays activations, terminations, and activity grouped by offer.",
              ],
            },
            customerSimSessions: {
              title: "Customer SIM Sessions Report",
              description:
                "The Customer SIM Sessions report shows information about the active and past SIM sessions of customers. It helps track when and how SIM cards are connected to the network.",
              bullets: [
                "Accessible via Reports → Generate Report → Customer SIM Sessions.",
                "Displays session details such as IMSI, session start and end times, and data transferred.",
                "Useful for troubleshooting connectivity and analyzing SIM usage patterns.",
              ],
            },
            simOverview: {
              title: "SIM Overview Report",
              description:
                "The SIM Overview report provides a summary of the SIM cards in the system, displaying their distribution by state, allocation, and activity. It helps administrators quickly assess the overall SIM fleet.",
              bullets: [
                "Accessible via Reports → Generate Report → SIM Overview.",
                "Displays SIMs grouped by states such as Active, Suspended, Terminated, or On Stock.",
                "Useful for monitoring the health and distribution of SIM cards at a glance.",
              ],
            },
            simList: {
              title: "SIM List Report",
              description:
                "The SIM List report provides a detailed inventory of all SIM cards in the system. It includes identifiers such as IMSI and ICCID, their current state, and allocation details.",
              bullets: [
                "Accessible via Reports → Generate Report → SIM List.",
                "Displays each SIM card with IMSI, ICCID, and current status.",
                "Useful for auditing and managing the full inventory of SIM cards.",
              ],
            },
            exportReport: {
              title: "Export Report to File",
              description:
                "All reports generated can be exported into a file for further analysis or sharing. The export options include CSV and PDF formats, depending on user needs.",
              bullets: [
                "Accessible through Actions → Export → CSV or PDF.",
                "CSV format is useful for data analysis in Excel or other spreadsheet tools.",
                "PDF format is useful for sharing fixed-format reports.",
              ],
            },
            timeoutReports: {
              title: "Timeout Reports",
              description:
                "Each report generation has a timeout limit of 15 seconds. When this limit is exceeded, the report continues to generate in the background.",
              bullets: [
                "A notification informs the user when a report times out.",
                "When the report is ready, a push notification is received.",
                "The generated timeout report can be viewed from Actions → View.",
                "Timeout reports can also be exported to CSV or PDF, just like instantly generated reports.",
              ],
            },
          },
          automated: {
            title: "Automated Reports",
            description:
              "Automated Reports allow users to schedule the generation of reports at fixed intervals in a chosen format.",
            overview: {
              title: "Overview",
              description:
                "Automated Reports are created once and then generated automatically at the chosen frequency and in the chosen format.",
              bullets: [
                "Reports can be scheduled daily, weekly, or monthly.",
                "Reports can be generated in CSV or PDF format.",
                "Available report types: Usage and Customer SIM Overview.",
              ],
            },
            create: {
              title: "Creating an Automated Report",
              description:
                "To create a new automated report, click the button on the top right of the card. A form will appear requiring some information:",
              bullets: [
                "Name: The name of the report.",
                "Report Frequency: Daily, weekly, or monthly.",
                "Report Format: CSV or PDF.",
                "Report Type: Choose between Usage and Customer SIM Overview.",
                "Depending on the report type, additional fields may appear, similar to the Generate Report menu.",
              ],
            },
          },
          history: {
            title: "Report History",
            description:
              "The Report History section provides a list of results from all Automated Report executions. Each entry includes the report name, generation date, status, download option, and the ability to delete the report.",
            reportHistory: {
              title: "Viewing Automated Report Results",
              description: "From the Report History section, users can:",
              bullets: [
                "View the results of all executed Automated Reports.",
                "Check the execution status (Completed, Pending, Failed).",
                "Download generated files in CSV or PDF format.",
                "Delete a report entry using the Actions menu.",
              ],
            },
          },
        },
      },
    },
  },
  fr: {
    translation: {
      sidebar: {
        dashboard: "Tableau de bord",
        crm: "CRM",
        admins: "Administrateurs",
        tenants: "Locataires",
        managers: "Gestionnaires",
        customers: "Clients",
        subaccounts: "Sous-comptes",
        sims: "Cartes SIM",
        account: "Compte",
        profile: "Profil",
        billingProducts: "Produits de facturation",
        invoices: "Factures",
        statements: "Relevés",
        orders: "Commandes",
        emails: "E-mails",
        reports: "Rapports",
        generateReport: "Générer un rapport",
        automatedReports: "Rapports automatisés",
        reportHistory: "Historique des rapports",
        alerts: "Alertes",
        notifications: "Notifications",
        support: "Support",
        privileges: "Privilèges",
        settings: "Paramètres",
        services: "Services",
        documentation: "Documentation",
        whitelist: "Adresse IP autorisée",
        customFields: "Champs personnalisés",
        simProducts: "Produits SIM",
        purchaseSims: "Acheter des cartes SIM",
        health: "Santé du système",
        purchaseOrders: "Commandes de cartes SIM",
      },
      dashboard: {
        dataVolume: "Volume de données",
        dataSessions: "Sessions de données",
        alerts: "Alertes",
        zeroSessions: "Sessions à zéro",
        sinceYesterday: "Depuis hier",
        sinceLastMonth: "Depuis le mois dernier",
        sinceLastYear: "Depuis l'année dernière",
        averageVolume: "Volume de données moyen",
        activeSims: "SIM actives",
        dataVolumePerHour: "Volume de données par heure",
        topMetrics: "Principales métriques",
        simCardsPerOffer: "Cartes SIM par offre",
        simInventory: "Distribution des SIM par statut",
        dataVolumePerNetwork: "Volume de données par réseau",
        selectCountry: "Sélectionnez le pays",
        networksDistribution: "Distribution des SIM actives par réseau",
        watchdogAlerts: "Alertes de consommation",
        noData: "Pas de données disponibles",
        daily: "Quotidien",
        monthly: "Mensuel",
        yearly: "Annuel",
      },
      crm: {
        admins: "Administrateurs",
        tenants: "Locataires",
        managers: "Gestionnaires",
        customers: "Clients",
        subaccounts: "Sous-comptes",
        filters: "Filtres",
        fullName: "Nom complet",
        company: "Entreprise",
        email: "E-mail",
        address: "Adresse",
        city: "Ville",
        country: "Pays",
        postcode: "Code postal",
        telephone: "Téléphone",
        mobile: "Mobile",
        occupation: "Profession",
        tin: "Numéro fiscal",
        username: "Nom d'utilisateur",
        role: "Rôle",
        actions: "Actions",
        edit: "Éditer",
        delete: "Supprimer",
        billing: "Facturation",
        whitelabeling: "Marque blanche",
        offers: "Offres",
        impersonate: "Imiter",
        permissions: "Autorisations",
        sendWelcomeEmail: "Envoyer un e-mail de bienvenue",
        resetPassword: "Réinitialiser le mot de passe",
        initializeSIMs: "Initialiser les SIM",
        initializeAlerts: "Initialiser les alertes",
        newTenant: "Nouveau locataire",
        newManager: "Nouveau gestionnaire",
        newCustomer: "Nouveau client",
        newSubaccount: "Nouveau sous-compte",
        registerPayment: "Enregistrer Paiement",
        accountId: "ID de compte",
        registerPayment: {
          title: "Enregistrer paiement",
          amount: "Montant",
          currency: "Devise",
          invoice: "Numéro de facture",
          submit: "Soumettre",
          cancel: "Annuler",
          selectCurrency: "Sélectionner une devise",
          selectInvoice: "Sélectionner une facture",
        },
        creditNote: {
          title: "Avoir",
          amount: "Montant",
          vat: "TVA",
          reason: "Raison",
          submit: "Soumettre",
          cancel: "Annuler",
        },
        invoiceCycle: {
          title: "Relancer le cycle de facturation",
        },
        newModal: {
          newTenant: "Créer un locataire",
          newManager: "Créer un gestionnaire",
          newCustomer: "Créer un client",
          newSubaccount: "Créer un sous-compte",
          fullName: "Nom complet",
          address: "Adresse",
          city: "Ville",
          country: "Pays",
          postcode: "Code postal",
          telephone: "Téléphone",
          mobile: "Mobile",
          email: "E-mail",
          occupation: "Profession",
          company: "Entreprise",
          tin: "Numéro fiscal",
          username: "Nom d'utilisateur",
          sendWelcomeEmail: "Envoyer un e-mail de bienvenue",
          cancel: "Annuler",
          submit: "Soumettre",
          next: "Suivant",
          previous: "Précédent",
          preferredLanguage: "Langue préférée",
          billingEmail: "E-mail de facturation",
          currency: "Devise",
        },
        editModal: {
          editTenant: "Modifier le locataire",
          editManager: "Modifier le gestionnaire",
          editCustomer: "Modifier le client",
          editSubaccount: "Modifier le sous-compte",
          fullName: "Nom complet",
          address: "Adresse",
          city: "Ville",
          country: "Pays",
          postcode: "Code postal",
          telephone: "Téléphone",
          mobile: "Mobile",
          email: "E-mail",
          occupation: "Profession",
          company: "Entreprise",
          tin: "Numéro fiscal",
          username: "Nom d'utilisateur",
          cancel: "Annuler",
          submit: "Soumettre",
        },
        billingModal: {
          title: "Paramètres de facturation",
          currency: "Devise",
          billingFrequency: "Fréquence de facturation",
          daysToPayInvoice: "Jours pour payer la facture",
          minimumAmountToInvoice: "Montant minimum à facturer",
          invoiceType: "Type de facture",
          preferredLanguage: "Langue préférée",
          billingEmail: "E-mail de facturation",
          platformUsage: "Frais d'utilisation de la plateforme",
          platformUsagePrice: "Prix d'utilisation de la plateforme",
          onStockPriceEnabled: "Frais de carte SIM On Stock activés",
          onStockPrice: "Prix de la carte SIM On Stock",
          simCardPriceEnabled: "Frais de carte SIM ?",
          simCardPrice: "Prix de la carte SIM",
          simChipPriceEnabled: "Frais de puce SIM ?",
          simChipPrice: "Prix de la puce SIM",
          billable: "Facturable ?",
          isVatExempt: "Est exonéré de TVA",
          cancel: "Annuler",
          submit: "Soumettre",
        },
        whitelabelModal: {
          title: "Paramètres de marque blanche",
          enableWhitelabel: "Activer la marque blanche",
          pricePerMonth: "Prix par mois",
          url: "URL",
          cancel: "Annuler",
          submit: "Soumettre",
        },
        roleModal: {
          title: "Mettre à jour le rôle",
          role: "Rôle",
          tenant: "Locataire",
          manager: "Gestionnaire",
          customer: "Client",
          cancel: "Annuler",
          submit: "Soumettre",
        },
        offersModal: {
          title: "Assigner des offres",
          availableOffers: "Offres disponibles",
          assignedOffers: "Offres assignées",
          submit: "Soumettre",
        },
      },
      sims: {
        title: "Cartes SIM",
        dataVolume: "Volume de données",
        dataSessions: "Sessions de données",
        zeroSessions: "Sessions à zéro",
        filters: "Filtres",
        simStatus: "Session active",
        simState: "État de la SIM",
        portfolioId: "Portfolio ID",
        imsi: "IMSI",
        iccid: "ICCID",
        msisdn: "MSISDN",
        eid: "EID",
        offer: "Offre",
        data: "Données",
        min: "Min",
        max: "Max",
        search: "Rechercher",
        clear: "Effacer",
        actions: "Actions",
        bulk: "Opérations en vrac",
        modify: "Modifier",
        product: "Produit",
        clearSelection: "Effacer la sélection",
        activate: "Activer",
        suspend: "Suspendre",
        resume: "Reprendre",
        terminate: "Résilier",
        testMode: "Mode test",
        sendSms: "Envoyer un SMS",
        watchdogs: "Watchdogs",
        createWatchdog: "Créer un Watchdog",
        removeAllWatchdogs: "Supprimer tous les Watchdogs",
        blockSuspension: "Bloquer la Suspension",
        export: "Exporter",
        simInformation: "Informations SIM",
        usage: "Utilisation",
        ipAddress: "Adresse IP",
        imei: "IMEI",
        status: "Statut",
        visitProfile: "Visiter le profil",
        provider: "Fournisseur",
        area: "Zone",
        cell: "Cellule",
        longitude: "Longitude",
        latitude: "Latitude",
        cellRange: "Portée de la cellule",
        unit: "Unité",
        sort: "Trier",
        suspendModal: {
          title: "Suspendre la SIM",
          orderComplete: "Suspension de la SIM complétée",
          orderError: "Échec de la suspension de la SIM",
          contactAdmin: "Veuillez contacter l'administrateur",
          cancel: "Annuler",
          submit: "Soumettre",
          close: "Fermer",
        },
        resumeModal: {
          title: "Reprendre la SIM",
          orderComplete: "Reprise de la SIM complétée",
          orderError: "Échec de la reprise de la SIM",
          contactAdmin: "Veuillez contacter l'administrateur",
          cancel: "Annuler",
          submit: "Soumettre",
          close: "Fermer",
        },
        activateModal: {
          title: "Activer la SIM",
          offer: "Offre",
          selectOffer: "Sélectionner l'offre",
          success: "Activation de la SIM complétée",
          orderError: "Échec de l'activation de la SIM",
          contactAdmin: "Veuillez contacter l'administrateur",
          cancel: "Annuler",
          submit: "Soumettre",
          close: "Fermer",
        },
        terminateModal: {
          title: "Résilier la SIM",
          targetState: "État désiré",
          onStock: "En stock",
          terminated: "Résiliée",
          success: "Résiliation de la SIM complétée",
          orderError: "Échec de la résiliation de la SIM",
          contactAdmin: "Veuillez contacter l'administrateur",
          cancel: "Annuler",
          submit: "Soumettre",
          close: "Fermer",
        },
      },
      simProfile: {
        simProvisioning: "Gestion de l’état de la carte SIM",
        simDetails: "Détails de la SIM",
        actions: "Actions",
        hlr: "HLR",
        session: "Sessions",
        smsUsage: "Utilisation des SMS",
        updateLoc: "Mettre à jour la localisation",
        imeiLock: "Verrouillage IMEI",
        usage: "Utilisation",
        imei: "IMEI",
        status: "Statut",
        dataSession: "Session active",
        map: "Carte",
        provider: "Fournisseur",
        imsi: "IMSI",
        iccid: "ICCID",
        msisdn: "MSISDN",
        country: "Pays",
        operator: "Opérateur de réseau",
        area: "Zone",
        cell: "Cellule",
        longitude: "Longitude",
        latitude: "Latitude",
        cellRange: "Portée de la cellule",
        activity: "Activité",
        selectPeriod: "Sélectionner la période",
        daily: "Quotidien",
        monthly: "Mensuel",
        yearly: "Annuel",
        dataVolume: "Volume de données",
        dataSessions: "Sessions de données",
        alerts: "Alertes",
        zeroSessions: "Sessions à zéro",
        watchdog: "Watchdog",
        type: "Type",
        blockSuspension: "La carte SIM sera suspendue",
        amount: "Montant",
        hlrModal: {
          title: "Profil HLR",
          selectScope: "Sélectionner la portée",
          basicInfo: "Informations de base",
          locationInfo: "Informations de localisation",
          csBasicInfo: "Informations de base CS",
          gprsService2g3g: "Services GPRS 2G/3G",
          telephonyService: "Services de téléphonie",
          supplementaryService: "Services supplémentaires",
          epcService4G: "Services EPC 4G",
        },
        sessionModal: {
          title: "Sessions de données SIM",
          openDate: "Date d'ouverture",
          closeDate: "Date de fermeture",
          consumption: "Consommation",
          roundedBytes: "Octets arrondis",
          operator: "Opérateur",
          cell: "Cellule",
          imei: "IMEI",
          close: "Fermer",
        },
        orders: {
          title: "Demandes",
          close: "Fermer",
        },
        smsUsageModal: {
          title: "Utilisation des SMS",
          direction: "Direction",
          date: "Date",
          sender: "Expéditeur",
          message: "Message",
          status: "Statut",
          close: "Fermer",
        },
      },
      profile: {
        profileDetails: "Détails du profil",
        contactInformation: "Informations de contact",
        professionalInformation: "Informations professionnelles",
        activities: "Activités",
        loadMore: "Charger plus",
      },
      billingProducts: {
        title: "Produits de facturation",
        name: "Nom",
        pricePlan: "Plan tarifaire",
        price: "Prix",
        number: "Numéro",
      },
      invoices: {
        title: "Factures",
        invoiceNo: "Numéro de facture",
        date: "Date",
        amount: "Montant (TTC)",
        description: "Description",
        paid: "Payée",
        download: "Télécharger",
      },
      statements: {
        title: "Relevés de compte",
        cutDate: "Date de clôture",
        description: "Description",
        amount: "Montant (TTC)",
        balance: "Solde",
      },
      orders: {
        title: "Commandes",
        open: "Ouvertes",
        parked: "En attente",
        finished: "Terminées",
        error: "Erreur",
        noOrders: "Aucune commande",
        showAllOrders: "Voir toutes les commandes",
        showLess: "Voir moines de commandes",
      },
      emails: {
        filters: "Filtres",
        category: "Catégorie",
        name: "Nom",
        address: "Adresse",
        actions: "Actions",
        newEmail: "Nouveau courriel",
        edit: "Éditer",
        delete: "Supprimer",
        cancel: "Annuler",
        submit: "Soumettre",
        selectCategory: "Sélectionner la catégorie",
        invoice: "Facture",
        watchdog: "Watchdog",
        updateEmail: "Mettre à jour l'e-mail",
      },
      reports: {
        title: "Rapports",
        reportType: "Type de rapport",
        usage: "Utilisation",
        groupBy: "Grouper par",
        field: "Champ",
        usageType: "Type d'utilisation",
        selectUsageType: "Sélectionner le type d'utilisation",
        data: "Données",
        sms: "SMS",
        all: "Tous",
        imsi: "IMSI",
        eid: "EID",
        network: "Réseau",
        customer: "Client",
        period: "Période",
        day: "Jour",
        month: "Mois",
        year: "Année",
        today: "Aujourd'hui",
        "This Week": "Cette semaine",
        "This Month": "Ce mois-ci",
        "This Year": "Cette année",
        "Last Month": "Le mois dernier",
        "Last Year": "L'année dernière",
        customer: "Client",
        select: "Sélectionner",
        simSearchCriteria: "Critères de recherche de SIM",
        bySpecificImsi: "Par IMSI spécifique",
        byImsiRange: "Par plage IMSI",
        byIccid: "Par ICCID",
        startImsi: "IMSI de début",
        endImsi: "IMSI de fin",
        iccid: "ICCID",
        view: "Voir",
        customerId: "ID client",
        date: "Date",
        startDate: "Depuis",
        simType: "Type de SIM",
        networkCode: "Code réseau",
        networkName: "Nom du réseau",
        country: "Pays",
        totalBytes: "Total octets",
        roundedBytes: "Octets arrondis",
        sessions: "Sessions",
        zeroSessions: "Sessions à zéro",
        actions: "Actions",
        export: "Exporter",
        description: "Description",
        quantity: "Quantité",
        unitPrice: "Prix unitaire",
        tax: "TVA",
        costWithoutTax: "Prix hors taxe",
        costWithTax: "Prix après taxe",
        currency: "Devise",
        offerName: "Forfait",
        id: "ID",
        name: "Nom",
        status: "Statut",
        creator: "Créateur",
        creationDate: "Date de Création",
        offer: "Forfait",
        activations: "Activations",
        terminations: "Résiliations",
        automated: {
          title: "Rapports automatisés",
          name: "Nom",
          type: "Type",
          frequency: "Fréquence",
          nextReport: "Prochain rapport",
          new: "Nouveau rapport automatisé",
          save: "Enregistrer",
          daily: "Quotidien",
          weekly: "Hebdomadaire",
          monthly: "Mensuel",
          edit: "Éditer",
          delete: "Supprimer",
          actions: "Actions",
        },
        history: {
          title: "Historique des rapports",
          tableHeaders: {
            reportName: "Nom du rapport",
            date: "Date",
            status: "Statut",
            download: "Télécharger",
            actions: "Actions",
          },
          delete: "Supprimer",
          completed: "Complété",
          incomplete: "Incomplet",
        },
      },
      timeoutReports: {
        view: "Afficher",
        delete: "Supprimer",
      },
      alerts: {
        title: "Alertes",
        filters: "Filtres",
        alert: "Alerte",
        date: "Date",
        imsi: "IMSI",
        enterValue: "Saisir une valeur",
      },
      settings: {
        title: "Paramètres",
        profileSettings: "Paramètres du profil",
        general: "Général",
        account: "Compte",
        profileImage: "Image de profil",
        whitelabel: "Marque blanche",
        privacyAndSafety: "Confidentialité et sécurité",
        notifications: "Notifications",
        billing: "Facturation",
        invoice: "Facture",
        importSim: "Importer SIM",
        mailConfig: "Serveur de messagerie",
        generalSettings: {
          title: "Paramètres généraux",
          timeZone: "Fuseau horaire",
          dateFormat: "Format de date",
          timeFormat: "Format de l'heure",
          save: "Enregistrer",
        },
        accountSettings: {
          title: "Paramètres du compte",
          fullName: "Nom complet",
          address: "Adresse",
          city: "Ville",
          country: "Pays",
          postcode: "Code postal",
          telephone: "Téléphone",
          mobileNumber: "Mobile",
          email: "E-mail",
          occupation: "Profession",
          company: "Entreprise",
          tin: "Numéro fiscal",
          username: "Nom d'utilisateur",
          changePassword: "Changer le mot de passe",
          password: "Mot de passe",
          confirmPassword: "Confirmer le mot de passe",
          save: "Enregistrer",
        },
        profileImageSettings: {
          title: "Paramètres de l'image de profil",
          upload: "Téléverser",
          save: "Enregistrer",
        },
        whitelabelSettings: {
          title: "Paramètres de marque blanche",
          backgroundColor: "Couleur de fond",
          fontColor: "Couleur de la police",
          accentColor: "Couleur d'accentuation",
          sidebarPosition: "Position de la barre latérale",
          favicon: "Favicon",
          whitelabelImage: "Image de marque blanche",
          upload: "Téléverser",
          save: "Enregistrer",
        },
        privacySettings: {
          title: "Paramètres de confidentialité",
          enable2FA: "Activer 2FA",
          save: "Enregistrer",
        },
        notificationSettings: {
          title: "Paramètres de notification",
          receiveNotifications: "Recevoir des notifications",
          sms: "SMS",
          email: "E-mail",
          weeklyAnalytics: "Analyses hebdomadaires",
          checkIfYouWantToReceiveWeeklyAnalytics:
            "Cochez si vous souhaitez recevoir des analyses hebdomadaires",
          notifyAboutNewAlerts: "Notifier en cas de nouvelles alertes",
          checkIfYouWantToReceiveNotificationsWhenThereAreNewAlerts:
            "Cochez si vous souhaitez recevoir des notifications en cas de nouvelles alertes",
          submit: "Soumettre",
        },
        billingSettings: {
          title: "Paramètres de facturation",
          selectCurrency: "Sélectionner la devise",
          currency: "Devise",
          preferredLanguage: "Langue préférée",
          selectLanguage: "Sélectionner la langue",
          submit: "Soumettre",
        },
        invoiceSettings: {
          title: "Paramètres de la facture",
          name: "Nom",
          showGuis: "Afficher les interfaces",
          showSubtotal: "Afficher le sous-total",
          showLineOfService: "Afficher la ligne de service",
          save: "Enregistrer",
        },
        importSimSettings: {
          title: "Importer SIM",
          provider: "Fournisseur",
          selectProvider: "Sélectionnez un fournisseur",
          submit: "Soumettre",
          inputType: "Type d'entrée",
          selectInputType: "Sélectionnez un Type d'entrée",
          single: "Entrée unique",
          file: "Entrée par fichier",
        },
        mailConfig: {
          title: "Paramètres du Serveur Mail",
          host: "Adresse de l’hôte SMTP",
          port: "Port SMTP",
          fromAddress: "Adresse de l’expéditeur",
          username: "Nom d’utilisateur",
          changePassword: "Changer le mot de passe",
          password: "Mot de passe",
          confirmPassword: "Confirmer le mot de passe",
          useTLS: "Utiliser TLS",
          save: "Enregistrer les paramètres",
          success: "Paramètres du serveur mail enregistrés avec succès",
          error: "Échec de l’enregistrement des paramètres du serveur mail",
          healthStatus: "État de Santé",
          healthUp: "En Bon État (UP)",
          healthDown: "En Panne (DOWN)",
          healthUnknown: "Inconnu",
          lastCheckedAt: "Dernière Vérification",
        },
        purchaseOrderConfig: {
          title: "Configuration du bon de commande",
          sellerName: "Nom du vendeur",
          host: "Adresse de l’hôte SMTP",
          port: "Port SMTP",
          fromAddress: "Adresse de l’expéditeur",
          username: "Nom d’utilisateur",
          changePassword: "Changer le mot de passe",
          password: "Mot de passe",
          confirmPassword: "Confirmer le mot de passe",
          useTLS: "Utiliser TLS",
          save: "Enregistrer les paramètres",
          success: "Paramètres du serveur mail enregistrés avec succès",
          error: "Échec de l’enregistrement des paramètres du serveur mail",
          healthStatus: "État de Santé",
          healthUp: "En Bon État (UP)",
          healthDown: "En Panne (DOWN)",
          healthUnknown: "Inconnu",
          lastCheckedAt: "Dernière Vérification",
        },
        platformConfig: {
          title: "Configuration de la plateforme",
          dataStreamingEnabled: "Data Streaming Activé",
          maintenanceMode: "Mode de Maintenance",
          maintenanceMessage: "Message de maintenance",
          maintenanceMessagePlaceholder:
            "Entrez le message de maintenance ici...",
          save: "Enregistrer les paramètres",
          reset: "Réinitialiser aux valeurs par défaut",
        },
        crmConfig: {
          title: "Configuration du CRM",
          type: "Type de CRM",
          authType: "Type d'authentification",
          selectAuthType: "Sélectionnez le type d'authentification",
          selectType: "Sélectionnez le type de CRM",
          username: "Nom d'utilisateur",
          changePassword: "Changer le mot de passe ?",
          changeToken: "Changer le jeton ?",
          password: "Mot de passe",
          confirmPassword: "Confirmer le mot de passe",
          token: "Jeton",
        },
      },
      privileges: {
        title: "Privilèges",
        name: "Nom",
        actions: "Actions",
        newPrivilege: "Nouveau privilège",
        edit: "Éditer",
        delete: "Supprimer",
      },
      table: {
        page: "Page",
        of: "de",
        show: "Afficher",
        goToPage: "Aller à la page",
      },
      notifications: {
        title: "Notifications",
        id: "ID",
        date: "Date",
        message: "Message",
        type: "Type",
      },
      whitelist: {
        title: "Adresse IP autorisée",
        ip: "Adresse IP",
        active: "Active",
        createdAt: "Date d'ajout",
        updatedAt: "Dernière mise à jour",
        lastUsed: "Dernière utilisation",
        new: "Nouvelle adresse IP",
      },
      customFields: {
        title: "Champs personnalisés",
        new: "Nouveau champ personnalisé",
        name: "Nom",
        type: "Type",
        createdAt: "Date de création",
        updatedAt: "Date de mise à jour",
        edit: "Éditer",
        delete: "Supprimer",
        submit: "Soumettre",
        cancel: "Annuler",
        actions: "Actions",
        selectType: "Sélectionner le type",
        text: "Texte",
        number: "Nombre",
      },
      documentation: {
        introduction: {
          welcomeTitle: "Bienvenue sur {{brand}}",
          welcomeText:
            "{{brand}} est votre plateforme tout-en-un pour gérer facilement vos cartes SIM. Surveillez l'utilisation, activez de nouvelles lignes et gardez vos opérations fluides—le tout depuis un seul tableau de bord.",
          getStarted: "Commencer",
        },
        dashboard: {
          title: "Aperçu du tableau de bord",
          description:
            "Le tableau de bord est l’écran principal de suivi et d’analyse de l’activité des cartes SIM via la plateforme {{brand}}...",
          goal: "L’objectif du tableau de bord est de fournir aux utilisateurs un outil de supervision immédiat...",
          cards: {
            title: "Cartes de statistiques (haut de l’écran)",
            dataVolume: {
              title: "Volume de données",
              description:
                "Indique le volume total de données consommées aujourd’hui, avec une comparaison par rapport à la veille.",
            },
            dataSessions: {
              title: "Sessions de données",
              description:
                "Affiche le nombre de connexions établies aujourd’hui, comparé à la veille.",
            },
            alerts: {
              title: "Alertes de consommation",
              description:
                "Affiche le nombre d’alertes de consommation générées aujourd’hui en raison du dépassement des seuils.",
            },
            zeroSessions: {
              title: "Sessions à consommation nulle",
              description:
                "Indique combien de sessions de données ont enregistré une consommation nulle sur la période sélectionnée.",
            },
          },
          charts: {
            title: "Graphiques et cartes détaillés",
            dataSessionsMap: {
              title: "Répartition géographique des connexions de données",
              description:
                "La carte affiche les pays ayant le plus grand nombre de connexions. Depuis le menu situé en haut à droite de la carte, vous pouvez choisir l’information à afficher : Data Sessions, Data Volume ou Zero Sessions.",
            },
            avgDataAndActiveSims: {
              title: "Consommation moyenne de données et SIM actives",
              description:
                "Fournit la consommation moyenne de données par connexion et le nombre total de SIM actives.",
            },
            dataVolumePerHour: {
              title: "Répartition horaire de la consommation de données",
              description:
                "Le graphique présente la consommation de données par tranche de trois heures et par jour de la semaine pour le mois en cours, offrant une vision plus complète des périodes de forte activité des SIM.",
            },
            monthlyDataVolume: {
              title: "Répartition mensuelle de la consommation de données",
              description:
                "Le graphique présente la répartition mensuelle de la consommation de données au cours des 12 derniers mois. Depuis le menu situé en haut à droite de la carte, vous pouvez choisir l’information à afficher : Data Sessions, Data Volume ou Zero Sessions.",
            },
            topMetrics: {
              title: "Métriques principales",
              description:
                "Ce graphique met en évidence les cartes SIM ayant le plus grand nombre de connexions pour la période sélectionnée. Il permet d’identifier rapidement les SIM les plus actives du réseau, d’analyser les habitudes d’utilisation, de détecter les utilisateurs intensifs et d’optimiser l’allocation des ressources.",
            },
            dataVolumePerNetwork: {
              title:
                "Consommation de données par réseau - SIM actives par réseau",
              description:
                "Ces graphiques offrent une vue comparative de l’activité des réseaux dans le pays sélectionné. Le premier montre la répartition de la consommation totale de données par réseau mobile, aidant à évaluer la charge, identifier les concentrations d’utilisation et comparer les performances des opérateurs. Le second montre la répartition des SIM actives par réseau, fournissant des informations sur la couverture et la part de marché. Ensemble, ils donnent une compréhension complète de la façon dont vos SIM interagissent avec les différents réseaux et mettent en évidence les schémas de connectivité et d’utilisation.",
            },
            simCardsPerOffer: {
              title: "Cartes SIM par offre et par statut",
              description:
                "Ces graphiques offrent une vue d’ensemble de votre portefeuille de SIM. Le premier montre la répartition par offre et forfait, permettant d’identifier les préférences et les services les plus populaires. Le second montre la répartition par statut, donnant de la visibilité sur les étapes du cycle de vie et la disponibilité. Ensemble, ils aident à surveiller les tendances d’utilisation, les stocks et l’efficacité globale de la gestion des SIM.",
            },
            alerts: {
              title: "Alertes de consommation",
              description:
                "Ce tableau présente les alertes de consommation générées par le mécanisme de surveillance WatchDog. WatchDog surveille en continu l’utilisation des données SIM et déclenche des alertes lorsque des seuils prédéfinis sont atteints.",
              types: {
                warning:
                  "Warning : déclenchée lorsque la consommation atteint 80 % du volume alloué.",
                depleted:
                  "Depleted : déclenchée lorsque la consommation atteint 100 % du volume alloué.",
              },
              note: "Ces alertes vous aident à agir rapidement afin d’éviter des interruptions de service ou des coûts imprévus. Une analyse plus détaillée de WatchDog et de sa logique sera présentée dans le chapitre correspondant de la documentation.",
            },
          },
          utility: {
            title: "Utilité du tableau de bord",
            description:
              "Grâce à la présentation unifiée des indicateurs clés, tendances et alertes, le tableau de bord permet une détection rapide des problèmes et une meilleure prise de décision.",
          },
        },
        simCards: {
          introduction: {
            title: "Introduction aux cartes SIM",
            description:
              "Ce chapitre fournit toutes les informations nécessaires sur les cartes SIM dans la plateforme {{brand}}.",
            details:
              "Vous apprendrez comment les cartes SIM sont gérées, surveillées et analysées, avec des informations sur la consommation de données, la connectivité, les alertes et les étapes du cycle de vie.",
            getStarted: "Commencer",
          },
          lifecycle: {
            title: "Cycle de vie des SIM",
            intro:
              "Les cartes SIM de la plateforme passent par différents statuts de cycle de vie. Chaque statut est représenté par un cercle coloré et dispose de transitions spécifiques autorisées.",
            status: {
              productive: "Active et en cours d’utilisation.",
              suspended: "Suspendue manuellement.",
              autoSuspended: "Suspendue automatiquement.",
              onstock: "Disponible mais inactive.",
              deleted: "Supprimée et inactive.",
            },
            diagramDescription:
              "Ce diagramme montre les états du cycle de vie des SIM et les transitions possibles entre eux. Les transitions peuvent être déclenchées manuellement (par exemple, activer une SIM de OnStock à Productive) ou automatiquement (comme lorsqu’un processus suspend automatiquement une SIM lorsque des limites sont atteintes). Ces transitions garantissent un contrôle approprié de l’activité, de la disponibilité et de la désactivation des SIM sur la plateforme.",
          },
          panel: {
            title: "Panneau SIMs",
            intro:
              "Le panneau SIMs fournit une vue d’ensemble de toutes les cartes SIM de la plateforme. Il vous permet de surveiller l’activité, d’analyser la consommation de données et de gérer efficacement les étapes du cycle de vie.",
            summary: {
              title: "Cartes Résumé & Filtres",
              intro:
                "En haut du panneau, trois cartes présentent un aperçu rapide de l’utilisation des SIMs pour le mois en cours :",
              dataVolume: "Volume de Données – données totales consommées.",
              dataSessions: "Sessions de Données – nombre de connexions.",
              zeroSessions: "Sessions Zéro – sessions sans données.",
              filters:
                "Les filtres permettent de restreindre les SIMs par IMSI, ICCID, MSISDN, état de la SIM, offre, type de SIM ou volume de données. Le tri peut être appliqué sur plusieurs champs tels que IMSI ou utilisation.",
            },
            table: {
              title: "Tableau SIM",
              intro:
                "Le tableau principal répertorie toutes les cartes SIM avec leurs détails clés :",
              activeSession:
                "Session Active – indicateur d’activité en direct.",
              identifiers: "Identifiants – IMSI, ICCID, MSISDN.",
              state:
                "État SIM – statut du cycle de vie (ex. : Active, Suspendue).",
              offer: "Offre – plan d’abonnement (le cas échéant).",
              data: "Données – volume d’utilisation pour le mois.",
              type: "Type de SIM – type de produit (ex. : embarquée, industrielle).",
              footer:
                "La pagination et les opérations groupées sont également prises en charge pour une gestion efficace des SIMs.",
            },
          },
          simProvisioning: {
            introduction: {
              title: "Provisionnement des SIM",
              description:
                "Le provisionnement des SIM fait référence à l’ensemble des fonctionnalités qui permettent aux administrateurs de gérer le cycle de vie des cartes SIM au sein de la plateforme. Grâce au provisionnement, vous pouvez :",
              closing:
                "Ces actions garantissent que les SIM sont correctement provisionnées, contrôlées et désactivées, soutenant à la fois la flexibilité opérationnelle et la sécurité.",
            },
            actions: {
              activate: {
                title: "Activer",
                description:
                  "mettre une SIM en service pour une utilisation productive.",
                details: {
                  intro:
                    "Pour activer une ou plusieurs cartes SIM, il existe trois méthodes :",
                  steps: [
                    "En sélectionnant les cartes SIM dans le tableau en cochant les cases et, dans le menu Opérations groupées en haut à droite, sélectionner Activer.",
                    "En cliquant directement sur le même menu et en utilisant un fichier Excel contenant les numéros IMSI/ICCID dans la colonne A avec le titre correspondant (IMSI/ICCID) dans la cellule A1.",
                    "En cliquant sur la ligne, une carte latérale s’affiche avec le profil de la SIM, en haut de laquelle se trouve un bouton Activer.",
                  ],
                  important:
                    "Important ! Toutes les cartes SIM sélectionnées doivent être dans l’état EnStock pour pouvoir être activées.",
                  closing:
                    "Après avoir suivi les étapes décrites, une fenêtre de confirmation en 2 étapes apparaîtra : l’utilisateur devra choisir l’Offre sous laquelle il souhaite activer les cartes SIM. Optionnellement, il peut définir certains champs personnalisés pour ces SIMs. Lors de la deuxième étape, l’utilisateur vérifie les SIMs sélectionnées et procède à l’activation.",
                },
              },
              suspend: {
                title: "Suspendre",
                description: "désactiver temporairement la connectivité.",
                details: {
                  intro:
                    "De la même manière que pour l’activation, pour suspendre une ou plusieurs cartes SIM, l’utilisateur dispose des mêmes options :",
                  steps: [
                    "En sélectionnant les cartes SIM dans le tableau en cochant les cases et, dans le menu Opérations groupées en haut à droite, sélectionner Suspendre.",
                    "En cliquant directement sur le même menu et en utilisant un fichier Excel contenant les numéros IMSI/ICCID dans la colonne A avec le titre correspondant (IMSI/ICCID) dans la cellule A1.",
                    "En cliquant sur la ligne, une carte latérale s’affiche avec le profil de la SIM, en haut de laquelle se trouve un bouton Suspendre.",
                  ],
                  important:
                    "Important ! Toutes les cartes SIM sélectionnées doivent être dans l’état Productif pour pouvoir être suspendues.",
                  closing:
                    "Après avoir suivi les étapes décrites, une fenêtre de confirmation apparaîtra, où l’utilisateur vérifiera les SIMs sélectionnées et procédera à la suspension.",
                },
              },
              resume: {
                title: "Reprendre",
                description: "réactiver une SIM suspendue.",
                details: {
                  intro:
                    "De la même manière, pour reprendre une ou plusieurs cartes SIM, l’utilisateur dispose des mêmes options :",
                  steps: [
                    "En sélectionnant les cartes SIM dans le tableau en cochant les cases et, dans le menu Opérations groupées en haut à droite, sélectionner Reprendre.",
                    "En cliquant directement sur le même menu et en utilisant un fichier Excel contenant les numéros IMSI/ICCID dans la colonne A avec le titre correspondant (IMSI/ICCID) dans la cellule A1.",
                    "En cliquant sur la ligne, une carte latérale s’affiche avec le profil de la SIM, en haut de laquelle se trouve un bouton Reprendre.",
                  ],
                  important:
                    "Important ! Toutes les cartes SIM sélectionnées doivent être dans l’état Suspendu ou AutoSuspendu pour pouvoir être reprises.",
                  closing:
                    "Après avoir suivi les étapes décrites, une fenêtre de confirmation apparaîtra, où l’utilisateur vérifiera les SIMs sélectionnées et procédera à la reprise.",
                },
              },
              terminate: {
                title: "Résilier",
                description:
                  "retirer une SIM de l’utilisation active (vers En Stock ou Supprimé).",
                details: {
                  intro:
                    "De la même manière, pour résilier une ou plusieurs cartes SIM, l’utilisateur dispose des mêmes options :",
                  steps: [
                    "En sélectionnant les cartes SIM dans le tableau en cochant les cases et, dans le menu Opérations groupées en haut à droite, sélectionner Résilier.",
                    "En cliquant directement sur le même menu et en utilisant un fichier Excel contenant les numéros IMSI/ICCID dans la colonne A avec le titre correspondant (IMSI/ICCID) dans la cellule A1.",
                    "En cliquant sur la ligne, une carte latérale s’affiche avec le profil de la SIM, en haut de laquelle se trouve un bouton Résilier.",
                  ],
                  important:
                    "Important ! Toutes les cartes SIM sélectionnées doivent être dans l’état Productif pour pouvoir être résiliées.",
                  closing:
                    "Après avoir suivi les étapes décrites, une fenêtre de confirmation apparaîtra, où l’utilisateur devra choisir l’état cible (EnStock ou Supprimé définitivement) de la résiliation, vérifier les SIMs sélectionnées et procéder à la résiliation.",
                },
              },
              modify: {
                title: "Modifier",
                description:
                  "modifiez l’Offre sous laquelle la carte est activée et facturée.",
                details: {
                  intro: "Pour modifier l’offre d’une carte SIM :",
                  steps: [
                    "En sélectionnant la SIM dans le tableau en cochant sa case et, dans le menu Actions en haut à droite, sélectionner Modifier.",
                  ],
                  important:
                    "Important ! La carte SIM sélectionnée doit être dans l’état Productif pour pouvoir être modifiée.",
                  closing:
                    "Après avoir suivi les étapes décrites, une fenêtre de confirmation apparaîtra : l’utilisateur devra choisir l’Offre cible souhaitée pour la carte SIM. Ensuite, il vérifie la carte SIM sélectionnée et procède à la modification.",
                },
              },
            },
          },
          simProfile: {
            title: "Profil SIM",
            description:
              "Le Profil SIM est un tableau de bord qui se concentre sur les statistiques et les fonctionnalités d’une seule carte SIM. Il fournit des statistiques similaires au tableau de bord principal ainsi que des informations détaillées pour l’analyse et la gestion.",
            items: {
              kpis: "KPIs et statistiques d’utilisation",
              monthly: "Répartition mensuelle de l’utilisation",
              hlr: "Profil HLR (si applicable)",
              dataSessions: "Historique des sessions de données",
              smsUsage: "Historique d’utilisation des SMS",
              requests: "Demandes effectuées pour cette carte SIM",
              provisioning: "Activité et fonctionnalités de provisioning SIM",
              cellInfo: "Informations cellule et connectivité",
              watchdogs: "Informations et alertes des watchdogs",
            },
            sections: {
              howToAccess: {
                title: "Comment accéder",
                description:
                  "Pour accéder au profil d’une carte SIM spécifique, sélectionnez la SIM dans le tableau et cliquez dessus. Un panneau latéral s’affichera avec les informations de la SIM. À l’intérieur de ce panneau, un lien 'Visiter le profil' vous redirige vers la page complète du Profil SIM. La page Profil SIM fournit des statistiques détaillées, l’historique d’utilisation, les actions de provisioning et les informations techniques concernant la SIM sélectionnée.",
              },
              kpis: {
                title: "Indicateurs Clés (KPIs)",
                description:
                  "La section KPI du profil SIM fournit un aperçu rapide des performances et de l’activité de la SIM. Ces indicateurs aident l’utilisateur à comprendre instantanément l’utilisation et l’état de la SIM.",
                bullets: [
                  "Volume de Données – le volume total de données consommées par la SIM pendant la période sélectionnée.",
                  "Sessions de Données – le nombre de sessions de données établies pendant la période sélectionnée.",
                  "Alertes – le nombre d’alertes déclenchées pour cette SIM (par ex. seuils d’utilisation).",
                  "Sessions Zéro – le nombre de sessions où la SIM a tenté de se connecter sans consommer de données.",
                ],
                closing:
                  "En haut à droite, l’utilisateur peut filtrer les KPIs par période (Quotidien, Mensuel ou Annuel) pour analyser les tendances d’utilisation au fil du temps.",
              },
              monthly: {
                title: "Répartition mensuelle",
                description:
                  "Répartition des données, SMS et sessions par mois.",
              },
              hlr: {
                title: "Profil HLR",
                description:
                  "Le profil HLR (Home Location Register) fournit des informations détaillées sur l’abonnement et le réseau de la carte SIM. En cliquant sur le bouton HLR dans le menu Actions, une fenêtre s’ouvre affichant des détails tels que :",
                fields: {
                  msisdn: "MSISDN",
                  imsi: "IMSI",
                  networkAccessMode: "Mode d’accès réseau (ex. CS et PS)",
                  subscriberType: "Type d’abonné (ex. abonné LTE)",
                  simStatus: "Statut SIM (ex. Disponible)",
                },
                scopes:
                  "De plus, l’utilisateur peut sélectionner dans une liste déroulante les portées disponibles (ex. Informations de base, Informations étendues) afin d’afficher les détails correspondants en fonction du niveau d’information requis.",
                closing:
                  "Cette fonctionnalité permet aux administrateurs de valider rapidement les détails de provisionnement de la SIM et de confirmer que la SIM est correctement enregistrée et disponible sur le réseau.",
              },
              dataSessions: {
                title: "Sessions de données",
                description:
                  "La fonctionnalité Sessions de données permet aux administrateurs de consulter l’historique détaillé de toutes les sessions de données associées à une carte SIM. En cliquant sur le bouton Sessions dans le menu Actions, une fenêtre modale s’ouvre et affiche l’historique des sessions et les informations associées.",
                fields: {
                  openDate: "Horodatage du début de la session",
                  closeDate: "Horodatage de la fin de la session",
                  consumption:
                    "Nombre réel d’octets consommés pendant la session",
                  roundedBytes:
                    "Utilisation arrondie selon les politiques de facturation de l’opérateur",
                  operator: "L’opérateur réseau gérant la session",
                  cell: "Identifiant de la cellule où la session a été établie",
                  imei: "Identifiant de l’appareil (IMEI) utilisé pour cette session",
                },
              },
              smsUsage: {
                title: "Utilisation SMS",
                description:
                  "La fenêtre d'utilisation des SMS permet aux administrateurs de surveiller tous les messages SMS envoyés et reçus par la carte SIM. En cliquant sur le bouton Utilisation SMS dans le menu Actions, un tableau détaillé apparaît répertoriant chaque transaction SMS.",
                fields: {
                  direction: "Direction (par ex., Entrant ou Sortant)",
                  date: "Date et heure de l’événement SMS",
                  sender: "L’expéditeur du SMS",
                  message: "Le contenu du message SMS (si disponible)",
                  status:
                    "Statut de livraison (par ex., Soumis, Livré, Échoué)",
                },
                note: "Cette fonctionnalité fournit une traçabilité complète du trafic SMS à des fins de dépannage, de conformité ou d’analyse d’utilisation.",
              },
              requests: {
                title: "Requêtes",
                description:
                  "La section Requêtes fournit un historique complet de toutes les commandes de provisioning effectuées pour la carte SIM sélectionnée. En cliquant sur le bouton Requêtes dans le menu Actions, une fenêtre modale apparaît listant toutes les commandes, telles qu’Activer, Suspendre, Reprendre et Résilier.",
                fields: {
                  id: "ID : L’identifiant unique de la commande.",
                  name: "Nom : Le type d’action (ex. SuspendSIM, ResumeSIM, TerminateSIM).",
                  status:
                    "Statut : L’état d’exécution de la commande (ex. Terminé, En attente).",
                  creator: "Créateur : L’utilisateur ayant initié la requête.",
                  creationDate:
                    "Date de création : Date de création de la commande.",
                  lastUpdate:
                    "Dernière mise à jour : Horodatage de la dernière mise à jour de l’état.",
                },
                note: "Cette fonctionnalité permet aux administrateurs de suivre toutes les activités de provisioning effectuées sur la SIM, garantissant transparence et responsabilité dans la gestion du cycle de vie.",
              },

              provisioning: {
                title: "Activité de provisioning",
                description:
                  "Actions de provisioning telles qu’activation, suspension et modifications.",
              },
              cellInfo: {
                title: "Informations Cellule",
                description:
                  "Informations antenne et données de connexion pour la SIM.",
              },
              watchdogs: {
                title: "Surveillances (Watchdogs)",
                description:
                  "La section Watchdogs du profil SIM affiche les surveillances configurées associées à la carte SIM. Ces surveillances sont généralement définies au niveau de la plateforme et liées à une SIM pour contrôler certaines conditions.",
                bullets: [
                  "Consulter la liste des surveillances actives liées à la SIM.",
                  "Vérifier leur configuration (par ex. type de surveillance, état et limites définies).",
                  "Suivre quelles surveillances contrôlent actuellement l’activité de la SIM.",
                ],
                note: "Remarque : La configuration des seuils, alertes ou actions automatiques n’est pas disponible depuis le profil SIM. Cette section est en lecture seule et sert uniquement au suivi.",
              },
            },
          },
          simTransfers: {
            title: "Transferts de SIM",
            description:
              "La fonctionnalité de transfert de SIM permet aux administrateurs de déplacer des cartes SIM entre des comptes ou des entités. Ceci est utile pour réallouer des SIM, les expédier à une autre organisation ou gérer les changements de propriété.",

            howToAccess: {
              title: "Comment accéder",
              description:
                "Pour accéder aux transferts de SIM, allez dans la section Gestion des utilisateurs, ouvrez le menu Actions d’un utilisateur et sélectionnez l’option 'Expédier des SIMs'.",
            },

            steps: {
              title: "Étapes pour effectuer un transfert de SIM",
              description:
                "Le processus de transfert se compose des étapes suivantes :",
              bullets: [
                "Assurez-vous que les cartes SIM sont dans l’état 'En Stock' avant de commencer le transfert. Seules les SIM disponibles peuvent être transférées entre comptes.",
                "Choisissez un type de sélection de SIM : IMSI unique, ICCID unique, plage IMSI, plage ICCID ou importation de fichier CSV/XLSX. Cela détermine comment identifier les SIM à transférer.",
                "Saisissez ou importez les identifiants SIM nécessaires en fonction du type de sélection choisi.",
                "Définissez éventuellement le prix et le pourcentage de TVA. Ces champs permettent de suivre les implications financières du transfert.",
                "Sélectionnez une Offre de facturation. C’est l’offre qui sera facturée au compte source lorsque le compte de destination activera la carte SIM transférée.",
                "Cliquez sur 'Soumettre' pour finaliser le transfert de SIM. Une fois confirmé, les SIM apparaîtront dans l’inventaire du compte de destination.",
              ],
            },
            deallocate: {
              title: "Désallocation de SIMs",
              description:
                "La désallocation est la procédure inverse d’un transfert de SIM. Elle permet aux utilisateurs de retirer des cartes SIM d’un compte de destination et de les renvoyer au compte source ou au stock. Cela est utile lorsque des SIMs ont été attribuées par erreur, ne sont plus nécessaires ou doivent être réaffectées.",
              bullets: [
                "Accédez à la section Gestion des Utilisateurs, ouvrez le menu Actions pour un utilisateur et sélectionnez 'Désallocation de SIMs'.",
                "Assurez-vous que les cartes SIM sont dans l’état 'En Stock' ou 'Attribuées' avant de tenter la désallocation.",
                "Choisissez un type de sélection SIM : IMSI unique, ICCID unique, plage IMSI, plage ICCID ou fichier CSV/XLSX.",
                "Saisissez ou importez les identifiants des SIMs à désallouer.",
                "Confirmez les comptes source et destination. Le champ 'De' indique le compte actuel, et le champ 'Vers' indique le compte ou le stock auquel les SIMs seront retournées.",
                "Cliquez sur 'Soumettre' pour finaliser la désallocation. Une fois confirmées, les SIMs ne figureront plus dans l’inventaire du compte de destination et seront disponibles pour une nouvelle affectation.",
              ],
            },
          },
        },
        watchdog: {
          title: "Watchdog",
          description:
            "Les Watchdogs sont des règles de surveillance qui aident les utilisateurs à contrôler l’utilisation des cartes SIM et à détecter un comportement anormal. Ils permettent une gestion proactive en définissant des seuils sur des indicateurs tels que le volume de données, les sessions ou l’utilisation des SMS. Lorsqu’un seuil est dépassé, le système peut générer des alertes ou déclencher des actions pour éviter une utilisation abusive ou des coûts inattendus.",
          items: {
            add: "Comment ajouter un Watchdog",
            remove: "Comment supprimer un Watchdog",
            reset: "Comment réinitialiser un Watchdog",
            suspensionBlock:
              "Bloquer la suspension de la SIM pendant la période de facturation en cours",
            alerts: "Alertes générées par les Watchdogs",
          },
          add: {
            title: "Ajouter un Watchdog",
            description:
              "Les utilisateurs peuvent créer un nouveau watchdog pour surveiller l’activité des SIM et déclencher des actions automatiques lorsque l’utilisation dépasse les seuils définis. Cela permet une gestion proactive des SIM et un meilleur contrôle des coûts.",
            howToAccess:
              "Pour ajouter un nouveau watchdog, allez dans le Panneau SIM → Opérations groupées → Watchdogs → Créer un Watchdog. Important : toutes les cartes SIM doivent être à l’état Productive (activées) pour configurer un watchdog.",
            fields: {
              actionType:
                "Sélectionnez l’action à effectuer lorsque le seuil est atteint (par ex., notifier, suspendre).",
              interval:
                "Choisissez la période de suivi (quotidienne, hebdomadaire, mensuelle).",
              amount: "Entrez le seuil d’utilisation qui déclenchera l’action.",
              service:
                "Sélectionnez le service à surveiller (par ex., Données, SMS).",
              unitType:
                "Choisissez l’unité de mesure (par ex., octets, nombre de SMS).",
              warnings:
                "Définissez des seuils d’alerte anticipés avant l’action principale pour avertir les utilisateurs à l’avance.",
              suspendInterval:
                "Définit la durée pendant laquelle la SIM reste suspendue une fois le watchdog déclenché. Si quotidien, la SIM sera réactivée à minuit le lendemain. Si hebdomadaire, à minuit le lundi suivant. Si mensuel, à minuit le premier jour du mois suivant.",
            },
          },
          removeAll: {
            title: "Supprimer Tous les Watchdogs",
            description:
              "Les utilisateurs peuvent supprimer tous les watchdogs configurés d’une carte SIM en une seule action. Cela est utile pour réinitialiser rapidement la surveillance sans avoir à supprimer chaque watchdog individuellement.",
            howToAccess:
              "Pour supprimer tous les watchdogs, allez dans le panneau SIM → sélectionnez les cartes SIM actives → Opérations groupées → Watchdogs → Supprimer tous les Watchdogs.",
            details: {
              title: "Détails",
              immediateEffect:
                "Lors de l’exécution, toutes les configurations de watchdog existantes sur les SIM sélectionnées seront supprimées.",
              noAlerts:
                "Aucune alerte ni action automatique ne sera déclenchée après la suppression.",
              cleanSlate:
                "La carte SIM continuera de fonctionner normalement, mais sans surveillance jusqu’à ce que de nouveaux watchdogs soient créés.",
            },
            useCases: {
              title: "Cas d’Utilisation",
              policyChanges:
                "Lorsque les politiques de surveillance changent, il peut être nécessaire de supprimer les watchdogs existants.",
              testing:
                "Dans les environnements de test, de nombreux watchdogs peuvent être créés puis supprimés rapidement pour nettoyage.",
              errorRecovery:
                "Si des watchdogs mal configurés ou conflictuels existent, leur suppression les réinitialise à un état neutre.",
            },
            considerations: {
              title: "Considérations",
              irreversible:
                "La suppression de tous les watchdogs est irréversible ; ils doivent être recréés si nécessaire.",
              criticalMonitoring:
                "Assurez-vous que les SIM ne restent pas sans surveillance dans des environnements critiques.",
              bulkOperations:
                "Dans les opérations groupées, vérifiez attentivement car toutes les SIM sélectionnées seront affectées.",
            },
          },
          reset: {
            title: "Réinitialiser le Watchdog",
            description:
              "La réinitialisation d’un watchdog remet à zéro son compteur de consommation et rétablit la suspension si l’utilisateur avait choisi de la bloquer pour la période de facturation en cours. Cela permet de relancer la surveillance sans créer un nouveau watchdog.",
            howToAccess: {
              title: "Comment y accéder",
              description:
                "Accédez au profil de la carte SIM. Dans la section Watchdog, cliquez sur l’icône de flèche circulaire à côté du watchdog concerné pour le réinitialiser.",
            },
          },
          blockSuspension: {
            title: "Bloquer la Suspension",
            description:
              "Le blocage de la suspension empêche la suspension d’une carte SIM lorsqu’un watchdog qui surveille sa consommation déclenche une alerte de consommation à 100 % (alerte d’épuisement). Cette fonctionnalité est valable uniquement pour la période de facturation en cours. Au début de la période suivante, la suspension est automatiquement rétablie.",
            howToAccess: {
              title: "Comment y accéder",
              description:
                "Sélectionnez les cartes SIM en état 'Productive' dans le panneau SIM. Ensuite, ouvrez Opérations Groupées → Watchdogs → Bloquer la Suspension.",
            },
          },
          alerts: {
            title: "Alertes",
            description:
              "Les watchdogs surveillant la consommation des SIM déclenchent des alertes. Les alertes permettent aux utilisateurs de suivre les seuils d’utilisation et d’agir en conséquence.",
            typesTitle: "Types d’Alertes",
            types: {
              depleted:
                "Épuisée : Générée pour tous les watchdogs. Déclenchée lorsqu’une carte SIM atteint 100% de sa consommation.",
              warning:
                "Avertissement : Générée en option pour les watchdogs ayant défini des seuils d’avertissement.",
            },
            howToAccess: {
              title: "Comment y accéder",
              description:
                "Pour consulter les alertes, accédez au menu 'Alertes' dans la barre latérale. Le tableau répertorie les alertes triées par date (les plus récentes en premier) et inclut des filtres par type, date et IMSI.",
            },
          },
        },
        reports: {
          intro: {
            title: "Rapports",
            description:
              "La plateforme permet aux utilisateurs de consulter et d’exporter une grande variété de rapports, tels que la consommation de cartes SIM, les listes de factures, le détail des lignes de factures, les demandes de provisioning SIM, l’activité du portefeuille (activations et résiliations par offre), la répartition des états des cartes SIM et les sessions SIM actives. De plus, il est possible de créer des rapports automatisés pour l’utilisation et l’aperçu des SIM, générés à intervalles réguliers sous forme téléchargeable. Ce chapitre se concentre sur trois sous-chapitres.",
            subchaptersTitle: "Sous-chapitres",
            subchapters: {
              single: "Rapport unique",
              automated: "Rapport automatisé",
              history: "Historique des rapports",
            },
          },
          single: {
            title: "Rapport Unique",
            description:
              "Les rapports uniques permettent aux utilisateurs de générer des rapports spécifiques sur la consommation des cartes SIM, les factures, l’activité du portefeuille, les demandes d’approvisionnement ou les sessions. Les rapports peuvent être personnalisés selon des critères, regroupés et exportés pour une analyse approfondie.",

            howToAccess: {
              title: "Accès",
              description:
                "Pour accéder aux Rapports Uniques, allez dans la section Rapports du menu latéral et sélectionnez 'Générer un Rapport'.",
            },

            usageReport: {
              title: "Rapport d’Utilisation",
              description:
                "Le Rapport d’Utilisation fournit des informations détaillées sur la consommation SIM pour les données ou les SMS, avec des options flexibles de regroupement et de filtrage.",
              bullets: [
                "Choisissez 'Usage' comme Type de Rapport.",
                "Sélectionnez le Type d’Utilisation : Données ou SMS.",
                "Regrouper par Champ : IMSI, Réseau, Client ou aucun regroupement.",
                "Regrouper par Période : Jour, Mois ou Année.",
                "Filtrer éventuellement par SIM : IMSI spécifique, Plage IMSI ou ICCID.",
                "Cliquez sur 'Voir' pour générer le rapport.",
              ],
            },
            invoiceList: {
              title: "Liste des Factures",
              description:
                "Le rapport Liste des Factures fournit un aperçu de toutes les factures émises pour le compte. Il inclut des informations clés telles que le numéro de facture, la date d’émission, la date d’échéance, le montant total et l’état du paiement. Les utilisateurs peuvent filtrer les factures par période pour retrouver rapidement un document de facturation.",
              bullets: [
                "Accédez à Rapports → Générer un rapport.",
                "Sélectionnez 'Liste des Factures' comme type de rapport.",
                "Définissez la période (De – À) pour limiter la liste des factures.",
                "Cliquez sur 'Afficher' pour générer le rapport.",
                "Le tableau résultant affiche les factures avec des détails tels que numéro, date d’émission, date d’échéance, montant total et état du paiement.",
              ],
            },
            orders: {
              title: "Rapport des Commandes",
              description:
                "Le rapport Commandes permet à l’utilisateur de consulter toutes les demandes de provisionnement liées aux cartes SIM. Il fournit un aperçu historique des commandes créées pendant la période sélectionnée.",
              bullets: [
                "Accès via Rapports → Générer un rapport → Commandes.",
                "Permet de filtrer par période.",
                "Affiche une liste des commandes de provisionnement SIM.",
              ],
            },
            portfolioActivity: {
              title: "Rapport d’Activité du Portefeuille",
              description:
                "Le rapport d’Activité du Portefeuille fournit une vue d’ensemble de l’activité des cartes SIM, y compris les activations, les résiliations et les changements par offre. Il aide les utilisateurs à suivre l’évolution de leur portefeuille de SIM au fil du temps.",
              bullets: [
                "Accessible via Rapports → Générer un rapport → Activité du portefeuille.",
                "Permet de filtrer le rapport par période (De–À).",
                "Affiche les activations, résiliations et activités regroupées par offre.",
              ],
            },
            customerSimSessions: {
              title: "Rapport des Sessions SIM Clients",
              description:
                "Le rapport des Sessions SIM Clients affiche des informations sur les sessions SIM actives et passées des clients. Il aide à suivre quand et comment les cartes SIM sont connectées au réseau.",
              bullets: [
                "Accessible via Rapports → Générer un rapport → Sessions SIM Clients.",
                "Affiche les détails de session tels que l’IMSI, l’heure de début et de fin, et les données transférées.",
                "Utile pour résoudre les problèmes de connectivité et analyser les modèles d’utilisation des SIM.",
              ],
            },
            simOverview: {
              title: "Rapport de Vue d’Ensemble des SIM",
              description:
                "Le rapport de Vue d’Ensemble des SIM fournit un résumé des cartes SIM dans le système, affichant leur répartition par état, allocation et activité. Il aide les administrateurs à évaluer rapidement l’ensemble du parc SIM.",
              bullets: [
                "Accessible via Rapports → Générer un rapport → Vue d’Ensemble des SIM.",
                "Affiche les SIM regroupées par état comme Actif, Suspendu, Résilié ou En Stock.",
                "Utile pour surveiller l’état et la distribution des cartes SIM en un coup d’œil.",
              ],
            },
            simList: {
              title: "Rapport de Liste des SIM",
              description:
                "Le rapport de Liste des SIM fournit un inventaire détaillé de toutes les cartes SIM dans le système. Il inclut les identifiants tels que IMSI et ICCID, leur état actuel et les détails d’allocation.",
              bullets: [
                "Accessible via Rapports → Générer un rapport → Liste des SIM.",
                "Affiche chaque carte SIM avec IMSI, ICCID et statut actuel.",
                "Utile pour auditer et gérer l’inventaire complet des cartes SIM.",
              ],
            },
            exportReport: {
              title: "Exporter le Rapport en Fichier",
              description:
                "Tous les rapports générés peuvent être exportés dans un fichier pour une analyse plus approfondie ou pour être partagés. Les options d’exportation incluent les formats CSV et PDF.",
              bullets: [
                "Accessible via Actions → Exporter → CSV ou PDF.",
                "Le format CSV est utile pour l’analyse de données dans Excel ou d’autres tableurs.",
                "Le format PDF est utile pour partager des rapports à format fixe.",
              ],
            },
            timeoutReports: {
              title: "Rapports en Timeout",
              description:
                "Chaque génération de rapport a une limite de 15 secondes. Lorsque cette limite est dépassée, le rapport continue à être généré en arrière-plan.",
              bullets: [
                "Une notification informe l’utilisateur lorsqu’un rapport dépasse le délai.",
                "Quand le rapport est prêt, une notification push est envoyée.",
                "Le rapport généré peut être consulté depuis Actions → Voir.",
                "Les rapports en timeout peuvent également être exportés en CSV ou PDF, comme les rapports instantanés.",
              ],
            },
          },
          automated: {
            title: "Rapports Automatisés",
            description:
              "Les Rapports Automatisés permettent aux utilisateurs de planifier la génération de rapports à intervalles fixes et dans un format choisi.",
            overview: {
              title: "Aperçu",
              description:
                "Les Rapports Automatisés sont créés une seule fois puis générés automatiquement à la fréquence et au format choisis.",
              bullets: [
                "Les rapports peuvent être programmés quotidiennement, chaque semaine ou chaque mois.",
                "Les rapports peuvent être générés en format CSV ou PDF.",
                "Types de rapports disponibles : Utilisation et Vue d’Ensemble des SIM Clients.",
              ],
            },
            create: {
              title: "Créer un Rapport Automatisé",
              description:
                "Pour créer un nouveau rapport automatisé, cliquez sur le bouton situé en haut à droite de la carte. Un formulaire apparaîtra et demandera certaines informations :",
              bullets: [
                "Nom : Le nom du rapport.",
                "Fréquence du rapport : Quotidien, hebdomadaire ou mensuel.",
                "Format du rapport : CSV ou PDF.",
                "Type de rapport : Choisissez entre Utilisation et Vue d’Ensemble des SIM Clients.",
                "Selon le type de rapport, des champs supplémentaires peuvent apparaître, similaires au menu Générer un Rapport.",
              ],
            },
          },
          history: {
            title: "Historique des Rapports",
            description:
              "La section Historique des Rapports fournit une liste des résultats de toutes les exécutions de Rapports Automatisés. Chaque entrée inclut le nom du rapport, la date de génération, le statut, l’option de téléchargement et la possibilité de supprimer le rapport.",
            reportHistory: {
              title: "Consulter les Résultats des Rapports Automatisés",
              description:
                "Depuis la section Historique des Rapports, les utilisateurs peuvent :",
              bullets: [
                "Consulter les résultats de tous les Rapports Automatisés exécutés.",
                "Vérifier l’état d’exécution (Terminé, En attente, Échoué).",
                "Télécharger les fichiers générés au format CSV ou PDF.",
                "Supprimer une entrée de rapport via le menu Actions.",
              ],
            },
          },
        },
      },
    },
  },
  de: {
    translation: {
      sidebar: {
        dashboard: "Dashboard",
        crm: "CRM",
        admins: "Administratoren",
        tenants: "Mieter",
        managers: "Manager",
        customers: "Kunden",
        subaccounts: "Unterkonten",
        sims: "SIM-Karten",
        account: "Konto",
        profile: "Profil",
        billingProducts: "Abrechnungsprodukte",
        invoices: "Rechnungen",
        statements: "Kontoauszüge",
        orders: "Bestellungen",
        emails: "E-Mails",
        reports: "Berichte",
        generateReport: "Bericht generieren",
        automatedReports: "Automatisierte Berichte",
        reportHistory: "Berichtsverlauf",
        alerts: "Benachrichtigungen",
        notifications: "Benachrichtigungen",
        support: "Support",
        privileges: "Berechtigungen",
        settings: "Einstellungen",
        services: "Dienstleistungen",
        documentation: "Dokumentation",
        whitelist: "Zugelassene IP-Adresse",
        customFields: "Benutzerdefinierte Felder",
        simProducts: "SIM-Produkte",
        purchaseSims: "SIM-Karten kaufen",
        health: "Systemzustand",
        purchaseOrders: "SIM-Karten-Bestellungen",
      },
      dashboard: {
        dataVolume: "Datenvolumen",
        dataSessions: "Datensitzungen",
        alerts: "Warnungen",
        zeroSessions: "Null-Sitzungen",
        sinceYesterday: "Seit gestern",
        sinceLastMonth: "Seit letztem Monat",
        sinceLastYear: "Seit letztem Jahr",
        averageVolume: "Durchschnittliches Datenvolumen",
        activeSims: "Aktive SIMs",
        dataVolumePerHour: "Datenvolumen pro Stunde",
        topMetrics: "Top Metriken",
        simCardsPerOffer: "SIM-Karten pro Angebot",
        simInventory: "SIM-Verteilung nach Status",
        dataVolumePerNetwork: "Datenvolumen pro Netzwerk",
        selectCountry: "Land auswählen",
        networksDistribution: "Aktive SIM-Karten nach Netzwerkverteilung",
        watchdogAlerts: "Verbrauchswarnungen",
        noData: "Keine Daten verfügbar",
        daily: "Täglich",
        monthly: "Monatlich",
        yearly: "Jährlich",
      },
      crm: {
        admins: "Administratoren",
        tenants: "Mieter",
        managers: "Manager",
        customers: "Kunden",
        subaccounts: "Unterkonten",
        filters: "Filter",
        fullName: "Vollständiger Name",
        company: "Firma",
        email: "E-Mail",
        address: "Adresse",
        city: "Stadt",
        country: "Land",
        postcode: "Postleitzahl",
        telephone: "Telefon",
        mobile: "Mobiltelefon",
        occupation: "Beruf",
        tin: "Steuer-ID",
        username: "Benutzername",
        role: "Rolle",
        actions: "Aktionen",
        edit: "Bearbeiten",
        delete: "Löschen",
        billing: "Abrechnung",
        whitelabeling: "Whitelabel",
        offers: "Angebote",
        impersonate: "Imitieren",
        permissions: "Berechtigungen",
        sendWelcomeEmail: "Willkommens-E-Mail senden",
        resetPassword: "Passwort zurücksetzen",
        initializeSIMs: "SIMs initialisieren",
        initializeAlerts: "Warnungen initialisieren",
        newTenant: "Neuer Mieter",
        newManager: "Neuer Manager",
        newCustomer: "Neuer Kunde",
        newSubaccount: "Neues Unterkonto",
        registerPayment: "Zahlung registrieren",
        accountId: "Konto-ID",
        registerPayment: {
          title: "Zahlung registrieren",
          amount: "Betrag",
          currency: "Währung",
          invoice: "Rechnungsnummer",
          submit: "Absenden",
          cancel: "Abbrechen",
          selectCurrency: "Währung auswählen",
          selectInvoice: "Rechnung auswählen",
        },
        creditNote: {
          title: "Gutschrift",
          amount: "Betrag",
          vat: "MwSt",
          reason: "Grund",
          submit: "Absenden",
          cancel: "Abbrechen",
        },
        invoiceCycle: {
          title: "Abrechnungslauf erneut ausführen",
        },
        newModal: {
          newTenant: "Mieter erstellen",
          newManager: "Manager erstellen",
          newCustomer: "Kunde erstellen",
          newSubaccount: "Unterkonto erstellen",
          fullName: "Vollständiger Name",
          address: "Adresse",
          city: "Stadt",
          country: "Land",
          postcode: "Postleitzahl",
          telephone: "Telefon",
          mobile: "Mobiltelefon",
          email: "E-Mail",
          occupation: "Beruf",
          company: "Firma",
          tin: "Steuer-ID",
          username: "Benutzername",
          sendWelcomeEmail: "Willkommens-E-Mail senden",
          cancel: "Abbrechen",
          submit: "Einreichen",
          next: "Weiter",
          previous: "Zurück",
          preferredLanguage: "Bevorzugte Sprache",
          billingEmail: "Rechnungs-E-Mail",
          currency: "Währung",
        },
        editModal: {
          editTenant: "Mieter bearbeiten",
          editManager: "Manager bearbeiten",
          editCustomer: "Kunde bearbeiten",
          editSubaccount: "Unterkonto bearbeiten",
          fullName: "Vollständiger Name",
          address: "Adresse",
          city: "Stadt",
          country: "Land",
          postcode: "Postleitzahl",
          telephone: "Telefon",
          mobile: "Mobiltelefon",
          email: "E-Mail",
          occupation: "Beruf",
          company: "Firma",
          tin: "Steuer-ID",
          username: "Benutzername",
          cancel: "Abbrechen",
          submit: "Einreichen",
        },
        billingModal: {
          title: "Abrechnungseinstellungen",
          currency: "Währung",
          billingFrequency: "Abrechnungshäufigkeit",
          daysToPayInvoice: "Tage zur Bezahlung der Rechnung",
          minimumAmountToInvoice: "Mindestbetrag zur Rechnungsstellung",
          invoiceType: "Rechnungstyp",
          preferredLanguage: "Bevorzugte Sprache",
          billingEmail: "Abrechnungs-E-Mail",
          platformUsage: "Plattformnutzung",
          platformUsagePrice: "Plattformnutzungspreis",
          onStockPriceEnabled: "On Stock SIM-Karten Gebühren aktiviert",
          onStockPrice: "On Stock SIM-Karten Preis",
          simCardPriceEnabled: "SIM-Karten-Gebühr?",
          simCardPrice: "SIM-Kartenpreis",
          simChipPriceEnabled: "SIM-Chip-Gebühr?",
          simChipPrice: "SIM-Chip-Preis",
          billable: "Abrechenbar?",
          isVatExempt: "Ist von der Mehrwertsteuer befreit?",
          cancel: "Abbrechen",
          submit: "Einreichen",
        },
        whitelabelModal: {
          title: "Whitelabel-Einstellungen",
          enableWhitelabel: "Whitelabel aktivieren",
          pricePerMonth: "Preis pro Monat",
          url: "URL",
          cancel: "Abbrechen",
          submit: "Einreichen",
        },
        roleModal: {
          title: "Rolle aktualisieren",
          role: "Rolle",
          tenant: "Mieter",
          manager: "Manager",
          customer: "Kunde",
          cancel: "Abbrechen",
          submit: "Einreichen",
        },
        offersModal: {
          title: "Angebote zuweisen",
          availableOffers: "Verfügbare Angebote",
          assignedOffers: "Zugewiesene Angebote",
          submit: "Einreichen",
        },
      },
      sims: {
        title: "SIM-Karten",
        dataVolume: "Datenvolumen",
        dataSessions: "Datensitzungen",
        zeroSessions: "Null-Sitzungen",
        filters: "Filter",
        simStatus: "Aktive Sitzung",
        simState: "SIM-Status",
        portfolioId: "Portfolio ID",
        imsi: "IMSI",
        iccid: "ICCID",
        msisdn: "MSISDN",
        eid: "EID",
        offer: "Angebot",
        data: "Daten",
        min: "Min",
        max: "Max",
        search: "Suchen",
        clear: "Löschen",
        actions: "Aktionen",
        bulk: "Massenoperationen",
        modify: "Ändern",
        product: "Produkt",
        clearSelection: "Auswahl löschen",
        activate: "Aktivieren",
        suspend: "Aussetzen",
        resume: "Fortsetzen",
        terminate: "Beenden",
        testMode: "Testmodus",
        sendSms: "SMS senden",
        watchdogs: "Watchdogs",
        createWatchdog: "Watchdog erstellen",
        removeAllWatchdogs: "Alle Watchdogs entfernen",
        blockSuspension: "Sperrung der Aussetzung",
        export: "Exportieren",
        simInformation: "SIM-Informationen",
        usage: "Nutzung",
        ipAddress: "IP-Adresse",
        imei: "IMEI",
        status: "Status",
        visitProfile: "Profil besuchen",
        provider: "Anbieter",
        area: "Bereich",
        cell: "Zelle",
        longitude: "Längengrad",
        latitude: "Breitengrad",
        cellRange: "Zellenreichweite",
        unit: "Einheit",
        sort: "Sortieren",
        suspendModal: {
          title: "SIM aussetzen",
          orderComplete: "SIM-Aussetzung abgeschlossen",
          orderError: "SIM-Aussetzung fehlgeschlagen",
          contactAdmin: "Bitte kontaktieren Sie den Systemadministrator",
          cancel: "Abbrechen",
          submit: "Einreichen",
          close: "Schließen",
        },
        resumeModal: {
          title: "SIM fortsetzen",
          orderComplete: "SIM-Fortsetzung abgeschlossen",
          orderError: "SIM-Fortsetzung fehlgeschlagen",
          contactAdmin: "Bitte kontaktieren Sie den Systemadministrator",
          cancel: "Abbrechen",
          submit: "Einreichen",
          close: "Schließen",
        },
        activateModal: {
          title: "SIM aktivieren",
          offer: "Angebot",
          selectOffer: "Angebot auswählen",
          success: "SIM-Aktivierung abgeschlossen",
          orderError: "SIM-Aktivierung fehlgeschlagen",
          contactAdmin: "Bitte kontaktieren Sie den Systemadministrator",
          cancel: "Abbrechen",
          submit: "Einreichen",
          close: "Schließen",
        },
        terminateModal: {
          title: "SIM beenden",
          targetState: "Gewünschter Status",
          onStock: "Auf Lager",
          terminated: "Beendet",
          success: "SIM-Beendigung abgeschlossen",
          orderError: "SIM-Beendigung fehlgeschlagen",
          contactAdmin: "Bitte kontaktieren Sie den Systemadministrator",
          cancel: "Abbrechen",
          submit: "Einreichen",
          close: "Schließen",
        },
      },
      simProfile: {
        simProvisioning: "SIM-Statusverwaltung",
        simDetails: "SIM-Details",
        actions: "Aktionen",
        hlr: "HLR",
        session: "Sitzungen",
        smsUsage: "SMS-Nutzung",
        updateLoc: "Standort aktualisieren",
        imeiLock: "IMEI-Sperre",
        usage: "Nutzung",
        imei: "IMEI",
        status: "Status",
        dataSession: "Aktive Sitzung",
        map: "Karte",
        provider: "Anbieter",
        imsi: "IMSI",
        iccid: "ICCID",
        msisdn: "MSISDN",
        country: "Land",
        operator: "Netzbetreiber",
        area: "Bereich",
        cell: "Zelle",
        longitude: "Längengrad",
        latitude: "Breitengrad",
        cellRange: "Zellenreichweite",
        activity: "Aktivität",
        selectPeriod: "Zeitraum auswählen",
        daily: "Täglich",
        monthly: "Monatlich",
        yearly: "Jährlich",
        dataVolume: "Datenvolumen",
        dataSessions: "Datensitzungen",
        alerts: "Warnungen",
        zeroSessions: "Null-Sitzungen",
        watchdog: "Watchdog",
        type: "Typ",
        blockSuspension: "SIM wird gesperrt",
        amount: "Betrag",
        hlrModal: {
          title: "HLR-Profil",
          selectScope: "Bereich auswählen",
          basicInfo: "Basisinformationen",
          locationInfo: "Standortinformationen",
          csBasicInfo: "CS Basisinformationen",
          gprsService2g3g: "GPRS-Dienste 2G/3G",
          telephonyService: "Telefondienste",
          supplementaryService: "Zusatzdienste",
          epcService4G: "EPC-Dienste 4G",
        },
        sessionModal: {
          title: "SIM-Datensitzungen",
          openDate: "Eröffnungsdatum",
          closeDate: "Schließdatum",
          consumption: "Verbrauch",
          roundedBytes: "Gerundete Bytes",
          operator: "Betreiber",
          cell: "Zelle",
          imei: "IMEI",
          close: "Schließen",
        },
        orders: {
          title: "Anfragen",
          close: "Schließen",
        },
        smsUsageModal: {
          title: "SMS-Nutzung",
          direction: "Richtung",
          date: "Datum",
          sender: "Absender",
          message: "Nachricht",
          status: "Status",
          close: "Schließen",
        },
      },
      profile: {
        profileDetails: "Profildetails",
        contactInformation: "Kontaktinformationen",
        professionalInformation: "Berufliche Informationen",
        activities: "Aktivitäten",
        loadMore: "Mehr laden",
      },
      billingProducts: {
        title: "Abrechnungsprodukte",
        name: "Name",
        pricePlan: "Preismodell",
        price: "Preis",
        number: "Nummer",
      },
      invoices: {
        title: "Rechnungen",
        invoiceNo: "Rechnungsnummer",
        date: "Datum",
        amount: "Betrag (inkl. MwSt.)",
        description: "Beschreibung",
        paid: "Bezahlt",
        download: "Herunterladen",
      },
      statements: {
        title: "Kontoauszüge",
        cutDate: "Abrechnungsdatum",
        description: "Beschreibung",
        amount: "Betrag (inkl. MwSt.)",
        balance: "Saldo",
      },
      orders: {
        title: "Bestellungen",
        open: "Offen",
        parked: "Geparkt",
        finished: "Abgeschlossen",
        error: "Fehler",
        noOrders: "Keine Bestellungen",
        showAllOrders: "Alle Bestellungen anzeigen",
        showLess: "Weniger Bestellungen anzeigen",
      },
      emails: {
        filters: "Filter",
        category: "Kategorie",
        name: "Name",
        address: "Adresse",
        actions: "Aktionen",
        newEmail: "Neue E-Mail",
        edit: "Bearbeiten",
        delete: "Löschen",
        cancel: "Abbrechen",
        submit: "Einreichen",
        selectCategory: "Kategorie auswählen",
        invoice: "Rechnung",
        watchdog: "Watchdog",
        updateEmail: "E-Mail aktualisieren",
      },
      reports: {
        title: "Berichte",
        reportType: "Berichtstyp",
        usage: "Nutzung",
        groupBy: "Gruppieren nach",
        field: "Feld",
        usageType: "Nutzungsart",
        selectUsageType: "Nutzungsart auswählen",
        data: "Daten",
        sms: "SMS",
        all: "Alle",
        imsi: "IMSI",
        eid: "EID",
        network: "Netzwerk",
        customer: "Kunde",
        period: "Zeitraum",
        day: "Tag",
        month: "Monat",
        year: "Jahr",
        today: "Heute",
        "This Week": "Diese Woche",
        "This Month": "Dieser Monat",
        "This Year": "Dieses Jahr",
        "Last Month": "Letzter Monat",
        "Last Year": "Letztes Jahr",
        customer: "Kunde",
        select: "Auswählen",
        simSearchCriteria: "SIM-Suchkriterien",
        bySpecificImsi: "Nach spezifischer IMSI",
        byImsiRange: "Nach IMSI-Bereich",
        byIccid: "Nach ICCID",
        startImsi: "Start-IMSI",
        endImsi: "End-IMSI",
        iccid: "ICCID",
        view: "Ansehen",
        customerId: "Kunden-ID",
        date: "Datum",
        startDate: "Aus",
        simType: "SIM-Typ",
        networkCode: "Netzcode",
        networkName: "Netzname",
        country: "Land",
        totalBytes: "Gesamtbytes",
        roundedBytes: "Gerundete Bytes",
        sessions: "Sitzungen",
        zeroSessions: "Null-Sitzungen",
        actions: "Aktionen",
        export: "Exportieren",
        description: "Beschreibung",
        quantity: "Menge",
        unitPrice: "Stückpreis",
        tax: "MwSt",
        costWithoutTax: "Preis vor Steuern",
        costWithTax: "Preis nach Steuern",
        currency: "Währung",
        offerName: "Paket",
        id: "ID",
        name: "Name",
        status: "Status",
        creator: "Ersteller",
        creationDate: "Erstellungsdatum",
        offer: "Datenpaket",
        activations: "Aktivierungen",
        terminations: "Kündigungen",
        automated: {
          title: "Automatisierte Berichte",
          name: "Name",
          type: "Typ",
          frequency: "Frequenz",
          nextReport: "Nächster Bericht",
          new: "Neuer automatisierter Bericht",
          save: "Speichern",
          daily: "Täglich",
          weekly: "Wöchentlich",
          monthly: "Monatlich",
          edit: "Bearbeiten",
          delete: "Löschen",
          actions: "Aktionen",
        },
        history: {
          title: "Berichtsverlauf",
          tableHeaders: {
            reportName: "Berichtsname",
            date: "Datum",
            status: "Status",
            download: "Herunterladen",
            actions: "Aktionen",
          },
          delete: "Löschen",
          completed: "Abgeschlossen",
          incomplete: "Unvollständig",
        },
      },
      timeoutReports: {
        view: "Anzeigen",
        delete: "Löschen",
      },
      alerts: {
        title: "Warnungen",
        filters: "Filter",
        alert: "Warnung",
        date: "Datum",
        imsi: "IMSI",
        enterValue: "Wert eingeben",
      },
      settings: {
        title: "Einstellungen",
        profileSettings: "Profileinstellungen",
        general: "Allgemein",
        account: "Konto",
        profileImage: "Profilbild",
        whitelabel: "Whitelabel",
        privacyAndSafety: "Datenschutz & Sicherheit",
        notifications: "Benachrichtigungen",
        billing: "Abrechnung",
        invoice: "Rechnung",
        importSim: "Sim importieren",
        mailConfig: "Mailserver",
        generalSettings: {
          title: "Allgemeine Einstellungen",
          timeZone: "Zeitzone",
          dateFormat: "Datumsformat",
          timeFormat: "Zeitformat",
          save: "Speichern",
        },
        accountSettings: {
          title: "Kontoeinstellungen",
          fullName: "Vollständiger Name",
          address: "Adresse",
          city: "Stadt",
          country: "Land",
          postcode: "Postleitzahl",
          telephone: "Telefon",
          mobileNumber: "Mobilnummer",
          email: "E-Mail",
          occupation: "Beruf",
          company: "Firma",
          tin: "Steuer-ID",
          username: "Benutzername",
          changePassword: "Passwort ändern",
          password: "Passwort",
          confirmPassword: "Passwort bestätigen",
          save: "Speichern",
        },
        profileImageSettings: {
          title: "Profilbildeinstellungen",
          upload: "Hochladen",
          save: "Speichern",
        },
        whitelabelSettings: {
          title: "Whitelabel-Einstellungen",
          backgroundColor: "Hintergrundfarbe",
          fontColor: "Schriftfarbe",
          accentColor: "Akzentfarbe",
          sidebarPosition: "Seitenleistenposition",
          favicon: "Favicon",
          whitelabelImage: "Whitelabel-Bild",
          upload: "Hochladen",
          save: "Speichern",
        },
        privacySettings: {
          title: "Datenschutzeinstellungen",
          enable2FA: "2FA aktivieren",
          save: "Speichern",
        },
        notificationSettings: {
          title: "Benachrichtigungseinstellungen",
          receiveNotifications: "Benachrichtigungen erhalten",
          sms: "SMS",
          email: "E-Mail",
          weeklyAnalytics: "Wöchentliche Analysen",
          checkIfYouWantToReceiveWeeklyAnalytics:
            "Aktivieren Sie diese Option, wenn Sie wöchentliche Analysen erhalten möchten",
          notifyAboutNewAlerts: "Über neue Warnungen benachrichtigen",
          checkIfYouWantToReceiveNotificationsWhenThereAreNewAlerts:
            "Aktivieren Sie diese Option, wenn Sie Benachrichtigungen bei neuen Warnungen erhalten möchten",
          submit: "Einreichen",
        },
        billingSettings: {
          title: "Abrechnungseinstellungen",
          selectCurrency: "Währung auswählen",
          currency: "Währung",
          preferredLanguage: "Bevorzugte Sprache",
          selectLanguage: "Sprache auswählen",
          submit: "Einreichen",
        },
        invoiceSettings: {
          title: "Rechnungseinstellungen",
          name: "Name",
          showGuis: "GUIs anzeigen",
          showSubtotal: "Zwischensumme anzeigen",
          showLineOfService: "Dienstleistungslinie anzeigen",
          save: "Speichern",
        },
        importSimSettings: {
          title: "Sim importieren",
          provider: "Anbieter",
          selectProvider: "Anbieter auswählen",
          submit: "Einreichen",
          inputType: "Eingabetyp",
          selectInputType: "Eingabetyp auswählen",
          single: "Einzelne Eingabe",
          file: "Dateieingabe",
        },
        mailConfig: {
          title: "Mailserver-Einstellungen",
          host: "SMTP-Hostadresse",
          port: "SMTP-Port",
          fromAddress: "Absenderadresse",
          username: "Benutzername",
          changePassword: "Passwort ändern",
          password: "Passwort",
          confirmPassword: "Passwort bestätigen",
          useTLS: "TLS verwenden",
          save: "Einstellungen speichern",
          success: "Mailserver-Einstellungen erfolgreich gespeichert",
          error: "Speichern der Mailserver-Einstellungen fehlgeschlagen",
          healthStatus: "Systemzustand",
          healthUp: "Funktionsfähig (UP)",
          healthDown: "Fehlerhaft (DOWN)",
          healthUnknown: "Unbekannt",
          lastCheckedAt: "Zuletzt Geprüft",
        },
        purchaseOrderConfig: {
          title: "Bestellkonfiguration",
          sellerName: "Name des Verkäufers",
          host: "SMTP-Host-Adresse",
          port: "SMTP-Port",
          fromAddress: "Absenderadresse",
          username: "Benutzername",
          changePassword: "Passwort ändern",
          password: "Passwort",
          confirmPassword: "Passwort bestätigen",
          useTLS: "TLS verwenden",
          save: "Einstellungen speichern",
          success: "Mailserver-Einstellungen erfolgreich gespeichert",
          error: "Fehler beim Speichern der Mailserver-Einstellungen",
          healthStatus: "Systemstatus",
          healthUp: "In gutem Zustand (UP)",
          healthDown: "Außer Betrieb (DOWN)",
          healthUnknown: "Unbekannt",
          lastCheckedAt: "Zuletzt überprüft am",
        },
        platformConfig: {
          title: "Plattformkonfiguration",
          dataStreamingEnabled: "Daten-Streaming aktiviert",
          maintenanceMode: "Wartungsmodus",
          maintenanceMessage: "Wartungsnachricht",
          maintenanceMessagePlaceholder: "Geben Sie die Wartungsnachricht ein",
          save: "Speichern",
          reset: "Zurücksetzen",
        },
        crmConfig: {
          title: "CRM-Konfiguration",
          type: "CRM-Typ",
          authType: "Authentifizierungstyp",
          selectAuthType: "Authentifizierungstyp auswählen",
          selectType: "CRM-Typ auswählen",
          username: "Benutzername",
          changePassword: "Passwort ändern?",
          changeToken: "Token ändern?",
          password: "Passwort",
          confirmPassword: "Passwort bestätigen",
          token: "Token",
        },
      },
      privileges: {
        title: "Berechtigungen",
        name: "Name",
        actions: "Aktionen",
        newPrivilege: "Neue Berechtigung",
        edit: "Bearbeiten",
        delete: "Löschen",
      },
      table: {
        page: "Seite",
        of: "von",
        show: "Anzeigen",
        goToPage: "Gehe zu Seite",
      },
      notifications: {
        title: "Benachrichtigungen",
        id: "ID",
        date: "Datum",
        message: "Nachricht",
        type: "Typ",
      },
      whitelist: {
        title: "Zugelassene IP-Adresse",
        ip: "IP-Adresse",
        active: "Aktiv",
        createdAt: "Hinzugefügt am",
        updatedAt: "Zuletzt aktualisiert",
        lastUsed: "Zuletzt verwendet",
        new: "Neue IP-Adresse",
      },
      customFields: {
        title: "Benutzerdefinierte Felder",
        new: "Neues benutzerdefiniertes Feld",
        name: "Name",
        type: "Typ",
        createdAt: "Erstellt am",
        updatedAt: "Aktualisiert am",
        edit: "Bearbeiten",
        delete: "Löschen",
        submit: "Absenden",
        cancel: "Abbrechen",
        actions: "Aktionen",
        selectType: "Typ auswählen",
        text: "Text",
        number: "Zahl",
      },
      documentation: {
        introduction: {
          welcomeTitle: "Willkommen bei {{brand}}",
          welcomeText:
            "{{brand}} ist Ihre All-in-One-Plattform zur einfachen Verwaltung von SIM-Karten. Überwachen Sie die Nutzung, aktivieren Sie neue Leitungen und halten Sie Ihre Abläufe reibungslos—alles von einem einzigen Dashboard aus.",
          getStarted: "Loslegen",
        },
        dashboard: {
          title: "Dashboard-Übersicht",
          description:
            "Das Dashboard ist die zentrale Oberfläche zur Überwachung und Analyse der SIM-Karten-Aktivitäten über die {{brand}}-Plattform...",
          goal: "Ziel des Dashboards ist es, den Nutzern ein sofortiges Überwachungswerkzeug bereitzustellen...",
          cards: {
            title: "Statistikkarten (oberer Bereich)",
            dataVolume: {
              title: "Datenvolumen",
              description:
                "Zeigt das gesamte heute verbrauchte Datenvolumen sowie den Vergleich zum Vortag.",
            },
            dataSessions: {
              title: "Datensitzungen",
              description:
                "Zeigt die Anzahl der Verbindungen, die heute hergestellt wurden, im Vergleich zum Vortag.",
            },
            alerts: {
              title: "Verbrauchsbenachrichtigungen",
              description:
                "Zeigt die Anzahl der heute generierten Verbrauchsbenachrichtigungen aufgrund von Schwellenwertüberschreitungen.",
            },
            zeroSessions: {
              title: "Sitzungen ohne Verbrauch",
              description:
                "Zeigt, wie viele Datensitzungen im ausgewählten Zeitraum keinen Verbrauch verzeichnet haben.",
            },
          },
          charts: {
            title: "Detaillierte Diagramme und Karten",
            dataSessionsMap: {
              title: "Geografische Verteilung der Datenverbindungen",
              description:
                "Die Karte zeigt die Länder mit der höchsten Anzahl an Verbindungen. Über das Menü oben rechts in der Karte können Sie auswählen, welche Information angezeigt wird: Data Sessions, Data Volume oder Zero Sessions.",
            },
            avgDataAndActiveSims: {
              title: "Durchschnittlicher Datenverbrauch und aktive SIMs",
              description:
                "Zeigt den durchschnittlichen Datenverbrauch pro Verbindung sowie die Gesamtzahl der aktiven SIMs an.",
            },
            dataVolumePerHour: {
              title: "Stündliche Verteilung des Datenverbrauchs",
              description:
                "Das Diagramm zeigt den Datenverbrauch pro Dreistundenzeitraum und pro Wochentag im aktuellen Monat und bietet so ein vollständigeres Bild der Zeiträume mit der höchsten SIM-Aktivität.",
            },
            monthlyDataVolume: {
              title: "Monatliche Verteilung des Datenverbrauchs",
              description:
                "Das Diagramm zeigt die monatliche Verteilung des Datenverbrauchs in den letzten 12 Monaten. Über das Menü oben rechts in der Karte können Sie auswählen, welche Information angezeigt wird: Data Sessions, Data Volume oder Zero Sessions.",
            },
            topMetrics: {
              title: "Top-Kennzahlen",
              description:
                "Dieses Diagramm hebt die SIM-Karten mit der höchsten Anzahl an Verbindungen für den ausgewählten Zeitraum hervor. Es ermöglicht Ihnen, die aktivsten SIMs in Ihrem Netzwerk schnell zu identifizieren, Nutzungsmuster zu analysieren, Vielnutzer zu erkennen und die Ressourcenzuweisung zu optimieren.",
            },
            dataVolumePerNetwork: {
              title: "Datenverbrauch pro Netzwerk - Aktive SIMs pro Netzwerk",
              description:
                "Diese Diagramme bieten eine vergleichende Ansicht der Netzaktivität im ausgewählten Land. Das erste Diagramm zeigt die Verteilung des gesamten Datenverbrauchs pro Mobilfunknetz, um Last, Nutzungsschwerpunkte und Betreiberleistung zu bewerten. Das zweite Diagramm zeigt die Verteilung aktiver SIMs pro Netzwerk und liefert Einblicke in Netzabdeckung und Marktanteile. Zusammen vermitteln sie ein vollständiges Verständnis darüber, wie Ihre SIMs mit verschiedenen Netzen interagieren, und verdeutlichen Konnektivitäts- und Nutzungsmuster.",
            },
            simCardsPerOffer: {
              title: "SIM-Karten nach Angebot und Status",
              description:
                "Diese Diagramme geben einen Überblick über Ihr SIM-Portfolio. Das erste zeigt die Verteilung nach Angeboten und Datentarifen und hilft dabei, Präferenzen und die beliebtesten Dienste zu erkennen. Das zweite zeigt die Verteilung nach Status und bietet Sichtbarkeit der Lebenszyklusphasen und Verfügbarkeit. Zusammen helfen sie, Nutzungstrends, Bestände und die Effizienz der SIM-Verwaltung zu überwachen.",
            },
            alerts: {
              title: "Verbrauchsbenachrichtigungen",
              description:
                "Diese Tabelle zeigt die Verbrauchsbenachrichtigungen, die vom Überwachungsmechanismus WatchDog generiert werden. WatchDog überwacht kontinuierlich die Datennutzung der SIMs und löst Benachrichtigungen aus, wenn vordefinierte Schwellenwerte erreicht werden.",
              types: {
                warning:
                  "Warning: wird ausgelöst, wenn der Verbrauch 80 % des zugewiesenen Volumens erreicht.",
                depleted:
                  "Depleted: wird ausgelöst, wenn der Verbrauch 100 % des zugewiesenen Volumens erreicht.",
              },
              note: "Diese Benachrichtigungen helfen Ihnen, rechtzeitig Maßnahmen zu ergreifen, um Dienstunterbrechungen oder unerwartete Kosten zu vermeiden. Eine detaillierte Analyse von WatchDog und seiner Funktionsweise wird im entsprechenden Kapitel der Dokumentation vorgestellt.",
            },
          },
          utility: {
            title: "Nutzen des Dashboards",
            description:
              "Das Dashboard ermöglicht durch eine einheitliche Darstellung von Kennzahlen, Trends und Warnungen die schnelle Problemerkennung und fundierte Entscheidungen.",
          },
        },
        simCards: {
          introduction: {
            title: "Einführung in SIM-Karten",
            description:
              "Dieses Kapitel bietet alle notwendigen Informationen zu SIM-Karten innerhalb der {{brand}}-Plattform.",
            details:
              "Sie erfahren, wie SIM-Karten verwaltet, überwacht und analysiert werden, mit Einblicken in Datenverbrauch, Konnektivität, Warnmeldungen und Lebenszyklusphasen.",
            getStarted: "Loslegen",
          },
          lifecycle: {
            title: "SIM-Lebenszyklus",
            intro:
              "SIM-Karten in der Plattform durchlaufen verschiedene Lebenszyklus-Phasen. Jeder Status wird durch einen farbcodierten Kreis dargestellt und hat spezifisch erlaubte Übergänge.",
            status: {
              productive: "Aktiv und in Gebrauch.",
              suspended: "Manuell gesperrt.",
              autoSuspended: "Automatisch gesperrt.",
              onstock: "Verfügbar, aber nicht aktiv.",
              deleted: "Gelöscht und inaktiv.",
            },
            diagramDescription:
              "Dieses Diagramm zeigt die SIM-Lebenszykluszustände und die möglichen Übergänge zwischen ihnen. Übergänge können manuell ausgelöst werden (z. B. Aktivierung einer SIM von OnStock zu Productive) oder automatisch (z. B. wenn ein Systemprozess eine SIM beim Erreichen von Limits automatisch sperrt). Diese Übergänge gewährleisten eine ordnungsgemäße Kontrolle der SIM-Aktivität, Verfügbarkeit und Deaktivierung innerhalb der Plattform.",
          },
          panel: {
            title: "SIMs Übersicht",
            intro:
              "Das SIMs-Panel bietet einen Überblick über alle SIM-Karten in der Plattform. Es ermöglicht die Überwachung der Aktivität, die Analyse des Datenverbrauchs und die effiziente Verwaltung der Lebenszyklusphasen.",
            summary: {
              title: "Übersichtskarten & Filter",
              intro:
                "Oben im Panel zeigen drei Karten einen schnellen Überblick über die SIM-Nutzung im aktuellen Monat:",
              dataVolume: "Datenvolumen – insgesamt verbrauchte Daten.",
              dataSessions: "Datensitzungen – Anzahl der Verbindungen.",
              zeroSessions: "Null-Sitzungen – Sitzungen ohne Daten.",
              filters:
                "Filter ermöglichen die Eingrenzung von SIMs nach IMSI, ICCID, MSISDN, SIM-Status, Angebot, SIM-Typ oder Datenvolumen. Sortierung kann auf mehrere Felder wie IMSI oder Nutzung angewendet werden.",
            },
            table: {
              title: "SIM-Tabelle",
              intro:
                "Die Haupttabelle listet alle SIM-Karten mit ihren wichtigsten Details auf:",
              activeSession: "Aktive Sitzung – Anzeige der Live-Aktivität.",
              identifiers: "Kennungen – IMSI, ICCID, MSISDN.",
              state: "SIM-Status – Lebenszyklusstatus (z. B. Aktiv, Gesperrt).",
              offer: "Angebot – Abonnementplan (falls zutreffend).",
              data: "Daten – Nutzungsvolumen für den Monat.",
              type: "SIM-Typ – Produkttyp (z. B. eingebettet, industriell).",
              footer:
                "Paginierung und Massenoperationen werden ebenfalls unterstützt, um die SIM-Verwaltung effizient zu gestalten.",
            },
          },
          simProvisioning: {
            introduction: {
              title: "SIM-Bereitstellung",
              description:
                "Die SIM-Bereitstellung umfasst Funktionen, die Administratoren ermöglichen, den Lebenszyklus von SIM-Karten innerhalb der Plattform zu verwalten. Durch das Provisioning können Sie:",
              closing:
                "Diese Aktionen stellen sicher, dass SIMs ordnungsgemäß bereitgestellt, kontrolliert und deaktiviert werden, und unterstützen sowohl die betriebliche Flexibilität als auch die Sicherheit.",
            },
            actions: {
              activate: {
                title: "Aktivieren",
                description:
                  "eine SIM für die produktive Nutzung bereitstellen.",
                details: {
                  intro:
                    "Um eine oder mehrere SIM-Karten zu aktivieren, gibt es drei Möglichkeiten:",
                  steps: [
                    "Durch Auswahl der SIM-Karten in der Tabelle über die Kontrollkästchen und Auswahl von Aktivieren im Menü Massenoperationen oben rechts.",
                    "Durch direktes Anklicken desselben Menüs und Hochladen einer Excel-Datei mit den IMSI/ICCID-Nummern in Spalte A, wobei die entsprechende Überschrift (IMSI/ICCID) in Zelle A1 steht.",
                    "Durch Anklicken der Zeile, woraufhin eine Seitenkarte mit dem Profil der SIM eingeblendet wird. Oben befindet sich ein Button Aktivieren.",
                  ],
                  important:
                    "Wichtig! Alle ausgewählten SIM-Karten müssen sich im Zustand Auf Lager befinden, um aktiviert werden zu können.",
                  closing:
                    "Nach den beschriebenen Schritten erscheint ein Bestätigungsdialog mit zwei Schritten: Der Benutzer muss das Angebot auswählen, unter dem er die SIM-Karten aktivieren möchte. Optional können benutzerdefinierte Feldwerte gesetzt werden. Im zweiten Schritt überprüft der Benutzer die ausgewählten SIMs und fährt mit der Aktivierung fort.",
                },
              },
              suspend: {
                title: "Aussetzen",
                description: "die Konnektivität vorübergehend deaktivieren.",
                details: {
                  intro:
                    "Ähnlich wie bei der Aktivierung hat der Benutzer für das Sperren einer oder mehrerer SIM-Karten die gleichen Optionen:",
                  steps: [
                    "Durch Auswahl der SIM-Karten in der Tabelle über die Kontrollkästchen und Auswahl von Sperren im Menü Massenoperationen oben rechts.",
                    "Durch direktes Anklicken desselben Menüs und Hochladen einer Excel-Datei mit den IMSI/ICCID-Nummern in Spalte A, wobei die entsprechende Überschrift (IMSI/ICCID) in Zelle A1 steht.",
                    "Durch Anklicken der Zeile, woraufhin eine Seitenkarte mit dem Profil der SIM eingeblendet wird. Oben befindet sich ein Button Sperren.",
                  ],
                  important:
                    "Wichtig! Alle ausgewählten SIM-Karten müssen sich im Zustand Produktiv befinden, um gesperrt werden zu können.",
                  closing:
                    "Nach den beschriebenen Schritten erscheint ein Bestätigungsdialog, in dem der Benutzer die ausgewählten SIM-Karten überprüft und mit der Sperrung fortfährt.",
                },
              },
              resume: {
                title: "Fortsetzen",
                description: "eine ausgesetzte SIM reaktivieren.",
                details: {
                  intro:
                    "Ebenso hat der Benutzer zum Reaktivieren einer oder mehrerer SIM-Karten die gleichen Optionen:",
                  steps: [
                    "Durch Auswahl der SIM-Karten in der Tabelle über die Kontrollkästchen und Auswahl von Reaktivieren im Menü Massenoperationen oben rechts.",
                    "Durch direktes Anklicken desselben Menüs und Hochladen einer Excel-Datei mit den IMSI/ICCID-Nummern in Spalte A, wobei die entsprechende Überschrift (IMSI/ICCID) in Zelle A1 steht.",
                    "Durch Anklicken der Zeile, woraufhin eine Seitenkarte mit dem Profil der SIM eingeblendet wird. Oben befindet sich ein Button Reaktivieren.",
                  ],
                  important:
                    "Wichtig! Alle ausgewählten SIM-Karten müssen sich im Zustand Gesperrt oder Automatisch gesperrt befinden, um reaktiviert werden zu können.",
                  closing:
                    "Nach den beschriebenen Schritten erscheint ein Bestätigungsdialog, in dem der Benutzer die ausgewählten SIM-Karten überprüft und mit der Reaktivierung fortfährt.",
                },
              },
              terminate: {
                title: "Beenden",
                description:
                  "eine SIM aus der aktiven Nutzung entfernen (entweder zu OnStock oder Gelöscht).",
                details: {
                  intro:
                    "Ebenso hat der Benutzer zum Kündigen einer oder mehrerer SIM-Karten die gleichen Optionen:",
                  steps: [
                    "Durch Auswahl der SIM-Karten in der Tabelle über die Kontrollkästchen und Auswahl von Kündigen im Menü Massenoperationen oben rechts.",
                    "Durch direktes Anklicken desselben Menüs und Hochladen einer Excel-Datei mit den IMSI/ICCID-Nummern in Spalte A, wobei die entsprechende Überschrift (IMSI/ICCID) in Zelle A1 steht.",
                    "Durch Anklicken der Zeile, woraufhin eine Seitenkarte mit dem Profil der SIM eingeblendet wird. Oben befindet sich ein Button Kündigen.",
                  ],
                  important:
                    "Wichtig! Alle ausgewählten SIM-Karten müssen sich im Zustand Produktiv befinden, um gekündigt werden zu können.",
                  closing:
                    "Nach den beschriebenen Schritten erscheint ein Bestätigungsdialog, in dem der Benutzer den Zielstatus (Auf Lager oder Dauerhaft gelöscht) der Kündigung auswählt, die SIM-Karten überprüft und mit der Kündigung fortfährt.",
                },
              },
              modify: {
                title: "Ändern",
                description:
                  "ändern Sie das Angebot, unter dem die Karte aktiviert und abgerechnet wird.",
                details: {
                  intro: "Um das Angebot einer SIM-Karte zu ändern:",
                  steps: [
                    "Durch Auswahl der SIM-Karte in der Tabelle über das Kontrollkästchen und Auswahl von Ändern im Menü Aktionen oben rechts.",
                  ],
                  important:
                    "Wichtig! Die ausgewählte SIM-Karte muss sich im Zustand Produktiv befinden, um geändert werden zu können.",
                  closing:
                    "Nach den beschriebenen Schritten erscheint ein Bestätigungsdialog, in dem der Benutzer das gewünschte Zielangebot der SIM-Karte auswählt. Danach überprüft er die SIM-Karte und fährt mit der Änderung fort.",
                },
              },
            },
          },
          simProfile: {
            title: "SIM-Profil",
            description:
              "Das SIM-Profil ist ein Dashboard, das sich auf die Statistiken und Funktionen einer einzelnen SIM-Karte konzentriert. Es bietet ähnliche Statistiken wie das Haupt-Dashboard sowie detaillierte Informationen für Analyse und Verwaltung.",
            items: {
              kpis: "KPIs und Nutzungsstatistiken",
              monthly: "Monatliche Nutzungsverteilung",
              hlr: "HLR-Profil (falls zutreffend)",
              dataSessions: "Verlauf der Datensitzungen",
              smsUsage: "Verlauf der SMS-Nutzung",
              requests: "Anfragen für diese SIM-Karte",
              provisioning: "SIM-Provisionierungsaktivität und -funktionen",
              cellInfo: "Zellinformationen und Konnektivitätsdetails",
              watchdogs: "Watchdog-Informationen und Warnungen",
            },
            sections: {
              howToAccess: {
                title: "Zugriff",
                description:
                  "Um auf das Profil einer bestimmten SIM-Karte zuzugreifen, wählen Sie die SIM in der Tabelle aus und klicken Sie darauf. Ein Seitenpanel mit den SIM-Informationen wird eingeblendet. In diesem Panel befindet sich der Link 'Profil anzeigen', der Sie zur vollständigen SIM-Profilseite weiterleitet. Die SIM-Profilseite bietet detaillierte Statistiken, Nutzungshistorie, Provisionierungsaktionen und technische Informationen zur ausgewählten SIM-Karte.",
              },
              kpis: {
                title: "Kennzahlen (KPIs)",
                description:
                  "Der KPI-Bereich des SIM-Profils bietet einen schnellen Überblick über die Leistung und Aktivität der SIM. Diese Kennzahlen helfen dem Benutzer, die aktuelle Nutzung und den Zustand der SIM auf einen Blick zu verstehen.",
                bullets: [
                  "Datenvolumen – die insgesamt von der SIM verbrauchten Daten im ausgewählten Zeitraum.",
                  "Datensitzungen – die Anzahl der aufgebauten Datensitzungen im ausgewählten Zeitraum.",
                  "Warnmeldungen – die Anzahl der ausgelösten Warnungen für diese SIM (z. B. Nutzungsschwellen).",
                  "Null-Sitzungen – die Anzahl der Sitzungen, bei denen die SIM eine Verbindung versucht hat, aber keine Daten verbrauchte.",
                ],
                closing:
                  "Oben rechts kann der Benutzer die KPIs nach Zeitraum (Täglich, Monatlich oder Jährlich) filtern, um Nutzungsmuster im Zeitverlauf zu analysieren.",
              },
              monthly: {
                title: "Monatliche Verteilung",
                description:
                  "Verteilung von Daten, SMS und Sitzungen pro Monat.",
              },
              hlr: {
                title: "HLR-Profil",
                description:
                  "Das HLR (Home Location Register) Profil liefert detaillierte Informationen zu Abonnement und Netzwerk der SIM-Karte. Durch Klicken auf die Schaltfläche HLR im Aktionsmenü erscheint ein Modal mit Details wie:",
                fields: {
                  msisdn: "MSISDN",
                  imsi: "IMSI",
                  networkAccessMode: "Netzzugriffsmodus (z. B. CS und PS)",
                  subscriberType: "Teilnehmertyp (z. B. LTE-Abonnent)",
                  simStatus: "SIM-Status (z. B. Verfügbar)",
                },
                scopes:
                  "Zusätzlich kann der Benutzer aus einer Dropdown-Liste verfügbarer Bereiche (z. B. Basisinformationen, Erweiterte Informationen) auswählen, um die entsprechenden Details je nach gewünschter Informationstiefe anzuzeigen.",
                closing:
                  "Diese Funktion ermöglicht Administratoren, die SIM-Provisionierungsdetails schnell zu validieren und zu bestätigen, ob die SIM korrekt registriert und im Netzwerk verfügbar ist.",
              },

              dataSessions: {
                title: "Datensitzungen",
                description:
                  "Die Funktion Datensitzungen ermöglicht Administratoren die detaillierte Ansicht aller mit einer SIM-Karte verbundenen Datensitzungen. Durch Klicken auf die Schaltfläche Sitzungen im Menü Aktionen öffnet sich ein Modal, das den Sitzungsverlauf und die zugehörigen Details anzeigt.",
                fields: {
                  openDate: "Zeitstempel, wann die Sitzung gestartet wurde",
                  closeDate: "Zeitstempel, wann die Sitzung beendet wurde",
                  consumption:
                    "Tatsächlich während der Sitzung verbrauchte Bytes",
                  roundedBytes:
                    "Nutzung, gerundet nach den Abrechnungsrichtlinien des Betreibers",
                  operator: "Der Netzbetreiber, der die Sitzung verwaltet",
                  cell: "Die Zell-ID, in der die Sitzung aufgebaut wurde",
                  imei: "Gerätekennung (IMEI), die für diese Sitzung verwendet wurde",
                },
              },
              smsUsage: {
                title: "SMS-Nutzung",
                description:
                  "Das SMS-Nutzungsfenster ermöglicht Administratoren die Überwachung aller von der SIM-Karte gesendeten und empfangenen SMS. Durch Klicken auf die Schaltfläche SMS-Nutzung im Menü Aktionen erscheint eine detaillierte Tabelle mit jeder SMS-Transaktion.",
                fields: {
                  direction: "Richtung (z. B. Eingehend oder Ausgehend)",
                  date: "Datum und Uhrzeit des SMS-Ereignisses",
                  sender: "Der Absender der SMS",
                  message: "Der Inhalt der SMS (falls verfügbar)",
                  status:
                    "Lieferstatus (z. B. Übermittelt, Zugestellt, Fehlgeschlagen)",
                },
                note: "Diese Funktion bietet vollständige Nachverfolgbarkeit des SMS-Verkehrs für Fehlerbehebung, Compliance oder Nutzungsanalysen.",
              },
              requests: {
                title: "Anfragen",
                description:
                  "Der Bereich Anfragen bietet eine vollständige Historie aller Provisionierungsaufträge, die für die ausgewählte SIM-Karte durchgeführt wurden. Durch Klicken auf die Schaltfläche Anfragen im Aktionsmenü erscheint ein Modal, das alle Aufträge auflistet, wie Aktivieren, Sperren, Fortsetzen und Kündigen.",
                fields: {
                  id: "ID: Die eindeutige Kennung des Auftrags.",
                  name: "Name: Die Art der Aktion (z. B. SuspendSIM, ResumeSIM, TerminateSIM).",
                  status:
                    "Status: Der Ausführungsstatus des Auftrags (z. B. Erledigt, Ausstehend).",
                  creator:
                    "Ersteller: Der Benutzer, der die Anfrage initiiert hat.",
                  creationDate:
                    "Erstellungsdatum: Wann der Auftrag erstellt wurde.",
                  lastUpdate:
                    "Letzte Aktualisierung: Der Zeitpunkt der letzten Statusaktualisierung.",
                },
                note: "Diese Funktion ermöglicht Administratoren, alle Provisionierungsaktivitäten der SIM nachzuverfolgen und stellt Transparenz und Verantwortlichkeit im Lebenszyklusmanagement sicher.",
              },
              provisioning: {
                title: "Provisioning-Aktivität",
                description:
                  "Provisioning-Aktionen wie Aktivierung, Sperrung und Änderungen.",
              },
              cellInfo: {
                title: "Zellinformationen",
                description:
                  "Informationen zur Funkzelle und Verbindungsdaten der SIM.",
              },
              watchdogs: {
                title: "Watchdogs",
                description:
                  "Der Abschnitt Watchdogs im SIM-Profil zeigt alle konfigurierten Watchdogs an, die der SIM-Karte zugeordnet sind. Diese Watchdogs werden in der Regel auf Plattformebene definiert und mit einer SIM verknüpft, um bestimmte Bedingungen zu überwachen.",
                bullets: [
                  "Liste der aktiven Watchdogs anzeigen, die mit der SIM verbunden sind.",
                  "Konfiguration überprüfen (z. B. Typ des Watchdogs, Status und festgelegte Grenzwerte).",
                  "Nachverfolgen, welche Watchdogs die SIM-Aktivität derzeit überwachen.",
                ],
                note: "Hinweis: Die Konfiguration von Schwellenwerten, Warnungen oder automatischen Aktionen ist über das SIM-Profil selbst nicht verfügbar. Dieser Abschnitt ist schreibgeschützt und dient ausschließlich zur Überwachung.",
              },
            },
          },
          simTransfers: {
            title: "SIM-Übertragungen",
            description:
              "Die Funktion SIM-Übertragung ermöglicht Administratoren, SIM-Karten zwischen Konten oder Organisationen zu verschieben. Dies ist nützlich für die Neuzuweisung von SIMs, den Versand an andere Organisationen oder die Verwaltung von Eigentumsänderungen.",

            howToAccess: {
              title: "Zugriff",
              description:
                "Um auf SIM-Übertragungen zuzugreifen, gehen Sie zum Benutzerverwaltungsbereich, öffnen Sie das Aktionsmenü eines Benutzers und wählen Sie die Option 'SIMs versenden'.",
            },

            steps: {
              title: "Schritte zur Durchführung einer SIM-Übertragung",
              description:
                "Der Übertragungsprozess umfasst die folgenden Schritte:",
              bullets: [
                "Stellen Sie sicher, dass sich die SIM-Karten im Status 'Auf Lager' befinden, bevor Sie den Transfer starten. Nur verfügbare SIMs können zwischen Konten übertragen werden.",
                "Wählen Sie einen SIM-Auswahltyp: Einzel-IMSI, Einzel-ICCID, IMSI-Bereich, ICCID-Bereich oder CSV/XLSX-Upload. Dies bestimmt, wie die SIMs identifiziert werden.",
                "Geben Sie die erforderlichen SIM-IDs ein oder laden Sie diese hoch, je nach gewähltem Typ.",
                "Optional können Preis und Mehrwertsteuer angegeben werden. Diese Felder dienen zur Nachverfolgung der finanziellen Auswirkungen des Transfers.",
                "Wählen Sie ein Abrechnungsangebot. Dies ist das Angebot, das dem Quellkonto belastet wird, wenn das Zielkonto die übertragene SIM aktiviert.",
                "Klicken Sie auf 'Absenden', um den SIM-Transfer abzuschließen. Nach der Bestätigung erscheinen die SIMs im Zielkonto-Bestand.",
              ],
            },
            deallocate: {
              title: "SIMs Dealokalisieren",
              description:
                "Die Dealokalisierung ist das Gegenstück zur SIM-Übertragung. Sie ermöglicht es Benutzern, SIM-Karten aus einem Zielkonto zu entfernen und sie zurück an das Quellkonto oder in den Bestand zu geben. Dies ist nützlich, wenn SIMs versehentlich zugewiesen wurden, nicht mehr benötigt werden oder neu zugewiesen werden müssen.",
              bullets: [
                "Navigieren Sie zum Benutzerverwaltungsbereich, öffnen Sie das Aktionsmenü für einen Benutzer und wählen Sie 'SIMs Dealokalisieren'.",
                "Stellen Sie sicher, dass sich die SIM-Karten im Status 'Auf Lager' oder 'Zugewiesen' befinden, bevor Sie die Dealokalisierung versuchen.",
                "Wählen Sie einen SIM-Auswahltyp: Einzelnes IMSI, Einzelnes ICCID, IMSI-Bereich, ICCID-Bereich oder CSV/XLSX-Datei.",
                "Geben Sie die Kennungen der zu dealokalisierenden SIMs ein oder laden Sie sie hoch.",
                "Bestätigen Sie die Quell- und Zielkonten. Das Feld 'Von' zeigt das aktuelle Konto, und das Feld 'An' zeigt das Konto oder Lager, an das die SIMs zurückgegeben werden.",
                "Klicken Sie auf 'Absenden', um die Dealokalisierung abzuschließen. Nach der Bestätigung erscheinen die SIMs nicht mehr im Inventar des Zielkontos und stehen für eine erneute Zuweisung zur Verfügung.",
              ],
            },
          },
        },
        watchdog: {
          title: "Watchdog",
          description:
            "Watchdogs sind Überwachungsregeln, die den Nutzern helfen, die SIM-Kartennutzung zu kontrollieren und ungewöhnliches Verhalten zu erkennen. Sie ermöglichen eine proaktive Verwaltung, indem Schwellenwerte für Kennzahlen wie Datenvolumen, Sitzungen oder SMS-Nutzung definiert werden. Wenn ein Schwellenwert überschritten wird, kann das System Warnungen erzeugen oder Aktionen auslösen, um Missbrauch oder unerwartete Kosten zu verhindern.",
          items: {
            add: "Wie man einen Watchdog hinzufügt",
            remove: "Wie man einen Watchdog entfernt",
            reset: "Wie man einen Watchdog zurücksetzt",
            suspensionBlock:
              "SIM-Sperre in der aktuellen Abrechnungsperiode blockieren",
            alerts: "Von Watchdogs generierte Warnungen",
          },
          add: {
            title: "Watchdog hinzufügen",
            description:
              "Benutzer können einen neuen Watchdog erstellen, um die SIM-Aktivität zu überwachen und automatische Aktionen auszulösen, wenn die Nutzung definierte Schwellenwerte überschreitet. Dies unterstützt eine proaktive Verwaltung und Kostenkontrolle.",
            howToAccess:
              "Um einen neuen Watchdog hinzuzufügen, gehen Sie zum SIM-Panel → Massenoperationen → Watchdogs → Watchdog erstellen. Wichtig: Alle SIM-Karten müssen sich im Status Productive (aktiviert) befinden, um einen Watchdog zu konfigurieren.",
            fields: {
              actionType:
                "Wählen Sie die Aktion, die ausgeführt wird, wenn der Schwellenwert erreicht wird (z. B. benachrichtigen, sperren).",
              interval:
                "Wählen Sie den Überwachungszeitraum (täglich, wöchentlich, monatlich).",
              amount:
                "Geben Sie den Nutzungsschwellenwert ein, der die Aktion auslöst.",
              service:
                "Wählen Sie den zu überwachenden Dienst (z. B. Daten, SMS).",
              unitType: "Wählen Sie die Maßeinheit (z. B. Bytes, Anzahl SMS).",
              warnings:
                "Definieren Sie Vorwarnschwellen, bevor die Hauptaktion ausgeführt wird, um Benutzer rechtzeitig zu informieren.",
              suspendInterval:
                "Legt fest, wie lange die SIM nach dem Auslösen des Watchdogs gesperrt bleibt. Wenn täglich eingestellt, wird die SIM um Mitternacht des nächsten Tages automatisch wieder aktiviert. Wenn wöchentlich, um Mitternacht am kommenden Montag. Wenn monatlich, um Mitternacht am ersten Tag des nächsten Monats.",
            },
          },
          removeAll: {
            title: "Alle Watchdogs Entfernen",
            description:
              "Benutzer können alle konfigurierten Watchdogs von einer SIM-Karte mit einer einzigen Aktion entfernen. Dies ist nützlich, um die Überwachung schnell zurückzusetzen, ohne jeden Watchdog einzeln löschen zu müssen.",
            howToAccess:
              "Um alle Watchdogs zu entfernen, gehen Sie zum SIM-Panel → aktive SIM-Karten auswählen → Massenaktionen → Watchdogs → Alle Watchdogs entfernen.",
            details: {
              title: "Details",
              immediateEffect:
                "Bei Ausführung werden alle vorhandenen Watchdog-Konfigurationen auf den ausgewählten SIMs gelöscht.",
              noAlerts:
                "Nach der Entfernung werden keine Alarme oder automatischen Aktionen mehr ausgelöst.",
              cleanSlate:
                "Die SIM funktioniert weiterhin normal, jedoch ohne Überwachung, bis neue Watchdogs erstellt werden.",
            },
            useCases: {
              title: "Anwendungsfälle",
              policyChanges:
                "Wenn sich Überwachungsrichtlinien ändern, müssen bestehende Watchdogs möglicherweise gelöscht werden.",
              testing:
                "In Testumgebungen können viele Watchdogs erstellt und zur Bereinigung schnell entfernt werden.",
              errorRecovery:
                "Wenn falsch konfigurierte oder widersprüchliche Watchdogs vorhanden sind, setzt die Entfernung sie in einen neutralen Zustand zurück.",
            },
            considerations: {
              title: "Wichtige Hinweise",
              irreversible:
                "Das Entfernen aller Watchdogs kann nicht rückgängig gemacht werden; sie müssen bei Bedarf neu erstellt werden.",
              criticalMonitoring:
                "Stellen Sie sicher, dass SIMs in kritischen Umgebungen nicht ohne Überwachung bleiben.",
              bulkOperations:
                "Überprüfen Sie bei Massenaktionen sorgfältig, da alle ausgewählten SIMs betroffen sind.",
            },
          },
          reset: {
            title: "Watchdog Zurücksetzen",
            description:
              "Das Zurücksetzen eines Watchdogs setzt den Verbrauchszähler zurück und stellt die Sperre wieder her, wenn der Benutzer zuvor gewählt hat, die Sperre für den aktuellen Abrechnungszeitraum zu blockieren. Dies ermöglicht eine erneute Überwachung ohne einen neuen Watchdog zu erstellen.",
            howToAccess: {
              title: "Zugriff",
              description:
                "Navigieren Sie zum SIM-Kartenprofil. Klicken Sie im Abschnitt Watchdog auf das kreisförmige Pfeilsymbol neben dem entsprechenden Watchdog, um ihn zurückzusetzen.",
            },
          },
          blockSuspension: {
            title: "Sperrung Blockieren",
            description:
              "Das Blockieren der Sperrung verhindert, dass eine SIM-Karte gesperrt wird, wenn ein Watchdog, der ihren Verbrauch überwacht, eine 100%-Verbrauchswarnung (Depleted Alert) auslöst. Diese Funktion gilt nur für den aktuellen Abrechnungszeitraum. Zu Beginn des nächsten Abrechnungszeitraums wird die Sperre automatisch wieder aktiviert.",
            howToAccess: {
              title: "Zugriff",
              description:
                "Wählen Sie SIM-Karten im Status 'Produktiv' aus dem SIM-Panel. Öffnen Sie dann Massenoperationen → Watchdogs → Sperrung Blockieren.",
            },
          },
          alerts: {
            title: "Benachrichtigungen",
            description:
              "Watchdogs, die den SIM-Verbrauch überwachen, lösen Benachrichtigungen aus. Diese helfen Nutzern, Verbrauchsgrenzen im Auge zu behalten und rechtzeitig Maßnahmen zu ergreifen.",
            typesTitle: "Arten von Benachrichtigungen",
            types: {
              depleted:
                "Erschöpft: Wird für alle Watchdogs generiert. Ausgelöst, wenn eine SIM-Karte 100% ihres Verbrauchs erreicht.",
              warning:
                "Warnung: Optional für Watchdogs, die Warnschwellen festgelegt haben.",
            },
            howToAccess: {
              title: "Zugriff",
              description:
                "Um Benachrichtigungen einzusehen, öffnen Sie das Menü 'Benachrichtigungen' in der Seitenleiste. Die Tabelle listet die Benachrichtigungen nach Datum (neueste zuerst) und bietet Filter für Typ, Datum und IMSI.",
            },
          },
        },
        reports: {
          intro: {
            title: "Berichte",
            description:
              "Die Plattform bietet den Benutzern die Möglichkeit, eine Vielzahl von Berichten anzuzeigen und zu exportieren, darunter SIM-Kartenverbrauch, Rechnungslisten, detaillierte Rechnungszeilen, SIM-Provisionierungsanfragen, Portfolioaktivitäten (Aktivierungen und Kündigungen pro Angebot), SIM-Kartenstatusverteilung und aktive SIM-Sitzungen. Außerdem können automatisierte Berichte zur Nutzung und SIM-Übersicht erstellt werden, die in festen Intervallen als Download generiert werden. Dieses Kapitel konzentriert sich auf drei Unterkapitel.",
            subchaptersTitle: "Unterkapitel",
            subchapters: {
              single: "Einzelbericht",
              automated: "Automatisierter Bericht",
              history: "Berichtsverlauf",
            },
          },
          single: {
            title: "Einzelbericht",
            description:
              "Einzelberichte ermöglichen es Benutzern, spezifische Berichte über SIM-Nutzung, Rechnungen, Portfolioaktivitäten, Bereitstellungsanfragen oder Sitzungen zu erstellen. Diese Berichte können nach Kriterien angepasst, gruppiert und für weitere Analysen exportiert werden.",

            howToAccess: {
              title: "Zugriff",
              description:
                "Um auf Einzelberichte zuzugreifen, navigieren Sie in der Seitenleiste zu Berichte und wählen Sie 'Bericht erstellen'.",
            },

            usageReport: {
              title: "Nutzungsbericht",
              description:
                "Der Nutzungsbericht liefert detaillierte Einblicke in den SIM-Verbrauch für Daten oder SMS mit flexiblen Gruppierungs- und Filteroptionen.",
              bullets: [
                "Wählen Sie 'Usage' als Berichtstyp.",
                "Wählen Sie den Nutzungstyp: Daten oder SMS.",
                "Gruppierung nach Feld: IMSI, Netzwerk, Kunde oder keine Gruppierung.",
                "Gruppierung nach Zeitraum: Tag, Monat oder Jahr.",
                "Optional nach SIM filtern: spezifische IMSI, IMSI-Bereich oder ICCID.",
                "Klicken Sie auf 'Anzeigen', um den Bericht zu generieren.",
              ],
            },
            invoiceList: {
              title: "Rechnungsliste",
              description:
                "Der Bericht Rechnungsliste bietet eine Übersicht über alle für das Konto ausgestellten Rechnungen. Er enthält wichtige Informationen wie Rechnungsnummer, Ausstellungsdatum, Fälligkeitsdatum, Gesamtbetrag und Zahlungsstatus. Benutzer können Rechnungen nach Datumsbereich filtern, um schnell die gewünschten Dokumente zu finden.",
              bullets: [
                "Navigieren Sie zu Berichte → Bericht erstellen.",
                "Wählen Sie 'Rechnungsliste' als Berichtstyp.",
                "Definieren Sie den Datumsbereich (Von – Bis), um die Liste der Rechnungen einzugrenzen.",
                "Klicken Sie auf 'Anzeigen', um den Bericht zu generieren.",
                "Die resultierende Tabelle zeigt Rechnungen mit Details wie Nummer, Ausstellungsdatum, Fälligkeitsdatum, Gesamtbetrag und Zahlungsstatus.",
              ],
            },
            orders: {
              title: "Bestellbericht",
              description:
                "Der Bestellbericht ermöglicht es dem Benutzer, alle Bereitstellungsaufträge im Zusammenhang mit SIM-Karten einzusehen. Er bietet einen historischen Überblick über die während des ausgewählten Zeitraums erstellten Bestellungen.",
              bullets: [
                "Zugänglich über Berichte → Bericht erstellen → Bestellungen.",
                "Filterung nach Zeitraum möglich.",
                "Zeigt eine Liste der SIM-Bereitstellungsaufträge an.",
              ],
            },
            portfolioActivity: {
              title: "Portfolioaktivitätsbericht",
              description:
                "Der Portfolioaktivitätsbericht bietet einen Überblick über die SIM-Kartenaktivitäten, einschließlich Aktivierungen, Kündigungen und Änderungen pro Tarif. Er hilft Benutzern, die Entwicklung ihres SIM-Portfolios im Laufe der Zeit zu verfolgen.",
              bullets: [
                "Zugänglich über Berichte → Bericht erstellen → Portfolioaktivität.",
                "Bericht kann nach Zeitraum (Von–Bis) gefiltert werden.",
                "Zeigt Aktivierungen, Kündigungen und Aktivitäten nach Tarif gruppiert an.",
              ],
            },
            customerSimSessions: {
              title: "Bericht über Kundensitzungen von SIM-Karten",
              description:
                "Der Bericht über Kundensitzungen von SIM-Karten zeigt Informationen über aktive und vergangene SIM-Sitzungen von Kunden. Er hilft nachzuvollziehen, wann und wie SIM-Karten mit dem Netzwerk verbunden sind.",
              bullets: [
                "Zugänglich über Berichte → Bericht erstellen → Kundensitzungen SIM.",
                "Zeigt Sitzungsdetails wie IMSI, Start- und Endzeit sowie übertragene Daten an.",
                "Nützlich zur Behebung von Verbindungsproblemen und Analyse von Nutzungsmustern.",
              ],
            },
            simOverview: {
              title: "SIM-Übersichtsbericht",
              description:
                "Der SIM-Übersichtsbericht bietet eine Zusammenfassung der SIM-Karten im System und zeigt deren Verteilung nach Status, Zuweisung und Aktivität. Er hilft Administratoren, den gesamten SIM-Bestand schnell einzuschätzen.",
              bullets: [
                "Zugänglich über Berichte → Bericht erstellen → SIM-Übersicht.",
                "Zeigt SIMs gruppiert nach Status wie Aktiv, Gesperrt, Beendet oder Auf Lager.",
                "Nützlich, um den Zustand und die Verteilung der SIM-Karten auf einen Blick zu überwachen.",
              ],
            },
            simList: {
              title: "SIM-Listenbericht",
              description:
                "Der SIM-Listenbericht bietet eine detaillierte Bestandsaufnahme aller SIM-Karten im System. Er enthält Kennungen wie IMSI und ICCID, deren aktuellen Status und Zuweisungsdetails.",
              bullets: [
                "Zugänglich über Berichte → Bericht erstellen → SIM-Liste.",
                "Zeigt jede SIM-Karte mit IMSI, ICCID und aktuellem Status an.",
                "Nützlich zur Prüfung und Verwaltung des gesamten SIM-Bestands.",
              ],
            },
            exportReport: {
              title: "Bericht in Datei exportieren",
              description:
                "Alle erstellten Berichte können in eine Datei exportiert werden, um sie weiter zu analysieren oder zu teilen. Die Exportoptionen umfassen CSV- und PDF-Formate.",
              bullets: [
                "Zugänglich über Aktionen → Exportieren → CSV oder PDF.",
                "Das CSV-Format ist nützlich für die Datenanalyse in Excel oder anderen Tabellenkalkulationsprogrammen.",
                "Das PDF-Format ist nützlich zum Teilen von Berichten im festen Layout.",
              ],
            },
            timeoutReports: {
              title: "Timeout-Berichte",
              description:
                "Jede Berichtserstellung hat ein Zeitlimit von 15 Sekunden. Wird dieses Limit überschritten, wird der Bericht im Hintergrund weiter generiert.",
              bullets: [
                "Eine Benachrichtigung informiert den Benutzer, wenn ein Bericht ein Timeout erreicht.",
                "Sobald der Bericht fertig ist, wird eine Push-Benachrichtigung gesendet.",
                "Der generierte Timeout-Bericht kann über Aktionen → Anzeigen geöffnet werden.",
                "Timeout-Berichte können ebenfalls als CSV oder PDF exportiert werden, genau wie sofort generierte Berichte.",
              ],
            },
          },
          automated: {
            title: "Automatisierte Berichte",
            description:
              "Automatisierte Berichte ermöglichen es den Benutzern, die Erstellung von Berichten in festen Intervallen und in einem ausgewählten Format zu planen.",
            overview: {
              title: "Übersicht",
              description:
                "Automatisierte Berichte werden einmal erstellt und anschließend automatisch in der gewählten Häufigkeit und im gewählten Format generiert.",
              bullets: [
                "Berichte können täglich, wöchentlich oder monatlich geplant werden.",
                "Berichte können im CSV- oder PDF-Format generiert werden.",
                "Verfügbare Berichtstypen: Nutzung und Kunden-SIM-Übersicht.",
              ],
            },
            create: {
              title: "Erstellen eines automatisierten Berichts",
              description:
                "Um einen neuen automatisierten Bericht zu erstellen, klicken Sie auf die Schaltfläche oben rechts in der Karte. Ein Formular wird angezeigt, das bestimmte Informationen erfordert:",
              bullets: [
                "Name: Der Name des Berichts.",
                "Berichtshäufigkeit: Täglich, wöchentlich oder monatlich.",
                "Berichtsformat: CSV oder PDF.",
                "Berichtstyp: Wählen Sie zwischen Nutzung und Kunden-SIM-Übersicht.",
                "Je nach Berichtstyp können zusätzliche Felder erscheinen, ähnlich wie im Menü Bericht Erstellen.",
              ],
            },
          },
          history: {
            title: "Berichtsverlauf",
            description:
              "Der Bereich Berichtsverlauf bietet eine Liste der Ergebnisse aller Ausführungen automatisierter Berichte. Jeder Eintrag enthält den Berichtsnamen, das Erstellungsdatum, den Status, die Download-Option und die Möglichkeit, den Bericht zu löschen.",
            reportHistory: {
              title: "Anzeigen von Ergebnissen automatisierter Berichte",
              description: "Im Bereich Berichtsverlauf können Benutzer:",
              bullets: [
                "Die Ergebnisse aller ausgeführten automatisierten Berichte anzeigen.",
                "Den Ausführungsstatus prüfen (Abgeschlossen, Ausstehend, Fehlgeschlagen).",
                "Die generierten Dateien im CSV- oder PDF-Format herunterladen.",
                "Einen Berichtseintrag über das Aktionsmenü löschen.",
              ],
            },
          },
        },
      },
    },
  },
  nl: {
    translation: {
      sidebar: {
        dashboard: "Dashboard",
        crm: "CRM",
        admins: "Beheerders",
        tenants: "Huurders",
        managers: "Managers",
        customers: "Klanten",
        subaccounts: "Subaccounts",
        sims: "SIM-kaarten",
        account: "Account",
        profile: "Profiel",
        billingProducts: "Factureringsproducten",
        invoices: "Facturen",
        statements: "Rekeningen",
        orders: "Bestellingen",
        emails: "E-mails",
        reports: "Rapporten",
        generateReport: "Genereer rapport",
        automatedReports: "Geautomatiseerde rapporten",
        reportHistory: "Rapportgeschiedenis",
        alerts: "Waarschuwingen",
        notifications: "Meldingen",
        support: "Ondersteuning",
        privileges: "Rechten",
        settings: "Instellingen",
        services: "Diensten",
        documentation: "Documentatie",
        whitelist: "Toegestaan IP-adres",
        customFields: "Aangepaste velden",
        simProducts: "SIM-producten",
        purchaseSims: "SIM-kaarten kopen",
        health: "Systeemstatus",
        purchaseOrders: "SIM-kaartbestellingen",
      },
      dashboard: {
        dataVolume: "Datavolume",
        dataSessions: "Datasessies",
        alerts: "Waarschuwingen",
        zeroSessions: "Nulsessies",
        sinceYesterday: "Sinds gisteren",
        sinceLastMonth: "Sinds vorige maand",
        sinceLastYear: "Sinds vorig jaar",
        averageVolume: "Gemiddeld datavolume",
        activeSims: "Actieve SIM-kaarten",
        dataVolumePerHour: "Datavolume per uur",
        topMetrics: "Top statistieken",
        simCardsPerOffer: "SIM-kaarten per aanbieding",
        simInventory: "SIM-verdeling per status",
        dataVolumePerNetwork: "Datavolume per netwerk",
        selectCountry: "Land selecteren",
        networksDistribution: "Actieve SIM-kaarten per netwerkverdeling",
        watchdogAlerts: "Verbruikswaarschuwingen",
        noData: "Geen gegevens beschikbaar",
        daily: "Dagelijks",
        monthly: "Maandelijks",
        yearly: "Jaarlijks",
      },
      crm: {
        admins: "Beheerders",
        tenants: "Huurders",
        managers: "Managers",
        customers: "Klanten",
        subaccounts: "Subaccounts",
        filters: "Filters",
        fullName: "Volledige naam",
        company: "Bedrijf",
        email: "E-mail",
        address: "Adres",
        city: "Stad",
        country: "Land",
        postcode: "Postcode",
        telephone: "Telefoon",
        mobile: "Mobiel",
        occupation: "Beroep",
        tin: "Belastingnummer",
        username: "Gebruikersnaam",
        role: "Rol",
        actions: "Acties",
        edit: "Bewerken",
        delete: "Verwijderen",
        billing: "Facturering",
        whitelabeling: "Witlabel",
        offers: "Aanbiedingen",
        impersonate: "Imiteren",
        permissions: "Rechten",
        sendWelcomeEmail: "Verwelkomingsmail versturen",
        resetPassword: "Wachtwoord resetten",
        initializeSIMs: "SIM-kaarten initialiseren",
        initializeAlerts: "Waarschuwingen initialiseren",
        newTenant: "Nieuwe huurder",
        newManager: "Nieuwe manager",
        newCustomer: "Nieuwe klant",
        newSubaccount: "Nieuw subaccount",
        registerPayment: "Betaling registreren",
        accountId: "Account-ID",
        registerPayment: {
          title: "Betaling registreren",
          amount: "Bedrag",
          currency: "Valuta",
          invoice: "Factuurnummer",
          submit: "Verzenden",
          cancel: "Annuleren",
          selectCurrency: "Selecteer valuta",
          selectInvoice: "Selecteer factuur",
        },
        creditNote: {
          title: "Creditnota",
          amount: "Bedrag",
          vat: "BTW",
          reason: "Reden",
          submit: "Verzenden",
          cancel: "Annuleren",
        },
        invoiceCycle: {
          title: "Facturatiecyclus opnieuw uitvoeren",
        },
        newModal: {
          newTenant: "Huurder aanmaken",
          newManager: "Manager aanmaken",
          newCustomer: "Klant aanmaken",
          newSubaccount: "Subaccount aanmaken",
          fullName: "Volledige naam",
          address: "Adres",
          city: "Stad",
          country: "Land",
          postcode: "Postcode",
          telephone: "Telefoon",
          mobile: "Mobiel",
          email: "E-mail",
          occupation: "Beroep",
          company: "Bedrijf",
          tin: "Belastingnummer",
          username: "Gebruikersnaam",
          sendWelcomeEmail: "Verwelkomingsmail versturen",
          cancel: "Annuleren",
          submit: "Verzenden",
          next: "Volgende",
          previous: "Vorige",
          preferredLanguage: "Voorkeurstaal",
          billingEmail: "Facturatie-e-mail",
          currency: "Valuta",
        },
        editModal: {
          editTenant: "Huurder bewerken",
          editManager: "Manager bewerken",
          editCustomer: "Klant bewerken",
          editSubaccount: "Subaccount bewerken",
          fullName: "Volledige naam",
          address: "Adres",
          city: "Stad",
          country: "Land",
          postcode: "Postcode",
          telephone: "Telefoon",
          mobile: "Mobiel",
          email: "E-mail",
          occupation: "Beroep",
          company: "Bedrijf",
          tin: "Belastingnummer",
          username: "Gebruikersnaam",
          cancel: "Annuleren",
          submit: "Verzenden",
        },
        billingModal: {
          title: "Factureringsinstellingen",
          currency: "Valuta",
          billingFrequency: "Factureringsfrequentie",
          daysToPayInvoice: "Dagen om factuur te betalen",
          minimumAmountToInvoice: "Minimaal factuurbedrag",
          invoiceType: "Factuurtype",
          preferredLanguage: "Voorkeurstaal",
          billingEmail: "Facturatie e-mail",
          platformUsage: "Platformgebruik",
          platformUsagePrice: "Platformgebruik prijs",
          onStockPriceEnabled: "On Stock SIM-kaarten kosten ingeschakeld",
          onStockPrice: "On Stock SIM-kaarten prijs",
          simCardPriceEnabled: "Simkaartkosten?",
          simCardPrice: "Prijs van simkaart",
          simChipPriceEnabled: "Simchipkosten?",
          simChipPrice: "Prijs van simchip",
          billable: "Factureerbaar?",
          isVatExempt: "Is vrijgesteld van btw?",
          cancel: "Annuleren",
          submit: "Verzenden",
        },
        whitelabelModal: {
          title: "Witlabel-instellingen",
          enableWhitelabel: "Witlabel inschakelen",
          pricePerMonth: "Prijs per maand",
          url: "URL",
          cancel: "Annuleren",
          submit: "Verzenden",
        },
        roleModal: {
          title: "Rol bijwerken",
          role: "Rol",
          tenant: "Huurder",
          manager: "Manager",
          customer: "Klant",
          cancel: "Annuleren",
          submit: "Verzenden",
        },
        offersModal: {
          title: "Aanbiedingen toewijzen",
          availableOffers: "Beschikbare aanbiedingen",
          assignedOffers: "Toegewezen aanbiedingen",
          submit: "Verzenden",
        },
      },
      sims: {
        title: "SIM-kaarten",
        dataVolume: "Datavolume",
        dataSessions: "Datasessies",
        zeroSessions: "Nulsessies",
        filters: "Filters",
        simStatus: "Actieve sessie",
        simState: "SIM-status",
        portfolioId: "Portfolio ID",
        imsi: "IMSI",
        iccid: "ICCID",
        msisdn: "MSISDN",
        eid: "EID",
        offer: "Aanbieding",
        data: "Data",
        min: "Min",
        max: "Max",
        search: "Zoeken",
        clear: "Wissen",
        actions: "Acties",
        bulk: "Bulkacties",
        modify: "Wijzigen",
        product: "Product",
        clearSelection: "Selectie wissen",
        activate: "Activeren",
        suspend: "Schorsen",
        resume: "Hervatten",
        terminate: "Beëindigen",
        testMode: "Testmodus",
        sendSms: "SMS versturen",
        watchdogs: "Watchdogs",
        createWatchdog: "Watchdog aanmaken",
        removeAllWatchdogs: "Verwijder alle Watchdogs",
        blockSuspension: "Blokkering van Opschorting",
        export: "Exporteren",
        simInformation: "SIM-informatie",
        usage: "Verbruik",
        ipAddress: "IP-adres",
        imei: "IMEI",
        status: "Status",
        visitProfile: "Profiel bezoeken",
        provider: "Provider",
        area: "Gebied",
        cell: "Cel",
        longitude: "Lengtegraad",
        latitude: "Breedtegraad",
        cellRange: "Cell bereik",
        unit: "Eenheid",
        sort: "Sorteren",
        suspendModal: {
          title: "SIM schorsen",
          orderComplete: "SIM-schorsing voltooid",
          orderError: "SIM-schorsing mislukt",
          contactAdmin: "Neem contact op met de systeembeheerder",
          cancel: "Annuleren",
          submit: "Verzenden",
          close: "Sluiten",
        },
        resumeModal: {
          title: "SIM hervatten",
          orderComplete: "SIM-hervatting voltooid",
          orderError: "SIM-hervatting mislukt",
          contactAdmin: "Neem contact op met de systeembeheerder",
          cancel: "Annuleren",
          submit: "Verzenden",
          close: "Sluiten",
        },
        activateModal: {
          title: "SIM activeren",
          offer: "Aanbieding",
          selectOffer: "Selecteer aanbieding",
          success: "SIM-activatie voltooid",
          orderError: "SIM-activatie mislukt",
          contactAdmin: "Neem contact op met de systeembeheerder",
          cancel: "Annuleren",
          submit: "Verzenden",
          close: "Sluiten",
        },
        terminateModal: {
          title: "SIM beëindigen",
          targetState: "Gewenste status",
          onStock: "Op voorraad",
          terminated: "Beëindigd",
          success: "SIM-beëindiging voltooid",
          orderError: "SIM-beëindiging mislukt",
          contactAdmin: "Neem contact op met de systeembeheerder",
          cancel: "Annuleren",
          submit: "Verzenden",
          close: "Sluiten",
        },
      },
      simProfile: {
        simProvisioning: "SIM-statusbeheer",
        simDetails: "SIM-details",
        actions: "Acties",
        hlr: "HLR",
        session: "Sessies",
        smsUsage: "SMS-verbruik",
        updateLoc: "Locatie bijwerken",
        imeiLock: "IMEI-vergrendeling",
        usage: "Verbruik",
        imei: "IMEI",
        status: "Status",
        dataSession: "Actieve sessie",
        map: "Kaart",
        provider: "Provider",
        imsi: "IMSI",
        iccid: "ICCID",
        msisdn: "MSISDN",
        country: "Land",
        operator: "Netwerkoperator",
        area: "Gebied",
        cell: "Cel",
        longitude: "Lengtegraad",
        latitude: "Breedtegraad",
        cellRange: "Cell bereik",
        activity: "Activiteit",
        selectPeriod: "Periode selecteren",
        daily: "Dagelijks",
        monthly: "Maandelijks",
        yearly: "Jaarlijks",
        dataVolume: "Datavolume",
        dataSessions: "Datasessies",
        alerts: "Waarschuwingen",
        zeroSessions: "Nulsessies",
        watchdog: "Watchdog",
        type: "Type",
        blockSuspension: "SIM wordt opgeschort",
        amount: "Bedrag",
        hlrModal: {
          title: "HLR-profiel",
          selectScope: "Bereik selecteren",
          basicInfo: "Basisinformatie",
          locationInfo: "Locatie-informatie",
          csBasicInfo: "CS Basisinformatie",
          gprsService2g3g: "GPRS-diensten 2G/3G",
          telephonyService: "Telefoondiensten",
          supplementaryService: "Aanvullende diensten",
          epcService4G: "EPC-diensten 4G",
        },
        sessionModal: {
          title: "SIM-datasessies",
          openDate: "Openingsdatum",
          closeDate: "Sluitingsdatum",
          consumption: "Verbruik",
          roundedBytes: "Afgeronde bytes",
          operator: "Operator",
          cell: "Cel",
          imei: "IMEI",
          close: "Sluiten",
        },
        orders: {
          title: "Verzoeken",
          close: "Sluiten",
        },
        smsUsageModal: {
          title: "SMS-verbruik",
          direction: "Richting",
          date: "Datum",
          sender: "Afzender",
          message: "Bericht",
          status: "Status",
          close: "Sluiten",
        },
      },
      profile: {
        profileDetails: "Profielgegevens",
        contactInformation: "Contactinformatie",
        professionalInformation: "Professionele informatie",
        activities: "Activiteiten",
        loadMore: "Meer laden",
      },
      billingProducts: {
        title: "Factureringsproducten",
        name: "Naam",
        pricePlan: "Prijsplan",
        price: "Prijs",
        number: "Nummer",
      },
      invoices: {
        title: "Facturen",
        invoiceNo: "Factuurnummer",
        date: "Datum",
        amount: "Bedrag (incl. BTW)",
        description: "Beschrijving",
        paid: "Betaald",
        download: "Downloaden",
      },
      statements: {
        title: "Rekeningen",
        cutDate: "Knipdatum",
        description: "Beschrijving",
        amount: "Bedrag (incl. BTW)",
        balance: "Saldo",
      },
      orders: {
        title: "Bestellingen",
        open: "Open",
        parked: "Gepauzeerd",
        finished: "Voltooid",
        error: "Fout",
        noOrders: "Geen bestellingen",
        showAllOrders: "Toon alle bestellingen",
        showLess: "Minder bestellingen weergeven",
      },
      emails: {
        filters: "Filters",
        category: "Categorie",
        name: "Naam",
        address: "Adres",
        actions: "Acties",
        newEmail: "Nieuwe e-mail",
        edit: "Bewerken",
        delete: "Verwijderen",
        cancel: "Annuleren",
        submit: "Verzenden",
        selectCategory: "Categorie selecteren",
        invoice: "Factuur",
        watchdog: "Watchdog",
        updateEmail: "E-mail bijwerken",
      },
      reports: {
        title: "Rapporten",
        reportType: "Rapporttype",
        usage: "Verbruik",
        groupBy: "Groeperen op",
        field: "Veld",
        usageType: "Verbruikstype",
        selectUsageType: "Verbruikstype selecteren",
        data: "Data",
        sms: "SMS",
        all: "Alle",
        imsi: "IMSI",
        eid: "EID",
        network: "Netwerk",
        customer: "Klant",
        period: "Periode",
        day: "Dag",
        month: "Maand",
        year: "Jaar",
        today: "Vandaag",
        "This Week": "Deze week",
        "This Month": "Deze maand",
        "This Year": "Dit jaar",
        "Last Month": "Vorige maand",
        "Last Year": "Vorig jaar",
        customer: "Klant",
        select: "Selecteren",
        simSearchCriteria: "SIM-zoekcriteria",
        bySpecificImsi: "Op specifieke IMSI",
        byImsiRange: "Op IMSI-bereik",
        byIccid: "Op ICCID",
        startImsi: "Start-IMSI",
        endImsi: "Eind-IMSI",
        iccid: "ICCID",
        view: "Weergeven",
        customerId: "Klant-ID",
        date: "Datum",
        startDate: "Van",
        simType: "SIM-type",
        networkCode: "Netwerkcode",
        networkName: "Netwerknaam",
        country: "Land",
        totalBytes: "Totaal bytes",
        roundedBytes: "Afgeronde bytes",
        sessions: "Sessies",
        zeroSessions: "Nulsessies",
        actions: "Acties",
        export: "Exporteren",
        description: "Beschrijving",
        quantity: "Hoeveelheid",
        unitPrice: "Eenheidsprijs",
        tax: "BTW",
        costWithoutTax: "Prijs vóór belasting",
        costWithTax: "Prijs na belasting",
        currency: "Valuta",
        offerName: "Pakket",
        id: "ID",
        name: "Naam",
        status: "Status",
        creator: "Maker",
        creationDate: "Aanmaakdatum",
        offer: "Pakket",
        activations: "Activaties",
        terminations: "Beëindigingen",
        automated: {
          title: "Geautomatiseerde rapporten",
          name: "Naam",
          type: "Type",
          frequency: "Frequentie",
          nextReport: "Volgend rapport",
          new: "Nieuw geautomatiseerd rapport",
          save: "Opslaan",
          daily: "Dagelijks",
          weekly: "Wekelijks",
          monthly: "Maandelijks",
          edit: "Bewerken",
          delete: "Verwijderen",
          actions: "Acties",
        },
        history: {
          title: "Rapportgeschiedenis",
          tableHeaders: {
            reportName: "Rapportnaam",
            date: "Datum",
            status: "Status",
            download: "Downloaden",
            actions: "Acties",
          },
          delete: "Verwijderen",
          completed: "Voltooid",
          incomplete: "Onvolledig",
        },
      },
      timeoutReports: {
        view: "Bekijken",
        delete: "Verwijderen",
      },
      alerts: {
        title: "Waarschuwingen",
        filters: "Filters",
        alert: "Waarschuwing",
        date: "Datum",
        imsi: "IMSI",
        enterValue: "Waarde invoeren",
      },
      settings: {
        title: "Instellingen",
        profileSettings: "Profielinstellingen",
        general: "Algemeen",
        account: "Account",
        profileImage: "Profielfoto",
        whitelabel: "Witlabel",
        privacyAndSafety: "Privacy & Veiligheid",
        notifications: "Meldingen",
        billing: "Facturering",
        invoice: "Factuur",
        importSim: "Sim importeren",
        mailConfig: "Mailserver",
        generalSettings: {
          title: "Algemene instellingen",
          timeZone: "Tijdzone",
          dateFormat: "Datumnotatie",
          timeFormat: "Tijdnotatie",
          save: "Opslaan",
        },
        accountSettings: {
          title: "Accountinstellingen",
          fullName: "Volledige naam",
          address: "Adres",
          city: "Stad",
          country: "Land",
          postcode: "Postcode",
          telephone: "Telefoon",
          mobileNumber: "Mobiel nummer",
          email: "E-mail",
          occupation: "Beroep",
          company: "Bedrijf",
          tin: "Belastingnummer",
          username: "Gebruikersnaam",
          changePassword: "Wachtwoord wijzigen",
          password: "Wachtwoord",
          confirmPassword: "Wachtwoord bevestigen",
          save: "Opslaan",
        },
        profileImageSettings: {
          title: "Profielfotoinstellingen",
          upload: "Uploaden",
          save: "Opslaan",
        },
        whitelabelSettings: {
          title: "Witlabel-instellingen",
          backgroundColor: "Achtergrondkleur",
          fontColor: "Letterkleur",
          accentColor: "Accentkleur",
          sidebarPosition: "Zijbalkpositie",
          favicon: "Favicon",
          whitelabelImage: "Witlabel-afbeelding",
          upload: "Uploaden",
          save: "Opslaan",
        },
        privacySettings: {
          title: "Privacy-instellingen",
          enable2FA: "2FA inschakelen",
          save: "Opslaan",
        },
        notificationSettings: {
          title: "Meldingsinstellingen",
          receiveNotifications: "Meldingen ontvangen",
          sms: "SMS",
          email: "E-mail",
          weeklyAnalytics: "Wekelijkse analyses",
          checkIfYouWantToReceiveWeeklyAnalytics:
            "Aanvinken als u wekelijks analyses wilt ontvangen",
          notifyAboutNewAlerts: "Melden over nieuwe waarschuwingen",
          checkIfYouWantToReceiveNotificationsWhenThereAreNewAlerts:
            "Aanvinken als u meldingen wilt ontvangen bij nieuwe waarschuwingen",
          submit: "Verzenden",
        },
        billingSettings: {
          title: "Factureringsinstellingen",
          selectCurrency: "Valuta selecteren",
          currency: "Valuta",
          preferredLanguage: "Voorkeurstaal",
          selectLanguage: "Taal selecteren",
          submit: "Verzenden",
        },
        invoiceSettings: {
          title: "Factuurinstellingen",
          name: "Naam",
          showGuis: "GUI's weergeven",
          showSubtotal: "Subtotaal weergeven",
          showLineOfService: "Dienstregel weergeven",
          save: "Opslaan",
        },
        importSimSettings: {
          title: "Sim importeren",
          provider: "Provider",
          selectProvider: "Selecteer provider",
          submit: "Indienen",
          inputType: "Invoertype",
          selectInputType: "Selecteer invoertype",
          single: "Enkele invoer",
          file: "Bestandsinvoer",
        },
        mailConfig: {
          title: "Mailserverinstellingen",
          host: "SMTP-hostadres",
          port: "SMTP-poort",
          fromAddress: "Afzenderadres",
          username: "Gebruikersnaam",
          changePassword: "Wachtwoord wijzigen",
          password: "Wachtwoord",
          confirmPassword: "Bevestig wachtwoord",
          useTLS: "TLS gebruiken",
          save: "Instellingen opslaan",
          success: "Mailserverinstellingen succesvol opgeslagen",
          error: "Opslaan van mailserverinstellingen mislukt",
          healthStatus: "Gezondheidstoestand",
          healthUp: "Werkend (UP)",
          healthDown: "Niet Werkend (DOWN)",
          healthUnknown: "Onbekend",
          lastCheckedAt: "Laatst Gecontroleerd",
        },
        purchaseOrderConfig: {
          title: "Bestelconfiguratie",
          sellerName: "Naam van verkoper",
          host: "SMTP-hostadres",
          port: "SMTP-poort",
          fromAddress: "Afzenderadres",
          username: "Gebruikersnaam",
          changePassword: "Wachtwoord wijzigen",
          password: "Wachtwoord",
          confirmPassword: "Bevestig wachtwoord",
          useTLS: "TLS gebruiken",
          save: "Instellingen opslaan",
          success: "Mailserverinstellingen succesvol opgeslagen",
          error: "Fout bij het opslaan van de mailserverinstellingen",
          healthStatus: "Systeemstatus",
          healthUp: "In goede staat (UP)",
          healthDown: "Niet operationeel (DOWN)",
          healthUnknown: "Onbekend",
          lastCheckedAt: "Laatst gecontroleerd op",
        },
        platformConfig: {
          title: "Platformconfiguratie",
          dataStreamingEnabled: "Data streaming ingeschakeld",
          maintenanceMode: "Onderhoudsmodus",
          maintenanceMessage: "Wartungsnachricht",
          maintenanceMessagePlaceholder:
            "Het platform is momenteel in onderhoud. Probeer het later opnieuw.",
          save: "Opslaan",
          reset: "Resetten",
        },
        crmConfig: {
          title: "CRM-configuratie",
          type: "CRM-type",
          authType: "Authenticatietype",
          selectAuthType: "Selecteer authenticatietype",
          selectType: "Selecteer CRM-type",
          username: "Gebruikersnaam",
          changePassword: "Wachtwoord wijzigen?",
          changeToken: "Token wijzigen?",
          password: "Wachtwoord",
          confirmPassword: "Bevestig wachtwoord",
          token: "Token",
        },
      },
      privileges: {
        title: "Rechten",
        name: "Naam",
        actions: "Acties",
        newPrivilege: "Nieuw recht",
        edit: "Bewerken",
        delete: "Verwijderen",
      },
      table: {
        page: "Pagina",
        of: "van",
        show: "Weergeven",
        goToPage: "Ga naar pagina",
      },
      notifications: {
        title: "Meldingen",
        id: "ID",
        date: "Datum",
        message: "Bericht",
        type: "Type",
      },
      whitelist: {
        title: "Toegestaan IP-adres",
        ip: "IP-adres",
        active: "Actief",
        createdAt: "Datum toegevoegd",
        updatedAt: "Laatst bijgewerkt",
        lastUsed: "Laatst gebruikt",
        new: "Nieuw IP-adres",
      },
      customFields: {
        title: "Aangepaste velden",
        new: "Nieuw aangepast veld",
        name: "Naam",
        type: "Type",
        createdAt: "Aangemaakt op",
        updatedAt: "Bijgewerkt op",
        edit: "Bewerken",
        delete: "Verwijderen",
        submit: "Verzenden",
        cancel: "Annuleren",
        actions: "Acties",
        selectType: "Selecteer type",
        text: "Tekst",
        number: "Nummer",
      },
      documentation: {
        introduction: {
          welcomeTitle: "Welkom bij {{brand}}",
          welcomeText:
            "{{brand}} is jouw alles-in-één platform voor eenvoudig SIM-kaartbeheer. Houd gebruik bij, activeer nieuwe lijnen en laat je bedrijfsvoering soepel verlopen—allemaal vanuit één dashboard.",
          getStarted: "Aan de slag",
        },
        dashboard: {
          title: "Dashboard Overzicht",
          description:
            "Het dashboard is het centrale scherm voor het monitoren en analyseren van SIM-kaartactiviteiten via het {{brand}}-platform...",
          goal: "Het doel van het dashboard is om gebruikers een direct toezichtinstrument te bieden...",
          cards: {
            title: "Statistiekkaarten (bovenste gedeelte)",
            dataVolume: {
              title: "Datavolume",
              description:
                "Toont het totale datavolume dat vandaag is verbruikt, samen met een vergelijking met de vorige dag.",
            },
            dataSessions: {
              title: "Datasessies",
              description:
                "Toont het aantal verbindingen dat vandaag is gemaakt, vergeleken met de vorige dag.",
            },
            alerts: {
              title: "Verbruikswaarschuwingen",
              description:
                "Toont het aantal verbruikswaarschuwingen dat vandaag is gegenereerd vanwege overschrijding van drempels.",
            },
            zeroSessions: {
              title: "Sessies zonder verbruik",
              description:
                "Geeft aan hoeveel datasessies tijdens de geselecteerde periode geen verbruik hebben geregistreerd.",
            },
          },
          charts: {
            title: "Gedetailleerde grafieken en kaarten",
            dataSessionsMap: {
              title: "Geografische verdeling van dataverbindingen",
              description:
                "De kaart toont de landen met het hoogste aantal verbindingen. Via het menu rechtsboven in de kaart kunt u kiezen welke informatie wordt weergegeven: Data Sessions, Data Volume of Zero Sessions.",
            },
            avgDataAndActiveSims: {
              title: "Gemiddeld dataverbruik en actieve SIM’s",
              description:
                "Toont het gemiddelde dataverbruik per verbinding en het totale aantal actieve SIM’s.",
            },
            dataVolumePerHour: {
              title: "Uurverdeling van dataverbruik",
              description:
                "De grafiek toont het dataverbruik per drie uur en per dag van de week voor de huidige maand, waardoor u een vollediger beeld krijgt van de momenten waarop SIM’s het meest actief zijn.",
            },
            monthlyDataVolume: {
              title: "Maandelijkse verdeling van dataverbruik",
              description:
                "De grafiek toont de maandelijkse verdeling van het dataverbruik gedurende de afgelopen 12 maanden. Via het menu rechtsboven in de kaart kunt u kiezen welke informatie wordt weergegeven: Data Sessions, Data Volume of Zero Sessions.",
            },
            topMetrics: {
              title: "Belangrijkste statistieken",
              description:
                "Deze grafiek benadrukt de SIM-kaarten met het hoogste aantal verbindingen in de geselecteerde periode. Hiermee kunt u snel de meest actieve SIM’s identificeren, gebruikspatronen analyseren, intensieve gebruikers opsporen en de toewijzing van middelen optimaliseren.",
            },
            dataVolumePerNetwork: {
              title: "Dataverbruik per netwerk - Actieve SIM’s per netwerk",
              description:
                "Deze grafieken tonen een vergelijkend beeld van de netwerkactiviteit in het geselecteerde land. De eerste grafiek toont de verdeling van het totale dataverbruik per mobiel netwerk, zodat u de belasting kunt beoordelen, gebruiksconcentraties kunt identificeren en netwerkprestaties kunt vergelijken. De tweede grafiek toont de verdeling van actieve SIM’s per netwerk, wat inzicht geeft in dekking en marktaandeel. Samen geven ze een volledig beeld van hoe uw SIM’s communiceren met de netwerken en belichten ze patronen van connectiviteit en gebruik.",
            },
            simCardsPerOffer: {
              title: "SIM-kaarten per aanbod en status",
              description:
                "Deze grafieken geven een overzicht van uw SIM-portefeuille. De eerste toont de verdeling per abonnement en datapakket, waardoor u voorkeuren en de meest populaire diensten kunt identificeren. De tweede toont de verdeling per status, wat zichtbaarheid biedt in levenscyclusfasen en beschikbaarheid. Samen helpen ze u om gebruikstrends, voorraadniveaus en de efficiëntie van SIM-beheer te monitoren.",
            },
            alerts: {
              title: "Verbruikswaarschuwingen",
              description:
                "Deze tabel toont de verbruikswaarschuwingen die worden gegenereerd door het bewakingsmechanisme WatchDog. WatchDog controleert voortdurend het dataverbruik van SIM-kaarten en genereert waarschuwingen wanneer vooraf ingestelde drempels worden bereikt.",
              types: {
                warning:
                  "Warning: wordt geactiveerd wanneer het verbruik 80% van het toegewezen volume bereikt.",
                depleted:
                  "Depleted: wordt geactiveerd wanneer het verbruik 100% van het toegewezen volume bereikt.",
              },
              note: "Deze waarschuwingen helpen u om tijdig actie te ondernemen en zo onderbrekingen of onverwachte kosten te voorkomen. Een meer gedetailleerde analyse van WatchDog en zijn logica wordt besproken in het relevante hoofdstuk van de documentatie.",
            },
          },
          utility: {
            title: "Nuttigheid van het dashboard",
            description:
              "Door de uniforme presentatie van kerncijfers, trends en waarschuwingen maakt het dashboard snelle probleemdetectie en betere besluitvorming mogelijk.",
          },
        },
        simCards: {
          introduction: {
            title: "Inleiding tot SIM-kaarten",
            description:
              "Dit hoofdstuk biedt alle noodzakelijke informatie over SIM-kaarten binnen het {{brand}}-platform.",
            details:
              "U leert hoe SIM-kaarten worden beheerd, gecontroleerd en geanalyseerd, met inzichten in dataverbruik, connectiviteit, waarschuwingen en levenscyclusstadia.",
            getStarted: "Aan de slag",
          },
          lifecycle: {
            title: "SIM-levenscyclus",
            intro:
              "SIM-kaarten in het platform doorlopen verschillende levenscyclusstadia. Elke status wordt weergegeven door een kleurgecodeerde cirkel en heeft specifieke toegestane overgangen.",
            status: {
              productive: "Actief en in gebruik.",
              suspended: "Handmatig geschorst.",
              autoSuspended: "Automatisch geschorst.",
              onstock: "Beschikbaar maar niet actief.",
              deleted: "Verwijderd en inactief.",
            },
            diagramDescription:
              "Dit diagram toont de SIM-levenscyclusstatussen en de mogelijke overgangen daartussen. Overgangen kunnen handmatig worden uitgevoerd (bijvoorbeeld het activeren van een SIM van OnStock naar Productive) of automatisch (zoals wanneer een systeemproces een SIM automatisch onderbreekt wanneer limieten zijn bereikt). Deze overgangen zorgen voor goed beheer van de activiteit, beschikbaarheid en deactivering van SIM-kaarten binnen het platform.",
          },
          panel: {
            title: "SIMs Paneel",
            intro:
              "Het SIMs-paneel geeft een overzicht van alle SIM-kaarten binnen het platform. Het stelt je in staat om activiteit te monitoren, dataverbruik te analyseren en de levenscyclusfasen efficiënt te beheren.",
            summary: {
              title: "Overzichtskaarten & Filters",
              intro:
                "Bovenaan het paneel tonen drie kaarten een snel overzicht van het SIM-gebruik in de huidige maand:",
              dataVolume: "Datavolume – totaal verbruikte data.",
              dataSessions: "Datasessies – aantal verbindingen.",
              zeroSessions: "Nulsessies – sessies zonder data.",
              filters:
                "Filters maken het mogelijk SIMs te beperken op IMSI, ICCID, MSISDN, SIM-status, aanbod, SIM-type of datavolume. Sorteren kan worden toegepast op meerdere velden zoals IMSI of gebruik.",
            },
            table: {
              title: "SIM Tabel",
              intro:
                "De hoofdtabel toont alle SIM-kaarten met hun belangrijkste details:",
              activeSession: "Actieve Sessie – live activiteitsindicator.",
              identifiers: "Identificaties – IMSI, ICCID, MSISDN.",
              state:
                "SIM-status – levenscyclusstatus (bijv. Actief, Onderbroken).",
              offer: "Aanbod – abonnement (indien van toepassing).",
              data: "Data – gebruiksvolume voor de maand.",
              type: "SIM-type – producttype (bijv. embedded, industrieel).",
              footer:
                "Paginering en bulkbewerkingen worden ook ondersteund voor een efficiënte SIM-beheer.",
            },
          },
          simProvisioning: {
            introduction: {
              title: "SIM-provisionering",
              description:
                "SIM-provisionering verwijst naar de set functionaliteiten waarmee beheerders de levenscyclus van SIM-kaarten binnen het platform kunnen beheren. Met provisioning kunt u:",
              closing:
                "Deze acties zorgen ervoor dat SIM-kaarten correct worden geprovisioned, beheerd en gedeactiveerd, wat zowel operationele flexibiliteit als veiligheid ondersteunt.",
            },
            actions: {
              activate: {
                title: "Activeren",
                description: "een SIM klaar maken voor productief gebruik.",
                details: {
                  intro:
                    "Om één of meer SIM-kaarten te activeren zijn er drie mogelijkheden:",
                  steps: [
                    "Door de SIM-kaarten in de tabel te selecteren via de selectievakjes en rechtsboven in het menu Bulkbewerkingen te kiezen voor Activeren.",
                    "Door direct op hetzelfde menu te klikken en een Excel-bestand te uploaden met de IMSI/ICCID-nummers in kolom A, waarbij de betreffende titel (IMSI/ICCID) in cel A1 staat.",
                    "Door op de rij te klikken, waarna een zijpaneel met het profiel van de SIM verschijnt. Bovenaan bevindt zich een knop Activeren.",
                  ],
                  important:
                    "Belangrijk! Alle geselecteerde SIM-kaarten moeten zich in de status Op Voorraad bevinden om te kunnen worden geactiveerd.",
                  closing:
                    "Na de beschreven stappen verschijnt er een bevestigingsvenster met twee stappen: de gebruiker moet het aanbod selecteren waaronder de SIM-kaarten geactiveerd moeten worden. Optioneel kunnen aangepaste veldwaarden worden ingesteld. In de tweede stap controleert de gebruiker de geselecteerde SIM’s en gaat verder met de activatie.",
                },
              },
              suspend: {
                title: "Opschorten",
                description: "connectiviteit tijdelijk uitschakelen.",
                details: {
                  intro:
                    "Net als bij activering heeft de gebruiker voor het onderbreken van één of meer SIM-kaarten dezelfde opties:",
                  steps: [
                    "Door de SIM-kaarten in de tabel te selecteren via de selectievakjes en rechtsboven in het menu Bulkbewerkingen te kiezen voor Onderbreken.",
                    "Door direct op hetzelfde menu te klikken en een Excel-bestand te uploaden met de IMSI/ICCID-nummers in kolom A, waarbij de betreffende titel (IMSI/ICCID) in cel A1 staat.",
                    "Door op de rij te klikken, waarna een zijpaneel met het profiel van de SIM verschijnt. Bovenaan bevindt zich een knop Onderbreken.",
                  ],
                  important:
                    "Belangrijk! Alle geselecteerde SIM-kaarten moeten zich in de status Productief bevinden om te kunnen worden onderbroken.",
                  closing:
                    "Na de beschreven stappen verschijnt er een bevestigingsvenster waarin de gebruiker de geselecteerde SIM-kaarten controleert en doorgaat met de onderbreking.",
                },
              },
              resume: {
                title: "Hervatten",
                description: "een opgeschorte SIM opnieuw activeren.",
                details: {
                  intro:
                    "Op dezelfde manier heeft de gebruiker voor het hervatten van één of meer SIM-kaarten dezelfde opties:",
                  steps: [
                    "Door de SIM-kaarten in de tabel te selecteren via de selectievakjes en rechtsboven in het menu Bulkbewerkingen te kiezen voor Hervatten.",
                    "Door direct op hetzelfde menu te klikken en een Excel-bestand te uploaden met de IMSI/ICCID-nummers in kolom A, waarbij de betreffende titel (IMSI/ICCID) in cel A1 staat.",
                    "Door op de rij te klikken, waarna een zijpaneel met het profiel van de SIM verschijnt. Bovenaan bevindt zich een knop Hervatten.",
                  ],
                  important:
                    "Belangrijk! Alle geselecteerde SIM-kaarten moeten zich in de status Onderbroken of Automatisch onderbroken bevinden om hervat te kunnen worden.",
                  closing:
                    "Na de beschreven stappen verschijnt er een bevestigingsvenster waarin de gebruiker de geselecteerde SIM-kaarten controleert en doorgaat met het hervatten.",
                },
              },
              terminate: {
                title: "Beëindigen",
                description:
                  "een SIM uit actief gebruik halen (naar OnStock of Verwijderd).",
                details: {
                  intro:
                    "Op dezelfde manier heeft de gebruiker voor het beëindigen van één of meer SIM-kaarten dezelfde opties:",
                  steps: [
                    "Door de SIM-kaarten in de tabel te selecteren via de selectievakjes en rechtsboven in het menu Bulkbewerkingen te kiezen voor Beëindigen.",
                    "Door direct op hetzelfde menu te klikken en een Excel-bestand te uploaden met de IMSI/ICCID-nummers in kolom A, waarbij de betreffende titel (IMSI/ICCID) in cel A1 staat.",
                    "Door op de rij te klikken, waarna een zijpaneel met het profiel van de SIM verschijnt. Bovenaan bevindt zich een knop Beëindigen.",
                  ],
                  important:
                    "Belangrijk! Alle geselecteerde SIM-kaarten moeten zich in de status Productief bevinden om beëindigd te kunnen worden.",
                  closing:
                    "Na de beschreven stappen verschijnt er een bevestigingsvenster waarin de gebruiker de doelstatus van de beëindiging selecteert (Op Voorraad of Permanent verwijderd), de geselecteerde SIM’s controleert en doorgaat met de beëindiging.",
                },
              },
              modify: {
                title: "Wijzigen",
                description:
                  "wijzig het Abonnement (Offer) waaronder de kaart is geactiveerd en gefactureerd.",
                details: {
                  intro: "Om het aanbod van een SIM-kaart te wijzigen:",
                  steps: [
                    "Door de SIM-kaart in de tabel te selecteren via het selectievakje en rechtsboven in het menu Acties te kiezen voor Wijzigen.",
                  ],
                  important:
                    "Belangrijk! De geselecteerde SIM-kaart moet zich in de status Productief bevinden om gewijzigd te kunnen worden.",
                  closing:
                    "Na de beschreven stappen verschijnt er een bevestigingsvenster waarin de gebruiker het gewenste doel-aanbod van de SIM-kaart selecteert. Vervolgens controleert de gebruiker de SIM en gaat door met de wijziging.",
                },
              },
            },
          },
          simProfile: {
            title: "SIM-profiel",
            description:
              "Het SIM-profiel is een dashboard dat zich richt op de statistieken en functionaliteiten van een enkele SIM-kaart. Het biedt statistieken vergelijkbaar met het hoofddashboard en gedetailleerde informatie voor analyse en beheer.",
            items: {
              kpis: "KPI's en gebruiksstatistieken",
              monthly: "Maandelijkse verdeling van gebruik",
              hlr: "HLR-profiel (indien van toepassing)",
              dataSessions: "Geschiedenis van datasessies",
              smsUsage: "Geschiedenis van SMS-gebruik",
              requests: "Aanvragen gedaan voor deze SIM-kaart",
              provisioning: "SIM-provisioning activiteiten en functies",
              cellInfo: "Celinformatie en connectiviteitsdetails",
              watchdogs: "Watchdog-informatie en meldingen",
            },
            sections: {
              howToAccess: {
                title: "Toegang verkrijgen",
                description:
                  "Om toegang te krijgen tot het profiel van een specifieke SIM-kaart, selecteer de SIM in de tabel en klik erop. Er verschijnt een zijpaneel met de SIM-informatie. In dit paneel staat een link 'Profiel bekijken' die u doorverwijst naar de volledige SIM-profielpagina. De SIM-profielpagina biedt gedetailleerde statistieken, gebruiksgeschiedenis, provisioning-acties en technische informatie over de geselecteerde SIM-kaart.",
              },
              kpis: {
                title: "Kernprestatie-indicatoren (KPIs)",
                description:
                  "De KPI-sectie van het SIM-profiel biedt een snel overzicht van de prestaties en activiteit van de SIM. Deze indicatoren helpen de gebruiker om het huidige gebruik en de status van de SIM in één oogopslag te begrijpen.",
                bullets: [
                  "Datavolume – de totale hoeveelheid gegevens die door de SIM is verbruikt in de geselecteerde periode.",
                  "Datasessies – het aantal datasessies dat tot stand is gebracht in de geselecteerde periode.",
                  "Meldingen – het aantal meldingen dat is geactiveerd voor deze SIM (bijv. gebruiksdrempels).",
                  "Nulsessies – het aantal sessies waarbij de SIM probeerde te verbinden maar geen gegevens verbruikte.",
                ],
                closing:
                  "Rechtsboven kan de gebruiker de KPI’s filteren per periode (Dagelijks, Maandelijks of Jaarlijks) om gebruikspatronen in de tijd te analyseren.",
              },
              monthly: {
                title: "Maandelijkse verdeling",
                description: "Verdeling van data, sms en sessies per maand.",
              },
              hlr: {
                title: "HLR-profiel",
                description:
                  "Het HLR (Home Location Register) profiel geeft gedetailleerde informatie over het abonnement en netwerk van de SIM-kaart. Door op de HLR-knop in het Actiemenu te klikken, verschijnt een venster met details zoals:",
                fields: {
                  msisdn: "MSISDN",
                  imsi: "IMSI",
                  networkAccessMode: "Netwerktoegangsmodus (bijv. CS en PS)",
                  subscriberType: "Abonneetype (bijv. LTE-abonnee)",
                  simStatus: "SIM-status (bijv. Beschikbaar)",
                },
                scopes:
                  "Daarnaast kan de gebruiker in een vervolgkeuzelijst beschikbare bereiken selecteren (bijv. Basisinformatie, Uitgebreide informatie) om de respectieve details te bekijken, afhankelijk van de gewenste informatiediepte.",
                closing:
                  "Met deze functionaliteit kunnen beheerders snel de provisioningdetails van de SIM valideren en bevestigen dat de SIM correct geregistreerd en beschikbaar is in het netwerk.",
              },
              dataSessions: {
                title: "Datasessies",
                description:
                  "De functie Datasessies stelt beheerders in staat gedetailleerde logboeken te bekijken van alle datasessies die aan een SIM-kaart zijn gekoppeld. Door op de knop Sessies in het menu Acties te klikken, wordt een modaal venster geopend met de sessiegeschiedenis en bijbehorende details.",
                fields: {
                  openDate: "Tijdstip waarop de sessie werd gestart",
                  closeDate: "Tijdstip waarop de sessie werd beëindigd",
                  consumption:
                    "Werkelijk aantal bytes dat tijdens de sessie is verbruikt",
                  roundedBytes:
                    "Gebruik afgerond volgens de factureringsregels van de operator",
                  operator: "De netwerkoperator die de sessie beheert",
                  cell: "De cel-ID waarin de sessie tot stand is gebracht",
                  imei: "Apparaat-ID (IMEI) die voor de sessie werd gebruikt",
                },
              },
              smsUsage: {
                title: "SMS-gebruik",
                description:
                  "Het SMS-gebruiksvenster stelt beheerders in staat alle SMS-berichten die door de SIM-kaart zijn verzonden en ontvangen te monitoren. Door te klikken op de knop SMS-gebruik in het menu Acties verschijnt een gedetailleerde tabel met elke SMS-transactie.",
                fields: {
                  direction: "Richting (bijv. Inkomend of Uitgaand)",
                  date: "Datum en tijd van de SMS-gebeurtenis",
                  sender: "De afzender van het SMS-bericht",
                  message: "De inhoud van het SMS-bericht (indien beschikbaar)",
                  status:
                    "Leveringsstatus (bijv. Verzonden, Afgeleverd, Mislukt)",
                },
                note: "Deze functionaliteit biedt volledige traceerbaarheid van het SMS-verkeer voor probleemoplossing, naleving of gebruiksanalyse.",
              },
              requests: {
                title: "Verzoeken",
                description:
                  "De sectie Verzoeken biedt een volledig overzicht van alle provisioning-opdrachten die voor de geselecteerde SIM-kaart zijn uitgevoerd. Door op de knop Verzoeken in het menu Acties te klikken, verschijnt een venster met een lijst van alle opdrachten, zoals Activeren, Onderbreken, Hervatten en Beëindigen.",
                fields: {
                  id: "ID: De unieke identificatie van de opdracht.",
                  name: "Naam: Het type actie (bijv. SuspendSIM, ResumeSIM, TerminateSIM).",
                  status:
                    "Status: De uitvoeringsstatus van de opdracht (bijv. Voltooid, In behandeling).",
                  creator:
                    "Maker: De gebruiker die het verzoek heeft ingediend.",
                  creationDate:
                    "Aanmaakdatum: Wanneer de opdracht is aangemaakt.",
                  lastUpdate:
                    "Laatste update: Het meest recente tijdstip van statuswijziging.",
                },
                note: "Met deze functionaliteit kunnen beheerders alle provisioning-activiteiten op de SIM volgen, waardoor transparantie en verantwoordelijkheid in het levenscyclusbeheer worden gewaarborgd.",
              },
              provisioning: {
                title: "Provisioning-activiteit",
                description:
                  "Provisioning-acties zoals activeren, pauzeren en wijzigen.",
              },
              cellInfo: {
                title: "Cel-informatie",
                description:
                  "Informatie over de cel en verbindingsgegevens van de SIM.",
              },
              watchdogs: {
                title: "Watchdogs",
                description:
                  "De sectie Watchdogs in het SIM-profiel toont de geconfigureerde watchdogs die aan de SIM-kaart zijn gekoppeld. Deze watchdogs worden meestal op platformniveau gedefinieerd en gekoppeld aan een SIM om specifieke voorwaarden te bewaken.",
                bullets: [
                  "Bekijk de lijst met actieve watchdogs die aan de SIM zijn gekoppeld.",
                  "Controleer hun configuratie (bijv. type watchdog, status en ingestelde limieten).",
                  "Volg welke watchdogs momenteel de activiteit van de SIM bewaken.",
                ],
                note: "Opmerking: Configuratie van drempelwaarden, meldingen of automatische acties is niet beschikbaar via het SIM-profiel zelf. Deze sectie is alleen-lezen en bedoeld voor monitoring.",
              },
            },
          },
          simTransfers: {
            title: "SIM-overdrachten",
            description:
              "Met de functie SIM-overdracht kunnen beheerders SIM-kaarten verplaatsen tussen accounts of organisaties. Dit is handig voor het herverdelen van SIMs, het verzenden naar een andere organisatie of het beheren van eigendomsoverdrachten.",

            howToAccess: {
              title: "Toegang",
              description:
                "Om toegang te krijgen tot SIM-overdrachten, ga naar de gebruikersbeheersectie, open het actiemenu van een gebruiker en selecteer de optie 'SIMs verzenden'.",
            },

            steps: {
              title: "Stappen voor het uitvoeren van een SIM-overdracht",
              description:
                "Het overdrachtsproces bestaat uit de volgende stappen:",
              bullets: [
                "Zorg ervoor dat de SIM-kaarten zich in de status 'Op Voorraad' bevinden voordat u de overdracht start. Alleen beschikbare SIMs kunnen tussen accounts worden overgedragen.",
                "Kies een SIM-selectietype: enkele IMSI, enkele ICCID, IMSI-bereik, ICCID-bereik of CSV/XLSX-upload. Dit bepaalt hoe u de SIMs selecteert die worden overgedragen.",
                "Voer de vereiste SIM-ID’s in of upload deze afhankelijk van het gekozen type.",
                "Geef eventueel prijs en btw-percentage op. Deze velden helpen de financiële impact van de overdracht te registreren.",
                "Selecteer een Factureringsaanbod. Dit is het aanbod waarvoor het bronaccount wordt belast wanneer het doelaccount de overgedragen SIM activeert.",
                "Klik op 'Verzenden' om de overdracht te voltooien. Na bevestiging verschijnen de SIMs in de inventaris van het doelaccount.",
              ],
            },
            deallocate: {
              title: "SIMs Dealloceren",
              description:
                "Deallocatie is de omgekeerde procedure van een SIM-overdracht. Hiermee kunnen gebruikers SIM-kaarten uit een doelaccount verwijderen en terugzetten naar het bronaccount of de voorraad. Dit is handig wanneer SIMs per ongeluk zijn toegewezen, niet langer nodig zijn of opnieuw moeten worden toegewezen.",
              bullets: [
                "Ga naar het gedeelte Gebruikersbeheer, open het Acties-menu van een gebruiker en selecteer 'Deallocate SIMs'.",
                "Zorg ervoor dat de SIM-kaarten de status 'Op Voorraad' of 'Toegewezen' hebben voordat u deallocatie probeert.",
                "Kies een SIM-selectietype: Enkele IMSI, Enkele ICCID, IMSI-bereik, ICCID-bereik of CSV/XLSX-bestand.",
                "Voer de identificatoren van de te dealloceren SIMs in of upload ze.",
                "Bevestig de bron- en doelaccounts. Het veld 'Van' toont het huidige account en het veld 'Naar' toont het account of de voorraad waarnaar de SIMs worden teruggestuurd.",
                "Klik op 'Indienen' om de deallocatie te voltooien. Na bevestiging verschijnen de SIMs niet langer in de inventaris van het doelaccount en zijn ze beschikbaar voor herverdeling.",
              ],
            },
          },
        },
        watchdog: {
          title: "Watchdog",
          description:
            "Watchdogs zijn bewakingsregels die gebruikers helpen het gebruik van simkaarten te controleren en abnormaal gedrag te detecteren. Ze maken proactief beheer mogelijk door drempelwaarden te definiëren voor statistieken zoals datavolume, sessies of sms-gebruik. Wanneer een drempel wordt overschreden, kan het systeem waarschuwingen genereren of acties activeren om misbruik of onverwachte kosten te voorkomen.",
          items: {
            add: "Hoe een Watchdog toe te voegen",
            remove: "Hoe een Watchdog te verwijderen",
            reset: "Hoe een Watchdog te resetten",
            suspensionBlock:
              "SIM-suspensie in de huidige factureringsperiode blokkeren",
            alerts: "Waarschuwingen die door Watchdogs worden gegenereerd",
          },
          add: {
            title: "Watchdog toevoegen",
            description:
              "Gebruikers kunnen een nieuwe watchdog maken om SIM-activiteit te monitoren en automatische acties uit te voeren wanneer het gebruik de gedefinieerde drempels overschrijdt. Dit helpt bij proactief beheer en kostenbeheersing.",
            howToAccess:
              "Om een nieuwe watchdog toe te voegen, ga naar het SIM-paneel → Bulkoperaties → Watchdogs → Watchdog aanmaken. Belangrijk: alle SIM-kaarten moeten in de Productive-status (geactiveerd) zijn om een watchdog te configureren.",
            fields: {
              actionType:
                "Selecteer de actie die moet worden uitgevoerd wanneer de drempel wordt bereikt (bijv. melding, opschorten).",
              interval:
                "Kies de bewakingsperiode (dagelijks, wekelijks, maandelijks).",
              amount: "Voer de gebruiksdrempel in die de actie zal activeren.",
              service:
                "Selecteer de dienst die moet worden bewaakt (bijv. Data, SMS).",
              unitType: "Kies de meeteenheid (bijv. Bytes, aantal SMS).",
              warnings:
                "Definieer vroege waarschuwingsdrempels voordat de hoofdactie plaatsvindt om gebruikers tijdig te informeren.",
              suspendInterval:
                "Bepaalt hoe lang de SIM opgeschort blijft nadat de watchdog is geactiveerd. Als dagelijks ingesteld, wordt de SIM automatisch hervat om middernacht van de volgende dag. Als wekelijks, om middernacht op de komende maandag. Als maandelijks, om middernacht op de eerste dag van de volgende maand.",
            },
          },
          removeAll: {
            title: "Alle Watchdogs Verwijderen",
            description:
              "Gebruikers kunnen alle geconfigureerde watchdogs van een SIM-kaart in één handeling verwijderen. Dit is handig om monitoring snel te resetten zonder elke watchdog afzonderlijk te verwijderen.",
            howToAccess:
              "Om alle watchdogs te verwijderen, ga naar het SIM-paneel → selecteer actieve SIM-kaarten → Bulkacties → Watchdogs → Alle Watchdogs Verwijderen.",
            details: {
              title: "Details",
              immediateEffect:
                "Bij uitvoering worden alle bestaande watchdog-instellingen op de geselecteerde SIMs verwijderd.",
              noAlerts:
                "Na het verwijderen worden er geen meldingen of automatische acties meer uitgevoerd.",
              cleanSlate:
                "De SIM blijft normaal functioneren, maar zonder monitoring totdat er nieuwe watchdogs worden aangemaakt.",
            },
            useCases: {
              title: "Gebruikssituaties",
              policyChanges:
                "Wanneer monitoringbeleid verandert, kan het nodig zijn bestaande watchdogs te verwijderen.",
              testing:
                "In testomgevingen kunnen veel watchdogs worden aangemaakt en snel worden verwijderd voor opschoning.",
              errorRecovery:
                "Als er verkeerd geconfigureerde of conflicterende watchdogs zijn, zet verwijdering ze terug naar een neutrale staat.",
            },
            considerations: {
              title: "Overwegingen",
              irreversible:
                "Het verwijderen van alle watchdogs kan niet ongedaan worden gemaakt; ze moeten opnieuw worden aangemaakt indien nodig.",
              criticalMonitoring:
                "Zorg ervoor dat SIMs in kritieke omgevingen niet zonder monitoring blijven.",
              bulkOperations:
                "Controleer zorgvuldig bij bulkacties, aangezien alle geselecteerde SIMs worden beïnvloed.",
            },
          },
          reset: {
            title: "Watchdog Resetten",
            description:
              "Het resetten van een watchdog wist de verbruiks teller en herstelt de blokkering als de gebruiker ervoor had gekozen om de opschorting voor de huidige factureringsperiode te blokkeren. Dit maakt het mogelijk de monitoring opnieuw te starten zonder een nieuwe watchdog aan te maken.",
            howToAccess: {
              title: "Toegang",
              description:
                "Ga naar het profiel van de SIM-kaart. Klik in de sectie Watchdog op het cirkelpictogram met pijl naast de betreffende watchdog om deze te resetten.",
            },
          },
          blockSuspension: {
            title: "Opschorting Blokkeren",
            description:
              "Opschorting blokkeren voorkomt dat een SIM-kaart wordt opgeschort wanneer een watchdog die het verbruik bewaakt een 100%-verbruikswaarschuwing (Depleted Alert) activeert. Deze functionaliteit is alleen geldig voor de huidige factureringsperiode. Bij de start van de volgende periode wordt de opschorting automatisch hersteld.",
            howToAccess: {
              title: "Hoe te Toegangen",
              description:
                "Selecteer SIM-kaarten met de status 'Productive' in het SIM-paneel. Ga vervolgens naar Bulkoperaties → Watchdogs → Opschorting Blokkeren.",
            },
          },
          alerts: {
            title: "Meldingen",
            description:
              "Watchdogs die het SIM-verbruik bewaken genereren meldingen. Meldingen helpen gebruikers bij het bewaken van gebruiksdrempels en het ondernemen van actie wanneer dat nodig is.",
            typesTitle: "Soorten Meldingen",
            types: {
              depleted:
                "Uitgeput: Gegenereerd voor alle watchdogs. Wordt geactiveerd wanneer een SIM-kaart 100% van het verbruik bereikt.",
              warning:
                "Waarschuwing: Optioneel gegenereerd voor watchdogs met ingestelde waarschuwingslimieten.",
            },
            howToAccess: {
              title: "Toegang",
              description:
                "Om meldingen te bekijken, gaat u naar het menu 'Meldingen' in de zijbalk. De tabel toont meldingen gesorteerd op datum (meest recent eerst) en bevat filters voor type, datum en IMSI.",
            },
          },
        },
        reports: {
          intro: {
            title: "Rapporten",
            description:
              "Het platform biedt gebruikers de mogelijkheid om een grote verscheidenheid aan rapporten te bekijken en te exporteren, zoals SIM-kaartverbruik, factuurlijsten, gedetailleerde factuurregels, provisioning-aanvragen voor SIM-kaarten, portfolio-activiteit (activeringen en beëindigingen per aanbod), verdeling van SIM-kaartstatussen en actieve SIM-sessies. Daarnaast kunnen geautomatiseerde rapporten voor gebruik en SIM-overzicht worden gemaakt, die op vaste intervallen in downloadbare vorm worden gegenereerd. Dit hoofdstuk richt zich op drie subhoofdstukken.",
            subchaptersTitle: "Subhoofdstukken",
            subchapters: {
              single: "Enkelvoudig rapport",
              automated: "Geautomatiseerd rapport",
              history: "Rapportgeschiedenis",
            },
          },
          single: {
            title: "Enkel Rapport",
            description:
              "Enkele rapporten stellen gebruikers in staat om specifieke rapporten te genereren over SIM-verbruik, facturen, portfolio-activiteiten, provisioning-aanvragen of sessies. Deze rapporten kunnen worden aangepast op basis van criteria, gegroepeerd en geëxporteerd voor verdere analyse.",

            howToAccess: {
              title: "Toegang",
              description:
                "Om toegang te krijgen tot Enkele Rapporten, ga naar Rapporten in de zijbalk en selecteer 'Rapport Genereren'.",
            },

            usageReport: {
              title: "Verbruiksrapport",
              description:
                "Het Verbruiksrapport geeft gedetailleerd inzicht in SIM-verbruik voor Data of SMS, met flexibele groeperings- en filteropties.",
              bullets: [
                "Kies 'Usage' als rapporttype.",
                "Selecteer gebruikstype: Data of SMS.",
                "Groeperen op veld: IMSI, Netwerk, Klant of geen groepering.",
                "Groeperen op periode: Dag, Maand of Jaar.",
                "Optioneel filteren op SIM: Specifieke IMSI, IMSI-bereik of ICCID.",
                "Klik op 'Bekijken' om het rapport te genereren.",
              ],
            },
            invoiceList: {
              title: "Factuurlijst",
              description:
                "Het rapport Factuurlijst geeft een overzicht van alle facturen die voor het account zijn uitgegeven. Het bevat belangrijke gegevens zoals factuurnummer, uitgiftedatum, vervaldatum, totaalbedrag en betalingsstatus. Gebruikers kunnen facturen filteren op datumbereik om snel de juiste documenten te vinden.",
              bullets: [
                "Ga naar Rapporten → Rapport genereren.",
                "Selecteer 'Factuurlijst' als rapporttype.",
                "Definieer het datumbereik (Van – Tot) om de lijst met facturen te beperken.",
                "Klik op 'Weergeven' om het rapport te genereren.",
                "De resulterende tabel toont facturen met details zoals nummer, uitgiftedatum, vervaldatum, totaalbedrag en betalingsstatus.",
              ],
            },
            orders: {
              title: "Bestelrapport",
              description:
                "Het bestelrapport geeft de gebruiker de mogelijkheid om alle provisioning-orders met betrekking tot SIM-kaarten te bekijken. Het biedt een historisch overzicht van de bestellingen die in de geselecteerde periode zijn aangemaakt.",
              bullets: [
                "Toegankelijk via Rapporten → Rapport genereren → Bestellingen.",
                "Maakt filteren op datumbereik (periode) mogelijk.",
                "Toont een lijst met SIM-provisioningorders.",
              ],
            },
            portfolioActivity: {
              title: "Portfolioactiviteitsrapport",
              description:
                "Het Portfolioactiviteitsrapport geeft een overzicht van de activiteiten van SIM-kaarten, inclusief activeringen, beëindigingen en wijzigingen per aanbod. Het helpt gebruikers de ontwikkeling van hun SIM-portfolio in de loop van de tijd te volgen.",
              bullets: [
                "Toegankelijk via Rapporten → Rapport genereren → Portfolio-activiteit.",
                "Gebruikers kunnen het rapport filteren op periode (Van–Tot).",
                "Toont activeringen, beëindigingen en activiteiten gegroepeerd per aanbod.",
              ],
            },
            customerSimSessions: {
              title: "Rapport Klant-SIM-sessies",
              description:
                "Het rapport Klant-SIM-sessies toont informatie over de actieve en eerdere SIM-sessies van klanten. Het helpt te volgen wanneer en hoe SIM-kaarten verbinding maken met het netwerk.",
              bullets: [
                "Toegankelijk via Rapporten → Rapport genereren → Klant-SIM-sessies.",
                "Toont sessiedetails zoals IMSI, start- en eindtijd van de sessie en overgedragen data.",
                "Handig voor het oplossen van verbindingsproblemen en het analyseren van SIM-gebruiks­patronen.",
              ],
            },
            simOverview: {
              title: "SIM-overzichtsrapport",
              description:
                "Het SIM-overzichtsrapport biedt een samenvatting van de SIM-kaarten in het systeem en toont hun verdeling per status, toewijzing en activiteit. Het helpt beheerders snel inzicht te krijgen in de gehele SIM-vloot.",
              bullets: [
                "Toegankelijk via Rapporten → Rapport genereren → SIM-overzicht.",
                "Toont SIM’s gegroepeerd op status zoals Actief, Geschorst, Beëindigd of Op Voorraad.",
                "Handig om de staat en verdeling van SIM-kaarten in één oogopslag te volgen.",
              ],
            },
            simList: {
              title: "SIM-lijstrapport",
              description:
                "Het SIM-lijstrapport biedt een gedetailleerd overzicht van alle SIM-kaarten in het systeem. Het bevat identificaties zoals IMSI en ICCID, hun huidige status en toewijzingsdetails.",
              bullets: [
                "Toegankelijk via Rapporten → Rapport genereren → SIM-lijst.",
                "Toont elke SIM-kaart met IMSI, ICCID en huidige status.",
                "Handig voor auditing en beheer van de volledige SIM-inventaris.",
              ],
            },
            exportReport: {
              title: "Rapport Exporteren naar Bestand",
              description:
                "Alle gegenereerde rapporten kunnen worden geëxporteerd naar een bestand voor verdere analyse of om te delen. Exportopties zijn CSV en PDF.",
              bullets: [
                "Toegankelijk via Acties → Exporteren → CSV of PDF.",
                "CSV-formaat is handig voor data-analyse in Excel of andere spreadsheetprogramma’s.",
                "PDF-formaat is handig om rapporten in een vaste indeling te delen.",
              ],
            },
            timeoutReports: {
              title: "Timeout-rapporten",
              description:
                "Elke rapportgeneratie heeft een time-outlimiet van 15 seconden. Wanneer deze limiet wordt overschreden, wordt het rapport op de achtergrond verder gegenereerd.",
              bullets: [
                "Een melding informeert de gebruiker wanneer een rapport een timeout bereikt.",
                "Wanneer het rapport gereed is, ontvangt de gebruiker een pushmelding.",
                "Het gegenereerde timeout-rapport kan worden bekeken via Acties → Bekijken.",
                "Timeout-rapporten kunnen ook worden geëxporteerd naar CSV of PDF, net als direct gegenereerde rapporten.",
              ],
            },
          },
          automated: {
            title: "Geautomatiseerde Rapporten",
            description:
              "Geautomatiseerde Rapporten stellen gebruikers in staat om rapporten op vaste intervallen en in een gekozen formaat te genereren.",
            overview: {
              title: "Overzicht",
              description:
                "Geautomatiseerde Rapporten worden één keer aangemaakt en vervolgens automatisch gegenereerd volgens de gekozen frequentie en het gekozen formaat.",
              bullets: [
                "Rapporten kunnen dagelijks, wekelijks of maandelijks worden gepland.",
                "Rapporten kunnen in CSV- of PDF-formaat worden gegenereerd.",
                "Beschikbare rapporttypen: Gebruik en Klant-SIM Overzicht.",
              ],
            },
            create: {
              title: "Een Geautomatiseerd Rapport Aanmaken",
              description:
                "Om een nieuw geautomatiseerd rapport aan te maken, klikt u op de knop rechtsboven in de kaart. Een formulier verschijnt waarin enkele gegevens worden gevraagd:",
              bullets: [
                "Naam: De naam van het rapport.",
                "Rapportfrequentie: Dagelijks, wekelijks of maandelijks.",
                "Rapportformaat: CSV of PDF.",
                "Rapporttype: Kies tussen Gebruik en Klant-SIM Overzicht.",
                "Afhankelijk van het rapporttype kunnen extra velden verschijnen, vergelijkbaar met het menu Rapport Genereren.",
              ],
            },
          },
          history: {
            title: "Rapportgeschiedenis",
            description:
              "De sectie Rapportgeschiedenis biedt een lijst met de resultaten van alle uitgevoerde Geautomatiseerde Rapporten. Elke invoer bevat de rapportnaam, aanmaakdatum, status, downloadoptie en de mogelijkheid om het rapport te verwijderen.",
            reportHistory: {
              title: "Automatische Rapportresultaten Bekijken",
              description:
                "In de sectie Rapportgeschiedenis kunnen gebruikers:",
              bullets: [
                "De resultaten bekijken van alle uitgevoerde Geautomatiseerde Rapporten.",
                "De uitvoeringsstatus controleren (Voltooid, In behandeling, Mislukt).",
                "De gegenereerde bestanden downloaden in CSV- of PDF-formaat.",
                "Een rapportinvoer verwijderen via het Acties-menu.",
              ],
            },
          },
        },
      },
    },
  },
  it: {
    translation: {
      sidebar: {
        dashboard: "Dashboard",
        crm: "CRM",
        admins: "Amministratori",
        tenants: "Inquilini",
        managers: "Manager",
        customers: "Clienti",
        subaccounts: "Sottoconti",
        sims: "Carte SIM",
        account: "Account",
        profile: "Profilo",
        billingProducts: "Prodotti di fatturazione",
        invoices: "Fatture",
        statements: "Estratti conto",
        orders: "Ordini",
        emails: "Email",
        reports: "Report",
        generateReport: "Genera report",
        automatedReports: "Report automatizzati",
        reportHistory: "Cronologia report",
        alerts: "Avvisi",
        notifications: "Notifiche",
        support: "Supporto",
        privileges: "Privilegi",
        settings: "Impostazioni",
        services: "Servizi",
        documentation: "Documentazione",
        whitelist: "Indirizzo IP consentito",
        customFields: "Campi personalizzati",
        simProducts: "Prodotti SIM",
        purchaseSims: "Acquista SIM",
        health: "Stato del sistema",
        purchaseOrders: "Ordini di schede SIM",
      },
      dashboard: {
        dataVolume: "Volume dati",
        dataSessions: "Sessioni dati",
        alerts: "Avvisi",
        zeroSessions: "Sessioni zero",
        sinceYesterday: "Da ieri",
        sinceLastMonth: "Dallo scorso mese",
        sinceLastYear: "Dallo scorso anno",
        averageVolume: "Volume dati medio",
        activeSims: "SIM attive",
        dataVolumePerHour: "Volume dati per ora",
        topMetrics: "Migliori metriche",
        simCardsPerOffer: "SIM per offerta",
        simInventory: "Distribuzione SIM per stato",
        dataVolumePerNetwork: "Volume dati per rete",
        selectCountry: "Seleziona Paese",
        networksDistribution: "Distribuzione SIM attive per rete",
        watchdogAlerts: "Avvisi di consumo",
        noData: "Nessun dato disponibile",
        daily: "Giornaliero",
        monthly: "Mensile",
        yearly: "Annuale",
      },
      crm: {
        admins: "Amministratori",
        tenants: "Inquilini",
        managers: "Manager",
        customers: "Clienti",
        subaccounts: "Sottoconti",
        filters: "Filtri",
        fullName: "Nome completo",
        company: "Azienda",
        email: "Email",
        address: "Indirizzo",
        city: "Città",
        country: "Paese",
        postcode: "CAP",
        telephone: "Telefono",
        mobile: "Cellulare",
        occupation: "Occupazione",
        tin: "Codice fiscale",
        username: "Nome utente",
        role: "Ruolo",
        actions: "Azioni",
        edit: "Modifica",
        delete: "Elimina",
        billing: "Fatturazione",
        whitelabeling: "Whitelabel",
        offers: "Offerte",
        impersonate: "Impersona",
        permissions: "Permessi",
        sendWelcomeEmail: "Invia email di benvenuto",
        resetPassword: "Reimposta password",
        initializeSIMs: "Inizializza SIM",
        initializeAlerts: "Inizializza avvisi",
        newTenant: "Nuovo inquilino",
        newManager: "Nuovo manager",
        newCustomer: "Nuovo cliente",
        newSubaccount: "Nuovo sottoconto",
        registerPayment: "Registrare pagamento",
        accountId: "ID account",
        registerPayment: {
          title: "Registrare pagamento",
          amount: "Importo",
          currency: "Valuta",
          invoice: "Numero fattura",
          submit: "Invia",
          cancel: "Annulla",
          selectCurrency: "Seleziona valuta",
          selectInvoice: "Seleziona fattura",
        },
        creditNote: {
          title: "Nota di credito",
          amount: "Importo",
          vat: "IVA",
          reason: "Motivo",
          submit: "Invia",
          cancel: "Annulla",
        },
        invoiceCycle: {
          title: "Riesegui ciclo di fatturazione",
        },
        newModal: {
          newTenant: "Crea inquilino",
          newManager: "Crea manager",
          newCustomer: "Crea cliente",
          newSubaccount: "Crea sottoconto",
          fullName: "Nome completo",
          address: "Indirizzo",
          city: "Città",
          country: "Paese",
          postcode: "CAP",
          telephone: "Telefono",
          mobile: "Cellulare",
          email: "Email",
          occupation: "Occupazione",
          company: "Azienda",
          tin: "Codice fiscale",
          username: "Nome utente",
          sendWelcomeEmail: "Invia email di benvenuto",
          cancel: "Annulla",
          submit: "Invia",
          next: "Avanti",
          previous: "Indietro",
          preferredLanguage: "Lingua preferita",
          billingEmail: "Email di fatturazione",
          currency: "Valuta",
        },
        editModal: {
          editTenant: "Modifica inquilino",
          editManager: "Modifica manager",
          editCustomer: "Modifica cliente",
          editSubaccount: "Modifica sottoconto",
          fullName: "Nome completo",
          address: "Indirizzo",
          city: "Città",
          country: "Paese",
          postcode: "CAP",
          telephone: "Telefono",
          mobile: "Cellulare",
          email: "Email",
          occupation: "Occupazione",
          company: "Azienda",
          tin: "Codice fiscale",
          username: "Nome utente",
          cancel: "Annulla",
          submit: "Invia",
        },
        billingModal: {
          title: "Impostazioni di fatturazione",
          currency: "Valuta",
          billingFrequency: "Frequenza di fatturazione",
          daysToPayInvoice: "Giorni per pagare la fattura",
          minimumAmountToInvoice: "Importo minimo per fatturare",
          invoiceType: "Tipo di fattura",
          preferredLanguage: "Lingua preferita",
          billingEmail: "Email per la fatturazione",
          platformUsage: "Utilizzo della piattaforma",
          platformUsagePrice: "Prezzo utilizzo piattaforma",
          onStockPriceEnabled: "Prezzo SIM On Stock abilitato",
          onStockPrice: "Prezzo SIM On Stock",
          simCardPriceEnabled: "Costo della scheda SIM?",
          simCardPrice: "Prezzo della scheda SIM",
          simChipPriceEnabled: "Costo del chip SIM?",
          simChipPrice: "Prezzo del chip SIM",
          billable: "Fatturabile?",
          isVatExempt: "è esente da IVA?",
          cancel: "Annulla",
          submit: "Invia",
        },
        whitelabelModal: {
          title: "Impostazioni Whitelabel",
          enableWhitelabel: "Abilita Whitelabel",
          pricePerMonth: "Prezzo per mese",
          url: "URL",
          cancel: "Annulla",
          submit: "Invia",
        },
        roleModal: {
          title: "Aggiorna ruolo",
          role: "Ruolo",
          tenant: "Inquilino",
          manager: "Manager",
          customer: "Cliente",
          cancel: "Annulla",
          submit: "Invia",
        },
        offersModal: {
          title: "Assegna offerte",
          availableOffers: "Offerte disponibili",
          assignedOffers: "Offerte assegnate",
          submit: "Invia",
        },
      },
      sims: {
        title: "Carte SIM",
        dataVolume: "Volume dati",
        dataSessions: "Sessioni dati",
        zeroSessions: "Sessioni zero",
        filters: "Filtri",
        simStatus: "Sessione attiva",
        simState: "Stato SIM",
        portfolioId: "Portfolio ID",
        imsi: "IMSI",
        iccid: "ICCID",
        eid: "EID",
        msisdn: "MSISDN",
        offer: "Offerta",
        data: "Dati",
        min: "Min",
        max: "Max",
        search: "Cerca",
        clear: "Pulisci",
        actions: "Azioni",
        bulk: "Operazioni collettive",
        modify: "Modifica",
        product: "Prodotto",
        clearSelection: "Pulisci selezione",
        activate: "Attiva",
        suspend: "Sospendi",
        resume: "Riprendi",
        terminate: "Termina",
        testMode: "Modalità test",
        sendSms: "Invia SMS",
        watchdogs: "Watchdogs",
        createWatchdog: "Crea Watchdog",
        removeAllWatchdogs: "Rimuovi tutti i Watchdog",
        blockSuspension: "Blocco della Sospensione",
        export: "Esporta",
        simInformation: "Informazioni SIM",
        usage: "Utilizzo",
        ipAddress: "Indirizzo IP",
        imei: "IMEI",
        status: "Stato",
        visitProfile: "Visita profilo",
        provider: "Provider",
        area: "Area",
        cell: "Cella",
        longitude: "Longitudine",
        latitude: "Latitudine",
        cellRange: "Raggio cella",
        unit: "Unità",
        sort: "Ordina",
        suspendModal: {
          title: "Sospendi SIM",
          orderComplete: "Sospensione della SIM completata",
          orderError: "Sospensione della SIM fallita",
          contactAdmin: "Contatta l'amministratore di sistema",
          cancel: "Annulla",
          submit: "Invia",
          close: "Chiudi",
        },
        resumeModal: {
          title: "Riprendi SIM",
          orderComplete: "Ripresa della SIM completata",
          orderError: "Ripresa della SIM fallita",
          contactAdmin: "Contatta l'amministratore di sistema",
          cancel: "Annulla",
          submit: "Invia",
          close: "Chiudi",
        },
        activateModal: {
          title: "Attiva SIM",
          offer: "Offerta",
          selectOffer: "Seleziona offerta",
          success: "Attivazione della SIM completata",
          orderError: "Attivazione della SIM fallita",
          contactAdmin: "Contatta l'amministratore di sistema",
          cancel: "Annulla",
          submit: "Invia",
          close: "Chiudi",
        },
        terminateModal: {
          title: "Termina SIM",
          targetState: "Stato desiderato",
          onStock: "In stock",
          terminated: "Terminata",
          success: "Terminazione della SIM completata",
          orderError: "Terminazione della SIM fallita",
          contactAdmin: "Contatta l'amministratore di sistema",
          cancel: "Annulla",
          submit: "Invia",
          close: "Chiudi",
        },
      },
      simProfile: {
        simProvisioning: "Gestione stato SIM",
        simDetails: "Dettagli SIM",
        actions: "Azioni",
        hlr: "HLR",
        session: "Sessioni",
        smsUsage: "Utilizzo SMS",
        updateLoc: "Aggiorna posizione",
        imeiLock: "Blocco IMEI",
        usage: "Utilizzo",
        imei: "IMEI",
        status: "Stato",
        dataSession: "Sessione attiva",
        map: "Mappa",
        provider: "Provider",
        imsi: "IMSI",
        iccid: "ICCID",
        msisdn: "MSISDN",
        country: "Paese",
        operator: "Operatore di rete",
        area: "Area",
        cell: "Cella",
        longitude: "Longitudine",
        latitude: "Latitudine",
        cellRange: "Raggio cella",
        activity: "Attività",
        selectPeriod: "Seleziona periodo",
        daily: "Giornaliero",
        monthly: "Mensile",
        yearly: "Annuale",
        dataVolume: "Volume dati",
        dataSessions: "Sessioni dati",
        alerts: "Avvisi",
        zeroSessions: "Sessioni zero",
        watchdog: "Watchdog",
        type: "Tipo",
        blockSuspension: "La SIM verrà sospesa",
        amount: "Quantità",
        hlrModal: {
          title: "Profilo HLR",
          selectScope: "Seleziona ambito",
          basicInfo: "Informazioni di base",
          locationInfo: "Informazioni sulla posizione",
          csBasicInfo: "Informazioni di base CS",
          gprsService2g3g: "Servizi GPRS 2G/3G",
          telephonyService: "Servizi di telefonia",
          supplementaryService: "Servizi supplementari",
          epcService4G: "Servizi EPC 4G",
        },
        sessionModal: {
          title: "Sessioni dati SIM",
          openDate: "Data di apertura",
          closeDate: "Data di chiusura",
          consumption: "Consumo",
          roundedBytes: "Byte arrotondati",
          operator: "Operatore",
          cell: "Cella",
          imei: "IMEI",
          close: "Chiudi",
        },
        orders: {
          title: "Richieste",
          close: "Chiudi",
        },
        smsUsageModal: {
          title: "Utilizzo SMS",
          direction: "Direzione",
          date: "Data",
          sender: "Mittente",
          message: "Messaggio",
          status: "Stato",
          close: "Chiudi",
        },
      },
      profile: {
        profileDetails: "Dettagli profilo",
        contactInformation: "Informazioni di contatto",
        professionalInformation: "Informazioni professionali",
        activities: "Attività",
        loadMore: "Carica altro",
      },
      billingProducts: {
        title: "Prodotti di fatturazione",
        name: "Nome",
        pricePlan: "Piano tariffario",
        price: "Prezzo",
        number: "Numero",
      },
      invoices: {
        title: "Fatture",
        invoiceNo: "Numero fattura",
        date: "Data",
        amount: "Importo (incl. IVA)",
        description: "Descrizione",
        paid: "Pagata",
        download: "Scarica",
      },
      statements: {
        title: "Estratti conto",
        cutDate: "Data di taglio",
        description: "Descrizione",
        amount: "Importo (incl. IVA)",
        balance: "Saldo",
      },
      orders: {
        title: "Ordini",
        open: "Aperti",
        parked: "In sospeso",
        finished: "Completati",
        error: "Errore",
        noOrders: "Nessun ordine",
        showAllOrders: "Mostra tutti gli ordini",
        showLess: "Mostra meno ordini",
      },
      emails: {
        filters: "Filtri",
        category: "Categoria",
        name: "Nome",
        address: "Indirizzo",
        actions: "Azioni",
        newEmail: "Nuova email",
        edit: "Modifica",
        delete: "Elimina",
        cancel: "Annulla",
        submit: "Invia",
        selectCategory: "Seleziona categoria",
        invoice: "Fattura",
        watchdog: "Watchdog",
        updateEmail: "Aggiorna email",
      },
      reports: {
        title: "Report",
        reportType: "Tipo di report",
        usage: "Utilizzo",
        groupBy: "Raggruppa per",
        field: "Campo",
        usageType: "Tipo di utilizzo",
        selectUsageType: "Seleziona tipo di utilizzo",
        data: "Dati",
        sms: "SMS",
        all: "Tutti",
        imsi: "IMSI",
        eid: "EID",
        network: "Rete",
        customer: "Cliente",
        period: "Periodo",
        day: "Giorno",
        month: "Mese",
        year: "Anno",
        today: "Oggi",
        "This Week": "Questa settimana",
        "This Month": "Questo mese",
        "This Year": "Quest'anno",
        "Last Month": "Il mese scorso",
        "Last Year": "L'anno scorso",
        customer: "Cliente",
        select: "Seleziona",
        simSearchCriteria: "Criteri di ricerca SIM",
        bySpecificImsi: "Per IMSI specifica",
        byImsiRange: "Per intervallo IMSI",
        byIccid: "Per ICCID",
        startImsi: "IMSI iniziale",
        endImsi: "IMSI finale",
        iccid: "ICCID",
        view: "Visualizza",
        customerId: "ID cliente",
        date: "Data",
        startDate: "Da",
        simType: "Tipo di SIM",
        networkCode: "Codice rete",
        networkName: "Nome rete",
        country: "Paese",
        totalBytes: "Byte totali",
        roundedBytes: "Byte arrotondati",
        sessions: "Sessioni",
        zeroSessions: "Sessioni zero",
        actions: "Azioni",
        export: "Esporta",
        description: "Descrizione",
        quantity: "Quantità",
        unitPrice: "Prezzo unitario",
        tax: "IVA",
        costWithoutTax: "Prezzo prima delle tasse",
        costWithTax: "Prezzo dopo le tasse",
        currency: "Valuta",
        offerName: "Pacchetto",
        id: "ID",
        name: "Nome",
        status: "Stato",
        creator: "Creatore",
        creationDate: "Data di Creazione",
        offer: "Pacchetto",
        activations: "Attivazioni",
        terminations: "Terminazioni",
        automated: {
          title: "Report automatizzati",
          name: "Nome",
          type: "Tipo",
          frequency: "Frequenza",
          nextReport: "Prossimo report",
          new: "Nuovo report automatizzato",
          save: "Salva",
          daily: "Giornaliero",
          weekly: "Settimanale",
          monthly: "Mensile",
          edit: "Modifica",
          delete: "Elimina",
          actions: "Azioni",
        },
        history: {
          title: "Cronologia report",
          tableHeaders: {
            reportName: "Nome report",
            date: "Data",
            status: "Stato",
            download: "Scarica",
            actions: "Azioni",
          },
          delete: "Elimina",
          completed: "Completato",
          incomplete: "Incompleto",
        },
      },
      timeoutReports: {
        view: "Visualizza",
        delete: "Elimina",
      },
      alerts: {
        title: "Avvisi",
        filters: "Filtri",
        alert: "Avviso",
        date: "Data",
        imsi: "IMSI",
        enterValue: "Inserisci valore",
      },
      settings: {
        title: "Impostazioni",
        profileSettings: "Impostazioni profilo",
        general: "Generale",
        account: "Account",
        profileImage: "Immagine del profilo",
        whitelabel: "Whitelabel",
        privacyAndSafety: "Privacy e sicurezza",
        notifications: "Notifiche",
        billing: "Fatturazione",
        invoice: "Fattura",
        importSim: "Importa Sim",
        mailConfig: "Server di posta",
        generalSettings: {
          title: "Impostazioni generali",
          timeZone: "Fuso orario",
          dateFormat: "Formato data",
          timeFormat: "Formato orario",
          save: "Salva",
        },
        accountSettings: {
          title: "Impostazioni account",
          fullName: "Nome completo",
          address: "Indirizzo",
          city: "Città",
          country: "Paese",
          postcode: "CAP",
          telephone: "Telefono",
          mobileNumber: "Numero di cellulare",
          email: "Email",
          occupation: "Occupazione",
          company: "Azienda",
          tin: "Codice fiscale",
          username: "Nome utente",
          changePassword: "Cambia password",
          password: "Password",
          confirmPassword: "Conferma password",
          save: "Salva",
        },
        profileImageSettings: {
          title: "Impostazioni immagine del profilo",
          upload: "Carica",
          save: "Salva",
        },
        whitelabelSettings: {
          title: "Impostazioni Whitelabel",
          backgroundColor: "Colore di sfondo",
          fontColor: "Colore del carattere",
          accentColor: "Colore di accento",
          sidebarPosition: "Posizione della barra laterale",
          favicon: "Favicon",
          whitelabelImage: "Immagine Whitelabel",
          upload: "Carica",
          save: "Salva",
        },
        privacySettings: {
          title: "Impostazioni privacy",
          enable2FA: "Abilita 2FA",
          save: "Salva",
        },
        notificationSettings: {
          title: "Impostazioni di notifica",
          receiveNotifications: "Ricevi notifiche",
          sms: "SMS",
          email: "Email",
          weeklyAnalytics: "Analisi settimanale",
          checkIfYouWantToReceiveWeeklyAnalytics:
            "Seleziona se desideri ricevere analisi settimanali",
          notifyAboutNewAlerts: "Notifica per nuovi avvisi",
          checkIfYouWantToReceiveNotificationsWhenThereAreNewAlerts:
            "Seleziona se desideri ricevere notifiche per nuovi avvisi",
          submit: "Invia",
        },
        billingSettings: {
          title: "Impostazioni di fatturazione",
          selectCurrency: "Seleziona valuta",
          currency: "Valuta",
          preferredLanguage: "Lingua preferita",
          selectLanguage: "Seleziona lingua",
          submit: "Invia",
        },
        invoiceSettings: {
          title: "Impostazioni fattura",
          name: "Nome",
          showGuis: "Mostra GUI",
          showSubtotal: "Mostra subtotale",
          showLineOfService: "Mostra linea di servizio",
          save: "Salva",
        },
        importSimSettings: {
          title: "Importa Sim",
          provider: "Fornitore",
          selectProvider: "Seleziona Fornitore",
          submit: "Invia",
          inputType: "Tipo di Input",
          selectInputType: "Seleziona Tipo di Input",
          single: "Inserimento singolo",
          file: "Inserimento da file",
        },
        mailConfig: {
          title: "Impostazioni Server Mail",
          host: "Indirizzo host SMTP",
          port: "Porta SMTP",
          fromAddress: "Indirizzo mittente",
          username: "Nome utente",
          changePassword: "Cambia password",
          password: "Password",
          confirmPassword: "Conferma password",
          useTLS: "Usa TLS",
          save: "Salva impostazioni",
          success: "Impostazioni del server mail salvate con successo",
          error: "Salvataggio delle impostazioni del server mail non riuscito",
          healthStatus: "Stato di Salute",
          healthUp: "Funzionante (UP)",
          healthDown: "Non Funzionante (DOWN)",
          healthUnknown: "Sconosciuto",
          lastCheckedAt: "Ultimo Controllo",
        },
        purchaseOrderConfig: {
          title: "Configurazione dell’ordine di acquisto",
          sellerName: "Nome del venditore",
          host: "Indirizzo host SMTP",
          port: "Porta SMTP",
          fromAddress: "Indirizzo del mittente",
          username: "Nome utente",
          changePassword: "Cambia password",
          password: "Password",
          confirmPassword: "Conferma password",
          useTLS: "Usa TLS",
          save: "Salva impostazioni",
          success: "Impostazioni del server di posta salvate con successo",
          error:
            "Errore durante il salvataggio delle impostazioni del server di posta",
          healthStatus: "Stato di salute",
          healthUp: "In buone condizioni (UP)",
          healthDown: "Non operativo (DOWN)",
          healthUnknown: "Sconosciuto",
          lastCheckedAt: "Ultimo controllo il",
        },
        platformConfig: {
          title: "Configurazione della piattaforma",
          dataStreamingEnabled: "Data Streaming abilitato",
          maintenanceMode: "Modalità di manutenzione",
          maintenanceMessage: "Messaggio di manutenzione",
          maintenanceMessagePlaceholder:
            "Inserisci il messaggio di manutenzione",
          save: "Salva",
          reset: "Reimposta",
        },
        crmConfig: {
          title: "Configurazione CRM",
          type: "Tipo di CRM",
          authType: "Tipo di autenticazione",
          selectAuthType: "Seleziona il tipo di autenticazione",
          selectType: "Seleziona il tipo di CRM",
          username: "Nome utente",
          changePassword: "Cambiare la password?",
          changeToken: "Cambiare il token?",
          password: "Password",
          confirmPassword: "Conferma password",
          token: "Token",
        },
      },
      privileges: {
        title: "Privilegi",
        name: "Nome",
        actions: "Azioni",
        newPrivilege: "Nuovo privilegio",
        edit: "Modifica",
        delete: "Elimina",
      },
      table: {
        page: "Pagina",
        of: "di",
        show: "Mostra",
        goToPage: "Vai alla pagina",
      },
      notifications: {
        title: "Notifiche",
        id: "ID",
        date: "Data",
        message: "Messaggio",
        type: "Tipo",
      },
      whitelist: {
        title: "Indirizzo IP consentito",
        ip: "Indirizzo IP",
        active: "Attivo",
        createdAt: "Data di aggiunta",
        updatedAt: "Ultimo aggiornamento",
        lastUsed: "Ultimo utilizzo",
        new: "Nuovo indirizzo IP",
      },
      customFields: {
        title: "Campi personalizzati",
        new: "Nuovo campo personalizzato",
        name: "Nome",
        type: "Tipo",
        createdAt: "Data di creazione",
        updatedAt: "Data di aggiornamento",
        edit: "Modifica",
        delete: "Elimina",
        submit: "Invia",
        cancel: "Annulla",
        actions: "Azioni",
        selectType: "Seleziona tipo",
        text: "Testo",
        number: "Numero",
      },
      documentation: {
        introduction: {
          welcomeTitle: "Benvenuto su {{brand}}",
          welcomeText:
            "{{brand}} è la tua piattaforma tutto-in-uno per gestire facilmente le schede SIM. Monitora l'utilizzo, attiva nuove linee e mantieni le tue operazioni senza intoppi—tutto da un'unica dashboard.",
          getStarted: "Inizia",
        },
        dashboard: {
          title: "Panoramica Dashboard",
          description:
            "La Dashboard è lo schermo principale per monitorare e analizzare l’attività delle SIM tramite la piattaforma {{brand}}...",
          goal: "L’obiettivo della Dashboard è fornire agli utenti uno strumento immediato di supervisione...",
          cards: {
            title: "Schede statistiche (parte superiore)",
            dataVolume: {
              title: "Volume dati",
              description:
                "Mostra il volume totale di dati consumati oggi, insieme al confronto con il giorno precedente.",
            },
            dataSessions: {
              title: "Sessioni di dati",
              description:
                "Mostra il numero di connessioni effettuate oggi, rispetto al giorno precedente.",
            },
            alerts: {
              title: "Avvisi di consumo",
              description:
                "Mostra il numero di avvisi di consumo generati oggi a causa del superamento delle soglie di utilizzo.",
            },
            zeroSessions: {
              title: "Sessioni a consumo zero",
              description:
                "Mostra quante sessioni di dati hanno registrato consumo pari a zero nel periodo selezionato.",
            },
          },
          charts: {
            title: "Grafici e mappe dettagliati",
            dataSessionsMap: {
              title: "Distribuzione geografica delle connessioni dati",
              description:
                "La mappa mostra i paesi con il maggior numero di connessioni. Dal menu nell’angolo in alto a destra della scheda è possibile scegliere quali informazioni visualizzare: Data Sessions, Data Volume o Zero Sessions.",
            },
            avgDataAndActiveSims: {
              title: "Consumo medio di dati e SIM attive",
              description:
                "Mostra il consumo medio di dati per connessione e il numero totale di SIM attive.",
            },
            dataVolumePerHour: {
              title: "Distribuzione oraria del consumo di dati",
              description:
                "Il grafico mostra il consumo di dati per intervalli di tre ore e per giorno della settimana del mese corrente, offrendo una visione più completa dei momenti di maggiore attività delle SIM.",
            },
            monthlyDataVolume: {
              title: "Distribuzione mensile del consumo di dati",
              description:
                "Il grafico mostra la distribuzione mensile del consumo di dati negli ultimi 12 mesi. Dal menu nell’angolo in alto a destra della scheda è possibile scegliere quali informazioni visualizzare: Data Sessions, Data Volume o Zero Sessions.",
            },
            topMetrics: {
              title: "Metriche principali",
              description:
                "Questo grafico evidenzia le SIM con il maggior numero di connessioni nel periodo selezionato. Consente di identificare rapidamente le SIM più attive nella rete, analizzare i modelli di utilizzo, rilevare gli utenti con maggiore attività e ottimizzare l’allocazione delle risorse.",
            },
            dataVolumePerNetwork: {
              title: "Consumo dati per rete - SIM attive per rete",
              description:
                "Questi grafici offrono una visione comparativa dell’attività di rete nel paese selezionato. Il primo mostra la distribuzione del consumo totale di dati tra le reti mobili, aiutando a valutare il carico, individuare concentrazioni di utilizzo e confrontare le prestazioni degli operatori. Il secondo mostra la distribuzione delle SIM attive tra le reti, fornendo informazioni sulla copertura e sulla quota di mercato. Insieme offrono una comprensione completa di come le vostre SIM interagiscono con le reti e mettono in evidenza i modelli di connettività e utilizzo.",
            },
            simCardsPerOffer: {
              title: "SIM per offerta e stato",
              description:
                "Questi grafici offrono una panoramica del portafoglio SIM. Il primo mostra la distribuzione per offerta e piano dati, aiutando a identificare le preferenze e i servizi più popolari. Il secondo mostra la distribuzione per stato, fornendo visibilità sulle fasi del ciclo di vita e sulla disponibilità. Insieme consentono di monitorare le tendenze di utilizzo, i livelli di stock e l’efficienza complessiva della gestione delle SIM.",
            },
            alerts: {
              title: "Avvisi di consumo",
              description:
                "Questa tabella mostra gli avvisi di consumo generati dal meccanismo di monitoraggio WatchDog. WatchDog controlla costantemente l’utilizzo dei dati delle SIM e genera avvisi quando vengono raggiunte soglie predefinite.",
              types: {
                warning:
                  "Warning: attivato quando il consumo raggiunge l’80% del volume assegnato.",
                depleted:
                  "Depleted: attivato quando il consumo raggiunge il 100% del volume assegnato.",
              },
              note: "Questi avvisi consentono di intervenire tempestivamente per evitare interruzioni del servizio o costi imprevisti. Un’analisi più dettagliata di WatchDog e della sua logica sarà presentata nel capitolo pertinente della documentazione.",
            },
          },
          utility: {
            title: "Utilità della Dashboard",
            description:
              "Con la presentazione unificata delle metriche chiave, tendenze e avvisi, la Dashboard consente di rilevare rapidamente problemi e prendere decisioni consapevoli.",
          },
        },
        simCards: {
          introduction: {
            title: "Introduzione alle SIM",
            description:
              "Questo capitolo fornisce tutte le informazioni necessarie sulle SIM all'interno della piattaforma {{brand}}.",
            details:
              "Imparerai come le SIM vengono gestite, monitorate e analizzate, con approfondimenti su consumo dati, connettività, avvisi e fasi del ciclo di vita.",
            getStarted: "Inizia",
          },
          lifecycle: {
            title: "Ciclo di vita delle SIM",
            intro:
              "Le SIM nella piattaforma attraversano diversi stati del ciclo di vita. Ogni stato è rappresentato da un cerchio con codice colore e ha transizioni specifiche consentite.",
            status: {
              productive: "Attiva e in uso.",
              suspended: "Sospesa manualmente.",
              autoSuspended: "Sospesa automaticamente.",
              onstock: "Disponibile ma non attiva.",
              deleted: "Eliminata e inattiva.",
            },
            diagramDescription:
              "Questo diagramma mostra gli stati del ciclo di vita delle SIM e le possibili transizioni tra di essi. Le transizioni possono essere attivate manualmente (ad esempio, attivare una SIM da OnStock a Productive) o automaticamente (come quando un processo di sistema sospende automaticamente una SIM al raggiungimento di determinati limiti). Queste transizioni garantiscono un controllo adeguato dell’attività, della disponibilità e della disattivazione delle SIM all’interno della piattaforma.",
          },
          panel: {
            title: "Pannello SIMs",
            intro:
              "Il pannello SIMs fornisce una panoramica di tutte le schede SIM all’interno della piattaforma. Permette di monitorare l’attività, analizzare il consumo di dati e gestire in modo efficiente le fasi del ciclo di vita.",
            summary: {
              title: "Carte Riepilogo e Filtri",
              intro:
                "Nella parte superiore del pannello, tre carte mostrano una panoramica rapida dell’utilizzo delle SIMs per il mese corrente:",
              dataVolume: "Volume Dati – dati totali consumati.",
              dataSessions: "Sessioni Dati – numero di connessioni.",
              zeroSessions: "Sessioni Zero – sessioni senza dati.",
              filters:
                "I filtri consentono di restringere le SIM per IMSI, ICCID, MSISDN, stato della SIM, offerta, tipo di SIM o volume di dati. L’ordinamento può essere applicato su più campi come IMSI o utilizzo.",
            },
            table: {
              title: "Tabella SIM",
              intro:
                "La tabella principale elenca tutte le schede SIM con i loro dettagli principali:",
              activeSession: "Sessione Attiva – indicatore di attività live.",
              identifiers: "Identificativi – IMSI, ICCID, MSISDN.",
              state:
                "Stato SIM – stato del ciclo di vita (es.: Attiva, Sospesa).",
              offer: "Offerta – piano di abbonamento (se applicabile).",
              data: "Dati – volume di utilizzo per il mese.",
              type: "Tipo SIM – tipo di prodotto (es.: integrata, industriale).",
              footer:
                "Sono supportati anche la paginazione e le operazioni in blocco per una gestione efficiente delle SIM.",
            },
          },
          simProvisioning: {
            introduction: {
              title: "Provisioning SIM",
              description:
                "Il provisioning SIM si riferisce all’insieme di funzionalità che consentono agli amministratori di gestire il ciclo di vita delle SIM all’interno della piattaforma. Tramite il provisioning è possibile:",
              closing:
                "Queste azioni garantiscono che le SIM siano correttamente provisionate, controllate e disattivate, supportando sia la flessibilità operativa che la sicurezza.",
            },
            actions: {
              activate: {
                title: "Attivare",
                description: "rendere una SIM pronta per l’uso produttivo.",
                details: {
                  intro: "Per attivare una o più SIM ci sono tre modalità:",
                  steps: [
                    "Selezionando le SIM dalla tabella tramite le caselle di spunta e dal menu Operazioni Multiple in alto a destra, scegliere Attiva.",
                    "Cliccando direttamente sullo stesso menu e caricando un file Excel contenente i numeri IMSI/ICCID nella colonna A con il relativo titolo (IMSI/ICCID) nella cella A1.",
                    "Cliccando sulla riga, si aprirà un pannello laterale con il profilo della SIM, in alto al quale sarà presente un pulsante Attiva.",
                  ],
                  important:
                    "Importante! Tutte le SIM selezionate devono essere nello stato In Magazzino per poter essere attivate.",
                  closing:
                    "Dopo i passaggi descritti, comparirà una finestra di conferma con due step: l’utente deve selezionare l’Offerta con cui intende attivare le SIM. Facoltativamente, può impostare alcuni valori di campi personalizzati. Nel secondo step l’utente rivede le SIM selezionate e procede con l’attivazione.",
                },
              },
              suspend: {
                title: "Sospendere",
                description: "disabilitare temporaneamente la connettività.",
                details: {
                  intro:
                    "Analogamente all’attivazione, per sospendere una o più SIM l’utente ha le stesse opzioni:",
                  steps: [
                    "Selezionando le SIM dalla tabella tramite le caselle di spunta e dal menu Operazioni Multiple in alto a destra, scegliere Sospendi.",
                    "Cliccando direttamente sullo stesso menu e caricando un file Excel contenente i numeri IMSI/ICCID nella colonna A con il relativo titolo (IMSI/ICCID) nella cella A1.",
                    "Cliccando sulla riga, si aprirà un pannello laterale con il profilo della SIM, in alto al quale sarà presente un pulsante Sospendi.",
                  ],
                  important:
                    "Importante! Tutte le SIM selezionate devono essere nello stato Produttivo per poter essere sospese.",
                  closing:
                    "Dopo i passaggi descritti, comparirà una finestra di conferma in cui l’utente rivede le SIM selezionate e procede con la sospensione.",
                },
              },
              resume: {
                title: "Riprendere",
                description: "riattivare una SIM sospesa.",
                details: {
                  intro:
                    "Allo stesso modo, per riprendere una o più SIM l’utente ha le stesse opzioni:",
                  steps: [
                    "Selezionando le SIM dalla tabella tramite le caselle di spunta e dal menu Operazioni Multiple in alto a destra, scegliere Riprendi.",
                    "Cliccando direttamente sullo stesso menu e caricando un file Excel contenente i numeri IMSI/ICCID nella colonna A con il relativo titolo (IMSI/ICCID) nella cella A1.",
                    "Cliccando sulla riga, si aprirà un pannello laterale con il profilo della SIM, in alto al quale sarà presente un pulsante Riprendi.",
                  ],
                  important:
                    "Importante! Tutte le SIM selezionate devono essere nello stato Sospeso o AutoSospeso per poter essere riprese.",
                  closing:
                    "Dopo i passaggi descritti, comparirà una finestra di conferma in cui l’utente rivede le SIM selezionate e procede con la ripresa.",
                },
              },
              terminate: {
                title: "Terminare",
                description:
                  "ritirare una SIM dall’uso attivo (verso OnStock o Eliminata).",
                details: {
                  intro:
                    "Allo stesso modo, per terminare una o più SIM l’utente ha le stesse opzioni:",
                  steps: [
                    "Selezionando le SIM dalla tabella tramite le caselle di spunta e dal menu Operazioni Multiple in alto a destra, scegliere Termina.",
                    "Cliccando direttamente sullo stesso menu e caricando un file Excel contenente i numeri IMSI/ICCID nella colonna A con il relativo titolo (IMSI/ICCID) nella cella A1.",
                    "Cliccando sulla riga, si aprirà un pannello laterale con il profilo della SIM, in alto al quale sarà presente un pulsante Termina.",
                  ],
                  important:
                    "Importante! Tutte le SIM selezionate devono essere nello stato Produttivo per poter essere terminate.",
                  closing:
                    "Dopo i passaggi descritti, comparirà una finestra di conferma in cui l’utente seleziona lo stato finale della terminazione (In Magazzino o Eliminato Permanentemente), rivede le SIM selezionate e procede con la terminazione.",
                },
              },
              modify: {
                title: "Modificare",
                description:
                  "modifica l’Offerta con cui la SIM è attivata e fatturata.",
                details: {
                  intro: "Per modificare l’offerta di una SIM:",
                  steps: [
                    "Selezionando la SIM dalla tabella tramite la casella di spunta e dal menu Azioni in alto a destra, scegliere Modifica.",
                  ],
                  important:
                    "Importante! La SIM selezionata deve essere nello stato Produttivo per poter essere modificata.",
                  closing:
                    "Dopo i passaggi descritti, comparirà una finestra di conferma in cui l’utente deve selezionare l’Offerta di destinazione desiderata per la SIM. Poi rivede la SIM selezionata e procede con la modifica.",
                },
              },
            },
          },
          simProfile: {
            title: "Profilo SIM",
            description:
              "Il Profilo SIM è una dashboard che si concentra sulle statistiche e sulle funzionalità di una singola SIM. Fornisce statistiche simili alla dashboard principale e informazioni dettagliate per l’analisi e la gestione.",
            items: {
              kpis: "KPI e statistiche di utilizzo",
              monthly: "Distribuzione mensile dell’utilizzo",
              hlr: "Profilo HLR (se applicabile)",
              dataSessions: "Cronologia delle sessioni dati",
              smsUsage: "Cronologia dell’utilizzo degli SMS",
              requests: "Richieste effettuate per questa SIM",
              provisioning: "Attività e funzionalità di provisioning SIM",
              cellInfo: "Informazioni sulla cella e dettagli di connettività",
              watchdogs: "Informazioni e avvisi dei watchdog",
            },
            sections: {
              howToAccess: {
                title: "Come accedere",
                description:
                  "Per accedere al profilo di una specifica SIM, seleziona la SIM dalla tabella e cliccaci sopra. Si aprirà un pannello laterale che mostra le informazioni della SIM. All’interno di questo pannello è presente il link 'Visita Profilo' che reindirizza alla pagina completa del Profilo SIM. La pagina Profilo SIM fornisce statistiche dettagliate, cronologia di utilizzo, azioni di provisioning e informazioni tecniche sulla SIM selezionata.",
              },
              kpis: {
                title: "Indicatori Chiave (KPIs)",
                description:
                  "La sezione KPI del profilo SIM fornisce una panoramica rapida delle prestazioni e dell’attività della SIM. Questi indicatori aiutano l’utente a comprendere immediatamente l’utilizzo e lo stato della SIM.",
                bullets: [
                  "Volume Dati – la quantità totale di dati consumata dalla SIM nel periodo selezionato.",
                  "Sessioni Dati – il numero di sessioni dati stabilite durante il periodo selezionato.",
                  "Avvisi – il numero di avvisi attivati per questa SIM (ad es. soglie di utilizzo).",
                  "Sessioni Zero – il numero di sessioni in cui la SIM ha tentato di connettersi senza consumare dati.",
                ],
                closing:
                  "In alto a destra l’utente può filtrare gli indicatori per periodo (Giornaliero, Mensile o Annuale) per analizzare i modelli di utilizzo nel tempo.",
              },
              monthly: {
                title: "Distribuzione mensile",
                description: "Distribuzione di dati, SMS e sessioni per mese.",
              },
              hlr: {
                title: "Profilo HLR",
                description:
                  "Il profilo HLR (Home Location Register) fornisce informazioni dettagliate sull’abbonamento e sulla rete della SIM. Facendo clic sul pulsante HLR nel menu Azioni, viene visualizzata una finestra con dettagli come:",
                fields: {
                  msisdn: "MSISDN",
                  imsi: "IMSI",
                  networkAccessMode:
                    "Modalità di accesso alla rete (es. CS e PS)",
                  subscriberType: "Tipo di abbonato (es. abbonato LTE)",
                  simStatus: "Stato SIM (es. Disponibile)",
                },
                scopes:
                  "Inoltre, l’utente può selezionare da un elenco a discesa gli ambiti disponibili (es. Informazioni di base, Informazioni estese) per visualizzare i dettagli corrispondenti a seconda del livello di approfondimento richiesto.",
                closing:
                  "Questa funzionalità consente agli amministratori di convalidare rapidamente i dettagli di provisioning della SIM e di confermare se la SIM è correttamente registrata e disponibile nella rete.",
              },

              dataSessions: {
                title: "Sessioni dati",
                description:
                  "La funzionalità Sessioni dati consente agli amministratori di visualizzare registri dettagliati di tutte le sessioni dati associate a una SIM. Facendo clic sul pulsante Sessioni nel menu Azioni, si apre una finestra modale che mostra la cronologia delle sessioni e i dettagli correlati.",
                fields: {
                  openDate: "Data e ora di inizio della sessione",
                  closeDate: "Data e ora di chiusura della sessione",
                  consumption:
                    "Numero effettivo di byte consumati durante la sessione",
                  roundedBytes:
                    "Utilizzo arrotondato in base alle politiche di fatturazione dell’operatore",
                  operator: "L’operatore di rete che gestisce la sessione",
                  cell: "L’ID cella in cui è stata stabilita la sessione",
                  imei: "Identificativo del dispositivo (IMEI) utilizzato per la sessione",
                },
              },
              smsUsage: {
                title: "Utilizzo SMS",
                description:
                  "La finestra di utilizzo SMS consente agli amministratori di monitorare tutti i messaggi SMS inviati e ricevuti dalla SIM. Cliccando sul pulsante Utilizzo SMS nel menu Azioni, appare una tabella dettagliata che elenca ogni transazione SMS.",
                fields: {
                  direction: "Direzione (es. In entrata o In uscita)",
                  date: "Data e ora dell’evento SMS",
                  sender: "Mittente dell’SMS",
                  message: "Contenuto del messaggio SMS (se disponibile)",
                  status:
                    "Stato di consegna (es. Inviato, Consegnato, Fallito)",
                },
                note: "Questa funzionalità fornisce la completa tracciabilità del traffico SMS per finalità di diagnostica, conformità o analisi dell’utilizzo.",
              },
              requests: {
                title: "Richieste",
                description:
                  "La sezione Richieste fornisce una cronologia completa di tutti gli ordini di provisioning effettuati per la SIM selezionata. Cliccando sul pulsante Richieste nel menu Azioni, si apre una finestra modale che elenca tutti gli ordini, come Attiva, Sospendi, Riprendi e Termina.",
                fields: {
                  id: "ID: L'identificativo univoco dell'ordine.",
                  name: "Nome: Il tipo di azione (es. SuspendSIM, ResumeSIM, TerminateSIM).",
                  status:
                    "Stato: Lo stato di esecuzione dell'ordine (es. Completato, In sospeso).",
                  creator: "Creatore: L'utente che ha avviato la richiesta.",
                  creationDate:
                    "Data di creazione: Quando l'ordine è stato creato.",
                  lastUpdate:
                    "Ultimo aggiornamento: L'ultima data/ora di aggiornamento dello stato.",
                },
                note: "Questa funzionalità consente agli amministratori di monitorare tutte le attività di provisioning eseguite sulla SIM, garantendo trasparenza e responsabilità nella gestione del ciclo di vita.",
              },
              provisioning: {
                title: "Attività di provisioning",
                description:
                  "Azioni di provisioning come attivazione, sospensione e modifica.",
              },
              cellInfo: {
                title: "Informazioni cella",
                description:
                  "Informazioni sulla cella e dettagli di connessione della SIM.",
              },
              watchdogs: {
                title: "Watchdogs",
                description:
                  "La sezione Watchdogs del profilo SIM mostra i watchdog configurati associati alla SIM. Questi watchdog sono generalmente definiti a livello di piattaforma e collegati a una SIM per monitorare condizioni specifiche.",
                bullets: [
                  "Visualizzare l’elenco dei watchdog attivi collegati alla SIM.",
                  "Verificare la loro configurazione (ad es. tipo di watchdog, stato e limiti assegnati).",
                  "Monitorare quali watchdog stanno controllando l’attività della SIM.",
                ],
                note: "Nota: La configurazione di soglie, avvisi o azioni automatiche non è disponibile dal profilo SIM. Questa sezione è di sola lettura e serve esclusivamente al monitoraggio.",
              },
            },
          },
          simTransfers: {
            title: "Trasferimenti SIM",
            description:
              "La funzione di trasferimento SIM consente agli amministratori di spostare le schede SIM tra account o entità. È utile per riallocare le SIM, spedirle a un’altra organizzazione o gestire cambi di proprietà.",

            howToAccess: {
              title: "Come accedere",
              description:
                "Per accedere ai trasferimenti SIM, vai alla sezione Gestione utenti, apri il menu Azioni di un utente e seleziona l’opzione 'Spedisci SIMs'.",
            },

            steps: {
              title: "Passaggi per effettuare un trasferimento SIM",
              description:
                "Il processo di trasferimento consiste nei seguenti passaggi:",
              bullets: [
                "Assicurati che le SIM siano nello stato 'In Stock' prima di iniziare il trasferimento. Solo le SIM disponibili possono essere trasferite tra account.",
                "Scegli un tipo di selezione SIM: IMSI singolo, ICCID singolo, intervallo IMSI, intervallo ICCID o caricamento file CSV/XLSX. Questo determina come identificare le SIM da trasferire.",
                "Inserisci o carica gli identificatori SIM richiesti in base al tipo scelto.",
                "Definisci facoltativamente prezzo e IVA. Questi campi aiutano a tracciare le implicazioni finanziarie del trasferimento.",
                "Seleziona un’Offerta di fatturazione. Questa è l’offerta che verrà addebitata all’account sorgente quando l’account di destinazione attiverà la SIM trasferita.",
                "Fai clic su 'Invia' per completare il trasferimento. Una volta confermato, le SIM appariranno nell’inventario dell’account di destinazione.",
              ],
            },
            deallocate: {
              title: "Deallocare SIM",
              description:
                "La deallocazione è la procedura inversa di un trasferimento SIM. Consente agli utenti di rimuovere le SIM da un account di destinazione e restituirle all’account di origine o allo stock. È utile quando le SIM sono state assegnate per errore, non sono più necessarie o devono essere riassegnate.",
              bullets: [
                "Accedere alla sezione Gestione Utenti, aprire il menu Azioni per un utente e selezionare 'Deallocare SIM'.",
                "Assicurarsi che le SIM siano nello stato 'In Magazzino' o 'Assegnate' prima di tentare la deallocazione.",
                "Scegliere un tipo di selezione SIM: IMSI singolo, ICCID singolo, Intervallo IMSI, Intervallo ICCID o file CSV/XLSX.",
                "Inserire o caricare gli identificatori delle SIM da deallocare.",
                "Confermare gli account di origine e destinazione. Il campo 'Da' mostra l’account corrente e il campo 'A' mostra l’account o il magazzino a cui le SIM verranno restituite.",
                "Fare clic su 'Invia' per completare la deallocazione. Una volta confermata, le SIM non compariranno più nell’inventario dell’account di destinazione e saranno disponibili per la riassegnazione.",
              ],
            },
          },
        },
        watchdog: {
          title: "Watchdog",
          description:
            "I Watchdog sono regole di monitoraggio che aiutano gli utenti a controllare l’utilizzo delle SIM e a rilevare comportamenti anomali. Consentono una gestione proattiva definendo soglie su metriche come volume dati, sessioni o utilizzo degli SMS. Quando una soglia viene superata, il sistema può generare avvisi o avviare azioni per prevenire abusi o costi imprevisti.",
          items: {
            add: "Come aggiungere un Watchdog",
            remove: "Come rimuovere un Watchdog",
            reset: "Come reimpostare un Watchdog",
            suspensionBlock:
              "Bloccare la sospensione della SIM nel periodo di fatturazione corrente",
            alerts: "Avvisi generati dai Watchdog",
          },
          add: {
            title: "Aggiungi Watchdog",
            description:
              "Gli utenti possono creare un nuovo watchdog per monitorare l’attività SIM e attivare azioni automatiche quando l’utilizzo supera le soglie definite. Questo consente una gestione proattiva delle SIM e il controllo dei costi.",
            howToAccess:
              "Per aggiungere un nuovo watchdog, vai al Pannello SIM → Operazioni di gruppo → Watchdogs → Crea Watchdog. Importante: tutte le SIM devono trovarsi nello stato Productive (attive) per configurare un watchdog.",
            fields: {
              actionType:
                "Seleziona l’azione da eseguire quando viene raggiunta la soglia (es. notifica, sospensione).",
              interval:
                "Scegli il periodo di monitoraggio (giornaliero, settimanale, mensile).",
              amount: "Inserisci la soglia di utilizzo che attiverà l’azione.",
              service: "Seleziona il servizio da monitorare (es. Dati, SMS).",
              unitType: "Scegli l’unità di misura (es. Byte, numero di SMS).",
              warnings:
                "Definisci soglie di avviso anticipato prima dell’azione principale per notificare gli utenti in anticipo.",
              suspendInterval:
                "Definisce per quanto tempo la SIM rimane sospesa una volta attivato il watchdog. Se impostato su giornaliero, la SIM verrà riattivata automaticamente a mezzanotte del giorno successivo. Se settimanale, a mezzanotte del lunedì successivo. Se mensile, a mezzanotte del primo giorno del mese successivo.",
            },
          },
          removeAll: {
            title: "Rimuovere Tutti i Watchdog",
            description:
              "Gli utenti possono rimuovere tutti i watchdog configurati da una SIM card con un’unica azione. Questo è utile per ripristinare rapidamente il monitoraggio senza dover eliminare ogni watchdog singolarmente.",
            howToAccess:
              "Per rimuovere tutti i watchdog, vai al pannello SIM → seleziona le SIM attive → Operazioni di gruppo → Watchdogs → Rimuovere Tutti i Watchdogs.",
            details: {
              title: "Dettagli",
              immediateEffect:
                "All’esecuzione, tutte le configurazioni watchdog esistenti sulle SIM selezionate verranno eliminate.",
              noAlerts:
                "Dopo la rimozione non verranno più generate notifiche o azioni automatiche.",
              cleanSlate:
                "La SIM continuerà a funzionare normalmente, ma senza monitoraggio finché non verranno creati nuovi watchdog.",
            },
            useCases: {
              title: "Casi d’Uso",
              policyChanges:
                "Quando le politiche di monitoraggio cambiano, potrebbe essere necessario eliminare i watchdog esistenti.",
              testing:
                "Negli ambienti di test, molti watchdog possono essere creati e rimossi rapidamente per la pulizia.",
              errorRecovery:
                "Se esistono watchdog configurati in modo errato o in conflitto, la rimozione li reimposta a uno stato neutrale.",
            },
            considerations: {
              title: "Considerazioni",
              irreversible:
                "La rimozione di tutti i watchdog non può essere annullata; devono essere ricreati se necessari.",
              criticalMonitoring:
                "Assicurati che le SIM non rimangano senza monitoraggio in ambienti critici.",
              bulkOperations:
                "Nelle operazioni di gruppo, verifica attentamente poiché tutte le SIM selezionate saranno interessate.",
            },
          },
          reset: {
            title: "Reimpostare Watchdog",
            description:
              "La reimpostazione di un watchdog azzera il contatore dei consumi e ripristina la sospensione se l’utente aveva scelto di bloccarla per il periodo di fatturazione corrente. Questo consente di riavviare il monitoraggio senza creare un nuovo watchdog.",
            howToAccess: {
              title: "Come Accedere",
              description:
                "Accedere al profilo della SIM. Nella sezione Watchdog, fare clic sull’icona con la freccia circolare accanto al watchdog corrispondente per reimpostarlo.",
            },
          },
          blockSuspension: {
            title: "Blocca la Sospensione",
            description:
              "Il blocco della sospensione impedisce la sospensione di una SIM quando un watchdog che ne monitora il consumo attiva un avviso di consumo al 100% (Depleted Alert). Questa funzionalità è valida solo per il periodo di fatturazione corrente. All’inizio del periodo successivo, la sospensione viene ripristinata automaticamente.",
            howToAccess: {
              title: "Come Accedere",
              description:
                "Seleziona le SIM in stato 'Produttivo' dal pannello SIM. Poi vai su Operazioni di Massa → Watchdogs → Blocca la Sospensione.",
            },
          },
          alerts: {
            title: "Avvisi",
            description:
              "I watchdog che monitorano il consumo delle SIM generano Avvisi. Gli avvisi aiutano gli utenti a monitorare le soglie di utilizzo e a intervenire quando necessario.",
            typesTitle: "Tipi di Avvisi",
            types: {
              depleted:
                "Esaurito: Generato per tutti i watchdog. Attivato quando una SIM raggiunge il 100% del consumo.",
              warning:
                "Avviso: Generato facoltativamente per i watchdog che hanno impostato limiti di avviso.",
            },
            howToAccess: {
              title: "Come accedere",
              description:
                "Per visualizzare gli avvisi, accedere al menu 'Avvisi' nella barra laterale. La tabella elenca gli avvisi ordinati per data (i più recenti per primi) e include filtri per tipo, data e IMSI.",
            },
          },
        },
        reports: {
          intro: {
            title: "Report",
            description:
              "La piattaforma offre agli utenti la possibilità di visualizzare ed esportare un’ampia varietà di report, tra cui consumo delle SIM, elenco delle fatture, dettagli delle righe di fattura, richieste di provisioning SIM, attività del portafoglio (attivazioni e cessazioni per offerta), distribuzione degli stati delle SIM e sessioni SIM attive. Inoltre, è possibile creare report automatizzati sull’uso e sulla panoramica SIM che vengono generati a intervalli fissi in formato scaricabile. Questo capitolo si concentra su tre sottocapitoli.",
            subchaptersTitle: "Sottocapitoli",
            subchapters: {
              single: "Report singolo",
              automated: "Report automatizzato",
              history: "Cronologia dei report",
            },
          },
          single: {
            title: "Report Singolo",
            description:
              "I report singoli consentono agli utenti di generare report specifici sull’utilizzo delle SIM, sulle fatture, sull’attività del portafoglio, sulle richieste di provisioning o sulle sessioni. Questi report possono essere personalizzati in base a criteri, raggruppati ed esportati per ulteriori analisi.",

            howToAccess: {
              title: "Accesso",
              description:
                "Per accedere ai Report Singoli, vai nella sezione Rapporti nella barra laterale e seleziona 'Genera Report'.",
            },

            usageReport: {
              title: "Report di Utilizzo",
              description:
                "Il Report di Utilizzo fornisce informazioni dettagliate sul consumo SIM per Dati o SMS, con opzioni flessibili di raggruppamento e filtraggio.",
              bullets: [
                "Scegli 'Usage' come Tipo di Report.",
                "Seleziona Tipo di Utilizzo: Dati o SMS.",
                "Raggruppa per Campo: IMSI, Rete, Cliente o nessun raggruppamento.",
                "Raggruppa per Periodo: Giorno, Mese o Anno.",
                "Facoltativamente filtra per SIM: IMSI specifico, intervallo IMSI o ICCID.",
                "Clicca 'Visualizza' per generare il report.",
              ],
            },
            invoiceList: {
              title: "Elenco Fatture",
              description:
                "Il rapporto Elenco Fatture fornisce una panoramica di tutte le fatture emesse per l’account. Include informazioni chiave come numero della fattura, data di emissione, data di scadenza, importo totale e stato del pagamento. Gli utenti possono filtrare le fatture per intervallo di date per individuare rapidamente i documenti di fatturazione.",
              bullets: [
                "Vai a Report → Genera Report.",
                "Seleziona 'Elenco Fatture' come tipo di report.",
                "Definisci l’intervallo di date (Da – A) per limitare l’elenco delle fatture.",
                "Fai clic su 'Visualizza' per generare il report.",
                "La tabella risultante mostra le fatture con dettagli come numero, data di emissione, data di scadenza, importo totale e stato del pagamento.",
              ],
            },
            orders: {
              title: "Report Ordini",
              description:
                "Il report Ordini consente all’utente di visualizzare tutti gli ordini di provisioning relativi alle SIM card. Fornisce una panoramica storica degli ordini creati durante il periodo selezionato.",
              bullets: [
                "Accessibile tramite Report → Genera Report → Ordini.",
                "Consente di filtrare per intervallo di date (periodo).",
                "Mostra un elenco degli ordini di provisioning SIM.",
              ],
            },
            portfolioActivity: {
              title: "Report Attività del Portafoglio",
              description:
                "Il report Attività del Portafoglio fornisce una panoramica delle attività delle SIM, comprese attivazioni, cessazioni e modifiche per offerta. Aiuta gli utenti a monitorare l’evoluzione del proprio portafoglio SIM nel tempo.",
              bullets: [
                "Accessibile tramite Report → Genera Report → Attività del portafoglio.",
                "Gli utenti possono filtrare il report per periodo (Da–A).",
                "Mostra attivazioni, cessazioni e attività raggruppate per offerta.",
              ],
            },
            customerSimSessions: {
              title: "Report Sessioni SIM Cliente",
              description:
                "Il report Sessioni SIM Cliente mostra informazioni sulle sessioni SIM attive e passate dei clienti. Aiuta a tracciare quando e come le SIM si connettono alla rete.",
              bullets: [
                "Accessibile tramite Report → Genera Report → Sessioni SIM Cliente.",
                "Mostra dettagli della sessione come IMSI, orario di inizio e fine, e dati trasferiti.",
                "Utile per risolvere problemi di connettività e analizzare i modelli di utilizzo delle SIM.",
              ],
            },
            simOverview: {
              title: "Report Panoramica SIM",
              description:
                "Il report Panoramica SIM fornisce un riepilogo delle SIM nel sistema, mostrando la loro distribuzione per stato, assegnazione e attività. Aiuta gli amministratori a valutare rapidamente l’intero parco SIM.",
              bullets: [
                "Accessibile tramite Report → Genera Report → Panoramica SIM.",
                "Mostra le SIM raggruppate per stato come Attiva, Sospesa, Terminata o In Magazzino.",
                "Utile per monitorare lo stato e la distribuzione delle SIM a colpo d’occhio.",
              ],
            },
            simList: {
              title: "Report Elenco SIM",
              description:
                "Il report Elenco SIM fornisce un inventario dettagliato di tutte le SIM nel sistema. Include identificatori come IMSI e ICCID, il loro stato attuale e i dettagli di assegnazione.",
              bullets: [
                "Accessibile tramite Report → Genera Report → Elenco SIM.",
                "Mostra ogni SIM con IMSI, ICCID e stato attuale.",
                "Utile per la verifica e la gestione dell’inventario completo delle SIM.",
              ],
            },
            exportReport: {
              title: "Esporta Report in File",
              description:
                "Tutti i report generati possono essere esportati in un file per ulteriori analisi o condivisione. Le opzioni di esportazione includono i formati CSV e PDF.",
              bullets: [
                "Accessibile tramite Azioni → Esporta → CSV o PDF.",
                "Il formato CSV è utile per l’analisi dei dati in Excel o altri strumenti di fogli di calcolo.",
                "Il formato PDF è utile per condividere report in formato fisso.",
              ],
            },
            timeoutReports: {
              title: "Report con Timeout",
              description:
                "Ogni generazione di report ha un limite di timeout di 15 secondi. Quando questo limite viene superato, il report continua a essere generato in background.",
              bullets: [
                "Una notifica informa l’utente quando un report supera il limite.",
                "Quando il report è pronto, viene ricevuta una notifica push.",
                "Il report generato può essere visualizzato da Azioni → Visualizza.",
                "I report con timeout possono essere esportati in CSV o PDF, proprio come quelli generati istantaneamente.",
              ],
            },
          },
          automated: {
            title: "Report Automatizzati",
            description:
              "I Report Automatizzati consentono agli utenti di programmare la generazione dei report a intervalli fissi e in un formato scelto.",
            overview: {
              title: "Panoramica",
              description:
                "I Report Automatizzati vengono creati una volta sola e poi generati automaticamente alla frequenza e nel formato scelti.",
              bullets: [
                "I report possono essere pianificati giornalmente, settimanalmente o mensilmente.",
                "I report possono essere generati in formato CSV o PDF.",
                "Tipi di report disponibili: Utilizzo e Panoramica SIM Cliente.",
              ],
            },
            create: {
              title: "Creare un Report Automatizzato",
              description:
                "Per creare un nuovo report automatizzato, fare clic sul pulsante in alto a destra della scheda. Apparirà un modulo che richiede alcune informazioni:",
              bullets: [
                "Nome: Il nome del report.",
                "Frequenza del report: Giornaliera, settimanale o mensile.",
                "Formato del report: CSV o PDF.",
                "Tipo di report: Scegliere tra Utilizzo e Panoramica SIM Cliente.",
                "A seconda del tipo di report, possono apparire campi aggiuntivi, simili al menu Genera Report.",
              ],
            },
          },
          history: {
            title: "Cronologia Report",
            description:
              "La sezione Cronologia Report fornisce un elenco dei risultati di tutte le esecuzioni dei Report Automatizzati. Ogni voce include il nome del report, la data di generazione, lo stato, l’opzione di download e la possibilità di eliminare il report.",
            reportHistory: {
              title: "Visualizzazione dei Risultati dei Report Automatizzati",
              description:
                "Nella sezione Cronologia Report, gli utenti possono:",
              bullets: [
                "Visualizzare i risultati di tutti i Report Automatizzati eseguiti.",
                "Controllare lo stato di esecuzione (Completato, In sospeso, Fallito).",
                "Scaricare i file generati in formato CSV o PDF.",
                "Eliminare una voce di report tramite il menu Azioni.",
              ],
            },
          },
        },
      },
    },
  },
  es: {
    translation: {
      sidebar: {
        dashboard: "Tablero",
        crm: "CRM",
        admins: "Administradores",
        tenants: "Inquilinos",
        managers: "Gerentes",
        customers: "Clientes",
        subaccounts: "Subcuentas",
        sims: "Tarjetas SIM",
        account: "Cuenta",
        profile: "Perfil",
        billingProducts: "Productos de facturación",
        invoices: "Facturas",
        statements: "Extractos",
        orders: "Pedidos",
        emails: "Correos electrónicos",
        reports: "Informes",
        generateReport: "Generar informe",
        automatedReports: "Informes automatizados",
        reportHistory: "Historial de informes",
        alerts: "Alertas",
        notifications: "Notificaciones",
        support: "Soporte",
        privileges: "Privilegios",
        settings: "Configuraciones",
        services: "Servicios",
        documentation: "Documentación",
        whitelist: "Dirección IP permitida",
        customFields: "Campos personalizados",
        simProducts: "Productos SIM",
        purchaseSims: "Comprar tarjetas SIM",
        health: "Estado del sistema",
        purchaseOrders: "Pedidos de tarjetas SIM",
      },
      dashboard: {
        dataVolume: "Volumen de datos",
        dataSessions: "Sesiones de datos",
        alerts: "Alertas",
        zeroSessions: "Sesiones cero",
        sinceYesterday: "Desde ayer",
        sinceLastMonth: "Desde el mes pasado",
        sinceLastYear: "Desde el año pasado",
        averageVolume: "Volumen de datos promedio",
        activeSims: "SIMs activas",
        dataVolumePerHour: "Volumen de datos por hora",
        topMetrics: "Principales métricas",
        simCardsPerOffer: "SIMs por oferta",
        simInventory: "Distribución de SIM por estado",
        dataVolumePerNetwork: "Volumen de datos por red",
        selectCountry: "Seleccionar país",
        networksDistribution: "Distribución de SIM activas por red",
        watchdogAlerts: "Alertas de consumo",
        noData: "No hay datos disponibles",
        daily: "Diario",
        monthly: "Mensual",
        yearly: "Anual",
      },
      crm: {
        admins: "Administradores",
        tenants: "Inquilinos",
        managers: "Gerentes",
        customers: "Clientes",
        subaccounts: "Subcuentas",
        filters: "Filtros",
        fullName: "Nombre completo",
        company: "Empresa",
        email: "Correo electrónico",
        address: "Dirección",
        city: "Ciudad",
        country: "País",
        postcode: "Código postal",
        telephone: "Teléfono",
        mobile: "Móvil",
        occupation: "Ocupación",
        tin: "Número de Identificación Fiscal",
        username: "Nombre de usuario",
        role: "Rol",
        actions: "Acciones",
        edit: "Editar",
        delete: "Eliminar",
        billing: "Facturación",
        whitelabeling: "Marca blanca",
        offers: "Ofertas",
        impersonate: "Suplantar",
        permissions: "Permisos",
        sendWelcomeEmail: "Enviar correo de bienvenida",
        resetPassword: "Restablecer contraseña",
        initializeSIMs: "Inicializar SIMs",
        initializeAlerts: "Inicializar alertas",
        newTenant: "Nuevo inquilino",
        newManager: "Nuevo gerente",
        newCustomer: "Nuevo cliente",
        newSubaccount: "Nueva subcuenta",
        registerPayment: "Registrar pago",
        accountId: "ID de cuenta",
        registerPayment: {
          title: "Registrar pago",
          amount: "Cantidad",
          currency: "Moneda",
          invoice: "Número de factura",
          submit: "Enviar",
          cancel: "Cancelar",
          selectCurrency: "Seleccionar moneda",
          selectInvoice: "Seleccionar factura",
        },
        creditNote: {
          title: "Nota de crédito",
          amount: "Cantidad",
          vat: "IVA",
          reason: "Motivo",
          submit: "Enviar",
          cancel: "Cancelar",
        },
        invoiceCycle: {
          title: "Volver a ejecutar el ciclo de facturación",
        },
        newModal: {
          newTenant: "Crear inquilino",
          newManager: "Crear gerente",
          newCustomer: "Crear cliente",
          newSubaccount: "Crear subcuenta",
          fullName: "Nombre completo",
          address: "Dirección",
          city: "Ciudad",
          country: "País",
          postcode: "Código postal",
          telephone: "Teléfono",
          mobile: "Móvil",
          email: "Correo electrónico",
          occupation: "Ocupación",
          company: "Empresa",
          tin: "Número de Identificación Fiscal",
          username: "Nombre de usuario",
          sendWelcomeEmail: "Enviar correo de bienvenida",
          cancel: "Cancelar",
          submit: "Enviar",
          next: "Siguiente",
          previous: "Anterior",
          preferredLanguage: "Idioma preferido",
          billingEmail: "Correo de facturación",
          currency: "Moneda",
        },
        editModal: {
          editTenant: "Editar inquilino",
          editManager: "Editar gerente",
          editCustomer: "Editar cliente",
          editSubaccount: "Editar subcuenta",
          fullName: "Nombre completo",
          address: "Dirección",
          city: "Ciudad",
          country: "País",
          postcode: "Código postal",
          telephone: "Teléfono",
          mobile: "Móvil",
          email: "Correo electrónico",
          occupation: "Ocupación",
          company: "Empresa",
          tin: "Número de Identificación Fiscal",
          username: "Nombre de usuario",
          cancel: "Cancelar",
          submit: "Enviar",
        },
        billingModal: {
          title: "Configuración de facturación",
          currency: "Moneda",
          billingFrequency: "Frecuencia de facturación",
          daysToPayInvoice: "Días para pagar la factura",
          minimumAmountToInvoice: "Monto mínimo para facturar",
          invoiceType: "Tipo de factura",
          preferredLanguage: "Idioma preferido",
          billingEmail: "Correo de facturación",
          platformUsage: "Uso de la plataforma",
          platformUsagePrice: "Precio de uso de la plataforma",
          onStockPriceEnabled: "Precio de SIM On Stock habilitado",
          onStockPrice: "Precio de SIM On Stock",
          simCardPriceEnabled: "¿Cargo por tarjeta SIM?",
          simCardPrice: "Precio de la tarjeta SIM",
          simChipPriceEnabled: "¿Cargo por chip SIM?",
          simChipPrice: "Precio del chip SIM",
          billable: "¿Facturable?",
          isVatExempt: "¿Está exento de IVA?",
          cancel: "Cancelar",
          submit: "Enviar",
        },
        whitelabelModal: {
          title: "Configuración de marca blanca",
          enableWhitelabel: "Habilitar marca blanca",
          pricePerMonth: "Precio por mes",
          url: "URL",
          cancel: "Cancelar",
          submit: "Enviar",
        },
        roleModal: {
          title: "Actualizar rol",
          role: "Rol",
          tenant: "Inquilino",
          manager: "Gerente",
          customer: "Cliente",
          cancel: "Cancelar",
          submit: "Enviar",
        },
        offersModal: {
          title: "Asignar ofertas",
          availableOffers: "Ofertas disponibles",
          assignedOffers: "Ofertas asignadas",
          submit: "Enviar",
        },
      },
      sims: {
        title: "Tarjetas SIM",
        dataVolume: "Volumen de datos",
        dataSessions: "Sesiones de datos",
        zeroSessions: "Sesiones cero",
        filters: "Filtros",
        simStatus: "Sesión activa",
        simState: "Estado SIM",
        portfolioId: "Portfolio ID",
        imsi: "IMSI",
        iccid: "ICCID",
        msisdn: "MSISDN",
        eid: "EID",
        offer: "Oferta",
        data: "Datos",
        min: "Mín",
        max: "Máx",
        search: "Buscar",
        clear: "Limpiar",
        actions: "Acciones",
        bulk: "Operaciones masivas",
        modify: "Modificar",
        product: "Producto",
        clearSelection: "Limpiar selección",
        activate: "Activar",
        suspend: "Suspender",
        resume: "Reanudar",
        terminate: "Terminar",
        testMode: "Modo de prueba",
        sendSms: "Enviar SMS",
        watchdogs: "Watchdogs",
        createWatchdog: "Crear Watchdog",
        removeAllWatchdogs: "Eliminar todos los Watchdogs",
        blockSuspension: "Bloquear la Suspensión",
        export: "Exportar",
        simInformation: "Información SIM",
        usage: "Uso",
        ipAddress: "Dirección IP",
        imei: "IMEI",
        status: "Estado",
        visitProfile: "Visitar perfil",
        provider: "Proveedor",
        area: "Área",
        cell: "Celda",
        longitude: "Longitud",
        latitude: "Latitud",
        cellRange: "Rango de celda",
        unit: "Unidad",
        sort: "Ordenar",
        suspendModal: {
          title: "Suspender SIM",
          orderComplete: "Suspensión de SIM completada",
          orderError: "Suspensión de SIM fallida",
          contactAdmin: "Contacta al administrador del sistema",
          cancel: "Cancelar",
          submit: "Enviar",
          close: "Cerrar",
        },
        resumeModal: {
          title: "Reanudar SIM",
          orderComplete: "Reanudación de SIM completada",
          orderError: "Reanudación de SIM fallida",
          contactAdmin: "Contacta al administrador del sistema",
          cancel: "Cancelar",
          submit: "Enviar",
          close: "Cerrar",
        },
        activateModal: {
          title: "Activar SIM",
          offer: "Oferta",
          selectOffer: "Seleccionar oferta",
          success: "Activación de SIM completada",
          orderError: "Activación de SIM fallida",
          contactAdmin: "Contacta al administrador del sistema",
          cancel: "Cancelar",
          submit: "Enviar",
          close: "Cerrar",
        },
        terminateModal: {
          title: "Terminar SIM",
          targetState: "Estado deseado",
          onStock: "En stock",
          terminated: "Terminada",
          success: "Terminación de SIM completada",
          orderError: "Terminación de SIM fallida",
          contactAdmin: "Contacta al administrador del sistema",
          cancel: "Cancelar",
          submit: "Enviar",
          close: "Cerrar",
        },
      },
      simProfile: {
        simProvisioning: "Gestión del estado de la SIM",
        simDetails: "Detalles de la SIM",
        actions: "Acciones",
        hlr: "HLR",
        session: "Sesiones",
        smsUsage: "Uso de SMS",
        updateLoc: "Actualizar ubicación",
        imeiLock: "Bloqueo de IMEI",
        usage: "Uso",
        imei: "IMEI",
        status: "Estado",
        dataSession: "Sesión activa",
        map: "Mapa",
        provider: "Proveedor",
        imsi: "IMSI",
        iccid: "ICCID",
        msisdn: "MSISDN",
        country: "País",
        operator: "Operador de red",
        area: "Área",
        cell: "Celda",
        longitude: "Longitud",
        latitude: "Latitud",
        cellRange: "Rango de celda",
        activity: "Actividad",
        selectPeriod: "Seleccionar período",
        daily: "Diario",
        monthly: "Mensual",
        yearly: "Anual",
        dataVolume: "Volumen de datos",
        dataSessions: "Sesiones de datos",
        alerts: "Alertas",
        zeroSessions: "Sesiones cero",
        watchdog: "Watchdog",
        type: "Tipo",
        blockSuspension: "La SIM será suspendida",
        amount: "Cantidad",
        hlrModal: {
          title: "Perfil HLR",
          selectScope: "Seleccionar alcance",
          basicInfo: "Información básica",
          locationInfo: "Información de ubicación",
          csBasicInfo: "Información básica de CS",
          gprsService2g3g: "Servicios GPRS 2G/3G",
          telephonyService: "Servicios de telefonía",
          supplementaryService: "Servicios complementarios",
          epcService4G: "Servicios EPC 4G",
        },
        sessionModal: {
          title: "Sesiones de datos de SIM",
          openDate: "Fecha de apertura",
          closeDate: "Fecha de cierre",
          consumption: "Consumo",
          roundedBytes: "Bytes redondeados",
          operator: "Operador",
          cell: "Celda",
          imei: "IMEI",
          close: "Cerrar",
        },
        orders: {
          title: "Solicitudes",
          close: "Cerrar",
        },
        smsUsageModal: {
          title: "Uso de SMS",
          direction: "Dirección",
          date: "Fecha",
          sender: "Remitente",
          message: "Mensaje",
          status: "Estado",
          close: "Cerrar",
        },
      },
      profile: {
        profileDetails: "Detalles del perfil",
        contactInformation: "Información de contacto",
        professionalInformation: "Información profesional",
        activities: "Actividades",
        loadMore: "Cargar más",
      },
      billingProducts: {
        title: "Productos de facturación",
        name: "Nombre",
        pricePlan: "Plan de precios",
        price: "Precio",
        number: "Número",
      },
      invoices: {
        title: "Facturas",
        invoiceNo: "Número de factura",
        date: "Fecha",
        amount: "Monto (incl. IVA)",
        description: "Descripción",
        paid: "Pagado",
        download: "Descargar",
      },
      statements: {
        title: "Extractos de cuenta",
        cutDate: "Fecha de corte",
        description: "Descripción",
        amount: "Monto (incl. IVA)",
        balance: "Saldo",
      },
      orders: {
        title: "Pedidos",
        open: "Abierto",
        parked: "Aplazado",
        finished: "Finalizado",
        error: "Error",
        noOrders: "No hay pedidos",
        showAllOrders: "Mostrar todos los pedidos",
        showLess: "Mostrar menos pedidos",
      },
      emails: {
        filters: "Filtros",
        category: "Categoría",
        name: "Nombre",
        address: "Dirección",
        actions: "Acciones",
        newEmail: "Nuevo correo electrónico",
        edit: "Editar",
        delete: "Eliminar",
        cancel: "Cancelar",
        submit: "Enviar",
        selectCategory: "Seleccionar categoría",
        invoice: "Factura",
        watchdog: "Watchdog",
        updateEmail: "Actualizar correo electrónico",
      },
      reports: {
        title: "Informes",
        reportType: "Tipo de informe",
        usage: "Uso",
        groupBy: "Agrupar por",
        field: "Campo",
        usageType: "Tipo de uso",
        selectUsageType: "Seleccionar tipo de uso",
        data: "Datos",
        sms: "SMS",
        all: "Todos",
        imsi: "IMSI",
        eid: "EID",
        network: "Red",
        customer: "Cliente",
        period: "Período",
        day: "Día",
        month: "Mes",
        year: "Año",
        today: "Hoy",
        "This Week": "Esta semana",
        "This Month": "Este mes",
        "This Year": "Este año",
        "Last Month": "Mes pasado",
        "Last Year": "Año pasado",
        customer: "Cliente",
        select: "Seleccionar",
        simSearchCriteria: "Criterios de búsqueda de SIM",
        bySpecificImsi: "Por IMSI específica",
        byImsiRange: "Por rango de IMSI",
        byIccid: "Por ICCID",
        startImsi: "IMSI de inicio",
        endImsi: "IMSI de fin",
        iccid: "ICCID",
        view: "Ver",
        customerId: "ID del cliente",
        date: "Fecha",
        startDate: "De",
        simType: "Tipo de SIM",
        networkCode: "Código de red",
        networkName: "Nombre de la red",
        country: "País",
        totalBytes: "Total de bytes",
        roundedBytes: "Bytes redondeados",
        sessions: "Sesiones",
        zeroSessions: "Sesiones cero",
        actions: "Acciones",
        export: "Exportar",
        description: "Descripción",
        quantity: "Cantidad",
        unitPrice: "Precio unitario",
        tax: "IVA",
        costWithoutTax: "Precio antes de impuestos",
        costWithTax: "Precio después de impuestos",
        currency: "Moneda",
        offerName: "Paquete",
        id: "ID",
        name: "Nombre",
        status: "Estado",
        creator: "Creador",
        creationDate: "Fecha de Creación",
        offer: "Paquete",
        activations: "Activaciones",
        terminations: "Terminaciones",
        automated: {
          title: "Informes automatizados",
          name: "Nombre",
          type: "Tipo",
          frequency: "Frecuencia",
          nextReport: "Próximo informe",
          new: "Nuevo informe automatizado",
          save: "Guardar",
          daily: "Diario",
          weekly: "Semanal",
          monthly: "Mensual",
          edit: "Editar",
          delete: "Eliminar",
          actions: "Acciones",
        },
        history: {
          title: "Historial de informes",
          tableHeaders: {
            reportName: "Nombre del informe",
            date: "Fecha",
            status: "Estado",
            download: "Descargar",
            actions: "Acciones",
          },
          delete: "Eliminar",
          completed: "Completado",
          incomplete: "Incompleto",
        },
      },
      timeoutReports: {
        view: "Ver",
        delete: "Eliminar",
      },
      alerts: {
        title: "Alertas",
        filters: "Filtros",
        alert: "Alerta",
        date: "Fecha",
        imsi: "IMSI",
        enterValue: "Ingrese valor",
      },
      settings: {
        title: "Configuraciones",
        profileSettings: "Configuración de perfil",
        general: "General",
        account: "Cuenta",
        profileImage: "Imagen de perfil",
        whitelabel: "Marca blanca",
        privacyAndSafety: "Privacidad y seguridad",
        notifications: "Notificaciones",
        billing: "Facturación",
        invoice: "Factura",
        importSim: "Importar Sim",
        mailConfig: "Servidor de correo",
        generalSettings: {
          title: "Configuración general",
          timeZone: "Zona horaria",
          dateFormat: "Formato de fecha",
          timeFormat: "Formato de hora",
          save: "Guardar",
        },
        accountSettings: {
          title: "Configuración de cuenta",
          fullName: "Nombre completo",
          address: "Dirección",
          city: "Ciudad",
          country: "País",
          postcode: "Código postal",
          telephone: "Teléfono",
          mobileNumber: "Número de móvil",
          email: "Correo electrónico",
          occupation: "Ocupación",
          company: "Empresa",
          tin: "Número de Identificación Fiscal",
          username: "Nombre de usuario",
          changePassword: "Cambiar contraseña",
          password: "Contraseña",
          confirmPassword: "Confirmar contraseña",
          save: "Guardar",
        },
        profileImageSettings: {
          title: "Configuración de imagen de perfil",
          upload: "Subir",
          save: "Guardar",
        },
        whitelabelSettings: {
          title: "Configuración de marca blanca",
          backgroundColor: "Color de fondo",
          fontColor: "Color de la fuente",
          accentColor: "Color de acento",
          sidebarPosition: "Posición de la barra lateral",
          favicon: "Favicon",
          whitelabelImage: "Imagen de marca blanca",
          upload: "Subir",
          save: "Guardar",
        },
        privacySettings: {
          title: "Configuración de privacidad",
          enable2FA: "Habilitar 2FA",
          save: "Guardar",
        },
        notificationSettings: {
          title: "Configuración de notificaciones",
          receiveNotifications: "Recibir notificaciones",
          sms: "SMS",
          email: "Correo electrónico",
          weeklyAnalytics: "Análisis semanales",
          checkIfYouWantToReceiveWeeklyAnalytics:
            "Marque si desea recibir análisis semanales",
          notifyAboutNewAlerts: "Notificar sobre nuevas alertas",
          checkIfYouWantToReceiveNotificationsWhenThereAreNewAlerts:
            "Marque si desea recibir notificaciones cuando haya nuevas alertas",
          submit: "Enviar",
        },
        billingSettings: {
          title: "Configuración de facturación",
          selectCurrency: "Seleccionar moneda",
          currency: "Moneda",
          preferredLanguage: "Idioma preferido",
          selectLanguage: "Seleccionar idioma",
          submit: "Enviar",
        },
        invoiceSettings: {
          title: "Configuración de factura",
          name: "Nombre",
          showGuis: "Mostrar GUI",
          showSubtotal: "Mostrar subtotal",
          showLineOfService: "Mostrar línea de servicio",
          save: "Guardar",
        },
        importSimSettings: {
          title: "Importar Sim",
          provider: "Proveedor",
          selectProvider: "Seleccione proveedor",
          submit: "Entregar",
          inputType: "Tipo de entrada",
          selectInputType: "Seleccione tipo de entrada",
          single: "Entrada única",
          file: "Entrada desde archivo",
        },
        mailConfig: {
          title: "Configuración del Servidor de Correo",
          host: "Dirección del host SMTP",
          port: "Puerto SMTP",
          fromAddress: "Dirección del remitente",
          username: "Nombre de usuario",
          changePassword: "Cambiar contraseña",
          password: "Contraseña",
          confirmPassword: "Confirmar contraseña",
          useTLS: "Usar TLS",
          save: "Guardar configuración",
          success: "Configuración del servidor de correo guardada con éxito",
          error: "No se pudo guardar la configuración del servidor de correo",
          healthStatus: "Estado de Salud",
          healthUp: "En Funcionamiento (UP)",
          healthDown: "No Funciona (DOWN)",
          healthUnknown: "Desconocido",
          lastCheckedAt: "Última Revisión",
        },
        purchaseOrderConfig: {
          title: "Configuración del pedido de compra",
          sellerName: "Nombre del vendedor",
          host: "Dirección del host SMTP",
          port: "Puerto SMTP",
          fromAddress: "Dirección del remitente",
          username: "Nombre de usuario",
          changePassword: "Cambiar contraseña",
          password: "Contraseña",
          confirmPassword: "Confirmar contraseña",
          useTLS: "Usar TLS",
          save: "Guardar configuración",
          success:
            "Configuración del servidor de correo guardada correctamente",
          error: "Error al guardar la configuración del servidor de correo",
          healthStatus: "Estado del sistema",
          healthUp: "En buen estado (UP)",
          healthDown: "Fuera de servicio (DOWN)",
          healthUnknown: "Desconocido",
          lastCheckedAt: "Última comprobación en",
        },
        platformConfig: {
          title: "Configuración de la plataforma",
          dataStreamingEnabled: "Transmisión de datos habilitada",
          maintenanceMode: "Modo de mantenimiento",
          maintenanceMessage: "Mensaje de mantenimiento",
          maintenanceMessagePlaceholder:
            "El sitio está en mantenimiento. Volveremos pronto.",
          save: "Guardar",
          reset: "Restablecer a valores predeterminados",
        },
        crmConfig: {
          title: "Configuración del CRM",
          type: "Tipo de CRM",
          authType: "Tipo de autenticación",
          selectAuthType: "Seleccione el tipo de autenticación",
          selectType: "Seleccione el tipo de CRM",
          username: "Nombre de usuario",
          changePassword: "¿Cambiar contraseña?",
          changeToken: "¿Cambiar token?",
          password: "Contraseña",
          confirmPassword: "Confirmar contraseña",
          token: "Token",
        },
      },
      privileges: {
        title: "Privilegios",
        name: "Nombre",
        actions: "Acciones",
        newPrivilege: "Nuevo privilegio",
        edit: "Editar",
        delete: "Eliminar",
      },
      table: {
        page: "Página",
        of: "de",
        show: "Mostrar",
        goToPage: "Ir a la página",
      },
      notifications: {
        title: "Notificaciones",
        id: "ID",
        date: "Fecha",
        message: "Mensaje",
        type: "Tipo",
      },
      whitelist: {
        title: "Dirección IP permitida",
        ip: "Dirección IP",
        active: "Activo",
        createdAt: "Fecha de adición",
        updatedAt: "Última actualización",
        lastUsed: "Último uso",
        new: "Nueva dirección IP",
      },
      customFields: {
        title: "Campos personalizados",
        new: "Nuevo campo personalizado",
        name: "Nombre",
        type: "Tipo",
        createdAt: "Fecha de creación",
        updatedAt: "Fecha de actualización",
        edit: "Editar",
        delete: "Eliminar",
        submit: "Enviar",
        cancel: "Cancelar",
        actions: "Acciones",
        selectType: "Seleccionar tipo",
        text: "Texto",
        number: "Número",
      },
      documentation: {
        introduction: {
          welcomeTitle: "Bienvenido a {{brand}}",
          welcomeText:
            "{{brand}} es tu plataforma todo-en-uno para gestionar fácilmente las tarjetas SIM. Supervisa el uso, activa nuevas líneas y mantén tus operaciones funcionando sin problemas—todo desde un solo panel de control.",
          getStarted: "Comenzar",
        },
        dashboard: {
          title: "Visión general del panel",
          description:
            "El panel es la pantalla principal para supervisar y analizar la actividad de las tarjetas SIM a través de la plataforma {{brand}}...",
          goal: "El objetivo del panel es proporcionar a los usuarios una herramienta inmediata de supervisión...",
          cards: {
            title: "Tarjetas de estadísticas (parte superior)",
            dataVolume: {
              title: "Volumen de datos",
              description:
                "Muestra el volumen total de datos consumidos hoy, junto con la comparación con el día anterior.",
            },
            dataSessions: {
              title: "Sesiones de datos",
              description:
                "Muestra el número de conexiones realizadas hoy, comparado con el día anterior.",
            },
            alerts: {
              title: "Alertas de consumo",
              description:
                "Muestra el número de alertas de consumo generadas hoy debido a la superación de umbrales.",
            },
            zeroSessions: {
              title: "Sesiones con consumo nulo",
              description:
                "Indica cuántas sesiones de datos registraron consumo nulo durante el período seleccionado.",
            },
          },
          charts: {
            title: "Gráficos y mapas detallados",
            dataSessionsMap: {
              title: "Distribución geográfica de conexiones de datos",
              description:
                "El mapa muestra los países con el mayor número de conexiones. Desde el menú en la esquina superior derecha de la tarjeta, puede seleccionar qué información mostrar: Data Sessions, Data Volume o Zero Sessions.",
            },
            avgDataAndActiveSims: {
              title: "Consumo medio de datos y SIM activas",
              description:
                "Muestra el consumo medio de datos por conexión y el número total de SIM activas.",
            },
            dataVolumePerHour: {
              title: "Distribución horaria del consumo de datos",
              description:
                "El gráfico muestra el consumo de datos por intervalos de tres horas y por día de la semana durante el mes actual, proporcionando una visión más completa de los momentos de mayor actividad de las SIM.",
            },
            monthlyDataVolume: {
              title: "Distribución mensual del consumo de datos",
              description:
                "El gráfico muestra la distribución mensual del consumo de datos durante los últimos 12 meses. Desde el menú en la esquina superior derecha de la tarjeta, puede seleccionar la información que desea mostrar: Data Sessions, Data Volume o Zero Sessions.",
            },
            topMetrics: {
              title: "Métricas principales",
              description:
                "Este gráfico muestra las tarjetas SIM con el mayor número de conexiones en el período seleccionado. Le permite identificar rápidamente las SIM más activas en su red, analizar patrones de uso, detectar usuarios intensivos y optimizar la asignación de recursos.",
            },
            dataVolumePerNetwork: {
              title: "Consumo de datos por red - SIM activas por red",
              description:
                "Estos gráficos ofrecen una visión comparativa de la actividad de red en el país seleccionado. El primero muestra la distribución del consumo total de datos entre las redes móviles, lo que ayuda a evaluar la carga, identificar concentraciones de uso y comparar el rendimiento de los operadores. El segundo muestra la distribución de las SIM activas entre las redes, proporcionando información sobre cobertura y cuota de mercado. Juntos ofrecen una comprensión completa de cómo sus SIM interactúan con las redes y destacan los patrones de conectividad y uso.",
            },
            simCardsPerOffer: {
              title: "Tarjetas SIM por oferta y estado",
              description:
                "Estos gráficos ofrecen una visión general de su cartera de SIM. El primero muestra la distribución por oferta y plan de datos, lo que le ayuda a identificar preferencias y los servicios más populares. El segundo muestra la distribución por estado, proporcionando visibilidad sobre las etapas del ciclo de vida y la disponibilidad. Juntos le ayudan a supervisar las tendencias de uso, los niveles de existencias y la eficiencia general en la gestión de SIM.",
            },
            alerts: {
              title: "Alertas de consumo",
              description:
                "Esta tabla muestra las alertas de consumo generadas por el mecanismo de supervisión WatchDog. WatchDog monitoriza de forma continua el uso de datos de las SIM y genera alertas cuando se alcanzan umbrales predefinidos.",
              types: {
                warning:
                  "Warning: se activa cuando el consumo alcanza el 80% del volumen asignado.",
                depleted:
                  "Depleted: se activa cuando el consumo alcanza el 100% del volumen asignado.",
              },
              note: "Estas alertas le ayudan a tomar medidas oportunas para evitar interrupciones del servicio o costes imprevistos. Un análisis más detallado de WatchDog y su lógica se presentará en el capítulo correspondiente de la documentación.",
            },
          },
          utility: {
            title: "Utilidad del panel",
            description:
              "Con una presentación unificada de métricas clave, tendencias y alertas, el panel permite detectar problemas rápidamente y tomar decisiones fundamentadas.",
          },
        },
        simCards: {
          introduction: {
            title: "Introducción a las tarjetas SIM",
            description:
              "Este capítulo proporciona toda la información necesaria sobre las tarjetas SIM dentro de la plataforma {{brand}}.",
            details:
              "Aprenderá cómo se gestionan, supervisan y analizan las SIM, con información sobre el consumo de datos, la conectividad, las alertas y las etapas del ciclo de vida.",
            getStarted: "Comenzar",
          },
          lifecycle: {
            title: "Ciclo de vida de la SIM",
            intro:
              "Las tarjetas SIM en la plataforma pasan por diferentes estados de ciclo de vida. Cada estado está representado por un círculo codificado por colores y tiene transiciones específicas permitidas.",
            status: {
              productive: "Activa y en uso.",
              suspended: "Suspendida manualmente.",
              autoSuspended: "Suspendida automáticamente.",
              onstock: "Disponible pero inactiva.",
              deleted: "Eliminada e inactiva.",
            },
            diagramDescription:
              "Este diagrama muestra los estados del ciclo de vida de la SIM y las posibles transiciones entre ellos. Las transiciones pueden activarse manualmente (por ejemplo, activar una SIM de OnStock a Productive) o automáticamente (como cuando un proceso del sistema suspende automáticamente una SIM cuando se alcanzan ciertos límites). Estas transiciones aseguran un control adecuado de la actividad, disponibilidad y desactivación de las SIM en la plataforma.",
          },
          panel: {
            title: "Panel de SIMs",
            intro:
              "El panel de SIMs proporciona una visión general de todas las tarjetas SIM en la plataforma. Permite supervisar la actividad, analizar el consumo de datos y gestionar eficazmente las etapas del ciclo de vida.",
            summary: {
              title: "Tarjetas Resumen y Filtros",
              intro:
                "En la parte superior del panel, tres tarjetas presentan una vista rápida del uso de las SIMs durante el mes actual:",
              dataVolume: "Volumen de Datos – datos totales consumidos.",
              dataSessions: "Sesiones de Datos – número de conexiones.",
              zeroSessions: "Sesiones Cero – sesiones sin datos.",
              filters:
                "Los filtros permiten restringir las SIMs por IMSI, ICCID, MSISDN, estado de la SIM, oferta, tipo de SIM o volumen de datos. La clasificación se puede aplicar a varios campos como IMSI o uso.",
            },
            table: {
              title: "Tabla de SIMs",
              intro:
                "La tabla principal enumera todas las tarjetas SIM con sus detalles clave:",
              activeSession: "Sesión Activa – indicador de actividad en vivo.",
              identifiers: "Identificadores – IMSI, ICCID, MSISDN.",
              state:
                "Estado de la SIM – estado del ciclo de vida (ej.: Activa, Suspendida).",
              offer: "Oferta – plan de suscripción (si aplica).",
              data: "Datos – volumen de uso del mes.",
              type: "Tipo de SIM – tipo de producto (ej.: integrada, industrial).",
              footer:
                "También se admiten la paginación y las operaciones masivas para una gestión eficiente de las SIMs.",
            },
          },
          simProvisioning: {
            introduction: {
              title: "Aprovisionamiento de SIM",
              description:
                "El aprovisionamiento de SIM se refiere al conjunto de funcionalidades que permiten a los administradores gestionar el ciclo de vida de las tarjetas SIM dentro de la plataforma. A través del aprovisionamiento, usted puede:",
              closing:
                "Estas acciones garantizan que las SIM se aprovisionen, controlen y desactiven correctamente, apoyando tanto la flexibilidad operativa como la seguridad.",
            },
            actions: {
              activate: {
                title: "Activar",
                description: "poner una SIM lista para uso productivo.",
                details: {
                  intro: "Para activar una o más SIMs existen tres formas:",
                  steps: [
                    "Seleccionando las SIMs de la tabla marcando las casillas de verificación y desde el menú Operaciones Masivas en la parte superior derecha, elegir Activar.",
                    "Haciendo clic directamente en el mismo menú y cargando un archivo Excel que contenga los números IMSI/ICCID en la columna A con el título correspondiente (IMSI/ICCID) en la celda A1.",
                    "Haciendo clic en la fila, se abrirá una tarjeta lateral con el perfil de la SIM, en la parte superior de la cual habrá un botón Activar.",
                  ],
                  important:
                    "¡Importante! Todas las SIMs seleccionadas deben estar en estado En Stock para poder ser activadas.",
                  closing:
                    "Tras los pasos descritos, aparecerá un modal de confirmación con dos pasos: el usuario debe seleccionar la Oferta con la que desea activar las SIMs. Opcionalmente, puede establecer algunos valores de campos personalizados. En el segundo paso, el usuario revisa las SIMs seleccionadas y procede con la activación.",
                },
              },
              suspend: {
                title: "Suspender",
                description: "deshabilitar temporalmente la conectividad.",
                details: {
                  intro:
                    "De manera similar a la activación, para suspender una o más SIMs el usuario tiene las mismas opciones:",
                  steps: [
                    "Seleccionando las SIMs de la tabla marcando las casillas de verificación y desde el menú Operaciones Masivas en la parte superior derecha, elegir Suspender.",
                    "Haciendo clic directamente en el mismo menú y cargando un archivo Excel que contenga los números IMSI/ICCID en la columna A con el título correspondiente (IMSI/ICCID) en la celda A1.",
                    "Haciendo clic en la fila, se abrirá una tarjeta lateral con el perfil de la SIM, en la parte superior de la cual habrá un botón Suspender.",
                  ],
                  important:
                    "¡Importante! Todas las SIMs seleccionadas deben estar en estado Productivo para poder ser suspendidas.",
                  closing:
                    "Tras los pasos descritos, aparecerá un modal de confirmación en el que el usuario revisa las SIMs seleccionadas y procede con la suspensión.",
                },
              },
              resume: {
                title: "Reanudar",
                description: "reactivar una SIM suspendida.",
                details: {
                  intro:
                    "De igual forma, para reanudar una o más SIMs el usuario tiene las mismas opciones:",
                  steps: [
                    "Seleccionando las SIMs de la tabla marcando las casillas de verificación y desde el menú Operaciones Masivas en la parte superior derecha, elegir Reanudar.",
                    "Haciendo clic directamente en el mismo menú y cargando un archivo Excel que contenga los números IMSI/ICCID en la columna A con el título correspondiente (IMSI/ICCID) en la celda A1.",
                    "Haciendo clic en la fila, se abrirá una tarjeta lateral con el perfil de la SIM, en la parte superior de la cual habrá un botón Reanudar.",
                  ],
                  important:
                    "¡Importante! Todas las SIMs seleccionadas deben estar en estado Suspendido o AutoSuspendido para poder ser reanudadas.",
                  closing:
                    "Tras los pasos descritos, aparecerá un modal de confirmación en el que el usuario revisa las SIMs seleccionadas y procede con la reanudación.",
                },
              },
              terminate: {
                title: "Terminar",
                description:
                  "retirar una SIM del uso activo (ya sea a En Stock o Eliminada).",
                details: {
                  intro:
                    "De la misma manera, para terminar una o más SIMs el usuario tiene las mismas opciones:",
                  steps: [
                    "Seleccionando las SIMs de la tabla marcando las casillas de verificación y desde el menú Operaciones Masivas en la parte superior derecha, elegir Terminar.",
                    "Haciendo clic directamente en el mismo menú y cargando un archivo Excel que contenga los números IMSI/ICCID en la columna A con el título correspondiente (IMSI/ICCID) en la celda A1.",
                    "Haciendo clic en la fila, se abrirá una tarjeta lateral con el perfil de la SIM, en la parte superior de la cual habrá un botón Terminar.",
                  ],
                  important:
                    "¡Importante! Todas las SIMs seleccionadas deben estar en estado Productivo para poder ser terminadas.",
                  closing:
                    "Tras los pasos descritos, aparecerá un modal de confirmación en el que el usuario selecciona el estado final de la terminación (En Stock o Eliminada Permanentemente), revisa las SIMs seleccionadas y procede con la terminación.",
                },
              },
              modify: {
                title: "Modificar",
                description:
                  "modifique la Oferta bajo la cual la tarjeta está activada y facturada.",
                details: {
                  intro: "Para modificar la oferta de una SIM:",
                  steps: [
                    "Seleccionando la SIM de la tabla marcando su casilla de verificación y desde el menú Acciones en la parte superior derecha, elegir Modificar.",
                  ],
                  important:
                    "¡Importante! La SIM seleccionada debe estar en estado Productivo para poder ser modificada.",
                  closing:
                    "Tras los pasos descritos, aparecerá un modal de confirmación en el que el usuario debe seleccionar la oferta de destino deseada para la SIM. Luego revisa la SIM seleccionada y procede con la modificación.",
                },
              },
            },
          },
          simProfile: {
            title: "Perfil SIM",
            description:
              "El Perfil SIM es un panel que se centra en las estadísticas y funcionalidades de una sola tarjeta SIM. Ofrece estadísticas similares al panel principal e información detallada para análisis y gestión.",
            items: {
              kpis: "KPIs y estadísticas de uso",
              monthly: "Distribución mensual del uso",
              hlr: "Perfil HLR (si aplica)",
              dataSessions: "Historial de sesiones de datos",
              smsUsage: "Historial de uso de SMS",
              requests: "Solicitudes realizadas para esta SIM",
              provisioning:
                "Actividad y funcionalidades de aprovisionamiento SIM",
              cellInfo: "Información de celda y detalles de conectividad",
              watchdogs: "Información y alertas de watchdog",
            },
            sections: {
              howToAccess: {
                title: "Cómo acceder",
                description:
                  "Para acceder al perfil de una tarjeta SIM específica, seleccione la SIM de la tabla y haga clic en ella. Se abrirá un panel lateral mostrando la información de la SIM. Dentro de este panel, hay un enlace 'Visitar Perfil' que redirige a la página completa del Perfil SIM. La página de Perfil SIM proporciona estadísticas detalladas, historial de uso, acciones de aprovisionamiento e información técnica sobre la SIM seleccionada.",
              },
              kpis: {
                title: "Indicadores Clave (KPIs)",
                description:
                  "La sección de KPIs del perfil SIM proporciona una visión rápida del rendimiento y la actividad de la SIM. Estos indicadores ayudan al usuario a comprender el uso y el estado actual de la SIM de un vistazo.",
                bullets: [
                  "Volumen de Datos – la cantidad total de datos consumidos por la SIM en el período seleccionado.",
                  "Sesiones de Datos – el número de sesiones de datos establecidas durante el período seleccionado.",
                  "Alertas – el número de alertas activadas para esta SIM (p. ej., umbrales de uso).",
                  "Sesiones Cero – el número de sesiones en las que la SIM intentó conectarse pero no consumió datos.",
                ],
                closing:
                  "En la parte superior derecha, el usuario puede filtrar los KPIs por período (Diario, Mensual o Anual) para analizar los patrones de uso a lo largo del tiempo.",
              },
              monthly: {
                title: "Distribución mensual",
                description: "Distribución de datos, SMS y sesiones por mes.",
              },
              hlr: {
                title: "Perfil HLR",
                description:
                  "El perfil HLR (Home Location Register) proporciona información detallada de suscripción y red de la tarjeta SIM. Al hacer clic en el botón HLR en el menú Acciones, aparece una ventana con detalles como:",
                fields: {
                  msisdn: "MSISDN",
                  imsi: "IMSI",
                  networkAccessMode: "Modo de acceso a la red (ej. CS y PS)",
                  subscriberType: "Tipo de suscriptor (ej. suscriptor LTE)",
                  simStatus: "Estado de la SIM (ej. Disponible)",
                },
                scopes:
                  "Además, el usuario puede seleccionar en una lista desplegable los ámbitos disponibles (ej. Información básica, Información extendida) para visualizar los detalles correspondientes según el nivel de información requerido.",
                closing:
                  "Esta funcionalidad permite a los administradores validar rápidamente los detalles de aprovisionamiento de la SIM y confirmar si la SIM está correctamente registrada y disponible en la red.",
              },

              dataSessions: {
                title: "Sesiones de datos",
                description:
                  "La funcionalidad de Sesiones de datos permite a los administradores visualizar registros detallados de todas las sesiones de datos asociadas a una tarjeta SIM. Al hacer clic en el botón Sesiones en el menú Acciones, aparece una ventana modal que muestra el historial de sesiones y los detalles correspondientes.",
                fields: {
                  openDate: "Marca de tiempo cuando se inició la sesión",
                  closeDate: "Marca de tiempo cuando finalizó la sesión",
                  consumption:
                    "Cantidad real de bytes consumidos durante la sesión",
                  roundedBytes:
                    "Uso redondeado según las políticas de facturación del operador",
                  operator: "El operador de red que gestionó la sesión",
                  cell: "El ID de celda donde se estableció la sesión",
                  imei: "Identificador del dispositivo (IMEI) utilizado en la sesión",
                },
              },
              smsUsage: {
                title: "Uso de SMS",
                description:
                  "La ventana de uso de SMS permite a los administradores supervisar todos los mensajes SMS enviados y recibidos por la tarjeta SIM. Al hacer clic en el botón Uso de SMS en el menú Acciones, aparece una tabla detallada con cada transacción SMS.",
                fields: {
                  direction: "Dirección (p. ej., Entrante o Saliente)",
                  date: "Fecha y hora del evento SMS",
                  sender: "Remitente del SMS",
                  message: "Contenido del mensaje SMS (si está disponible)",
                  status:
                    "Estado de entrega (p. ej., Enviado, Entregado, Fallido)",
                },
                note: "Esta funcionalidad proporciona una trazabilidad completa del tráfico SMS con fines de resolución de problemas, cumplimiento o análisis de uso.",
              },
              requests: {
                title: "Solicitudes",
                description:
                  "La sección Solicitudes proporciona un historial completo de todas las órdenes de aprovisionamiento realizadas para la tarjeta SIM seleccionada. Al hacer clic en el botón Solicitudes en el menú de Acciones, aparece una ventana modal que muestra todas las órdenes, como Activar, Suspender, Reanudar y Terminar.",
                fields: {
                  id: "ID: El identificador único de la orden.",
                  name: "Nombre: El tipo de acción (p. ej., SuspendSIM, ResumeSIM, TerminateSIM).",
                  status:
                    "Estado: El estado de ejecución de la orden (p. ej., Completada, Pendiente).",
                  creator: "Creador: El usuario que inició la solicitud.",
                  creationDate: "Fecha de creación: Cuándo se creó la orden.",
                  lastUpdate:
                    "Última actualización: La marca de tiempo más reciente del estado.",
                },
                note: "Esta funcionalidad permite a los administradores rastrear todas las actividades de aprovisionamiento realizadas en la SIM, garantizando transparencia y responsabilidad en la gestión del ciclo de vida.",
              },
              provisioning: {
                title: "Actividad de aprovisionamiento",
                description:
                  "Acciones de aprovisionamiento como activación, suspensión y modificación.",
              },
              cellInfo: {
                title: "Información de celda",
                description:
                  "Información sobre la celda y detalles de la conexión de la SIM.",
              },
              watchdogs: {
                title: "Watchdogs",
                description:
                  "La sección de Watchdogs en el perfil SIM muestra los watchdogs configurados asociados a la tarjeta SIM. Estos watchdogs suelen definirse a nivel de plataforma y vincularse a una SIM para supervisar condiciones específicas.",
                bullets: [
                  "Ver la lista de watchdogs activos asociados a la SIM.",
                  "Comprobar su configuración (por ejemplo, tipo de watchdog, estado y límites asignados).",
                  "Seguir qué watchdogs están supervisando actualmente la actividad de la SIM.",
                ],
                note: "Nota: La configuración de umbrales, alertas o acciones automáticas no está disponible desde el propio perfil SIM. Esta sección es de solo lectura y sirve únicamente para monitorización.",
              },
            },
          },
          simTransfers: {
            title: "Transferencias de SIM",
            description:
              "La funcionalidad de transferencia de SIM permite a los administradores mover tarjetas SIM entre cuentas o entidades. Es útil para reasignar SIMs, enviarlas a otra organización o gestionar cambios de propiedad.",

            howToAccess: {
              title: "Cómo acceder",
              description:
                "Para acceder a las transferencias de SIM, vaya a la sección de Gestión de usuarios, abra el menú de Acciones de un usuario y seleccione la opción 'Enviar SIMs'.",
            },

            steps: {
              title: "Pasos para realizar una transferencia de SIM",
              description:
                "El proceso de transferencia consta de los siguientes pasos:",
              bullets: [
                "Asegúrese de que las tarjetas SIM estén en estado 'En Stock' antes de iniciar la transferencia. Solo las SIM disponibles pueden transferirse entre cuentas.",
                "Elija un tipo de selección de SIM: IMSI único, ICCID único, rango IMSI, rango ICCID o carga de archivo CSV/XLSX. Esto determina cómo identificar las SIM a transferir.",
                "Ingrese o cargue los identificadores SIM requeridos según el tipo de selección.",
                "Opcionalmente defina precio e IVA. Estos campos ayudan a registrar el impacto financiero de la transferencia.",
                "Seleccione una Oferta de facturación. Esta es la oferta que se cargará a la cuenta de origen cuando la cuenta de destino active la SIM transferida.",
                "Haga clic en 'Enviar' para completar la transferencia. Una vez confirmadas, las SIM aparecerán en el inventario de la cuenta de destino.",
              ],
            },
            deallocate: {
              title: "Desasignar SIMs",
              description:
                "La desasignación es el procedimiento inverso de una transferencia de SIM. Permite a los usuarios eliminar tarjetas SIM de una cuenta de destino y devolverlas a la cuenta de origen o al inventario. Esto es útil cuando las SIMs se asignaron por error, ya no son necesarias o deben reasignarse.",
              bullets: [
                "Vaya a la sección de Gestión de Usuarios, abra el menú Acciones de un usuario y seleccione 'Desasignar SIMs'.",
                "Asegúrese de que las SIMs estén en estado 'En Stock' o 'Asignadas' antes de intentar desasignarlas.",
                "Elija un tipo de selección de SIM: IMSI único, ICCID único, Rango de IMSI, Rango de ICCID o archivo CSV/XLSX.",
                "Introduzca o cargue los identificadores de las SIMs que desea desasignar.",
                "Confirme las cuentas de origen y destino. El campo 'De' muestra la cuenta actual y el campo 'A' muestra la cuenta o inventario al que se devolverán las SIMs.",
                "Haga clic en 'Enviar' para completar la desasignación. Una vez confirmadas, las SIMs ya no aparecerán en el inventario de la cuenta de destino y estarán disponibles para su reasignación.",
              ],
            },
          },
        },
        watchdog: {
          title: "Watchdog",
          description:
            "Los Watchdogs son reglas de supervisión que ayudan a los usuarios a controlar el uso de las tarjetas SIM y detectar comportamientos anómalos. Permiten una gestión proactiva definiendo umbrales en métricas como volumen de datos, sesiones o uso de SMS. Cuando se supera un umbral, el sistema puede generar alertas o activar acciones para evitar un uso indebido o costes inesperados.",
          items: {
            add: "Cómo añadir un Watchdog",
            remove: "Cómo eliminar un Watchdog",
            reset: "Cómo restablecer un Watchdog",
            suspensionBlock:
              "Bloquear la suspensión de la SIM en el período de facturación actual",
            alerts: "Alertas generadas por los Watchdogs",
          },
          add: {
            title: "Añadir Watchdog",
            description:
              "Los usuarios pueden crear un nuevo watchdog para supervisar la actividad de la SIM y activar acciones automáticas cuando el uso supera los umbrales definidos. Esto ayuda a garantizar una gestión proactiva y control de costes.",
            howToAccess:
              "Para añadir un nuevo watchdog, vaya al Panel SIM → Operaciones masivas → Watchdogs → Crear Watchdog. Importante: todas las tarjetas SIM deben estar en estado Productive (activadas) para configurar un watchdog.",
            fields: {
              actionType:
                "Seleccione la acción a realizar cuando se alcance el umbral (p. ej., notificar, suspender).",
              interval:
                "Elija el período de supervisión (diario, semanal, mensual).",
              amount: "Introduzca el umbral de uso que activará la acción.",
              service:
                "Seleccione el servicio a supervisar (p. ej., Datos, SMS).",
              unitType:
                "Elija la unidad de medida (p. ej., Bytes, número de SMS).",
              warnings:
                "Defina umbrales de advertencia anticipada antes de la acción principal para notificar a los usuarios con antelación.",
              suspendInterval:
                "Define cuánto tiempo permanece suspendida la SIM una vez que se activa el watchdog. Si es diario, la SIM se reanudará automáticamente a la medianoche del día siguiente. Si es semanal, a la medianoche del próximo lunes. Si es mensual, a la medianoche del primer día del siguiente mes.",
            },
          },
          removeAll: {
            title: "Eliminar Todos los Watchdogs",
            description:
              "Los usuarios pueden eliminar todos los watchdogs configurados de una tarjeta SIM en una sola acción. Esto es útil para restablecer rápidamente la supervisión sin tener que borrar cada watchdog individualmente.",
            howToAccess:
              "Para eliminar todos los watchdogs, vaya al panel SIM → seleccione tarjetas SIM activas → Operaciones en lote → Watchdogs → Eliminar Todos los Watchdogs.",
            details: {
              title: "Detalles",
              immediateEffect:
                "Al ejecutarse, todas las configuraciones de watchdog existentes en las SIM seleccionadas serán eliminadas.",
              noAlerts:
                "Después de la eliminación no se generarán alertas ni acciones automáticas.",
              cleanSlate:
                "La SIM seguirá funcionando normalmente, pero sin supervisión hasta que se creen nuevos watchdogs.",
            },
            useCases: {
              title: "Casos de Uso",
              policyChanges:
                "Cuando cambian las políticas de supervisión, puede ser necesario borrar los watchdogs existentes.",
              testing:
                "En entornos de prueba, se pueden crear y eliminar muchos watchdogs rápidamente para limpieza.",
              errorRecovery:
                "Si existen watchdogs mal configurados o en conflicto, la eliminación los reinicia a un estado neutral.",
            },
            considerations: {
              title: "Consideraciones",
              irreversible:
                "La eliminación de todos los watchdogs no se puede deshacer; deberán crearse de nuevo si son necesarios.",
              criticalMonitoring:
                "Asegúrese de que las SIM no queden sin supervisión en entornos críticos.",
              bulkOperations:
                "En operaciones en lote, revise cuidadosamente ya que todas las SIM seleccionadas se verán afectadas.",
            },
          },
          reset: {
            title: "Restablecer Watchdog",
            description:
              "Restablecer un watchdog borra el contador de consumo y restablece la suspensión si el usuario había elegido bloquearla para el período de facturación actual. Esto permite reiniciar la supervisión sin necesidad de crear un nuevo watchdog.",
            howToAccess: {
              title: "Cómo acceder",
              description:
                "Vaya al perfil de la tarjeta SIM. En la sección Watchdog, haga clic en el icono de flecha circular junto al watchdog correspondiente para restablecerlo.",
            },
          },
          blockSuspension: {
            title: "Bloquear Suspensión",
            description:
              "Bloquear la suspensión evita que una tarjeta SIM se suspenda cuando un watchdog que monitoriza su consumo activa una alerta de consumo al 100 % (Depleted Alert). Esta funcionalidad solo es válida para el período de facturación actual. Al inicio del siguiente período, la suspensión se restablece automáticamente.",
            howToAccess: {
              title: "Cómo acceder",
              description:
                "Seleccione las tarjetas SIM en estado 'Productivo' desde el panel SIM. Luego, abra Operaciones Masivas → Watchdogs → Bloquear Suspensión.",
            },
          },
          alerts: {
            title: "Alertas",
            description:
              "Los watchdogs que supervisan el consumo de las SIM generan alertas. Las alertas ayudan a los usuarios a controlar los umbrales de uso y a tomar medidas cuando sea necesario.",
            typesTitle: "Tipos de Alertas",
            types: {
              depleted:
                "Agotada: Generada para todos los watchdogs. Se activa cuando una tarjeta SIM alcanza el 100% de su consumo.",
              warning:
                "Advertencia: Generada opcionalmente para los watchdogs que han definido límites de advertencia.",
            },
            howToAccess: {
              title: "Cómo acceder",
              description:
                "Para ver las alertas, vaya al menú 'Alertas' en la barra lateral. La tabla muestra las alertas ordenadas por fecha (la más reciente primero) e incluye filtros por tipo, fecha e IMSI.",
            },
          },
        },
        reports: {
          intro: {
            title: "Informes",
            description:
              "La plataforma ofrece a los usuarios la capacidad de visualizar y exportar una amplia variedad de informes, como el consumo de tarjetas SIM, listas de facturas, detalles de líneas de factura, solicitudes de aprovisionamiento de SIM, actividad de cartera (activaciones y terminaciones por oferta), distribución de estados de las tarjetas SIM y sesiones activas de SIM. Además, se pueden crear informes automatizados de uso y de visión general de SIM que se generan a intervalos fijos en formato descargable. Este capítulo se centra en tres subcapítulos.",
            subchaptersTitle: "Subcapítulos",
            subchapters: {
              single: "Informe único",
              automated: "Informe automatizado",
              history: "Historial de informes",
            },
          },
          single: {
            title: "Informe Único",
            description:
              "Los informes únicos permiten a los usuarios generar informes específicos sobre consumo de SIM, facturas, actividad de cartera, solicitudes de aprovisionamiento o sesiones. Estos informes pueden personalizarse según criterios, agruparse y exportarse para un análisis más detallado.",

            howToAccess: {
              title: "Acceso",
              description:
                "Para acceder a los Informes Únicos, vaya a la sección de Informes en la barra lateral y seleccione 'Generar Informe'.",
            },

            usageReport: {
              title: "Informe de Uso",
              description:
                "El Informe de Uso proporciona información detallada sobre el consumo de SIM para Datos o SMS, con opciones flexibles de agrupación y filtrado.",
              bullets: [
                "Seleccione 'Usage' como Tipo de Informe.",
                "Seleccione Tipo de Uso: Datos o SMS.",
                "Agrupar por Campo: IMSI, Red, Cliente o sin agrupación.",
                "Agrupar por Período: Día, Mes o Año.",
                "Opcionalmente filtre por SIM: IMSI específico, rango IMSI o ICCID.",
                "Haga clic en 'Ver' para generar el informe.",
              ],
            },
            invoiceList: {
              title: "Lista de Facturas",
              description:
                "El informe Lista de Facturas proporciona un resumen de todas las facturas emitidas a la cuenta. Incluye información clave como número de factura, fecha de emisión, fecha de vencimiento, importe total y estado del pago. Los usuarios pueden filtrar facturas por rango de fechas para localizar rápidamente los documentos de facturación.",
              bullets: [
                "Vaya a Informes → Generar Informe.",
                "Seleccione 'Lista de Facturas' como tipo de informe.",
                "Defina el rango de fechas (Desde – Hasta) para limitar la lista de facturas.",
                "Haga clic en 'Ver' para generar el informe.",
                "La tabla resultante muestra las facturas con detalles como número, fecha de emisión, fecha de vencimiento, importe total y estado del pago.",
              ],
            },
            orders: {
              title: "Informe de Pedidos",
              description:
                "El informe de Pedidos permite al usuario ver todas las órdenes de aprovisionamiento relacionadas con tarjetas SIM. Proporciona una visión histórica de los pedidos creados durante el período seleccionado.",
              bullets: [
                "Accesible a través de Informes → Generar Informe → Pedidos.",
                "Permite filtrar por rango de fechas (período).",
                "Muestra una lista de órdenes de aprovisionamiento SIM.",
              ],
            },
            portfolioActivity: {
              title: "Informe de Actividad del Portafolio",
              description:
                "El informe de Actividad del Portafolio proporciona una visión general de la actividad de las tarjetas SIM, incluidas activaciones, terminaciones y cambios por oferta. Ayuda a los usuarios a seguir la evolución de su portafolio de SIM a lo largo del tiempo.",
              bullets: [
                "Accesible a través de Informes → Generar Informe → Actividad del Portafolio.",
                "Permite filtrar el informe por período (De–A).",
                "Muestra activaciones, terminaciones y actividad agrupadas por oferta.",
              ],
            },
            customerSimSessions: {
              title: "Informe de Sesiones SIM de Clientes",
              description:
                "El informe de Sesiones SIM de Clientes muestra información sobre las sesiones SIM activas y pasadas de los clientes. Ayuda a rastrear cuándo y cómo las tarjetas SIM se conectan a la red.",
              bullets: [
                "Accesible a través de Informes → Generar Informe → Sesiones SIM de Clientes.",
                "Muestra detalles de la sesión como IMSI, hora de inicio y fin, y datos transferidos.",
                "Útil para solucionar problemas de conectividad y analizar patrones de uso de SIM.",
              ],
            },
            simOverview: {
              title: "Informe de Resumen de SIM",
              description:
                "El informe de Resumen de SIM proporciona una vista general de las tarjetas SIM en el sistema, mostrando su distribución por estado, asignación y actividad. Ayuda a los administradores a evaluar rápidamente toda la flota de SIM.",
              bullets: [
                "Accesible a través de Informes → Generar Informe → Resumen de SIM.",
                "Muestra las SIM agrupadas por estados como Activa, Suspendida, Terminada o En Stock.",
                "Útil para supervisar el estado y la distribución de las SIM de un vistazo.",
              ],
            },
            simList: {
              title: "Informe de Lista de SIM",
              description:
                "El informe de Lista de SIM proporciona un inventario detallado de todas las tarjetas SIM en el sistema. Incluye identificadores como IMSI e ICCID, su estado actual y detalles de asignación.",
              bullets: [
                "Accesible a través de Informes → Generar Informe → Lista de SIM.",
                "Muestra cada SIM con IMSI, ICCID y estado actual.",
                "Útil para auditar y gestionar el inventario completo de SIM.",
              ],
            },
            exportReport: {
              title: "Exportar Informe a Archivo",
              description:
                "Todos los informes generados pueden exportarse a un archivo para análisis posterior o para compartir. Las opciones de exportación incluyen los formatos CSV y PDF.",
              bullets: [
                "Accesible a través de Acciones → Exportar → CSV o PDF.",
                "El formato CSV es útil para análisis de datos en Excel u otras hojas de cálculo.",
                "El formato PDF es útil para compartir informes en formato fijo.",
              ],
            },
            timeoutReports: {
              title: "Informes con Tiempo de Espera",
              description:
                "Cada generación de informes tiene un límite de tiempo de 15 segundos. Cuando se supera este límite, el informe continúa generándose en segundo plano.",
              bullets: [
                "Una notificación informa al usuario cuando un informe alcanza el tiempo de espera.",
                "Cuando el informe está listo, se recibe una notificación push.",
                "El informe generado se puede ver desde Acciones → Ver.",
                "Los informes con tiempo de espera también pueden exportarse a CSV o PDF, al igual que los informes instantáneos.",
              ],
            },
          },
          automated: {
            title: "Informes Automatizados",
            description:
              "Los Informes Automatizados permiten a los usuarios programar la generación de informes en intervalos fijos y en un formato elegido.",
            overview: {
              title: "Descripción General",
              description:
                "Los Informes Automatizados se crean una vez y luego se generan automáticamente con la frecuencia y el formato seleccionados.",
              bullets: [
                "Los informes pueden programarse diariamente, semanalmente o mensualmente.",
                "Los informes pueden generarse en formato CSV o PDF.",
                "Tipos de informes disponibles: Uso y Vista General de SIM de Cliente.",
              ],
            },
            create: {
              title: "Crear un Informe Automatizado",
              description:
                "Para crear un nuevo informe automatizado, haga clic en el botón situado en la parte superior derecha de la tarjeta. Aparecerá un formulario que requerirá cierta información:",
              bullets: [
                "Nombre: El nombre del informe.",
                "Frecuencia del informe: Diario, semanal o mensual.",
                "Formato del informe: CSV o PDF.",
                "Tipo de informe: Elija entre Uso y Vista General de SIM de Cliente.",
                "Dependiendo del tipo de informe, pueden aparecer campos adicionales, similares al menú Generar Informe.",
              ],
            },
          },
          history: {
            title: "Historial de Informes",
            description:
              "La sección Historial de Informes proporciona una lista de los resultados de todas las ejecuciones de Informes Automatizados. Cada entrada incluye el nombre del informe, la fecha de generación, el estado, la opción de descarga y la posibilidad de eliminar el informe.",
            reportHistory: {
              title: "Visualización de Resultados de Informes Automatizados",
              description:
                "Desde la sección Historial de Informes, los usuarios pueden:",
              bullets: [
                "Visualizar los resultados de todos los Informes Automatizados ejecutados.",
                "Comprobar el estado de ejecución (Completado, Pendiente, Fallido).",
                "Descargar los archivos generados en formato CSV o PDF.",
                "Eliminar una entrada de informe mediante el menú Acciones.",
              ],
            },
          },
        },
      },
    },
  },
  ar: {
    translation: {
      sidebar: {
        dashboard: "لوحة التحكم",
        crm: "إدارة علاقات العملاء",
        admins: "المسؤولون",
        tenants: "المستأجرون",
        managers: "المديرون",
        customers: "العملاء",
        subaccounts: "الحسابات الفرعية",
        sims: "شرائح SIM",
        account: "الحساب",
        profile: "الملف الشخصي",
        billingProducts: "منتجات الفوترة",
        invoices: "الفواتير",
        statements: "الكشوفات",
        orders: "الطلبات",
        emails: "البريد الإلكتروني",
        reports: "التقارير",
        generateReport: "إنشاء تقرير",
        automatedReports: "تقارير آلية",
        reportHistory: "سجل التقارير",
        alerts: "التنبيهات",
        notifications: "الإشعارات",
        support: "الدعم",
        privileges: "الامتيازات",
        settings: "الإعدادات",
        services: "خدمات",
        documentation: "التوثيق",
        whitelist: "عنوان IP المسموح به",
        customFields: "الحقول المخصصة",
        simProducts: "منتجات الشريحة",
        purchaseSims: "شراء شرائح SIM",
        health: "صحة النظام",
        purchaseOrders: "طلبات بطاقات SIM",
      },
      dashboard: {
        dataVolume: "حجم البيانات",
        dataSessions: "جلسات البيانات",
        alerts: "التنبيهات",
        zeroSessions: "جلسات صفرية",
        sinceYesterday: "منذ الأمس",
        sinceLastMonth: "منذ الشهر الماضي",
        sinceLastYear: "منذ العام الماضي",
        averageVolume: "متوسط حجم البيانات",
        activeSims: "شرائح SIM النشطة",
        dataVolumePerHour: "حجم البيانات لكل ساعة",
        topMetrics: "أهم المقاييس",
        simCardsPerOffer: "شرائح SIM لكل عرض",
        simInventory: "توزيع شرائح SIM حسب الحالة",
        dataVolumePerNetwork: "حجم البيانات لكل شبكة",
        selectCountry: "اختر البلد",
        networksDistribution: "توزيع شرائح SIM النشطة حسب الشبكة",
        watchdogAlerts: "تنبيهات الاستهلاك",
        noData: "لا توجد بيانات متاحة",
        daily: "يومي",
        monthly: "شهري",
        yearly: "سنوي",
      },
      crm: {
        admins: "المسؤولون",
        tenants: "المستأجرون",
        managers: "المديرون",
        customers: "العملاء",
        subaccounts: "الحسابات الفرعية",
        filters: "فلاتر",
        fullName: "الاسم الكامل",
        company: "الشركة",
        email: "البريد الإلكتروني",
        address: "العنوان",
        city: "المدينة",
        country: "البلد",
        postcode: "الرمز البريدي",
        telephone: "الهاتف",
        mobile: "الهاتف المحمول",
        occupation: "المهنة",
        tin: "الرقم الضريبي",
        username: "اسم المستخدم",
        role: "الدور",
        actions: "الإجراءات",
        edit: "تعديل",
        delete: "حذف",
        billing: "الفوترة",
        whitelabeling: "العلامة البيضاء",
        offers: "العروض",
        impersonate: "انتحال",
        permissions: "الأذونات",
        sendWelcomeEmail: "إرسال بريد الترحيب",
        resetPassword: "إعادة تعيين كلمة المرور",
        initializeSIMs: "تهيئة شرائح SIM",
        initializeAlerts: "تهيئة التنبيهات",
        newTenant: "مستأجر جديد",
        newManager: "مدير جديد",
        newCustomer: "عميل جديد",
        newSubaccount: "حساب فرعي جديد",
        registerPayment: "تسجيل الدفع",
        accountId: "معرّف الحساب",
        registerPayment: {
          title: "تسجيل الدفع",
          amount: "المبلغ",
          currency: "العملة",
          invoice: "رقم الفاتورة",
          submit: "إرسال",
          cancel: "إلغاء",
          selectCurrency: "اختر العملة",
          selectInvoice: "اختر الفاتورة",
        },
        creditNote: {
          title: "إشعار دائن",
          amount: "المبلغ",
          vat: "ضريبة القيمة المضافة",
          reason: "السبب",
          submit: "إرسال",
          cancel: "إلغاء",
        },
        invoiceCycle: {
          title: "إعادة تشغيل دورة الفوترة",
        },
        newModal: {
          newTenant: "إنشاء مستأجر",
          newManager: "إنشاء مدير",
          newCustomer: "إنشاء عميل",
          newSubaccount: "إنشاء حساب فرعي",
          fullName: "الاسم الكامل",
          address: "العنوان",
          city: "المدينة",
          country: "البلد",
          postcode: "الرمز البريدي",
          telephone: "الهاتف",
          mobile: "الهاتف المحمول",
          email: "البريد الإلكتروني",
          occupation: "المهنة",
          company: "الشركة",
          tin: "الرقم الضريبي",
          username: "اسم المستخدم",
          sendWelcomeEmail: "إرسال بريد الترحيب",
          cancel: "إلغاء",
          submit: "إرسال",
          next: "التالي",
          previous: "السابق",
          preferredLanguage: "اللغة المفضلة",
          billingEmail: "البريد الإلكتروني للفوترة",
          currency: "العملة",
        },
        editModal: {
          editTenant: "تعديل المستأجر",
          editManager: "تعديل المدير",
          editCustomer: "تعديل العميل",
          editSubaccount: "تعديل الحساب الفرعي",
          fullName: "الاسم الكامل",
          address: "العنوان",
          city: "المدينة",
          country: "البلد",
          postcode: "الرمز البريدي",
          telephone: "الهاتف",
          mobile: "الهاتف المحمول",
          email: "البريد الإلكتروني",
          occupation: "المهنة",
          company: "الشركة",
          tin: "الرقم الضريبي",
          username: "اسم المستخدم",
          cancel: "إلغاء",
          submit: "إرسال",
        },
        billingModal: {
          title: "إعدادات الفوترة",
          currency: "العملة",
          billingFrequency: "تكرار الفوترة",
          daysToPayInvoice: "أيام لسداد الفاتورة",
          minimumAmountToInvoice: "الحد الأدنى للفوترة",
          invoiceType: "نوع الفاتورة",
          preferredLanguage: "اللغة المفضلة",
          billingEmail: "البريد الإلكتروني للفوترة",
          platformUsage: "استخدام المنصة",
          platformUsagePrice: "سعر استخدام المنصة",
          onStockPriceEnabled: "سعر شرائح SIM في المخزون مفعل",
          onStockPrice: "سعر شرائح SIM في المخزون",
          simCardPriceEnabled: "هل هناك رسوم على شريحة SIM؟",
          simCardPrice: "سعر شريحة SIM",
          simChipPriceEnabled: "هل هناك رسوم على شريحة SIM Chip؟",
          simChipPrice: "سعر شريحة SIM Chip",
          billable: "قابل للفوترة؟",
          isVatExempt: "معفى من ضريبة القيمة المضافة",
          cancel: "إلغاء",
          submit: "إرسال",
        },
        whitelabelModal: {
          title: "إعدادات العلامة البيضاء",
          enableWhitelabel: "تمكين العلامة البيضاء",
          pricePerMonth: "السعر لكل شهر",
          url: "الرابط",
          cancel: "إلغاء",
          submit: "إرسال",
        },
        roleModal: {
          title: "تحديث الدور",
          role: "الدور",
          tenant: "المستأجر",
          manager: "المدير",
          customer: "العميل",
          cancel: "إلغاء",
          submit: "إرسال",
        },
        offersModal: {
          title: "تعيين العروض",
          availableOffers: "العروض المتاحة",
          assignedOffers: "العروض المعينة",
          submit: "إرسال",
        },
      },
      sims: {
        title: "شرائح SIM",
        dataVolume: "حجم البيانات",
        dataSessions: "جلسات البيانات",
        zeroSessions: "جلسات صفرية",
        filters: "فلاتر",
        simStatus: "جلسة نشطة",
        simState: "حالة SIM",
        portfolioId: "Portfolio ID",
        imsi: "IMSI",
        iccid: "ICCID",
        msisdn: "MSISDN",
        eid: "EID",
        offer: "العرض",
        data: "البيانات",
        min: "الحد الأدنى",
        max: "الحد الأقصى",
        search: "بحث",
        clear: "مسح",
        actions: "الإجراءات",
        bulk: "عمليات مجمعة",
        modify: "تعديل",
        product: "المنتج",
        clearSelection: "مسح التحديد",
        activate: "تفعيل",
        suspend: "تعليق",
        resume: "استئناف",
        terminate: "إنهاء",
        testMode: "وضع الاختبار",
        sendSms: "إرسال رسالة نصية",
        watchdogs: "المراقبون",
        createWatchdog: "إنشاء مراقب",
        removeAllWatchdogs: "إزالة جميع المراقبين",
        blockSuspension: "حظر الإيقاف",
        export: "تصدير",
        simInformation: "معلومات SIM",
        usage: "الاستخدام",
        ipAddress: "عنوان IP",
        imei: "IMEI",
        status: "الحالة",
        visitProfile: "زيارة الملف الشخصي",
        provider: "مزود الخدمة",
        area: "المنطقة",
        cell: "الخلية",
        longitude: "خط الطول",
        latitude: "خط العرض",
        cellRange: "نطاق الخلية",
        unit: "الوحدة",
        sort: "ترتيب",
        suspendModal: {
          title: "تعليق SIM",
          orderComplete: "تم تعليق SIM بنجاح",
          orderError: "فشل في تعليق SIM",
          contactAdmin: "يرجى الاتصال بمسؤول النظام",
          cancel: "إلغاء",
          submit: "إرسال",
          close: "إغلاق",
        },
        resumeModal: {
          title: "استئناف SIM",
          orderComplete: "تم استئناف SIM بنجاح",
          orderError: "فشل في استئناف SIM",
          contactAdmin: "يرجى الاتصال بمسؤول النظام",
          cancel: "إلغاء",
          submit: "إرسال",
          close: "إغلاق",
        },
        activateModal: {
          title: "تفعيل SIM",
          offer: "العرض",
          selectOffer: "اختر العرض",
          success: "تم تفعيل SIM بنجاح",
          orderError: "فشل في تفعيل SIM",
          contactAdmin: "يرجى الاتصال بمسؤول النظام",
          cancel: "إلغاء",
          submit: "إرسال",
          close: "إغلاق",
        },
        terminateModal: {
          title: "إنهاء SIM",
          targetState: "الحالة المطلوبة",
          onStock: "في المخزون",
          terminated: "تم إنهاؤها",
          success: "تم إنهاء SIM بنجاح",
          orderError: "فشل في إنهاء SIM",
          contactAdmin: "يرجى الاتصال بمسؤول النظام",
          cancel: "إلغاء",
          submit: "إرسال",
          close: "إغلاق",
        },
      },
      simProfile: {
        simProvisioning: "إدارة حالة شريحة SIM",
        simDetails: "تفاصيل SIM",
        actions: "الإجراءات",
        hlr: "HLR",
        session: "الجلسات",
        smsUsage: "استخدام الرسائل النصية",
        updateLoc: "تحديث الموقع",
        imeiLock: "قفل IMEI",
        usage: "الاستخدام",
        imei: "IMEI",
        status: "الحالة",
        dataSession: "الجلسة النشطة",
        map: "خريطة",
        provider: "مزود الخدمة",
        imsi: "IMSI",
        iccid: "ICCID",
        msisdn: "MSISDN",
        country: "البلد",
        operator: "مشغل الشبكة",
        area: "المنطقة",
        cell: "الخلية",
        longitude: "خط الطول",
        latitude: "خط العرض",
        cellRange: "نطاق الخلية",
        activity: "النشاط",
        selectPeriod: "اختر الفترة",
        daily: "يومي",
        monthly: "شهري",
        yearly: "سنوي",
        dataVolume: "حجم البيانات",
        dataSessions: "جلسات البيانات",
        alerts: "التنبيهات",
        zeroSessions: "جلسات صفرية",
        watchdog: "المراقب",
        type: "النوع",
        blockSuspension: "سيتم إيقاف شريحة SIM",
        amount: "الكمية",
        hlrModal: {
          title: "ملف HLR",
          selectScope: "اختر النطاق",
          basicInfo: "معلومات أساسية",
          locationInfo: "معلومات الموقع",
          csBasicInfo: "معلومات CS الأساسية",
          gprsService2g3g: "خدمات GPRS 2G/3G",
          telephonyService: "خدمات الهاتف",
          supplementaryService: "الخدمات التكميلية",
          epcService4G: "خدمات EPC 4G",
        },
        sessionModal: {
          title: "جلسات بيانات SIM",
          openDate: "تاريخ الافتتاح",
          closeDate: "تاريخ الإغلاق",
          consumption: "الاستهلاك",
          roundedBytes: "بايت مقرب",
          operator: "المشغل",
          cell: "الخلية",
          imei: "IMEI",
          close: "إغلاق",
        },
        orders: {
          title: "الطلبات",
          close: "إغلاق",
        },
        smsUsageModal: {
          title: "استخدام الرسائل النصية",
          direction: "الاتجاه",
          date: "التاريخ",
          sender: "المرسل",
          message: "الرسالة",
          status: "الحالة",
          close: "إغلاق",
        },
      },
      profile: {
        profileDetails: "تفاصيل الملف الشخصي",
        contactInformation: "معلومات الاتصال",
        professionalInformation: "معلومات مهنية",
        activities: "الأنشطة",
        loadMore: "تحميل المزيد",
      },
      billingProducts: {
        title: "منتجات الفوترة",
        name: "الاسم",
        pricePlan: "الخطة السعرية",
        price: "السعر",
        number: "الرقم",
      },
      invoices: {
        title: "الفواتير",
        invoiceNo: "رقم الفاتورة",
        date: "التاريخ",
        amount: "المبلغ (شامل ضريبة القيمة المضافة)",
        description: "الوصف",
        paid: "مدفوع",
        download: "تحميل",
      },
      statements: {
        title: "كشف الحساب",
        cutDate: "تاريخ القطع",
        description: "الوصف",
        amount: "المبلغ (شامل ضريبة القيمة المضافة)",
        balance: "الرصيد",
      },
      orders: {
        title: "الطلبات",
        open: "مفتوح",
        parked: "مؤجل",
        finished: "مكتمل",
        error: "خطأ",
        noOrders: "لا توجد طلبات",
        showAllOrders: "عرض جميع الطلبات",
        showLess: "إظهار عدد أقل من الطلبات",
      },
      emails: {
        filters: "فلاتر",
        category: "الفئة",
        name: "الاسم",
        address: "العنوان",
        actions: "الإجراءات",
        newEmail: "بريد إلكتروني جديد",
        edit: "تعديل",
        delete: "حذف",
        cancel: "إلغاء",
        submit: "إرسال",
        selectCategory: "اختر الفئة",
        invoice: "الفاتورة",
        watchdog: "المراقب",
        updateEmail: "تحديث البريد الإلكتروني",
      },
      reports: {
        title: "التقارير",
        reportType: "نوع التقرير",
        usage: "الاستخدام",
        groupBy: "تجميع حسب",
        field: "الحقل",
        usageType: "نوع الاستخدام",
        selectUsageType: "اختر نوع الاستخدام",
        data: "البيانات",
        sms: "الرسائل النصية",
        all: "الكل",
        imsi: "IMSI",
        eid: "EID",
        network: "الشبكة",
        customer: "عميل",
        period: "الفترة",
        day: "يوم",
        month: "شهر",
        year: "سنة",
        today: "اليوم",
        "This Week": "هذا الأسبوع",
        "This Month": "هذا الشهر",
        "This Year": "هذا العام",
        "Last Month": "الشهر الماضي",
        "Last Year": "العام الماضي",
        customer: "العميل",
        select: "اختر",
        simSearchCriteria: "معايير البحث عن SIM",
        bySpecificImsi: "حسب IMSI محددة",
        byImsiRange: "حسب نطاق IMSI",
        byIccid: "حسب ICCID",
        startImsi: "IMSI البداية",
        endImsi: "IMSI النهاية",
        iccid: "ICCID",
        view: "عرض",
        customerId: "رقم العميل",
        date: "التاريخ",
        startDate: "من",
        simType: "نوع SIM",
        networkCode: "رمز الشبكة",
        networkName: "اسم الشبكة",
        country: "البلد",
        totalBytes: "إجمالي البايتات",
        roundedBytes: "بايت مقرب",
        sessions: "الجلسات",
        zeroSessions: "جلسات صفرية",
        actions: "الإجراءات",
        export: "تصدير",
        description: "الوصف",
        quantity: "الكمية",
        unitPrice: "سعر الوحدة",
        tax: "ضريبة القيمة المضافة",
        costWithoutTax: "السعر قبل الضريبة",
        costWithTax: "السعر بعد الضريبة",
        currency: "العملة",
        offerName: "الباقة",
        id: "المعرف",
        name: "الاسم",
        status: "الحالة",
        creator: "المنشئ",
        creationDate: "تاريخ الإنشاء",
        offer: "الباقة",
        activations: "عمليات التفعيل",
        terminations: "عمليات الإنهاء",
        automated: {
          title: "التقارير الآلية",
          name: "الاسم",
          type: "النوع",
          frequency: "التكرار",
          nextReport: "التقرير التالي",
          new: "تقرير جديد",
          save: "حفظ",
          daily: "يومي",
          weekly: "أسبوعي",
          monthly: "شهري",
          edit: "تعديل",
          delete: "حذف",
          actions: "الإجراءات",
        },
        history: {
          title: "سجل التقارير",
          tableHeaders: {
            reportName: "اسم التقرير",
            date: "التاريخ",
            status: "الحالة",
            download: "تحميل",
            actions: "الإجراءات",
          },
          delete: "حذف",
          completed: "مكتمل",
          incomplete: "غير مكتمل",
        },
      },
      timeoutReports: {
        view: "عرض",
        delete: "حذف",
      },
      alerts: {
        title: "التنبيهات",
        filters: "فلاتر",
        alert: "التنبيه",
        date: "التاريخ",
        imsi: "IMSI",
        enterValue: "أدخل القيمة",
      },
      settings: {
        title: "الإعدادات",
        profileSettings: "إعدادات الملف الشخصي",
        general: "عام",
        account: "الحساب",
        profileImage: "صورة الملف الشخصي",
        whitelabel: "العلامة البيضاء",
        privacyAndSafety: "الخصوصية والأمان",
        notifications: "الإشعارات",
        billing: "الفوترة",
        invoice: "الفاتورة",
        importSim: "استيراد سيم",
        mailConfig: "خادم البريد",
        generalSettings: {
          title: "الإعدادات العامة",
          timeZone: "المنطقة الزمنية",
          dateFormat: "تنسيق التاريخ",
          timeFormat: "تنسيق الوقت",
          save: "حفظ",
        },
        accountSettings: {
          title: "إعدادات الحساب",
          fullName: "الاسم الكامل",
          address: "العنوان",
          city: "المدينة",
          country: "البلد",
          postcode: "الرمز البريدي",
          telephone: "الهاتف",
          mobileNumber: "رقم الهاتف المحمول",
          email: "البريد الإلكتروني",
          occupation: "المهنة",
          company: "الشركة",
          tin: "الرقم الضريبي",
          username: "اسم المستخدم",
          changePassword: "تغيير كلمة المرور",
          password: "كلمة المرور",
          confirmPassword: "تأكيد كلمة المرور",
          save: "حفظ",
        },
        profileImageSettings: {
          title: "إعدادات صورة الملف الشخصي",
          upload: "رفع",
          save: "حفظ",
        },
        whitelabelSettings: {
          title: "إعدادات العلامة البيضاء",
          backgroundColor: "لون الخلفية",
          fontColor: "لون الخط",
          accentColor: "لون التمييز",
          sidebarPosition: "موقع الشريط الجانبي",
          favicon: "الأيقونة المفضلة",
          whitelabelImage: "صورة العلامة البيضاء",
          upload: "رفع",
          save: "حفظ",
        },
        privacySettings: {
          title: "إعدادات الخصوصية",
          enable2FA: "تمكين المصادقة الثنائية",
          save: "حفظ",
        },
        notificationSettings: {
          title: "إعدادات الإشعارات",
          receiveNotifications: "تلقي الإشعارات",
          sms: "رسالة نصية",
          email: "البريد الإلكتروني",
          weeklyAnalytics: "تحليلات أسبوعية",
          checkIfYouWantToReceiveWeeklyAnalytics:
            "حدد إذا كنت ترغب في تلقي التحليلات الأسبوعية",
          notifyAboutNewAlerts: "إخطار حول التنبيهات الجديدة",
          checkIfYouWantToReceiveNotificationsWhenThereAreNewAlerts:
            "حدد إذا كنت ترغب في تلقي الإشعارات عند وجود تنبيهات جديدة",
          submit: "إرسال",
        },
        billingSettings: {
          title: "إعدادات الفوترة",
          selectCurrency: "اختر العملة",
          currency: "العملة",
          preferredLanguage: "اللغة المفضلة",
          selectLanguage: "اختر اللغة",
          submit: "إرسال",
        },
        invoiceSettings: {
          title: "إعدادات الفاتورة",
          name: "الاسم",
          showGuis: "عرض واجهات المستخدم",
          showSubtotal: "عرض الإجمالي الفرعي",
          showLineOfService: "عرض سطر الخدمة",
          save: "حفظ",
        },
        importSimSettings: {
          title: "استيراد سيم",
          provider: "مزود الخدمة",
          selectProvider: "اختر مزود الخدمة",
          submit: "يُقدِّم",
          inputType: "نوع الإدخال",
          selectInputType: "اختر نوع الإدخال",
          single: "إدخال فردي",
          file: "إدخال من ملف",
        },
        mailConfig: {
          title: "إعدادات خادم البريد",
          host: "عنوان مضيف SMTP",
          port: "منفذ SMTP",
          fromAddress: "عنوان المرسل",
          username: "اسم المستخدم",
          changePassword: "تغيير كلمة المرور",
          password: "كلمة المرور",
          confirmPassword: "تأكيد كلمة المرور",
          useTLS: "استخدام TLS",
          save: "حفظ الإعدادات",
          success: "تم حفظ إعدادات خادم البريد بنجاح",
          error: "فشل في حفظ إعدادات خادم البريد",
          healthStatus: "حالة النظام",
          healthUp: "سليم (UP)",
          healthDown: "غير سليم (DOWN)",
          healthUnknown: "غير معروف",
          lastCheckedAt: "آخر فحص",
        },
        purchaseOrderConfig: {
          title: "إعداد أمر الشراء",
          sellerName: "اسم البائع",
          host: "عنوان مضيف SMTP",
          port: "منفذ SMTP",
          fromAddress: "عنوان المرسل",
          username: "اسم المستخدم",
          changePassword: "تغيير كلمة المرور",
          password: "كلمة المرور",
          confirmPassword: "تأكيد كلمة المرور",
          useTLS: "استخدام TLS",
          save: "حفظ الإعدادات",
          success: "تم حفظ إعدادات خادم البريد بنجاح",
          error: "فشل في حفظ إعدادات خادم البريد",
          healthStatus: "حالة النظام",
          healthUp: "في حالة جيدة (UP)",
          healthDown: "متعطل (DOWN)",
          healthUnknown: "غير معروف",
          lastCheckedAt: "آخر فحص في",
        },
        platformConfig: {
          title: "تكوين المنصة",
          dataStreamingEnabled: "تمكين تدفق البيانات",
          maintenanceMode: "وضع الصيانة",
          maintenanceMessage: "رسالة الصيانة",
          maintenanceMessagePlaceholder: "الموقع قيد الصيانة. سنعود قريبًا.",
          save: "حفظ",
          reset: "إعادة التعيين إلى القيم الافتراضية",
        },
        crmConfig: {
          title: "إعدادات نظام إدارة العلاقات مع العملاء",
          type: "نوع نظام إدارة العلاقات مع العملاء",
          authType: "نوع المصادقة",
          selectAuthType: "اختر نوع المصادقة",
          selectType: "اختر نوع نظام إدارة العلاقات مع العملاء",
          username: "اسم المستخدم",
          changePassword: "تغيير كلمة المرور؟",
          changeToken: "تغيير الرمز؟",
          password: "كلمة المرور",
          confirmPassword: "تأكيد كلمة المرور",
          token: "الرمز",
        },
      },
      privileges: {
        title: "الامتيازات",
        name: "الاسم",
        actions: "الإجراءات",
        newPrivilege: "امتياز جديد",
        edit: "تعديل",
        delete: "حذف",
      },
      table: {
        page: "الصفحة",
        of: "من",
        show: "عرض",
        goToPage: "الذهاب إلى الصفحة",
      },
      notifications: {
        title: "الإشعارات",
        id: "الرقم",
        date: "التاريخ",
        message: "الرسالة",
        type: "النوع",
      },
      whitelist: {
        title: "عنوان IP المسموح به",
        ip: "عنوان IP",
        active: "نشط",
        createdAt: "تاريخ الإضافة",
        updatedAt: "آخر تحديث",
        lastUsed: "آخر استخدام",
        new: "عنوان IP جديد",
      },
      customFields: {
        title: "الحقول المخصصة",
        new: "حقل مخصص جديد",
        name: "الاسم",
        type: "النوع",
        createdAt: "تاريخ الإنشاء",
        updatedAt: "تاريخ التحديث",
        edit: "تعديل",
        delete: "حذف",
        submit: "إرسال",
        cancel: "إلغاء",
        actions: "الإجراءات",
        selectType: "اختر النوع",
        text: "نص",
        number: "رقم",
      },
      documentation: {
        introduction: {
          welcomeTitle: "مرحبًا بك في {{brand}}",
          welcomeText:
            "{{brand}} هي منصتك الشاملة لإدارة بطاقات SIM بسهولة. راقب الاستخدام، فعّل الخطوط الجديدة، وحافظ على سير عملياتك بسلاسة—كل ذلك من لوحة تحكم واحدة.",
          getStarted: "ابدأ",
        },
        dashboard: {
          title: "نظرة عامة على لوحة التحكم",
          description:
            "تعد لوحة التحكم الشاشة الرئيسية لمراقبة وتحليل نشاط شرائح SIM عبر منصة {{brand}}...",
          goal: "هدف لوحة التحكم هو تزويد المستخدمين بأداة فورية للإشراف...",
          cards: {
            title: "بطاقات الإحصائيات (الجزء العلوي)",
            dataVolume: {
              title: "حجم البيانات",
              description:
                "يعرض الحجم الإجمالي للبيانات المستهلكة اليوم، مع مقارنة مع اليوم السابق.",
            },
            dataSessions: {
              title: "جلسات البيانات",
              description:
                "يعرض عدد الجلسات/الاتصالات التي تمت اليوم مقارنة باليوم السابق.",
            },
            alerts: {
              title: "تنبيهات الاستهلاك",
              description:
                "يعرض عدد تنبيهات الاستهلاك التي تم إنشاؤها اليوم بسبب تجاوز حدود الاستخدام.",
            },
            zeroSessions: {
              title: "جلسات بدون استهلاك",
              description:
                "يعرض عدد جلسات البيانات التي سجلت استهلاكًا صفريًا خلال الفترة المحددة.",
            },
          },
          charts: {
            title: "رسوم بيانية وخرائط تفصيلية",
            dataSessionsMap: {
              title: "التوزيع الجغرافي لاتصالات البيانات",
              description:
                "يعرض الخريطة البلدان ذات أعلى عدد من الاتصالات. من القائمة في الزاوية العلوية اليمنى من البطاقة، يمكنك اختيار المعلومات التي سيتم عرضها: جلسات البيانات (Data Sessions)، حجم البيانات (Data Volume)، أو الجلسات الصفرية (Zero Sessions).",
            },
            avgDataAndActiveSims: {
              title: "متوسط استهلاك البيانات وبطاقات SIM النشطة",
              description:
                "يوفر متوسط استهلاك البيانات لكل اتصال وعدد بطاقات SIM النشطة الإجمالي.",
            },
            dataVolumePerHour: {
              title: "التوزيع الساعي لاستهلاك البيانات",
              description:
                "يعرض الرسم البياني استهلاك البيانات لكل فترة مدتها ثلاث ساعات ولكل يوم من أيام الأسبوع خلال الشهر الحالي، مما يوفر صورة أوضح للفترات الزمنية ذات النشاط الأعلى لبطاقات SIM.",
            },
            monthlyDataVolume: {
              title: "التوزيع الشهري لاستهلاك البيانات",
              description:
                "يعرض الرسم البياني التوزيع الشهري لاستهلاك البيانات خلال الاثني عشر شهرًا الماضية. من القائمة في الزاوية العلوية اليمنى من البطاقة، يمكنك اختيار المعلومات التي تريد عرضها: جلسات البيانات (Data Sessions)، حجم البيانات (Data Volume)، أو الجلسات الصفرية (Zero Sessions).",
            },
            topMetrics: {
              title: "المؤشرات الرئيسية",
              description:
                "يبرز هذا الرسم البياني بطاقات SIM التي لديها أكبر عدد من الاتصالات خلال الفترة المحددة. يساعدك على تحديد أكثر البطاقات نشاطًا في شبكتك بسرعة، وتحليل أنماط الاستخدام، واكتشاف المستخدمين ذوي النشاط المكثف، وتحسين تخصيص الموارد.",
            },
            dataVolumePerNetwork: {
              title:
                "استهلاك البيانات حسب الشبكة - بطاقات SIM النشطة حسب الشبكة",
              description:
                "توفر هذه الرسوم البيانية عرضًا مقارنًا لنشاط الشبكات في البلد المحدد. يوضح الرسم البياني الأول توزيع إجمالي استهلاك البيانات عبر شبكات الجوال، مما يساعدك على تقييم الحمل، واكتشاف تركّز الاستخدام، ومقارنة أداء المزوّدين. يوضح الرسم البياني الثاني توزيع بطاقات SIM النشطة حسب الشبكة، مما يوفر رؤى حول تغطية المزوّدين وحصص السوق. معًا، يقدمان فهمًا شاملاً لكيفية تفاعل بطاقات SIM الخاصة بك مع الشبكات المختلفة ويسلطان الضوء على أنماط الاتصال والاستخدام.",
            },
            simCardsPerOffer: {
              title: "توزيع بطاقات SIM حسب العرض والحالة",
              description:
                "توفر هذه الرسوم البيانية نظرة عامة على محفظة بطاقات SIM الخاصة بك. يوضح الأول التوزيع حسب العروض وخطط البيانات، مما يساعدك على تحديد التفضيلات والخدمات الأكثر شيوعًا. يوضح الثاني التوزيع حسب الحالة، مما يمنحك رؤية أوضح لمراحل دورة الحياة والتوافر. معًا، يساعدانك في مراقبة اتجاهات الاستخدام ومستويات المخزون وكفاءة إدارة شرائح SIM.",
            },
            alerts: {
              title: "تنبيهات الاستهلاك",
              description:
                "يعرض هذا الجدول التنبيهات الناتجة عن آلية المراقبة WatchDog. يقوم WatchDog بمراقبة استهلاك بيانات شرائح SIM بشكل مستمر ويطلق التنبيهات عند الوصول إلى حدود محددة مسبقًا.",
              types: {
                warning:
                  "Warning: يتم تشغيله عند وصول الاستهلاك إلى %80 من الحجم المخصص.",
                depleted:
                  "Depleted: يتم تشغيله عند وصول الاستهلاك إلى %100 من الحجم المخصص.",
              },
              note: "تساعدك هذه التنبيهات على اتخاذ الإجراءات في الوقت المناسب لتجنب انقطاع الخدمة أو التكاليف غير المتوقعة. سيتم تقديم تحليل أكثر تفصيلًا لـ WatchDog وآلية عمله في الفصل ذي الصلة من التوثيق.",
            },
          },
          utility: {
            title: "فائدة لوحة التحكم",
            description:
              "من خلال العرض الموحد للمؤشرات الرئيسية والاتجاهات والتنبيهات، تتيح لوحة التحكم الكشف السريع عن المشكلات واتخاذ قرارات مستنيرة.",
          },
        },
        simCards: {
          introduction: {
            title: "مقدمة في شرائح SIM",
            description:
              "يوفر هذا الفصل جميع المعلومات اللازمة حول شرائح SIM داخل منصة {{brand}}.",
            details:
              "سوف تتعلم كيف تتم إدارة ومراقبة وتحليل شرائح SIM، مع تقديم رؤى حول استهلاك البيانات، الاتصال، التنبيهات ومراحل دورة الحياة.",
            getStarted: "ابدأ",
          },
          lifecycle: {
            title: "دورة حياة شريحة SIM",
            intro:
              "تمر شرائح SIM في المنصة بمراحل مختلفة من دورة الحياة. يتم تمثيل كل مرحلة بدائرة ملوّنة ولها انتقالات مسموح بها محددة.",
            status: {
              productive: "نشطة وقيد الاستخدام.",
              suspended: "معلقة يدويًا.",
              autoSuspended: "معلقة تلقائيًا.",
              onstock: "متوفرة ولكن غير مفعلة.",
              deleted: "محذوفة وغير نشطة.",
            },
            diagramDescription:
              "يوضح هذا الرسم البياني حالات دورة حياة شريحة SIM والانتقالات الممكنة بينها. يمكن تنفيذ الانتقالات يدويًا (على سبيل المثال، تفعيل الشريحة من OnStock إلى Productive) أو تلقائيًا (مثل قيام عملية في النظام بإيقاف الشريحة مؤقتًا عند الوصول إلى حدود معينة). تضمن هذه الانتقالات التحكم المناسب في نشاط الشرائح وتوفرها وتعطيلها ضمن المنصة.",
          },
          panel: {
            title: "لوحة شرائح SIM",
            intro:
              "توفر لوحة شرائح SIM نظرة عامة على جميع شرائح SIM داخل المنصة. تتيح لك مراقبة النشاط، تحليل استهلاك البيانات، وإدارة مراحل دورة الحياة بكفاءة.",
            summary: {
              title: "بطاقات الملخص والفلاتر",
              intro:
                "في أعلى اللوحة، تعرض ثلاث بطاقات لمحة سريعة عن استخدام شرائح SIM للشهر الحالي:",
              dataVolume: "حجم البيانات – إجمالي البيانات المستهلكة.",
              dataSessions: "جلسات البيانات – عدد الاتصالات.",
              zeroSessions: "جلسات صفرية – جلسات بدون بيانات.",
              filters:
                "تسمح الفلاتر بتصفية شرائح SIM حسب IMSI، ICCID، MSISDN، حالة الشريحة، العرض، نوع الشريحة، أو حجم البيانات. يمكن تطبيق الفرز على عدة حقول مثل IMSI أو الاستخدام.",
            },
            table: {
              title: "جدول شرائح SIM",
              intro: "يعرض الجدول الرئيسي جميع شرائح SIM مع تفاصيلها الرئيسية:",
              activeSession: "جلسة نشطة – مؤشر النشاط المباشر.",
              identifiers: "المعرفات – IMSI، ICCID، MSISDN.",
              state: "حالة الشريحة – حالة دورة الحياة (مثل: نشطة، معلقة).",
              offer: "العرض – خطة الاشتراك (إن وجدت).",
              data: "البيانات – حجم الاستخدام للشهر.",
              type: "نوع الشريحة – نوع المنتج (مثل: مدمجة، صناعية).",
              footer:
                "كما يتم دعم الترقيم والعمليات المجمعة لإدارة فعالة لشرائح SIM.",
            },
          },
          simProvisioning: {
            introduction: {
              title: "تهيئة شرائح SIM",
              description:
                "تشير تهيئة شرائح SIM إلى مجموعة من الوظائف التي تتيح للمسؤولين إدارة دورة حياة شرائح SIM ضمن المنصة. من خلال التهيئة، يمكنك:",
              closing:
                "تضمن هذه الإجراءات أن يتم تهيئة شرائح SIM والتحكم بها وإلغاء تفعيلها بشكل صحيح، مما يدعم كلًا من المرونة التشغيلية والأمان.",
            },
            actions: {
              activate: {
                title: "تفعيل",
                description: "جعل شريحة SIM جاهزة للاستخدام الفعّال.",
                details: {
                  intro: "لتفعيل شريحة SIM واحدة أو أكثر هناك ثلاث طرق:",
                  steps: [
                    "عن طريق تحديد شرائح SIM من الجدول عبر تحديد مربعات الاختيار ومن قائمة العمليات الجماعية في أعلى اليمين، اختر تفعيل.",
                    "بالضغط مباشرة على نفس القائمة واستخدام ملف Excel يحتوي على أرقام IMSI/ICCID في العمود A مع العنوان المناسب (IMSI/ICCID) في الخلية A1.",
                    "بالضغط على الصف، ستظهر بطاقة جانبية بملف تعريف الشريحة، في الجزء العلوي منها يوجد زر تفعيل.",
                  ],
                  important:
                    "هام! يجب أن تكون جميع شرائح SIM المحددة في حالة المخزون (OnStock) ليتم تفعيلها.",
                  closing:
                    "بعد الخطوات الموضحة، ستظهر نافذة تأكيد من خطوتين حيث يجب على المستخدم اختيار العرض الذي يرغب في تفعيل الشرائح من خلاله. اختياريًا، يمكن للمستخدم تعيين بعض القيم المخصصة لهذه الشرائح. في الخطوة الثانية، يراجع المستخدم الشرائح المحددة ويكمل عملية التفعيل.",
                },
              },
              suspend: {
                title: "تعليق",
                description: "تعطيل الاتصال مؤقتًا.",
                details: {
                  intro:
                    "وبالمثل مع التفعيل، لتعليق شريحة SIM أو أكثر لدى المستخدم نفس الخيارات:",
                  steps: [
                    "عن طريق تحديد شرائح SIM من الجدول عبر تحديد مربعات الاختيار ومن قائمة العمليات الجماعية في أعلى اليمين، اختر تعليق.",
                    "بالضغط مباشرة على نفس القائمة واستخدام ملف Excel يحتوي على أرقام IMSI/ICCID في العمود A مع العنوان المناسب (IMSI/ICCID) في الخلية A1.",
                    "بالضغط على الصف، ستظهر بطاقة جانبية بملف تعريف الشريحة، في الجزء العلوي منها يوجد زر تعليق.",
                  ],
                  important:
                    "هام! يجب أن تكون جميع شرائح SIM المحددة في حالة إنتاجية (Productive) ليتم تعليقها.",
                  closing:
                    "بعد الخطوات الموضحة، ستظهر نافذة تأكيد حيث يراجع المستخدم الشرائح المحددة ويتابع عملية التعليق.",
                },
              },
              resume: {
                title: "استئناف",
                description: "إعادة تفعيل شريحة SIM المعلقة.",
                details: {
                  intro:
                    "وبالمثل، لاستئناف شريحة SIM أو أكثر لدى المستخدم نفس الخيارات:",
                  steps: [
                    "عن طريق تحديد شرائح SIM من الجدول عبر تحديد مربعات الاختيار ومن قائمة العمليات الجماعية في أعلى اليمين، اختر استئناف.",
                    "بالضغط مباشرة على نفس القائمة واستخدام ملف Excel يحتوي على أرقام IMSI/ICCID في العمود A مع العنوان المناسب (IMSI/ICCID) في الخلية A1.",
                    "بالضغط على الصف، ستظهر بطاقة جانبية بملف تعريف الشريحة، في الجزء العلوي منها يوجد زر استئناف.",
                  ],
                  important:
                    "هام! يجب أن تكون جميع شرائح SIM المحددة في حالة معلقة (Suspended) أو معلقة تلقائيًا (AutoSuspended) ليتم استئنافها.",
                  closing:
                    "بعد الخطوات الموضحة، ستظهر نافذة تأكيد حيث يراجع المستخدم الشرائح المحددة ويتابع عملية الاستئناف.",
                },
              },
              terminate: {
                title: "إنهاء",
                description:
                  "إيقاف استخدام شريحة SIM (إما إلى المخزون أو محذوفة).",
                details: {
                  intro:
                    "وبالمثل، لإنهاء شريحة SIM أو أكثر لدى المستخدم نفس الخيارات:",
                  steps: [
                    "عن طريق تحديد شرائح SIM من الجدول عبر تحديد مربعات الاختيار ومن قائمة العمليات الجماعية في أعلى اليمين، اختر إنهاء.",
                    "بالضغط مباشرة على نفس القائمة واستخدام ملف Excel يحتوي على أرقام IMSI/ICCID في العمود A مع العنوان المناسب (IMSI/ICCID) في الخلية A1.",
                    "بالضغط على الصف، ستظهر بطاقة جانبية بملف تعريف الشريحة، في الجزء العلوي منها يوجد زر إنهاء.",
                  ],
                  important:
                    "هام! يجب أن تكون جميع شرائح SIM المحددة في حالة إنتاجية (Productive) ليتم إنهاؤها.",
                  closing:
                    "بعد الخطوات الموضحة، ستظهر نافذة تأكيد حيث يختار المستخدم الحالة المستهدفة (إما في المخزون أو محذوفة نهائيًا)، يراجع الشرائح المحددة ويتابع عملية الإنهاء.",
                },
              },
              modify: {
                title: "تعديل",
                description:
                  "تعديل العرض (Offer) الذي يتم بموجبه تفعيل الشريحة واحتساب الرسوم.",
                details: {
                  intro: "لتعديل عرض شريحة SIM:",
                  steps: [
                    "عن طريق تحديد الشريحة من الجدول عبر تحديد مربع الاختيار الخاص بها ومن قائمة الإجراءات في أعلى اليمين، اختر تعديل.",
                  ],
                  important:
                    "هام! يجب أن تكون الشريحة المحددة في حالة إنتاجية (Productive) ليتم تعديلها.",
                  closing:
                    "بعد الخطوات الموضحة، ستظهر نافذة تأكيد حيث يحدد المستخدم العرض المستهدف المطلوب للشريحة. بعد ذلك يراجع الشريحة المحددة ويتابع عملية التعديل.",
                },
              },
            },
          },
          simProfile: {
            title: "ملف تعريف بطاقة SIM",
            description:
              "ملف تعريف بطاقة SIM هو لوحة تحكم تركز على الإحصاءات والوظائف الخاصة ببطاقة SIM واحدة. يوفر إحصاءات مشابهة للوحة التحكم الرئيسية بالإضافة إلى معلومات مفصلة للتحليل والإدارة.",
            items: {
              kpis: "مؤشرات الأداء الرئيسية وإحصاءات الاستخدام",
              monthly: "التوزيع الشهري للاستخدام",
              hlr: "ملف تعريف HLR (إن وجد)",
              dataSessions: "سجل جلسات البيانات",
              smsUsage: "سجل استخدام الرسائل القصيرة",
              requests: "الطلبات المقدمة لهذه البطاقة",
              provisioning: "نشاط وخصائص إدارة بطاقة SIM",
              cellInfo: "معلومات الخلية وتفاصيل الاتصال",
              watchdogs: "معلومات وتنبيهات أنظمة المراقبة",
            },
            sections: {
              howToAccess: {
                title: "كيفية الوصول",
                description:
                  "للوصول إلى ملف تعريف بطاقة SIM محددة، اختر بطاقة SIM من الجدول واضغط عليها. سيظهر شريط جانبي يحتوي على معلومات البطاقة. داخل هذا الشريط يوجد رابط 'زيارة الملف الشخصي' الذي ينقلك إلى صفحة ملف تعريف SIM الكاملة. توفر صفحة ملف تعريف SIM إحصاءات مفصلة، سجل الاستخدام، إجراءات التزويد، والمعلومات التقنية حول بطاقة SIM المحددة.",
              },
              kpis: {
                title: "مؤشرات الأداء الرئيسية (KPIs)",
                description:
                  "يوفر قسم مؤشرات الأداء الرئيسية في ملف تعريف بطاقة SIM نظرة سريعة على أداء ونشاط البطاقة. تساعد هذه المؤشرات المستخدم على فهم الاستخدام الحالي وحالة البطاقة بسرعة.",
                bullets: [
                  "حجم البيانات – إجمالي كمية البيانات المستهلكة من قِبل البطاقة خلال الفترة المحددة.",
                  "جلسات البيانات – عدد جلسات البيانات التي تم إنشاؤها خلال الفترة المحددة.",
                  "التنبيهات – عدد التنبيهات التي تم تشغيلها لهذه البطاقة (مثل حدود الاستخدام أو مشاكل الاتصال).",
                  "جلسات صفرية – عدد الجلسات التي حاولت فيها البطاقة الاتصال لكنها لم تستهلك بيانات.",
                ],
                closing:
                  "يمكن للمستخدم من أعلى اليمين تصفية مؤشرات الأداء حسب الفترة (يومي، شهري، سنوي) لتحليل أنماط الاستخدام بمرور الوقت.",
              },
              monthly: {
                title: "التوزيع الشهري",
                description:
                  "توزيع البيانات والرسائل القصيرة والجلسات حسب الشهر.",
              },
              hlr: {
                title: "ملف HLR",
                description:
                  "يوفر ملف HLR (سجل الموقع الرئيسي) معلومات تفصيلية عن الاشتراك والشبكة لبطاقة SIM. عند النقر على زر HLR من قائمة الإجراءات، تظهر نافذة تحتوي على تفاصيل مثل:",
                fields: {
                  msisdn: "MSISDN",
                  imsi: "IMSI",
                  networkAccessMode: "وضع الوصول إلى الشبكة (مثل CS و PS)",
                  subscriberType: "نوع المشترك (مثل مشترك LTE)",
                  simStatus: "حالة بطاقة SIM (مثل متاحة)",
                },
                scopes:
                  "بالإضافة إلى ذلك، يمكن للمستخدم الاختيار من قائمة منسدلة تحتوي على النطاقات المتاحة (مثل المعلومات الأساسية، المعلومات الموسعة) لعرض التفاصيل المطلوبة حسب مستوى المعلومات.",
                closing:
                  "تتيح هذه الوظيفة للمسؤولين التحقق بسرعة من تفاصيل تهيئة بطاقة SIM والتأكد من أن البطاقة مسجلة بشكل صحيح ومتاحة في الشبكة.",
              },

              dataSessions: {
                title: "جلسات البيانات",
                description:
                  "تتيح وظيفة جلسات البيانات للمسؤولين عرض السجلات التفصيلية لجميع جلسات البيانات المرتبطة ببطاقة SIM. عند النقر على زر الجلسات في قائمة الإجراءات، تظهر نافذة منبثقة تعرض سجل الجلسات والتفاصيل ذات الصلة.",
                fields: {
                  openDate: "الطابع الزمني عند بدء الجلسة",
                  closeDate: "الطابع الزمني عند انتهاء الجلسة",
                  consumption: "العدد الفعلي للبايتات المستهلكة أثناء الجلسة",
                  roundedBytes:
                    "الاستخدام بعد التقريب وفقًا لسياسات الفوترة الخاصة بالمشغل",
                  operator: "مشغل الشبكة المسؤول عن الجلسة",
                  cell: "معرف الخلية حيث تم إنشاء الجلسة",
                  imei: "معرف الجهاز (IMEI) المستخدم لهذه الجلسة",
                },
              },
              smsUsage: {
                title: "استخدام الرسائل القصيرة",
                description:
                  "تتيح نافذة استخدام الرسائل القصيرة للمسؤولين مراقبة جميع الرسائل القصيرة المرسلة والمستلمة من بطاقة SIM. عند النقر على زر استخدام الرسائل القصيرة في قائمة الإجراءات، تظهر جدول تفصيلي يسرد كل معاملة SMS.",
                fields: {
                  direction: "الاتجاه (مثل: وارد أو صادر)",
                  date: "تاريخ ووقت حدث الرسالة القصيرة",
                  sender: "مرسل الرسالة القصيرة",
                  message: "محتوى الرسالة القصيرة (إن وجد)",
                  status: "حالة التسليم (مثل: تم الإرسال، تم التسليم، فشل)",
                },
                note: "توفر هذه الميزة إمكانية التتبع الكامل لحركة الرسائل القصيرة لأغراض استكشاف الأخطاء وإصلاحها أو الامتثال أو تحليل الاستخدام.",
              },
              requests: {
                title: "الطلبات",
                description:
                  "توفر قسم الطلبات سجلًا كاملًا لجميع أوامر التهيئة (Provisioning) التي تم تنفيذها لبطاقة SIM المحددة. عند النقر على زر الطلبات في قائمة الإجراءات، يظهر مربع حوار يعرض جميع الأوامر مثل التفعيل، التعليق، الاستئناف، والإيقاف.",
                fields: {
                  id: "المعرف: الرقم الفريد للأمر.",
                  name: "الاسم: نوع العملية (مثل SuspendSIM، ResumeSIM، TerminateSIM).",
                  status: "الحالة: حالة تنفيذ الأمر (مثل مكتمل، قيد الانتظار).",
                  creator: "المنشئ: المستخدم الذي بدأ الطلب.",
                  creationDate: "تاريخ الإنشاء: وقت إنشاء الأمر.",
                  lastUpdate: "آخر تحديث: أحدث طابع زمني لتحديث الحالة.",
                },
                note: "تتيح هذه الوظيفة للمسؤولين متابعة جميع أنشطة التهيئة المنفذة على بطاقة SIM، مما يضمن الشفافية والمساءلة في إدارة دورة الحياة.",
              },
              provisioning: {
                title: "نشاط التزويد",
                description:
                  "إجراءات التزويد مثل التفعيل، الإيقاف المؤقت، والاستبدال.",
              },
              cellInfo: {
                title: "معلومات الخلية",
                description: "معلومات حول الخلية وتفاصيل اتصال بطاقة SIM.",
              },
              watchdogs: {
                title: "المراقبات (Watchdogs)",
                description:
                  "يعرض قسم Watchdogs في ملف الـSIM أي مراقبات تم تكوينها والمرتبطة ببطاقة SIM. يتم عادةً تعريف هذه المراقبات على مستوى المنصة وربطها ببطاقة SIM لمتابعة شروط معينة.",
                bullets: [
                  "عرض قائمة المراقبات النشطة المرتبطة ببطاقة SIM.",
                  "التحقق من إعداداتها (مثل نوع المراقبة، الحالة والحدود المعينة).",
                  "متابعة المراقبات التي تراقب نشاط بطاقة SIM حالياً.",
                ],
                note: "ملاحظة: إعداد العتبات أو التنبيهات أو الإجراءات التلقائية غير متاح من خلال ملف SIM نفسه. هذا القسم للعرض فقط ومخصص لأغراض المراقبة.",
              },
            },
          },
          simTransfers: {
            title: "نقل شرائح SIM",
            description:
              "تتيح وظيفة نقل شرائح SIM للمسؤولين نقل الشرائح بين الحسابات أو الكيانات. يُعد ذلك مفيدًا لإعادة تخصيص الشرائح، أو شحنها إلى مؤسسة أخرى، أو إدارة تغييرات الملكية.",

            howToAccess: {
              title: "كيفية الوصول",
              description:
                "للوصول إلى نقل شرائح SIM، انتقل إلى قسم إدارة المستخدمين، وافتح قائمة الإجراءات الخاصة بالمستخدم، واختر خيار 'شحن الشرائح'.",
            },

            steps: {
              title: "خطوات إجراء نقل شريحة SIM",
              description: "تتكون عملية النقل من الخطوات التالية:",
              bullets: [
                "تأكد من أن الشرائح في حالة 'متاحة بالمخزون' قبل بدء عملية النقل. يمكن فقط نقل الشرائح المتاحة بين الحسابات.",
                "اختر نوع تحديد الشريحة: IMSI فردي، ICCID فردي، نطاق IMSI، نطاق ICCID أو رفع ملف CSV/XLSX. هذا يحدد كيفية تحديد الشرائح للنقل.",
                "أدخل أو ارفع معرفات الشرائح المطلوبة بناءً على نوع التحديد.",
                "يمكنك اختيارياً تحديد السعر ونسبة ضريبة القيمة المضافة. تساعد هذه الحقول في تتبع الأثر المالي للنقل.",
                "اختر عرض الفوترة. هذا هو العرض الذي سيتم فرضه على الحساب المصدر عند قيام الحساب الوجهة بتفعيل الشريحة المنقولة.",
                "انقر فوق 'إرسال' لإكمال عملية النقل. بعد التأكيد ستظهر الشرائح في مخزون الحساب الوجهة.",
              ],
            },
            deallocate: {
              title: "إلغاء تخصيص شرائح SIM",
              description:
                "إلغاء التخصيص هو الإجراء العكسي لنقل شرائح SIM. يسمح للمستخدمين بإزالة شرائح SIM من حساب الوجهة وإرجاعها إلى الحساب المصدر أو إلى المخزون. يكون هذا مفيدًا عند تخصيص شرائح SIM عن طريق الخطأ، أو لم تعد هناك حاجة إليها، أو يجب إعادة تخصيصها.",
              bullets: [
                "انتقل إلى قسم إدارة المستخدمين، وافتح قائمة الإجراءات الخاصة بمستخدم، ثم اختر 'إلغاء تخصيص شرائح SIM'.",
                "تأكد من أن شرائح SIM في حالة 'في المخزون' أو 'مخصصة' قبل محاولة إلغاء التخصيص.",
                "اختر نوع تحديد SIM: IMSI فردي، ICCID فردي، نطاق IMSI، نطاق ICCID، أو تحميل ملف CSV/XLSX.",
                "أدخل أو قم برفع معرفات شرائح SIM المراد إلغاء تخصيصها.",
                "قم بتأكيد حسابات المصدر والوجهة. يُظهر حقل 'من' الحساب الحالي، بينما يُظهر حقل 'إلى' الحساب أو المخزون الذي ستُعاد إليه الشرائح.",
                "انقر على 'إرسال' لإكمال عملية الإلغاء. بمجرد التأكيد، لن تظهر شرائح SIM بعد الآن في مخزون حساب الوجهة وستكون متاحة لإعادة التخصيص.",
              ],
            },
          },
        },
        watchdog: {
          title: "المراقبة (Watchdog)",
          description:
            "المراقبات (Watchdogs) هي قواعد مراقبة تساعد المستخدمين على التحكم في استخدام شرائح SIM واكتشاف السلوك غير الطبيعي. تتيح إدارة استباقية من خلال تحديد عتبات لمقاييس مثل حجم البيانات أو الجلسات أو استخدام الرسائل القصيرة. عند تجاوز العتبة، يمكن للنظام إنشاء تنبيهات أو تشغيل إجراءات لمنع سوء الاستخدام أو التكاليف غير المتوقعة.",
          items: {
            add: "كيفية إضافة مراقبة (Watchdog)",
            remove: "كيفية إزالة مراقبة (Watchdog)",
            reset: "كيفية إعادة ضبط مراقبة (Watchdog)",
            suspensionBlock: "منع تعليق شريحة SIM في دورة الفوترة الحالية",
            alerts: "التنبيهات التي يتم إنشاؤها بواسطة المراقبات (Watchdogs)",
          },
          add: {
            title: "إضافة ووتشدوغ",
            description:
              "يمكن للمستخدمين إنشاء ووتشدوغ جديد لمراقبة نشاط بطاقة SIM وتنفيذ إجراءات تلقائية عند تجاوز الاستخدام للحدود المحددة. يساعد ذلك على ضمان الإدارة الاستباقية والتحكم في التكاليف.",
            howToAccess:
              "لإضافة ووتشدوغ جديد، انتقل إلى لوحة تحكم الشرائح (SIM Panel) → العمليات الجماعية → ووتشدوغ → إنشاء ووتشدوغ. مهم: يجب أن تكون جميع بطاقات SIM في حالة Productive (مفعلة) لإعداد ووتشدوغ.",
            fields: {
              actionType:
                "اختر الإجراء الذي سيتم اتخاذه عند الوصول إلى الحد (مثل: إشعار، تعليق).",
              interval: "اختر فترة المراقبة (يومي، أسبوعي، شهري، أو مخصص).",
              amount: "أدخل حد الاستخدام الذي سيؤدي إلى تشغيل الإجراء.",
              service:
                "اختر الخدمة المطلوب مراقبتها (مثل: البيانات، الرسائل النصية).",
              unitType: "اختر وحدة القياس (مثل: البايت، عدد الرسائل النصية).",
              warnings:
                "حدد حدود الإنذار المبكر قبل الإجراء الرئيسي لإخطار المستخدمين مسبقاً.",
              suspendInterval:
                "يحدد المدة التي ستظل فيها بطاقة SIM معلقة بعد تشغيل ووتشدوغ. إذا تم تعيينه يوميًا، فسيتم استئناف البطاقة تلقائيًا عند منتصف ليل اليوم التالي. إذا كان أسبوعيًا، فسيتم استئنافها عند منتصف ليل يوم الاثنين التالي. إذا كان شهريًا، فسيتم استئنافها عند منتصف ليل اليوم الأول من الشهر التالي.",
            },
          },
          removeAll: {
            title: "إزالة جميع الـ Watchdogs",
            description:
              "يمكن للمستخدمين إزالة جميع الـ Watchdogs المُكوّنة من بطاقة SIM في إجراء واحد. هذا مفيد لإعادة ضبط المراقبة بسرعة دون الحاجة إلى حذف كل Watchdog بشكل فردي.",
            howToAccess:
              "لإزالة جميع الـ Watchdogs، انتقل إلى لوحة التحكم الخاصة بالـ SIM → اختر بطاقات SIM النشطة → العمليات الجماعية → Watchdogs → إزالة جميع الـ Watchdogs.",
            details: {
              title: "التفاصيل",
              immediateEffect:
                "عند التنفيذ، سيتم حذف جميع إعدادات الـ Watchdog الحالية على بطاقات SIM المحددة.",
              noAlerts:
                "لن يتم إنشاء أي تنبيهات أو إجراءات تلقائية بعد الإزالة.",
              cleanSlate:
                "ستستمر بطاقة SIM في العمل بشكل طبيعي، ولكن بدون مراقبة حتى يتم إنشاء Watchdogs جديدة.",
            },
            useCases: {
              title: "حالات الاستخدام",
              policyChanges:
                "عندما تتغير سياسات المراقبة، قد يكون من الضروري إزالة الـ Watchdogs الحالية.",
              testing:
                "في بيئات الاختبار، يمكن إنشاء العديد من الـ Watchdogs وإزالتها بسرعة للتنظيف.",
              errorRecovery:
                "إذا كانت هناك Watchdogs مُكوّنة بشكل خاطئ أو متعارضة، فإن الإزالة تعيدها إلى حالة محايدة.",
            },
            considerations: {
              title: "اعتبارات",
              irreversible:
                "إزالة جميع الـ Watchdogs لا يمكن التراجع عنها؛ يجب إعادة إنشائها إذا لزم الأمر.",
              criticalMonitoring:
                "تأكد من أن بطاقات SIM لا تبقى بدون مراقبة في البيئات الحرجة.",
              bulkOperations:
                "في العمليات الجماعية، تحقق بعناية حيث ستتأثر جميع بطاقات SIM المحددة.",
            },
          },
          reset: {
            title: "إعادة تعيين المراقب (Watchdog)",
            description:
              "إعادة تعيين المراقب تقوم بمسح عداد الاستهلاك وإعادة تفعيل الإيقاف إذا كان المستخدم قد اختار حجب الإيقاف خلال فترة الفوترة الحالية. يتيح ذلك إعادة بدء المراقبة دون الحاجة إلى إنشاء مراقب جديد.",
            howToAccess: {
              title: "كيفية الوصول",
              description:
                "انتقل إلى ملف بطاقة SIM. ضمن قسم المراقب، انقر على أيقونة السهم الدائري بجانب المراقب المعني لإعادة تعيينه.",
            },
          },
          blockSuspension: {
            title: "حظر الإيقاف",
            description:
              "يمنع حظر الإيقاف تعليق بطاقة SIM عندما يقوم المراقب (Watchdog) الذي يراقب استهلاكها بتشغيل تنبيه استهلاك بنسبة 100٪ (تنبيه النفاد). تنطبق هذه الوظيفة فقط على فترة الفوترة الحالية. عند بداية فترة الفوترة التالية، تتم إعادة تفعيل الإيقاف تلقائيًا.",
            howToAccess: {
              title: "كيفية الوصول",
              description:
                "حدد بطاقات SIM في حالة 'Productive' من لوحة SIM. ثم افتح العمليات الجماعية → المراقبون → حظر الإيقاف.",
            },
          },
          alerts: {
            title: "التنبيهات",
            description:
              "المراقبات (Watchdogs) التي تتابع استهلاك شرائح SIM تقوم بإنشاء تنبيهات. تساعد التنبيهات المستخدمين على متابعة حدود الاستخدام واتخاذ الإجراءات عند الحاجة.",
            typesTitle: "أنواع التنبيهات",
            types: {
              depleted:
                "مستنفذ: يتم إنشاؤه لجميع المراقبات. يتم تفعيله عند وصول شريحة SIM إلى 100% من الاستهلاك.",
              warning:
                "تحذير: يتم إنشاؤه اختياريًا للمراقبات التي تم تحديد حدود تحذير لها.",
            },
            howToAccess: {
              title: "كيفية الوصول",
              description:
                "لعرض التنبيهات، انتقل إلى قائمة 'التنبيهات' في الشريط الجانبي. يعرض الجدول التنبيهات مرتبة حسب التاريخ (الأحدث أولاً) ويحتوي على فلاتر لنوع التنبيه، التاريخ، وIMSI.",
            },
          },
        },
        reports: {
          intro: {
            title: "التقارير",
            description:
              "توفر المنصة للمستخدمين إمكانية عرض وتصدير مجموعة متنوعة من التقارير، مثل استهلاك شرائح SIM، قوائم الفواتير، تفاصيل الفاتورة (بنود الفاتورة)، طلبات تهيئة SIM، نشاط الحافظة (التنشيطات - الإنهاءات لكل عرض)، توزيع حالة شرائح SIM، والجلسات النشطة لشرائح SIM. كما يمكن إنشاء تقارير آلية عن الاستخدام ونظرة عامة على SIM يتم إنشاؤها على فترات منتظمة بشكل قابل للتنزيل. يركز هذا الفصل على ثلاثة أقسام فرعية.",
            subchaptersTitle: "الأقسام الفرعية",
            subchapters: {
              single: "تقرير فردي",
              automated: "تقرير آلي",
              history: "سجل التقارير",
            },
          },
          single: {
            title: "تقرير فردي",
            description:
              "تمكّن التقارير الفردية المستخدمين من إنشاء تقارير محددة حول استهلاك شرائح SIM، الفواتير، نشاط المحفظة، طلبات التزويد أو الجلسات. يمكن تخصيص هذه التقارير بناءً على معايير، وتجميعها وتصديرها لمزيد من التحليل.",

            howToAccess: {
              title: "الوصول",
              description:
                "للوصول إلى التقارير الفردية، انتقل إلى قسم التقارير في الشريط الجانبي واختر 'إنشاء تقرير'.",
            },

            usageReport: {
              title: "تقرير الاستخدام",
              description:
                "يوفر تقرير الاستخدام تفاصيل دقيقة حول استهلاك شرائح SIM للبيانات أو الرسائل القصيرة، مع خيارات مرنة للتجميع والتصفية.",
              bullets: [
                "اختر 'Usage' كنوع التقرير.",
                "حدد نوع الاستخدام: بيانات أو رسائل قصيرة.",
                "تجميع حسب الحقل: IMSI أو الشبكة أو العميل أو بدون تجميع.",
                "تجميع حسب الفترة: يوم، شهر أو سنة.",
                "اختياريًا، قم بتصفية شرائح SIM: IMSI محدد، نطاق IMSI أو ICCID.",
                "اضغط على 'عرض' لإنشاء التقرير.",
              ],
            },
            invoiceList: {
              title: "قائمة الفواتير",
              description:
                "يوفر تقرير قائمة الفواتير ملخصًا لجميع الفواتير الصادرة للحساب. يتضمن معلومات أساسية مثل رقم الفاتورة، تاريخ الإصدار، تاريخ الاستحقاق، المبلغ الإجمالي، وحالة الدفع. يمكن للمستخدمين تصفية الفواتير حسب النطاق الزمني للعثور بسرعة على المستندات المطلوبة.",
              bullets: [
                "انتقل إلى التقارير → إنشاء تقرير.",
                "اختر 'قائمة الفواتير' كنوع التقرير.",
                "حدد نطاق التواريخ (من – إلى) لتقييد قائمة الفواتير.",
                "انقر على 'عرض' لإنشاء التقرير.",
                "يعرض الجدول الناتج الفواتير مع تفاصيل مثل الرقم، تاريخ الإصدار، تاريخ الاستحقاق، المبلغ الإجمالي وحالة الدفع.",
              ],
            },
            orders: {
              title: "تقرير الطلبات",
              description:
                "يتيح تقرير الطلبات للمستخدم عرض جميع طلبات التوريد المتعلقة بشرائح SIM. يوفر نظرة عامة تاريخية على الطلبات التي تم إنشاؤها خلال الفترة المحددة.",
              bullets: [
                "متاح عبر التقارير → إنشاء تقرير → الطلبات.",
                "يسمح بالتصفية حسب النطاق الزمني (الفترة).",
                "يعرض قائمة بطلبات توريد شرائح SIM.",
              ],
            },
            portfolioActivity: {
              title: "تقرير نشاط المحفظة",
              description:
                "يوفر تقرير نشاط المحفظة نظرة عامة على نشاط شرائح SIM بما في ذلك التفعيلات، الإنهاءات، والتغييرات لكل عرض. يساعد المستخدمين على متابعة تطور محفظة شرائح SIM الخاصة بهم مع مرور الوقت.",
              bullets: [
                "متاح عبر التقارير → إنشاء تقرير → نشاط المحفظة.",
                "يمكن للمستخدمين تصفية التقرير حسب الفترة (من – إلى).",
                "يعرض التفعيلات، الإنهاءات والأنشطة مجمعة حسب العرض.",
              ],
            },
            customerSimSessions: {
              title: "تقرير جلسات شرائح SIM للعملاء",
              description:
                "يعرض تقرير جلسات شرائح SIM للعملاء معلومات عن الجلسات النشطة والسابقة لشرائح SIM. يساعد في تتبع متى وكيف تتصل شرائح SIM بالشبكة.",
              bullets: [
                "متاح عبر التقارير → إنشاء تقرير → جلسات شرائح SIM للعملاء.",
                "يعرض تفاصيل الجلسة مثل IMSI، وقت البداية والنهاية، والبيانات المنقولة.",
                "مفيد لاستكشاف مشكلات الاتصال وحلل أنماط استخدام شرائح SIM.",
              ],
            },
            simOverview: {
              title: "تقرير نظرة عامة على شرائح SIM",
              description:
                "يوفر تقرير نظرة عامة على شرائح SIM ملخصاً لبطاقات SIM في النظام، ويعرض توزيعها حسب الحالة والتخصيص والنشاط. يساعد المسؤولين على تقييم أسطول شرائح SIM بسرعة.",
              bullets: [
                "متاح عبر التقارير → إنشاء تقرير → نظرة عامة على SIM.",
                "يعرض الشرائح مجمعة حسب الحالة مثل نشطة، موقوفة، منتهية، أو في المخزون.",
                "مفيد لمراقبة حالة وتوزيع بطاقات SIM بنظرة سريعة.",
              ],
            },
            simList: {
              title: "تقرير قائمة شرائح SIM",
              description:
                "يوفر تقرير قائمة شرائح SIM جرداً مفصلاً لجميع بطاقات SIM في النظام. يتضمن معرفات مثل IMSI وICCID، حالتها الحالية وتفاصيل التخصيص.",
              bullets: [
                "متاح عبر التقارير → إنشاء تقرير → قائمة SIM.",
                "يعرض كل بطاقة SIM مع IMSI وICCID والحالة الحالية.",
                "مفيد للتدقيق وإدارة المخزون الكامل لبطاقات SIM.",
              ],
            },
            exportReport: {
              title: "تصدير التقرير إلى ملف",
              description:
                "يمكن تصدير جميع التقارير المولدة إلى ملف لمزيد من التحليل أو للمشاركة. تشمل خيارات التصدير تنسيقات CSV وPDF.",
              bullets: [
                "متاح عبر الإجراءات → تصدير → CSV أو PDF.",
                "تنسيق CSV مفيد لتحليل البيانات في Excel أو أدوات الجداول الأخرى.",
                "تنسيق PDF مفيد لمشاركة التقارير بتنسيق ثابت.",
              ],
            },
            timeoutReports: {
              title: "تقارير المهلة",
              description:
                "لكل إنشاء تقرير حد زمني قدره 15 ثانية. عند تجاوز هذا الحد، يستمر إنشاء التقرير في الخلفية.",
              bullets: [
                "يتم إخطار المستخدم عند وصول التقرير إلى حد المهلة.",
                "عند اكتمال التقرير، يتلقى المستخدم إشعار دفع.",
                "يمكن عرض التقرير الناتج من خلال الإجراءات → عرض.",
                "يمكن أيضًا تصدير تقارير المهلة إلى CSV أو PDF مثل التقارير الفورية.",
              ],
            },
          },
          automated: {
            title: "التقارير التلقائية",
            description:
              "تمكّن التقارير التلقائية المستخدمين من جدولة إنشاء التقارير على فترات زمنية ثابتة وبصيغة محددة.",
            overview: {
              title: "نظرة عامة",
              description:
                "يتم إنشاء التقارير التلقائية مرة واحدة، ثم يتم إنشاؤها تلقائيًا وفقًا للتكرار والصيغة المحددين.",
              bullets: [
                "يمكن جدولة التقارير بشكل يومي أو أسبوعي أو شهري.",
                "يمكن إنشاء التقارير بصيغة CSV أو PDF.",
                "أنواع التقارير المتاحة: الاستخدام ونظرة عامة على شرائح SIM الخاصة بالعميل.",
              ],
            },
            create: {
              title: "إنشاء تقرير تلقائي",
              description:
                "لإنشاء تقرير تلقائي جديد، اضغط على الزر الموجود في أعلى يمين البطاقة. ستظهر استمارة تطلب بعض المعلومات:",
              bullets: [
                "الاسم: اسم التقرير.",
                "تكرار التقرير: يومي أو أسبوعي أو شهري.",
                "صيغة التقرير: CSV أو PDF.",
                "نوع التقرير: اختر بين الاستخدام ونظرة عامة على شرائح SIM الخاصة بالعميل.",
                "اعتمادًا على نوع التقرير، قد تظهر حقول إضافية مشابهة لقائمة إنشاء تقرير.",
              ],
            },
          },
          history: {
            title: "سجل التقارير",
            description:
              "يوفر قسم سجل التقارير قائمة بنتائج جميع التقارير المؤتمتة التي تم تنفيذها. كل سجل يتضمن اسم التقرير، تاريخ الإنشاء، الحالة، خيار التنزيل وإمكانية حذف التقرير.",
            reportHistory: {
              title: "عرض نتائج التقارير المؤتمتة",
              description: "من قسم سجل التقارير يمكن للمستخدمين:",
              bullets: [
                "عرض نتائج جميع التقارير المؤتمتة المنفذة.",
                "التحقق من حالة التنفيذ (مكتمل، قيد الانتظار، فشل).",
                "تنزيل الملفات المولدة بصيغة CSV أو PDF.",
                "حذف إدخال التقرير من خلال قائمة الإجراءات.",
              ],
            },
          },
        },
      },
    },
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: "en",
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});
